import fetch$1, { Headers, Request as Request$1, Response as Response$1 } from 'node-fetch';
import _m0 from 'protobufjs/minimal';
import Long from 'long';

// @ts-ignore: Declare fetch for browser & node
if (!globalThis.fetch) {
  // @ts-ignore: Declare fetch for browser & node
  globalThis.fetch = fetch$1;
  // @ts-ignore: Declare fetch Headers for browser & node
  globalThis.Headers = Headers;
  // @ts-ignore: Declare fetch Request for browser & node
  globalThis.Request = Request$1;
  // @ts-ignore: Declare fetch Response for browser & node
  globalThis.Response = Response$1;
}
if (typeof TextEncoder === "undefined") {
  global.TextEncoder = /*#__PURE__*/require("util").TextEncoder;
}
if (typeof TextDecoder === "undefined") {
  global.TextDecoder = /*#__PURE__*/require("util").TextDecoder;
}

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var p = "=";
var tab = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var base64ToBytes = function base64ToBytes(base64) {
  //	summary
  //	Convert a base64-encoded string to an array of bytes
  var s = base64.split(""),
    out = [];
  var l = s.length;
  while (s[--l] === p) {} //	strip off trailing padding
  for (var i = 0; i < l;) {
    var t = tab.indexOf(s[i++]) << 18;
    if (i <= l) {
      t |= tab.indexOf(s[i++]) << 12;
    }
    if (i <= l) {
      t |= tab.indexOf(s[i++]) << 6;
    }
    if (i <= l) {
      t |= tab.indexOf(s[i++]);
    }
    out.push(t >>> 16 & 0xff);
    out.push(t >>> 8 & 0xff);
    out.push(t & 0xff);
  }
  //	strip off any null bytes
  while (out[out.length - 1] === 0) {
    out.pop();
  }
  return new Uint8Array(out); //	byte[]
};
var bytesToBase64 = function bytesToBase64(bytes) {
  //	summary
  //	Encode an array of bytes as a base64-encoded string
  var t;
  var s = [],
    l = bytes.length;
  var rm = l % 3;
  var x = l - rm;
  for (var i = 0; i < x;) {
    t = bytes[i++] << 16 | bytes[i++] << 8 | bytes[i++];
    s.push(tab.charAt(t >>> 18 & 0x3f));
    s.push(tab.charAt(t >>> 12 & 0x3f));
    s.push(tab.charAt(t >>> 6 & 0x3f));
    s.push(tab.charAt(t & 0x3f));
  }
  //	deal with trailers, based on patch from Peter Wood.
  switch (rm) {
    case 2:
      {
        t = bytes[i++] << 16 | bytes[i++] << 8;
        s.push(tab.charAt(t >>> 18 & 0x3f));
        s.push(tab.charAt(t >>> 12 & 0x3f));
        s.push(tab.charAt(t >>> 6 & 0x3f));
        s.push(p);
        break;
      }
    case 1:
      {
        t = bytes[i++] << 16;
        s.push(tab.charAt(t >>> 18 & 0x3f));
        s.push(tab.charAt(t >>> 12 & 0x3f));
        s.push(p);
        s.push(p);
        break;
      }
  }
  return s.join(""); //	string
};

var wasm;
var heap = /*#__PURE__*/new Array(128).fill(undefined);
heap.push(undefined, null, true, false);
function getObject(idx) {
  return heap[idx];
}
var heap_next = heap.length;
function dropObject(idx) {
  if (idx < 132) return;
  heap[idx] = heap_next;
  heap_next = idx;
}
function takeObject(idx) {
  var ret = getObject(idx);
  dropObject(idx);
  return ret;
}
var cachedTextDecoder = typeof TextDecoder !== 'undefined' ? /*#__PURE__*/new TextDecoder('utf-8', {
  ignoreBOM: true,
  fatal: true
}) : {
  decode: function decode() {
    throw Error('TextDecoder not available');
  }
};
if (typeof TextDecoder !== 'undefined') {
  cachedTextDecoder.decode();
}
var cachedUint8ArrayMemory0 = null;
function getUint8ArrayMemory0() {
  if (cachedUint8ArrayMemory0 === null || cachedUint8ArrayMemory0.byteLength === 0) {
    cachedUint8ArrayMemory0 = new Uint8Array(wasm.memory.buffer);
  }
  return cachedUint8ArrayMemory0;
}
function getStringFromWasm0(ptr, len) {
  ptr = ptr >>> 0;
  return cachedTextDecoder.decode(getUint8ArrayMemory0().subarray(ptr, ptr + len));
}
function addHeapObject(obj) {
  if (heap_next === heap.length) heap.push(heap.length + 1);
  var idx = heap_next;
  heap_next = heap[idx];
  heap[idx] = obj;
  return idx;
}
var WASM_VECTOR_LEN = 0;
var cachedTextEncoder = typeof TextEncoder !== 'undefined' ? /*#__PURE__*/new TextEncoder('utf-8') : {
  encode: function encode() {
    throw Error('TextEncoder not available');
  }
};
var encodeString = typeof cachedTextEncoder.encodeInto === 'function' ? function (arg, view) {
  return cachedTextEncoder.encodeInto(arg, view);
} : function (arg, view) {
  var buf = cachedTextEncoder.encode(arg);
  view.set(buf);
  return {
    read: arg.length,
    written: buf.length
  };
};
function passStringToWasm0(arg, malloc, realloc) {
  if (realloc === undefined) {
    var buf = cachedTextEncoder.encode(arg);
    var _ptr = malloc(buf.length, 1) >>> 0;
    getUint8ArrayMemory0().subarray(_ptr, _ptr + buf.length).set(buf);
    WASM_VECTOR_LEN = buf.length;
    return _ptr;
  }
  var len = arg.length;
  var ptr = malloc(len, 1) >>> 0;
  var mem = getUint8ArrayMemory0();
  var offset = 0;
  for (; offset < len; offset++) {
    var code = arg.charCodeAt(offset);
    if (code > 0x7F) break;
    mem[ptr + offset] = code;
  }
  if (offset !== len) {
    if (offset !== 0) {
      arg = arg.slice(offset);
    }
    ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
    var view = getUint8ArrayMemory0().subarray(ptr + offset, ptr + len);
    var ret = encodeString(arg, view);
    offset += ret.written;
    ptr = realloc(ptr, len, offset, 1) >>> 0;
  }
  WASM_VECTOR_LEN = offset;
  return ptr;
}
function isLikeNone(x) {
  return x === undefined || x === null;
}
var cachedDataViewMemory0 = null;
function getDataViewMemory0() {
  if (cachedDataViewMemory0 === null || cachedDataViewMemory0.buffer.detached === true || cachedDataViewMemory0.buffer.detached === undefined && cachedDataViewMemory0.buffer !== wasm.memory.buffer) {
    cachedDataViewMemory0 = new DataView(wasm.memory.buffer);
  }
  return cachedDataViewMemory0;
}
function debugString(val) {
  // primitive types
  var type = typeof val;
  if (type == 'number' || type == 'boolean' || val == null) {
    return "" + val;
  }
  if (type == 'string') {
    return "\"" + val + "\"";
  }
  if (type == 'symbol') {
    var description = val.description;
    if (description == null) {
      return 'Symbol';
    } else {
      return "Symbol(" + description + ")";
    }
  }
  if (type == 'function') {
    var name = val.name;
    if (typeof name == 'string' && name.length > 0) {
      return "Function(" + name + ")";
    } else {
      return 'Function';
    }
  }
  // objects
  if (Array.isArray(val)) {
    var length = val.length;
    var debug = '[';
    if (length > 0) {
      debug += debugString(val[0]);
    }
    for (var i = 1; i < length; i++) {
      debug += ', ' + debugString(val[i]);
    }
    debug += ']';
    return debug;
  }
  // Test for built-in
  var builtInMatches = /\[object ([^\]]+)\]/.exec(toString.call(val));
  var className;
  if (builtInMatches.length > 1) {
    className = builtInMatches[1];
  } else {
    // Failed to match the standard '[object ClassName]'
    return toString.call(val);
  }
  if (className == 'Object') {
    // we're a user defined class or Object
    // JSON.stringify avoids problems with cycles, and is generally much
    // easier than looping through ownProperties of `val`.
    try {
      return 'Object(' + JSON.stringify(val) + ')';
    } catch (_) {
      return 'Object';
    }
  }
  // errors
  if (val instanceof Error) {
    return val.name + ": " + val.message + "\n" + val.stack;
  }
  // TODO we could test for more things here, like `Set`s and `Map`s.
  return className;
}
var CLOSURE_DTORS = typeof FinalizationRegistry === 'undefined' ? {
  register: function register() {},
  unregister: function unregister() {}
} : /*#__PURE__*/new FinalizationRegistry(function (state) {
  wasm.__wbindgen_export_2.get(state.dtor)(state.a, state.b);
});
function makeMutClosure(arg0, arg1, dtor, f) {
  var state = {
    a: arg0,
    b: arg1,
    cnt: 1,
    dtor: dtor
  };
  var real = function real() {
    // First up with a closure we increment the internal reference
    // count. This ensures that the Rust closure environment won't
    // be deallocated while we're invoking it.
    state.cnt++;
    var a = state.a;
    state.a = 0;
    try {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return f.apply(void 0, [a, state.b].concat(args));
    } finally {
      if (--state.cnt === 0) {
        wasm.__wbindgen_export_2.get(state.dtor)(a, state.b);
        CLOSURE_DTORS.unregister(state);
      } else {
        state.a = a;
      }
    }
  };
  real.original = state;
  CLOSURE_DTORS.register(real, state, state);
  return real;
}
function __wbg_adapter_36(arg0, arg1) {
  wasm._dyn_core__ops__function__FnMut_____Output___R_as_wasm_bindgen__closure__WasmClosure___describe__invoke__h34d72becb484edde(arg0, arg1);
}
function __wbg_adapter_39(arg0, arg1, arg2) {
  wasm._dyn_core__ops__function__FnMut__A____Output___R_as_wasm_bindgen__closure__WasmClosure___describe__invoke__h02dcfcb7159ab190(arg0, arg1, addHeapObject(arg2));
}

/**
* @param {string} request_type
* @param {string} payload
* @returns {any}
*/
function request(request_type, payload) {
  var ptr0 = passStringToWasm0(request_type, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
  var len0 = WASM_VECTOR_LEN;
  var ptr1 = passStringToWasm0(payload, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
  var len1 = WASM_VECTOR_LEN;
  var ret = wasm.request(ptr0, len0, ptr1, len1);
  return takeObject(ret);
}
function handleError(f, args) {
  try {
    return f.apply(this, args);
  } catch (e) {
    wasm.__wbindgen_exn_store(addHeapObject(e));
  }
}
function __wbg_adapter_85(arg0, arg1, arg2, arg3) {
  wasm.wasm_bindgen__convert__closures__invoke2_mut__h4f54f8028bc440dd(arg0, arg1, addHeapObject(arg2), addHeapObject(arg3));
}
function __wbg_load(_x, _x2) {
  return _wbg_load.apply(this, arguments);
}
function _wbg_load() {
  _wbg_load = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(module, imports) {
    var bytes, instance;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(typeof Response === 'function' && module instanceof Response)) {
            _context.next = 23;
            break;
          }
          if (!(typeof WebAssembly.instantiateStreaming === 'function')) {
            _context.next = 15;
            break;
          }
          _context.prev = 2;
          _context.next = 5;
          return WebAssembly.instantiateStreaming(module, imports);
        case 5:
          return _context.abrupt("return", _context.sent);
        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](2);
          if (!(module.headers.get('Content-Type') != 'application/wasm')) {
            _context.next = 14;
            break;
          }
          console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", _context.t0);
          _context.next = 15;
          break;
        case 14:
          throw _context.t0;
        case 15:
          _context.next = 17;
          return module.arrayBuffer();
        case 17:
          bytes = _context.sent;
          _context.next = 20;
          return WebAssembly.instantiate(bytes, imports);
        case 20:
          return _context.abrupt("return", _context.sent);
        case 23:
          _context.next = 25;
          return WebAssembly.instantiate(module, imports);
        case 25:
          instance = _context.sent;
          if (!(instance instanceof WebAssembly.Instance)) {
            _context.next = 30;
            break;
          }
          return _context.abrupt("return", {
            instance: instance,
            module: module
          });
        case 30:
          return _context.abrupt("return", instance);
        case 31:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 8]]);
  }));
  return _wbg_load.apply(this, arguments);
}
function __wbg_get_imports() {
  var imports = {};
  imports.wbg = {};
  imports.wbg.__wbg_fetch_f20072c12998e7ae = function (arg0) {
    var ret = fetch(takeObject(arg0));
    return addHeapObject(ret);
  };
  imports.wbg.__wbg_new_ea1883e1e5e86686 = function (arg0) {
    var ret = new Uint8Array(getObject(arg0));
    return addHeapObject(ret);
  };
  imports.wbg.__wbg_length_8339fcf5d8ecd12e = function (arg0) {
    var ret = getObject(arg0).length;
    return ret;
  };
  imports.wbg.__wbg_clearTimeout_76877dbc010e786d = function (arg0) {
    var ret = clearTimeout(takeObject(arg0));
    return addHeapObject(ret);
  };
  imports.wbg.__wbindgen_object_drop_ref = function (arg0) {
    takeObject(arg0);
  };
  imports.wbg.__wbindgen_cb_drop = function (arg0) {
    var obj = takeObject(arg0).original;
    if (obj.cnt-- == 1) {
      obj.a = 0;
      return true;
    }
    var ret = false;
    return ret;
  };
  imports.wbg.__wbg_setTimeout_75cb9b6991a4031d = function () {
    return handleError(function (arg0, arg1) {
      var ret = setTimeout(getObject(arg0), arg1);
      return addHeapObject(ret);
    }, arguments);
  };
  imports.wbg.__wbindgen_string_new = function (arg0, arg1) {
    var ret = getStringFromWasm0(arg0, arg1);
    return addHeapObject(ret);
  };
  imports.wbg.__wbg_new_b85e72ed1bfd57f9 = function (arg0, arg1) {
    try {
      var state0 = {
        a: arg0,
        b: arg1
      };
      var cb0 = function cb0(arg0, arg1) {
        var a = state0.a;
        state0.a = 0;
        try {
          return __wbg_adapter_85(a, state0.b, arg0, arg1);
        } finally {
          state0.a = a;
        }
      };
      var ret = new Promise(cb0);
      return addHeapObject(ret);
    } finally {
      state0.a = state0.b = 0;
    }
  };
  imports.wbg.__wbg_now_b7a162010a9e75b4 = function () {
    var ret = Date.now();
    return ret;
  };
  imports.wbg.__wbindgen_object_clone_ref = function (arg0) {
    var ret = getObject(arg0);
    return addHeapObject(ret);
  };
  imports.wbg.__wbindgen_string_get = function (arg0, arg1) {
    var obj = getObject(arg1);
    var ret = typeof obj === 'string' ? obj : undefined;
    var ptr1 = isLikeNone(ret) ? 0 : passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
  };
  imports.wbg.__wbindgen_jsval_loose_eq = function (arg0, arg1) {
    var ret = getObject(arg0) == getObject(arg1);
    return ret;
  };
  imports.wbg.__wbindgen_boolean_get = function (arg0) {
    var v = getObject(arg0);
    var ret = typeof v === 'boolean' ? v ? 1 : 0 : 2;
    return ret;
  };
  imports.wbg.__wbindgen_number_get = function (arg0, arg1) {
    var obj = getObject(arg1);
    var ret = typeof obj === 'number' ? obj : undefined;
    getDataViewMemory0().setFloat64(arg0 + 8 * 1, isLikeNone(ret) ? 0 : ret, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, !isLikeNone(ret), true);
  };
  imports.wbg.__wbg_instanceof_Uint8Array_247a91427532499e = function (arg0) {
    var result;
    try {
      result = getObject(arg0) instanceof Uint8Array;
    } catch (_) {
      result = false;
    }
    var ret = result;
    return ret;
  };
  imports.wbg.__wbg_instanceof_ArrayBuffer_61dfc3198373c902 = function (arg0) {
    var result;
    try {
      result = getObject(arg0) instanceof ArrayBuffer;
    } catch (_) {
      result = false;
    }
    var ret = result;
    return ret;
  };
  imports.wbg.__wbg_new_525245e2b9901204 = function () {
    var ret = new Object();
    return addHeapObject(ret);
  };
  imports.wbg.__wbg_setmethod_dc68a742c2db5c6a = function (arg0, arg1, arg2) {
    getObject(arg0).method = getStringFromWasm0(arg1, arg2);
  };
  imports.wbg.__wbg_setmode_a781aae2bd3df202 = function (arg0, arg1) {
    getObject(arg0).mode = ["same-origin", "no-cors", "cors", "navigate"][arg1];
  };
  imports.wbg.__wbindgen_memory = function () {
    var ret = wasm.memory;
    return addHeapObject(ret);
  };
  imports.wbg.__wbg_buffer_b7b08af79b0b0974 = function (arg0) {
    var ret = getObject(arg0).buffer;
    return addHeapObject(ret);
  };
  imports.wbg.__wbg_newwithbyteoffsetandlength_8a2cb9ca96b27ec9 = function (arg0, arg1, arg2) {
    var ret = new Uint8Array(getObject(arg0), arg1 >>> 0, arg2 >>> 0);
    return addHeapObject(ret);
  };
  imports.wbg.__wbg_setbody_734cb3d7ee8e6e96 = function (arg0, arg1) {
    getObject(arg0).body = getObject(arg1);
  };
  imports.wbg.__wbg_newwithstrandinit_a31c69e4cc337183 = function () {
    return handleError(function (arg0, arg1, arg2) {
      var ret = new Request(getStringFromWasm0(arg0, arg1), getObject(arg2));
      return addHeapObject(ret);
    }, arguments);
  };
  imports.wbg.__wbindgen_number_new = function (arg0) {
    var ret = arg0;
    return addHeapObject(ret);
  };
  imports.wbg.__wbg_new_7982fb43cfca37ae = function (arg0) {
    var ret = new Date(getObject(arg0));
    return addHeapObject(ret);
  };
  imports.wbg.__wbg_getTimezoneOffset_c9929a3cc94500fe = function (arg0) {
    var ret = getObject(arg0).getTimezoneOffset();
    return ret;
  };
  imports.wbg.__wbg_new0_65387337a95cf44d = function () {
    var ret = new Date();
    return addHeapObject(ret);
  };
  imports.wbg.__wbg_getTime_91058879093a1589 = function (arg0) {
    var ret = getObject(arg0).getTime();
    return ret;
  };
  imports.wbg.__wbindgen_is_object = function (arg0) {
    var val = getObject(arg0);
    var ret = typeof val === 'object' && val !== null;
    return ret;
  };
  imports.wbg.__wbg_randomFillSync_5c9c955aa56b6049 = function () {
    return handleError(function (arg0, arg1) {
      getObject(arg0).randomFillSync(takeObject(arg1));
    }, arguments);
  };
  imports.wbg.__wbg_subarray_7c2e3576afe181d1 = function (arg0, arg1, arg2) {
    var ret = getObject(arg0).subarray(arg1 >>> 0, arg2 >>> 0);
    return addHeapObject(ret);
  };
  imports.wbg.__wbg_getRandomValues_3aa56aa6edec874c = function () {
    return handleError(function (arg0, arg1) {
      getObject(arg0).getRandomValues(getObject(arg1));
    }, arguments);
  };
  imports.wbg.__wbg_crypto_1d1f22824a6a080c = function (arg0) {
    var ret = getObject(arg0).crypto;
    return addHeapObject(ret);
  };
  imports.wbg.__wbg_process_4a72847cc503995b = function (arg0) {
    var ret = getObject(arg0).process;
    return addHeapObject(ret);
  };
  imports.wbg.__wbg_versions_f686565e586dd935 = function (arg0) {
    var ret = getObject(arg0).versions;
    return addHeapObject(ret);
  };
  imports.wbg.__wbg_node_104a2ff8d6ea03a2 = function (arg0) {
    var ret = getObject(arg0).node;
    return addHeapObject(ret);
  };
  imports.wbg.__wbindgen_is_string = function (arg0) {
    var ret = typeof getObject(arg0) === 'string';
    return ret;
  };
  imports.wbg.__wbg_require_cca90b1a94a0255b = function () {
    return handleError(function () {
      var ret = module.require;
      return addHeapObject(ret);
    }, arguments);
  };
  imports.wbg.__wbindgen_is_function = function (arg0) {
    var ret = typeof getObject(arg0) === 'function';
    return ret;
  };
  imports.wbg.__wbg_msCrypto_eb05e62b530a1508 = function (arg0) {
    var ret = getObject(arg0).msCrypto;
    return addHeapObject(ret);
  };
  imports.wbg.__wbg_newwithlength_ec548f448387c968 = function (arg0) {
    var ret = new Uint8Array(arg0 >>> 0);
    return addHeapObject(ret);
  };
  imports.wbg.__wbg_self_3093d5d1f7bcb682 = function () {
    return handleError(function () {
      var ret = self.self;
      return addHeapObject(ret);
    }, arguments);
  };
  imports.wbg.__wbg_window_3bcfc4d31bc012f8 = function () {
    return handleError(function () {
      var ret = window.window;
      return addHeapObject(ret);
    }, arguments);
  };
  imports.wbg.__wbg_globalThis_86b222e13bdf32ed = function () {
    return handleError(function () {
      var ret = globalThis.globalThis;
      return addHeapObject(ret);
    }, arguments);
  };
  imports.wbg.__wbg_global_e5a3fe56f8be9485 = function () {
    return handleError(function () {
      var ret = global.global;
      return addHeapObject(ret);
    }, arguments);
  };
  imports.wbg.__wbindgen_is_undefined = function (arg0) {
    var ret = getObject(arg0) === undefined;
    return ret;
  };
  imports.wbg.__wbg_newnoargs_76313bd6ff35d0f2 = function (arg0, arg1) {
    var ret = new Function(getStringFromWasm0(arg0, arg1));
    return addHeapObject(ret);
  };
  imports.wbg.__wbg_call_1084a111329e68ce = function () {
    return handleError(function (arg0, arg1) {
      var ret = getObject(arg0).call(getObject(arg1));
      return addHeapObject(ret);
    }, arguments);
  };
  imports.wbg.__wbg_call_89af060b4e1523f2 = function () {
    return handleError(function (arg0, arg1, arg2) {
      var ret = getObject(arg0).call(getObject(arg1), getObject(arg2));
      return addHeapObject(ret);
    }, arguments);
  };
  imports.wbg.__wbg_set_d1e79e2388520f18 = function (arg0, arg1, arg2) {
    getObject(arg0).set(getObject(arg1), arg2 >>> 0);
  };
  imports.wbg.__wbindgen_error_new = function (arg0, arg1) {
    var ret = new Error(getStringFromWasm0(arg0, arg1));
    return addHeapObject(ret);
  };
  imports.wbg.__wbindgen_throw = function (arg0, arg1) {
    throw new Error(getStringFromWasm0(arg0, arg1));
  };
  imports.wbg.__wbindgen_debug_string = function (arg0, arg1) {
    var ret = debugString(getObject(arg1));
    var ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
  };
  imports.wbg.__wbg_then_95e6edc0f89b73b1 = function (arg0, arg1) {
    var ret = getObject(arg0).then(getObject(arg1));
    return addHeapObject(ret);
  };
  imports.wbg.__wbg_queueMicrotask_12a30234db4045d3 = function (arg0) {
    queueMicrotask(getObject(arg0));
  };
  imports.wbg.__wbg_then_876bb3c633745cc6 = function (arg0, arg1, arg2) {
    var ret = getObject(arg0).then(getObject(arg1), getObject(arg2));
    return addHeapObject(ret);
  };
  imports.wbg.__wbg_queueMicrotask_48421b3cc9052b68 = function (arg0) {
    var ret = getObject(arg0).queueMicrotask;
    return addHeapObject(ret);
  };
  imports.wbg.__wbg_resolve_570458cb99d56a43 = function (arg0) {
    var ret = Promise.resolve(getObject(arg0));
    return addHeapObject(ret);
  };
  imports.wbg.__wbg_set_b3c7c6d2e5e783d6 = function () {
    return handleError(function (arg0, arg1, arg2, arg3, arg4) {
      getObject(arg0).set(getStringFromWasm0(arg1, arg2), getStringFromWasm0(arg3, arg4));
    }, arguments);
  };
  imports.wbg.__wbg_headers_7d46f181de2aa1dd = function (arg0) {
    var ret = getObject(arg0).headers;
    return addHeapObject(ret);
  };
  imports.wbg.__wbg_instanceof_Response_e91b7eb7c611a9ae = function (arg0) {
    var result;
    try {
      result = getObject(arg0) instanceof Response;
    } catch (_) {
      result = false;
    }
    var ret = result;
    return ret;
  };
  imports.wbg.__wbg_status_ae8de515694c5c7c = function (arg0) {
    var ret = getObject(arg0).status;
    return ret;
  };
  imports.wbg.__wbg_arrayBuffer_a5fbad63cc7e663b = function () {
    return handleError(function (arg0) {
      var ret = getObject(arg0).arrayBuffer();
      return addHeapObject(ret);
    }, arguments);
  };
  imports.wbg.__wbindgen_closure_wrapper1790 = function (arg0, arg1, arg2) {
    var ret = makeMutClosure(arg0, arg1, 315, __wbg_adapter_36);
    return addHeapObject(ret);
  };
  imports.wbg.__wbindgen_closure_wrapper9648 = function (arg0, arg1, arg2) {
    var ret = makeMutClosure(arg0, arg1, 635, __wbg_adapter_39);
    return addHeapObject(ret);
  };
  return imports;
}
function __wbg_finalize_init(instance, module) {
  wasm = instance.exports;
  __wbg_init.__wbindgen_wasm_module = module;
  cachedDataViewMemory0 = null;
  cachedUint8ArrayMemory0 = null;
  return wasm;
}
function __wbg_init(_x3) {
  return _wbg_init.apply(this, arguments);
}
function _wbg_init() {
  _wbg_init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(module_or_path) {
    var _module_or_path, imports, _yield$__wbg_load, instance, module;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!(wasm !== undefined)) {
            _context2.next = 2;
            break;
          }
          return _context2.abrupt("return", wasm);
        case 2:
          if (typeof module_or_path !== 'undefined' && Object.getPrototypeOf(module_or_path) === Object.prototype) {
            _module_or_path = module_or_path;
            module_or_path = _module_or_path.module_or_path;
          } else console.warn('using deprecated parameters for the initialization function; pass a single object instead');
          if (typeof module_or_path === 'undefined') {
            module_or_path = new URL('bloock_bridge_bg.wasm', import.meta.url);
          }
          imports = __wbg_get_imports();
          if (typeof module_or_path === 'string' || typeof Request === 'function' && module_or_path instanceof Request || typeof URL === 'function' && module_or_path instanceof URL) {
            module_or_path = fetch(module_or_path);
          }
          _context2.t0 = __wbg_load;
          _context2.next = 10;
          return module_or_path;
        case 10:
          _context2.t1 = _context2.sent;
          _context2.t2 = imports;
          _context2.next = 14;
          return (0, _context2.t0)(_context2.t1, _context2.t2);
        case 14:
          _yield$__wbg_load = _context2.sent;
          instance = _yield$__wbg_load.instance;
          module = _yield$__wbg_load.module;
          return _context2.abrupt("return", __wbg_finalize_init(instance, module));
        case 18:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _wbg_init.apply(this, arguments);
}

var FFIClient = /*#__PURE__*/function () {
  function FFIClient() {
    var _this = this;
    this.ready = new Promise(function (resolve, reject) {
      _this.init().then(resolve)["catch"](reject);
    });
  }
  FFIClient.getInstance = function getInstance() {
    if (!FFIClient.instance) {
      FFIClient.instance = new FFIClient();
    }
    return FFIClient.instance;
  };
  var _proto = FFIClient.prototype;
  _proto.request = /*#__PURE__*/function () {
    var _request2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(type, payload) {
      var response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return this.ready;
          case 2:
            _context.next = 4;
            return request(type, bytesToBase64(payload));
          case 4:
            response = _context.sent;
            return _context.abrupt("return", base64ToBytes(response));
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function request$1(_x, _x2) {
      return _request2.apply(this, arguments);
    }
    return request$1;
  }();
  _proto.init = /*#__PURE__*/function () {
    var _init2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var wasmFile, fs, wasmPath;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(typeof window === "undefined")) {
              _context2.next = 7;
              break;
            }
            _context2.next = 3;
            return import('fs');
          case 3:
            fs = _context2.sent;
            wasmFile = new Uint8Array(fs.readFileSync(__dirname + "/bloock_bridge_bg.wasm"));
            _context2.next = 11;
            break;
          case 7:
            // Browser
            wasmPath = new URL("bloock_bridge_bg.wasm", import.meta.url).toString();
            _context2.next = 10;
            return fetch(wasmPath);
          case 10:
            wasmFile = _context2.sent;
          case 11:
            _context2.next = 13;
            return __wbg_init(wasmFile);
          case 13:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    function init() {
      return _init2.apply(this, arguments);
    }
    return init;
  }();
  return FFIClient;
}();

var Connection = /*#__PURE__*/function () {
  function Connection() {
    this.ffiClient = FFIClient.getInstance();
  }
  var _proto = Connection.prototype;
  _proto.request = /*#__PURE__*/function () {
    var _request = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(service, method, data) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return this.ffiClient.request("/" + service + "/" + method, data);
          case 2:
            return _context.abrupt("return", _context.sent);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function request(_x, _x2, _x3) {
      return _request.apply(this, arguments);
    }
    return request;
  }();
  return Connection;
}();

/* eslint-disable */
var KeyType;
(function (KeyType) {
  KeyType[KeyType["EcP256k"] = 0] = "EcP256k";
  KeyType[KeyType["Rsa2048"] = 1] = "Rsa2048";
  KeyType[KeyType["Rsa3072"] = 2] = "Rsa3072";
  KeyType[KeyType["Rsa4096"] = 3] = "Rsa4096";
  KeyType[KeyType["Aes128"] = 4] = "Aes128";
  KeyType[KeyType["Aes256"] = 5] = "Aes256";
  KeyType[KeyType["Bjj"] = 6] = "Bjj";
  KeyType[KeyType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(KeyType || (KeyType = {}));
function keyTypeFromJSON(object) {
  switch (object) {
    case 0:
    case "EcP256k":
      return KeyType.EcP256k;
    case 1:
    case "Rsa2048":
      return KeyType.Rsa2048;
    case 2:
    case "Rsa3072":
      return KeyType.Rsa3072;
    case 3:
    case "Rsa4096":
      return KeyType.Rsa4096;
    case 4:
    case "Aes128":
      return KeyType.Aes128;
    case 5:
    case "Aes256":
      return KeyType.Aes256;
    case 6:
    case "Bjj":
      return KeyType.Bjj;
    case -1:
    case "UNRECOGNIZED":
    default:
      return KeyType.UNRECOGNIZED;
  }
}
function keyTypeToJSON(object) {
  switch (object) {
    case KeyType.EcP256k:
      return "EcP256k";
    case KeyType.Rsa2048:
      return "Rsa2048";
    case KeyType.Rsa3072:
      return "Rsa3072";
    case KeyType.Rsa4096:
      return "Rsa4096";
    case KeyType.Aes128:
      return "Aes128";
    case KeyType.Aes256:
      return "Aes256";
    case KeyType.Bjj:
      return "Bjj";
    case KeyType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
var KeyProtectionLevel;
(function (KeyProtectionLevel) {
  KeyProtectionLevel[KeyProtectionLevel["SOFTWARE"] = 0] = "SOFTWARE";
  KeyProtectionLevel[KeyProtectionLevel["HSM"] = 1] = "HSM";
  KeyProtectionLevel[KeyProtectionLevel["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(KeyProtectionLevel || (KeyProtectionLevel = {}));
function keyProtectionLevelFromJSON(object) {
  switch (object) {
    case 0:
    case "SOFTWARE":
      return KeyProtectionLevel.SOFTWARE;
    case 1:
    case "HSM":
      return KeyProtectionLevel.HSM;
    case -1:
    case "UNRECOGNIZED":
    default:
      return KeyProtectionLevel.UNRECOGNIZED;
  }
}
function keyProtectionLevelToJSON(object) {
  switch (object) {
    case KeyProtectionLevel.SOFTWARE:
      return "SOFTWARE";
    case KeyProtectionLevel.HSM:
      return "HSM";
    case KeyProtectionLevel.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
var AccessControlType;
(function (AccessControlType) {
  AccessControlType[AccessControlType["NO_ACCESS_CONTROL"] = 0] = "NO_ACCESS_CONTROL";
  AccessControlType[AccessControlType["TOTP"] = 1] = "TOTP";
  AccessControlType[AccessControlType["SECRET"] = 2] = "SECRET";
  AccessControlType[AccessControlType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AccessControlType || (AccessControlType = {}));
function accessControlTypeFromJSON(object) {
  switch (object) {
    case 0:
    case "NO_ACCESS_CONTROL":
      return AccessControlType.NO_ACCESS_CONTROL;
    case 1:
    case "TOTP":
      return AccessControlType.TOTP;
    case 2:
    case "SECRET":
      return AccessControlType.SECRET;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AccessControlType.UNRECOGNIZED;
  }
}
function accessControlTypeToJSON(object) {
  switch (object) {
    case AccessControlType.NO_ACCESS_CONTROL:
      return "NO_ACCESS_CONTROL";
    case AccessControlType.TOTP:
      return "TOTP";
    case AccessControlType.SECRET:
      return "SECRET";
    case AccessControlType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
var CertificateType;
(function (CertificateType) {
  CertificateType[CertificateType["PEM"] = 0] = "PEM";
  CertificateType[CertificateType["PFX"] = 1] = "PFX";
  CertificateType[CertificateType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CertificateType || (CertificateType = {}));
function certificateTypeFromJSON(object) {
  switch (object) {
    case 0:
    case "PEM":
      return CertificateType.PEM;
    case 1:
    case "PFX":
      return CertificateType.PFX;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CertificateType.UNRECOGNIZED;
  }
}
function certificateTypeToJSON(object) {
  switch (object) {
    case CertificateType.PEM:
      return "PEM";
    case CertificateType.PFX:
      return "PFX";
    case CertificateType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
function createBaseLocalKey() {
  return {
    key: "",
    keyType: 0,
    privateKey: undefined
  };
}
var LocalKey = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.keyType !== 0) {
      writer.uint32(16).int32(message.keyType);
    }
    if (message.privateKey !== undefined) {
      writer.uint32(26).string(message.privateKey);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseLocalKey();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.key = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }
          message.keyType = reader.int32();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.privateKey = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      keyType: isSet(object.keyType) ? keyTypeFromJSON(object.keyType) : 0,
      privateKey: isSet(object.privateKey) ? globalThis.String(object.privateKey) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.keyType !== 0) {
      obj.keyType = keyTypeToJSON(message.keyType);
    }
    if (message.privateKey !== undefined) {
      obj.privateKey = message.privateKey;
    }
    return obj;
  },
  create: function create(base) {
    return LocalKey.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$key, _object$keyType, _object$privateKey;
    var message = createBaseLocalKey();
    message.key = (_object$key = object.key) != null ? _object$key : "";
    message.keyType = (_object$keyType = object.keyType) != null ? _object$keyType : 0;
    message.privateKey = (_object$privateKey = object.privateKey) != null ? _object$privateKey : undefined;
    return message;
  }
};
function createBaseManagedKeyParams() {
  return {
    protection: 0,
    keyType: 0,
    name: undefined,
    expiration: undefined
  };
}
var ManagedKeyParams = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.protection !== 0) {
      writer.uint32(8).int32(message.protection);
    }
    if (message.keyType !== 0) {
      writer.uint32(16).int32(message.keyType);
    }
    if (message.name !== undefined) {
      writer.uint32(26).string(message.name);
    }
    if (message.expiration !== undefined) {
      writer.uint32(32).int64(message.expiration);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseManagedKeyParams();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }
          message.protection = reader.int32();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }
          message.keyType = reader.int32();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.name = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }
          message.expiration = longToNumber(reader.int64());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      protection: isSet(object.protection) ? keyProtectionLevelFromJSON(object.protection) : 0,
      keyType: isSet(object.keyType) ? keyTypeFromJSON(object.keyType) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      expiration: isSet(object.expiration) ? globalThis.Number(object.expiration) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.protection !== 0) {
      obj.protection = keyProtectionLevelToJSON(message.protection);
    }
    if (message.keyType !== 0) {
      obj.keyType = keyTypeToJSON(message.keyType);
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.expiration !== undefined) {
      obj.expiration = Math.round(message.expiration);
    }
    return obj;
  },
  create: function create(base) {
    return ManagedKeyParams.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$protection, _object$keyType2, _object$name, _object$expiration;
    var message = createBaseManagedKeyParams();
    message.protection = (_object$protection = object.protection) != null ? _object$protection : 0;
    message.keyType = (_object$keyType2 = object.keyType) != null ? _object$keyType2 : 0;
    message.name = (_object$name = object.name) != null ? _object$name : undefined;
    message.expiration = (_object$expiration = object.expiration) != null ? _object$expiration : undefined;
    return message;
  }
};
function createBaseManagedKey() {
  return {
    id: "",
    key: "",
    protection: 0,
    keyType: 0,
    name: "",
    expiration: 0,
    accessControlType: 0
  };
}
var ManagedKey = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.key !== "") {
      writer.uint32(18).string(message.key);
    }
    if (message.protection !== 0) {
      writer.uint32(24).int32(message.protection);
    }
    if (message.keyType !== 0) {
      writer.uint32(32).int32(message.keyType);
    }
    if (message.name !== "") {
      writer.uint32(42).string(message.name);
    }
    if (message.expiration !== 0) {
      writer.uint32(48).int64(message.expiration);
    }
    if (message.accessControlType !== 0) {
      writer.uint32(56).int32(message.accessControlType);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseManagedKey();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.key = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }
          message.protection = reader.int32();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }
          message.keyType = reader.int32();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }
          message.name = reader.string();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }
          message.expiration = longToNumber(reader.int64());
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }
          message.accessControlType = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      protection: isSet(object.protection) ? keyProtectionLevelFromJSON(object.protection) : 0,
      keyType: isSet(object.keyType) ? keyTypeFromJSON(object.keyType) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      expiration: isSet(object.expiration) ? globalThis.Number(object.expiration) : 0,
      accessControlType: isSet(object.accessControlType) ? accessControlTypeFromJSON(object.accessControlType) : 0
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.protection !== 0) {
      obj.protection = keyProtectionLevelToJSON(message.protection);
    }
    if (message.keyType !== 0) {
      obj.keyType = keyTypeToJSON(message.keyType);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.expiration !== 0) {
      obj.expiration = Math.round(message.expiration);
    }
    if (message.accessControlType !== 0) {
      obj.accessControlType = accessControlTypeToJSON(message.accessControlType);
    }
    return obj;
  },
  create: function create(base) {
    return ManagedKey.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$id, _object$key2, _object$protection2, _object$keyType3, _object$name2, _object$expiration2, _object$accessControl;
    var message = createBaseManagedKey();
    message.id = (_object$id = object.id) != null ? _object$id : "";
    message.key = (_object$key2 = object.key) != null ? _object$key2 : "";
    message.protection = (_object$protection2 = object.protection) != null ? _object$protection2 : 0;
    message.keyType = (_object$keyType3 = object.keyType) != null ? _object$keyType3 : 0;
    message.name = (_object$name2 = object.name) != null ? _object$name2 : "";
    message.expiration = (_object$expiration2 = object.expiration) != null ? _object$expiration2 : 0;
    message.accessControlType = (_object$accessControl = object.accessControlType) != null ? _object$accessControl : 0;
    return message;
  }
};
function createBaseCertificateSubject() {
  return {
    commonName: "",
    organizationalUnit: undefined,
    organization: undefined,
    location: undefined,
    state: undefined,
    country: undefined
  };
}
var CertificateSubject = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.commonName !== "") {
      writer.uint32(10).string(message.commonName);
    }
    if (message.organizationalUnit !== undefined) {
      writer.uint32(18).string(message.organizationalUnit);
    }
    if (message.organization !== undefined) {
      writer.uint32(26).string(message.organization);
    }
    if (message.location !== undefined) {
      writer.uint32(34).string(message.location);
    }
    if (message.state !== undefined) {
      writer.uint32(42).string(message.state);
    }
    if (message.country !== undefined) {
      writer.uint32(50).string(message.country);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseCertificateSubject();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.commonName = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.organizationalUnit = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.organization = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }
          message.location = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }
          message.state = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }
          message.country = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      commonName: isSet(object.commonName) ? globalThis.String(object.commonName) : "",
      organizationalUnit: isSet(object.organizationalUnit) ? globalThis.String(object.organizationalUnit) : undefined,
      organization: isSet(object.organization) ? globalThis.String(object.organization) : undefined,
      location: isSet(object.location) ? globalThis.String(object.location) : undefined,
      state: isSet(object.state) ? globalThis.String(object.state) : undefined,
      country: isSet(object.country) ? globalThis.String(object.country) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.commonName !== "") {
      obj.commonName = message.commonName;
    }
    if (message.organizationalUnit !== undefined) {
      obj.organizationalUnit = message.organizationalUnit;
    }
    if (message.organization !== undefined) {
      obj.organization = message.organization;
    }
    if (message.location !== undefined) {
      obj.location = message.location;
    }
    if (message.state !== undefined) {
      obj.state = message.state;
    }
    if (message.country !== undefined) {
      obj.country = message.country;
    }
    return obj;
  },
  create: function create(base) {
    return CertificateSubject.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$commonName, _object$organizationa, _object$organization, _object$location, _object$state, _object$country;
    var message = createBaseCertificateSubject();
    message.commonName = (_object$commonName = object.commonName) != null ? _object$commonName : "";
    message.organizationalUnit = (_object$organizationa = object.organizationalUnit) != null ? _object$organizationa : undefined;
    message.organization = (_object$organization = object.organization) != null ? _object$organization : undefined;
    message.location = (_object$location = object.location) != null ? _object$location : undefined;
    message.state = (_object$state = object.state) != null ? _object$state : undefined;
    message.country = (_object$country = object.country) != null ? _object$country : undefined;
    return message;
  }
};
function createBaseLocalCertificateParams() {
  return {
    keyType: 0,
    password: "",
    subject: undefined,
    expiration: 0
  };
}
var LocalCertificateParams = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.keyType !== 0) {
      writer.uint32(8).int32(message.keyType);
    }
    if (message.password !== "") {
      writer.uint32(18).string(message.password);
    }
    if (message.subject !== undefined) {
      CertificateSubject.encode(message.subject, writer.uint32(26).fork()).ldelim();
    }
    if (message.expiration !== 0) {
      writer.uint32(32).int32(message.expiration);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseLocalCertificateParams();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }
          message.keyType = reader.int32();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.password = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.subject = CertificateSubject.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }
          message.expiration = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      keyType: isSet(object.keyType) ? keyTypeFromJSON(object.keyType) : 0,
      password: isSet(object.password) ? globalThis.String(object.password) : "",
      subject: isSet(object.subject) ? CertificateSubject.fromJSON(object.subject) : undefined,
      expiration: isSet(object.expiration) ? globalThis.Number(object.expiration) : 0
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.keyType !== 0) {
      obj.keyType = keyTypeToJSON(message.keyType);
    }
    if (message.password !== "") {
      obj.password = message.password;
    }
    if (message.subject !== undefined) {
      obj.subject = CertificateSubject.toJSON(message.subject);
    }
    if (message.expiration !== 0) {
      obj.expiration = Math.round(message.expiration);
    }
    return obj;
  },
  create: function create(base) {
    return LocalCertificateParams.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$keyType4, _object$password, _object$expiration3;
    var message = createBaseLocalCertificateParams();
    message.keyType = (_object$keyType4 = object.keyType) != null ? _object$keyType4 : 0;
    message.password = (_object$password = object.password) != null ? _object$password : "";
    message.subject = object.subject !== undefined && object.subject !== null ? CertificateSubject.fromPartial(object.subject) : undefined;
    message.expiration = (_object$expiration3 = object.expiration) != null ? _object$expiration3 : 0;
    return message;
  }
};
function createBaseLocalCertificate() {
  return {
    pkcs12: new Uint8Array(0),
    password: ""
  };
}
var LocalCertificate = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.pkcs12.length !== 0) {
      writer.uint32(10).bytes(message.pkcs12);
    }
    if (message.password !== "") {
      writer.uint32(18).string(message.password);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseLocalCertificate();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.pkcs12 = reader.bytes();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.password = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      pkcs12: isSet(object.pkcs12) ? bytesFromBase64(object.pkcs12) : new Uint8Array(0),
      password: isSet(object.password) ? globalThis.String(object.password) : ""
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.pkcs12.length !== 0) {
      obj.pkcs12 = base64FromBytes(message.pkcs12);
    }
    if (message.password !== "") {
      obj.password = message.password;
    }
    return obj;
  },
  create: function create(base) {
    return LocalCertificate.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$pkcs, _object$password2;
    var message = createBaseLocalCertificate();
    message.pkcs12 = (_object$pkcs = object.pkcs12) != null ? _object$pkcs : new Uint8Array(0);
    message.password = (_object$password2 = object.password) != null ? _object$password2 : "";
    return message;
  }
};
function createBaseManagedCertificateParams() {
  return {
    keyType: 0,
    expiration: 0,
    subject: undefined
  };
}
var ManagedCertificateParams = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.keyType !== 0) {
      writer.uint32(8).int32(message.keyType);
    }
    if (message.expiration !== 0) {
      writer.uint32(16).int32(message.expiration);
    }
    if (message.subject !== undefined) {
      CertificateSubject.encode(message.subject, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseManagedCertificateParams();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }
          message.keyType = reader.int32();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }
          message.expiration = reader.int32();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.subject = CertificateSubject.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      keyType: isSet(object.keyType) ? keyTypeFromJSON(object.keyType) : 0,
      expiration: isSet(object.expiration) ? globalThis.Number(object.expiration) : 0,
      subject: isSet(object.subject) ? CertificateSubject.fromJSON(object.subject) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.keyType !== 0) {
      obj.keyType = keyTypeToJSON(message.keyType);
    }
    if (message.expiration !== 0) {
      obj.expiration = Math.round(message.expiration);
    }
    if (message.subject !== undefined) {
      obj.subject = CertificateSubject.toJSON(message.subject);
    }
    return obj;
  },
  create: function create(base) {
    return ManagedCertificateParams.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$keyType5, _object$expiration4;
    var message = createBaseManagedCertificateParams();
    message.keyType = (_object$keyType5 = object.keyType) != null ? _object$keyType5 : 0;
    message.expiration = (_object$expiration4 = object.expiration) != null ? _object$expiration4 : 0;
    message.subject = object.subject !== undefined && object.subject !== null ? CertificateSubject.fromPartial(object.subject) : undefined;
    return message;
  }
};
function createBaseManagedCertificate() {
  return {
    id: "",
    key: "",
    protection: 0,
    keyType: 0,
    expiration: 0,
    accessControlType: 0
  };
}
var ManagedCertificate = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.key !== "") {
      writer.uint32(18).string(message.key);
    }
    if (message.protection !== 0) {
      writer.uint32(24).int32(message.protection);
    }
    if (message.keyType !== 0) {
      writer.uint32(32).int32(message.keyType);
    }
    if (message.expiration !== 0) {
      writer.uint32(48).int64(message.expiration);
    }
    if (message.accessControlType !== 0) {
      writer.uint32(56).int32(message.accessControlType);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseManagedCertificate();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.key = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }
          message.protection = reader.int32();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }
          message.keyType = reader.int32();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }
          message.expiration = longToNumber(reader.int64());
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }
          message.accessControlType = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      protection: isSet(object.protection) ? keyProtectionLevelFromJSON(object.protection) : 0,
      keyType: isSet(object.keyType) ? keyTypeFromJSON(object.keyType) : 0,
      expiration: isSet(object.expiration) ? globalThis.Number(object.expiration) : 0,
      accessControlType: isSet(object.accessControlType) ? accessControlTypeFromJSON(object.accessControlType) : 0
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.protection !== 0) {
      obj.protection = keyProtectionLevelToJSON(message.protection);
    }
    if (message.keyType !== 0) {
      obj.keyType = keyTypeToJSON(message.keyType);
    }
    if (message.expiration !== 0) {
      obj.expiration = Math.round(message.expiration);
    }
    if (message.accessControlType !== 0) {
      obj.accessControlType = accessControlTypeToJSON(message.accessControlType);
    }
    return obj;
  },
  create: function create(base) {
    return ManagedCertificate.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$id2, _object$key3, _object$protection3, _object$keyType6, _object$expiration5, _object$accessControl2;
    var message = createBaseManagedCertificate();
    message.id = (_object$id2 = object.id) != null ? _object$id2 : "";
    message.key = (_object$key3 = object.key) != null ? _object$key3 : "";
    message.protection = (_object$protection3 = object.protection) != null ? _object$protection3 : 0;
    message.keyType = (_object$keyType6 = object.keyType) != null ? _object$keyType6 : 0;
    message.expiration = (_object$expiration5 = object.expiration) != null ? _object$expiration5 : 0;
    message.accessControlType = (_object$accessControl2 = object.accessControlType) != null ? _object$accessControl2 : 0;
    return message;
  }
};
function createBaseAccessControl() {
  return {
    accessControlTotp: undefined,
    accessControlSecret: undefined
  };
}
var AccessControl = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.accessControlTotp !== undefined) {
      AccessControlTotp.encode(message.accessControlTotp, writer.uint32(10).fork()).ldelim();
    }
    if (message.accessControlSecret !== undefined) {
      AccessControlSecret.encode(message.accessControlSecret, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseAccessControl();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.accessControlTotp = AccessControlTotp.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.accessControlSecret = AccessControlSecret.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      accessControlTotp: isSet(object.accessControlTotp) ? AccessControlTotp.fromJSON(object.accessControlTotp) : undefined,
      accessControlSecret: isSet(object.accessControlSecret) ? AccessControlSecret.fromJSON(object.accessControlSecret) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.accessControlTotp !== undefined) {
      obj.accessControlTotp = AccessControlTotp.toJSON(message.accessControlTotp);
    }
    if (message.accessControlSecret !== undefined) {
      obj.accessControlSecret = AccessControlSecret.toJSON(message.accessControlSecret);
    }
    return obj;
  },
  create: function create(base) {
    return AccessControl.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseAccessControl();
    message.accessControlTotp = object.accessControlTotp !== undefined && object.accessControlTotp !== null ? AccessControlTotp.fromPartial(object.accessControlTotp) : undefined;
    message.accessControlSecret = object.accessControlSecret !== undefined && object.accessControlSecret !== null ? AccessControlSecret.fromPartial(object.accessControlSecret) : undefined;
    return message;
  }
};
function createBaseAccessControlTotp() {
  return {
    code: ""
  };
}
var AccessControlTotp = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.code !== "") {
      writer.uint32(10).string(message.code);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseAccessControlTotp();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.code = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      code: isSet(object.code) ? globalThis.String(object.code) : ""
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.code !== "") {
      obj.code = message.code;
    }
    return obj;
  },
  create: function create(base) {
    return AccessControlTotp.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$code;
    var message = createBaseAccessControlTotp();
    message.code = (_object$code = object.code) != null ? _object$code : "";
    return message;
  }
};
function createBaseAccessControlSecret() {
  return {
    secret: ""
  };
}
var AccessControlSecret = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.secret !== "") {
      writer.uint32(10).string(message.secret);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseAccessControlSecret();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.secret = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      secret: isSet(object.secret) ? globalThis.String(object.secret) : ""
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.secret !== "") {
      obj.secret = message.secret;
    }
    return obj;
  },
  create: function create(base) {
    return AccessControlSecret.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$secret;
    var message = createBaseAccessControlSecret();
    message.secret = (_object$secret = object.secret) != null ? _object$secret : "";
    return message;
  }
};
function createBaseKey() {
  return {
    localKey: undefined,
    managedKey: undefined
  };
}
var Key = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.localKey !== undefined) {
      LocalKey.encode(message.localKey, writer.uint32(10).fork()).ldelim();
    }
    if (message.managedKey !== undefined) {
      ManagedKey.encode(message.managedKey, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseKey();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.localKey = LocalKey.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.managedKey = ManagedKey.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      localKey: isSet(object.localKey) ? LocalKey.fromJSON(object.localKey) : undefined,
      managedKey: isSet(object.managedKey) ? ManagedKey.fromJSON(object.managedKey) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.localKey !== undefined) {
      obj.localKey = LocalKey.toJSON(message.localKey);
    }
    if (message.managedKey !== undefined) {
      obj.managedKey = ManagedKey.toJSON(message.managedKey);
    }
    return obj;
  },
  create: function create(base) {
    return Key.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseKey();
    message.localKey = object.localKey !== undefined && object.localKey !== null ? LocalKey.fromPartial(object.localKey) : undefined;
    message.managedKey = object.managedKey !== undefined && object.managedKey !== null ? ManagedKey.fromPartial(object.managedKey) : undefined;
    return message;
  }
};
function bytesFromBase64(b64) {
  if (globalThis.Buffer) {
    return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
  } else {
    var bin = globalThis.atob(b64);
    var arr = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}
function base64FromBytes(arr) {
  if (globalThis.Buffer) {
    return globalThis.Buffer.from(arr).toString("base64");
  } else {
    var bin = [];
    arr.forEach(function (_byte) {
      bin.push(globalThis.String.fromCharCode(_byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}
function longToNumber(_long) {
  if (_long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return _long.toNumber();
}
if (_m0.util.Long !== Long) {
  _m0.util.Long = Long;
  _m0.configure();
}
function isSet(value) {
  return value !== null && value !== undefined;
}

/* eslint-disable */
var HashAlg;
(function (HashAlg) {
  HashAlg[HashAlg["SHA_256"] = 0] = "SHA_256";
  HashAlg[HashAlg["KECCAK_256"] = 1] = "KECCAK_256";
  HashAlg[HashAlg["POSEIDON"] = 2] = "POSEIDON";
  HashAlg[HashAlg["NONE"] = 3] = "NONE";
  HashAlg[HashAlg["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(HashAlg || (HashAlg = {}));
function hashAlgFromJSON(object) {
  switch (object) {
    case 0:
    case "SHA_256":
      return HashAlg.SHA_256;
    case 1:
    case "KECCAK_256":
      return HashAlg.KECCAK_256;
    case 2:
    case "POSEIDON":
      return HashAlg.POSEIDON;
    case 3:
    case "NONE":
      return HashAlg.NONE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return HashAlg.UNRECOGNIZED;
  }
}
function hashAlgToJSON(object) {
  switch (object) {
    case HashAlg.SHA_256:
      return "SHA_256";
    case HashAlg.KECCAK_256:
      return "KECCAK_256";
    case HashAlg.POSEIDON:
      return "POSEIDON";
    case HashAlg.NONE:
      return "NONE";
    case HashAlg.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
function createBaseSigner() {
  return {
    localKey: undefined,
    managedKey: undefined,
    localCertificate: undefined,
    managedCertificate: undefined,
    hashAlg: undefined,
    accessControl: undefined
  };
}
var Signer = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.localKey !== undefined) {
      LocalKey.encode(message.localKey, writer.uint32(10).fork()).ldelim();
    }
    if (message.managedKey !== undefined) {
      ManagedKey.encode(message.managedKey, writer.uint32(18).fork()).ldelim();
    }
    if (message.localCertificate !== undefined) {
      LocalCertificate.encode(message.localCertificate, writer.uint32(26).fork()).ldelim();
    }
    if (message.managedCertificate !== undefined) {
      ManagedCertificate.encode(message.managedCertificate, writer.uint32(34).fork()).ldelim();
    }
    if (message.hashAlg !== undefined) {
      writer.uint32(40).int32(message.hashAlg);
    }
    if (message.accessControl !== undefined) {
      AccessControl.encode(message.accessControl, writer.uint32(50).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseSigner();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.localKey = LocalKey.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.managedKey = ManagedKey.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.localCertificate = LocalCertificate.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }
          message.managedCertificate = ManagedCertificate.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }
          message.hashAlg = reader.int32();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }
          message.accessControl = AccessControl.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      localKey: isSet$1(object.localKey) ? LocalKey.fromJSON(object.localKey) : undefined,
      managedKey: isSet$1(object.managedKey) ? ManagedKey.fromJSON(object.managedKey) : undefined,
      localCertificate: isSet$1(object.localCertificate) ? LocalCertificate.fromJSON(object.localCertificate) : undefined,
      managedCertificate: isSet$1(object.managedCertificate) ? ManagedCertificate.fromJSON(object.managedCertificate) : undefined,
      hashAlg: isSet$1(object.hashAlg) ? hashAlgFromJSON(object.hashAlg) : undefined,
      accessControl: isSet$1(object.accessControl) ? AccessControl.fromJSON(object.accessControl) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.localKey !== undefined) {
      obj.localKey = LocalKey.toJSON(message.localKey);
    }
    if (message.managedKey !== undefined) {
      obj.managedKey = ManagedKey.toJSON(message.managedKey);
    }
    if (message.localCertificate !== undefined) {
      obj.localCertificate = LocalCertificate.toJSON(message.localCertificate);
    }
    if (message.managedCertificate !== undefined) {
      obj.managedCertificate = ManagedCertificate.toJSON(message.managedCertificate);
    }
    if (message.hashAlg !== undefined) {
      obj.hashAlg = hashAlgToJSON(message.hashAlg);
    }
    if (message.accessControl !== undefined) {
      obj.accessControl = AccessControl.toJSON(message.accessControl);
    }
    return obj;
  },
  create: function create(base) {
    return Signer.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$hashAlg;
    var message = createBaseSigner();
    message.localKey = object.localKey !== undefined && object.localKey !== null ? LocalKey.fromPartial(object.localKey) : undefined;
    message.managedKey = object.managedKey !== undefined && object.managedKey !== null ? ManagedKey.fromPartial(object.managedKey) : undefined;
    message.localCertificate = object.localCertificate !== undefined && object.localCertificate !== null ? LocalCertificate.fromPartial(object.localCertificate) : undefined;
    message.managedCertificate = object.managedCertificate !== undefined && object.managedCertificate !== null ? ManagedCertificate.fromPartial(object.managedCertificate) : undefined;
    message.hashAlg = (_object$hashAlg = object.hashAlg) != null ? _object$hashAlg : undefined;
    message.accessControl = object.accessControl !== undefined && object.accessControl !== null ? AccessControl.fromPartial(object.accessControl) : undefined;
    return message;
  }
};
function createBaseSignature() {
  return {
    signature: "",
    alg: "",
    kid: "",
    messageHash: "",
    subject: undefined,
    hashAlg: undefined
  };
}
var Signature = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.signature !== "") {
      writer.uint32(10).string(message.signature);
    }
    if (message.alg !== "") {
      writer.uint32(18).string(message.alg);
    }
    if (message.kid !== "") {
      writer.uint32(26).string(message.kid);
    }
    if (message.messageHash !== "") {
      writer.uint32(34).string(message.messageHash);
    }
    if (message.subject !== undefined) {
      writer.uint32(42).string(message.subject);
    }
    if (message.hashAlg !== undefined) {
      writer.uint32(50).string(message.hashAlg);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseSignature();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.signature = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.alg = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.kid = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }
          message.messageHash = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }
          message.subject = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }
          message.hashAlg = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      signature: isSet$1(object.signature) ? globalThis.String(object.signature) : "",
      alg: isSet$1(object.alg) ? globalThis.String(object.alg) : "",
      kid: isSet$1(object.kid) ? globalThis.String(object.kid) : "",
      messageHash: isSet$1(object.messageHash) ? globalThis.String(object.messageHash) : "",
      subject: isSet$1(object.subject) ? globalThis.String(object.subject) : undefined,
      hashAlg: isSet$1(object.hashAlg) ? globalThis.String(object.hashAlg) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.signature !== "") {
      obj.signature = message.signature;
    }
    if (message.alg !== "") {
      obj.alg = message.alg;
    }
    if (message.kid !== "") {
      obj.kid = message.kid;
    }
    if (message.messageHash !== "") {
      obj.messageHash = message.messageHash;
    }
    if (message.subject !== undefined) {
      obj.subject = message.subject;
    }
    if (message.hashAlg !== undefined) {
      obj.hashAlg = message.hashAlg;
    }
    return obj;
  },
  create: function create(base) {
    return Signature.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$signature, _object$alg, _object$kid, _object$messageHash, _object$subject, _object$hashAlg2;
    var message = createBaseSignature();
    message.signature = (_object$signature = object.signature) != null ? _object$signature : "";
    message.alg = (_object$alg = object.alg) != null ? _object$alg : "";
    message.kid = (_object$kid = object.kid) != null ? _object$kid : "";
    message.messageHash = (_object$messageHash = object.messageHash) != null ? _object$messageHash : "";
    message.subject = (_object$subject = object.subject) != null ? _object$subject : undefined;
    message.hashAlg = (_object$hashAlg2 = object.hashAlg) != null ? _object$hashAlg2 : undefined;
    return message;
  }
};
function isSet$1(value) {
  return value !== null && value !== undefined;
}

/* eslint-disable */
var Network;
(function (Network) {
  Network[Network["ETHEREUM_MAINNET"] = 0] = "ETHEREUM_MAINNET";
  Network[Network["ETHEREUM_SEPOLIA"] = 1] = "ETHEREUM_SEPOLIA";
  Network[Network["GNOSIS_CHAIN"] = 2] = "GNOSIS_CHAIN";
  Network[Network["POLYGON_CHAIN"] = 3] = "POLYGON_CHAIN";
  Network[Network["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Network || (Network = {}));
function networkFromJSON(object) {
  switch (object) {
    case 0:
    case "ETHEREUM_MAINNET":
      return Network.ETHEREUM_MAINNET;
    case 1:
    case "ETHEREUM_SEPOLIA":
      return Network.ETHEREUM_SEPOLIA;
    case 2:
    case "GNOSIS_CHAIN":
      return Network.GNOSIS_CHAIN;
    case 3:
    case "POLYGON_CHAIN":
      return Network.POLYGON_CHAIN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Network.UNRECOGNIZED;
  }
}
function networkToJSON(object) {
  switch (object) {
    case Network.ETHEREUM_MAINNET:
      return "ETHEREUM_MAINNET";
    case Network.ETHEREUM_SEPOLIA:
      return "ETHEREUM_SEPOLIA";
    case Network.GNOSIS_CHAIN:
      return "GNOSIS_CHAIN";
    case Network.POLYGON_CHAIN:
      return "POLYGON_CHAIN";
    case Network.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
function createBaseConfigData() {
  return {
    config: undefined,
    networksConfig: {}
  };
}
var ConfigData = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.config !== undefined) {
      Configuration.encode(message.config, writer.uint32(10).fork()).ldelim();
    }
    Object.entries(message.networksConfig).forEach(function (_ref) {
      var key = _ref[0],
        value = _ref[1];
      ConfigData_NetworksConfigEntry.encode({
        key: key,
        value: value
      }, writer.uint32(18).fork()).ldelim();
    });
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseConfigData();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.config = Configuration.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          var entry2 = ConfigData_NetworksConfigEntry.decode(reader, reader.uint32());
          if (entry2.value !== undefined) {
            message.networksConfig[entry2.key] = entry2.value;
          }
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      config: isSet$2(object.config) ? Configuration.fromJSON(object.config) : undefined,
      networksConfig: isObject(object.networksConfig) ? Object.entries(object.networksConfig).reduce(function (acc, _ref2) {
        var key = _ref2[0],
          value = _ref2[1];
        acc[globalThis.Number(key)] = NetworkConfig.fromJSON(value);
        return acc;
      }, {}) : {}
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.config !== undefined) {
      obj.config = Configuration.toJSON(message.config);
    }
    if (message.networksConfig) {
      var entries = Object.entries(message.networksConfig);
      if (entries.length > 0) {
        obj.networksConfig = {};
        entries.forEach(function (_ref3) {
          var k = _ref3[0],
            v = _ref3[1];
          obj.networksConfig[k] = NetworkConfig.toJSON(v);
        });
      }
    }
    return obj;
  },
  create: function create(base) {
    return ConfigData.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$networksConfi;
    var message = createBaseConfigData();
    message.config = object.config !== undefined && object.config !== null ? Configuration.fromPartial(object.config) : undefined;
    message.networksConfig = Object.entries((_object$networksConfi = object.networksConfig) != null ? _object$networksConfi : {}).reduce(function (acc, _ref4) {
      var key = _ref4[0],
        value = _ref4[1];
      if (value !== undefined) {
        acc[globalThis.Number(key)] = NetworkConfig.fromPartial(value);
      }
      return acc;
    }, {});
    return message;
  }
};
function createBaseConfigData_NetworksConfigEntry() {
  return {
    key: 0,
    value: undefined
  };
}
var ConfigData_NetworksConfigEntry = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.key !== 0) {
      writer.uint32(8).int32(message.key);
    }
    if (message.value !== undefined) {
      NetworkConfig.encode(message.value, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseConfigData_NetworksConfigEntry();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }
          message.key = reader.int32();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.value = NetworkConfig.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      key: isSet$2(object.key) ? globalThis.Number(object.key) : 0,
      value: isSet$2(object.value) ? NetworkConfig.fromJSON(object.value) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.key !== 0) {
      obj.key = Math.round(message.key);
    }
    if (message.value !== undefined) {
      obj.value = NetworkConfig.toJSON(message.value);
    }
    return obj;
  },
  create: function create(base) {
    return ConfigData_NetworksConfigEntry.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$key;
    var message = createBaseConfigData_NetworksConfigEntry();
    message.key = (_object$key = object.key) != null ? _object$key : 0;
    message.value = object.value !== undefined && object.value !== null ? NetworkConfig.fromPartial(object.value) : undefined;
    return message;
  }
};
function createBaseConfiguration() {
  return {
    libraryName: "",
    host: "",
    apiKey: "",
    waitMessageIntervalFactor: 0,
    waitMessageIntervalDefault: 0,
    keyTypeAlgorithm: "",
    ellipticCurveKey: "",
    signatureAlgorithm: "",
    identityApiHost: undefined
  };
}
var Configuration = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.libraryName !== "") {
      writer.uint32(10).string(message.libraryName);
    }
    if (message.host !== "") {
      writer.uint32(18).string(message.host);
    }
    if (message.apiKey !== "") {
      writer.uint32(26).string(message.apiKey);
    }
    if (message.waitMessageIntervalFactor !== 0) {
      writer.uint32(32).int32(message.waitMessageIntervalFactor);
    }
    if (message.waitMessageIntervalDefault !== 0) {
      writer.uint32(40).int32(message.waitMessageIntervalDefault);
    }
    if (message.keyTypeAlgorithm !== "") {
      writer.uint32(50).string(message.keyTypeAlgorithm);
    }
    if (message.ellipticCurveKey !== "") {
      writer.uint32(58).string(message.ellipticCurveKey);
    }
    if (message.signatureAlgorithm !== "") {
      writer.uint32(66).string(message.signatureAlgorithm);
    }
    if (message.identityApiHost !== undefined) {
      writer.uint32(74).string(message.identityApiHost);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseConfiguration();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.libraryName = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.host = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.apiKey = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }
          message.waitMessageIntervalFactor = reader.int32();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }
          message.waitMessageIntervalDefault = reader.int32();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }
          message.keyTypeAlgorithm = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }
          message.ellipticCurveKey = reader.string();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }
          message.signatureAlgorithm = reader.string();
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }
          message.identityApiHost = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      libraryName: isSet$2(object.libraryName) ? globalThis.String(object.libraryName) : "",
      host: isSet$2(object.host) ? globalThis.String(object.host) : "",
      apiKey: isSet$2(object.apiKey) ? globalThis.String(object.apiKey) : "",
      waitMessageIntervalFactor: isSet$2(object.waitMessageIntervalFactor) ? globalThis.Number(object.waitMessageIntervalFactor) : 0,
      waitMessageIntervalDefault: isSet$2(object.waitMessageIntervalDefault) ? globalThis.Number(object.waitMessageIntervalDefault) : 0,
      keyTypeAlgorithm: isSet$2(object.keyTypeAlgorithm) ? globalThis.String(object.keyTypeAlgorithm) : "",
      ellipticCurveKey: isSet$2(object.ellipticCurveKey) ? globalThis.String(object.ellipticCurveKey) : "",
      signatureAlgorithm: isSet$2(object.signatureAlgorithm) ? globalThis.String(object.signatureAlgorithm) : "",
      identityApiHost: isSet$2(object.identityApiHost) ? globalThis.String(object.identityApiHost) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.libraryName !== "") {
      obj.libraryName = message.libraryName;
    }
    if (message.host !== "") {
      obj.host = message.host;
    }
    if (message.apiKey !== "") {
      obj.apiKey = message.apiKey;
    }
    if (message.waitMessageIntervalFactor !== 0) {
      obj.waitMessageIntervalFactor = Math.round(message.waitMessageIntervalFactor);
    }
    if (message.waitMessageIntervalDefault !== 0) {
      obj.waitMessageIntervalDefault = Math.round(message.waitMessageIntervalDefault);
    }
    if (message.keyTypeAlgorithm !== "") {
      obj.keyTypeAlgorithm = message.keyTypeAlgorithm;
    }
    if (message.ellipticCurveKey !== "") {
      obj.ellipticCurveKey = message.ellipticCurveKey;
    }
    if (message.signatureAlgorithm !== "") {
      obj.signatureAlgorithm = message.signatureAlgorithm;
    }
    if (message.identityApiHost !== undefined) {
      obj.identityApiHost = message.identityApiHost;
    }
    return obj;
  },
  create: function create(base) {
    return Configuration.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$libraryName, _object$host, _object$apiKey, _object$waitMessageIn, _object$waitMessageIn2, _object$keyTypeAlgori, _object$ellipticCurve, _object$signatureAlgo, _object$identityApiHo;
    var message = createBaseConfiguration();
    message.libraryName = (_object$libraryName = object.libraryName) != null ? _object$libraryName : "";
    message.host = (_object$host = object.host) != null ? _object$host : "";
    message.apiKey = (_object$apiKey = object.apiKey) != null ? _object$apiKey : "";
    message.waitMessageIntervalFactor = (_object$waitMessageIn = object.waitMessageIntervalFactor) != null ? _object$waitMessageIn : 0;
    message.waitMessageIntervalDefault = (_object$waitMessageIn2 = object.waitMessageIntervalDefault) != null ? _object$waitMessageIn2 : 0;
    message.keyTypeAlgorithm = (_object$keyTypeAlgori = object.keyTypeAlgorithm) != null ? _object$keyTypeAlgori : "";
    message.ellipticCurveKey = (_object$ellipticCurve = object.ellipticCurveKey) != null ? _object$ellipticCurve : "";
    message.signatureAlgorithm = (_object$signatureAlgo = object.signatureAlgorithm) != null ? _object$signatureAlgo : "";
    message.identityApiHost = (_object$identityApiHo = object.identityApiHost) != null ? _object$identityApiHo : undefined;
    return message;
  }
};
function createBaseNetworkConfig() {
  return {
    ContractAddress: "",
    ContractAbi: "",
    HttpProvider: ""
  };
}
var NetworkConfig = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.ContractAddress !== "") {
      writer.uint32(10).string(message.ContractAddress);
    }
    if (message.ContractAbi !== "") {
      writer.uint32(18).string(message.ContractAbi);
    }
    if (message.HttpProvider !== "") {
      writer.uint32(26).string(message.HttpProvider);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseNetworkConfig();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.ContractAddress = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.ContractAbi = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.HttpProvider = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      ContractAddress: isSet$2(object.ContractAddress) ? globalThis.String(object.ContractAddress) : "",
      ContractAbi: isSet$2(object.ContractAbi) ? globalThis.String(object.ContractAbi) : "",
      HttpProvider: isSet$2(object.HttpProvider) ? globalThis.String(object.HttpProvider) : ""
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.ContractAddress !== "") {
      obj.ContractAddress = message.ContractAddress;
    }
    if (message.ContractAbi !== "") {
      obj.ContractAbi = message.ContractAbi;
    }
    if (message.HttpProvider !== "") {
      obj.HttpProvider = message.HttpProvider;
    }
    return obj;
  },
  create: function create(base) {
    return NetworkConfig.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$ContractAddre, _object$ContractAbi, _object$HttpProvider;
    var message = createBaseNetworkConfig();
    message.ContractAddress = (_object$ContractAddre = object.ContractAddress) != null ? _object$ContractAddre : "";
    message.ContractAbi = (_object$ContractAbi = object.ContractAbi) != null ? _object$ContractAbi : "";
    message.HttpProvider = (_object$HttpProvider = object.HttpProvider) != null ? _object$HttpProvider : "";
    return message;
  }
};
function isObject(value) {
  return typeof value === "object" && value !== null;
}
function isSet$2(value) {
  return value !== null && value !== undefined;
}

function createBaseAnchor() {
  return {
    id: 0,
    blockRoots: [],
    networks: [],
    root: "",
    status: ""
  };
}
var Anchor = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.id !== 0) {
      writer.uint32(8).int64(message.id);
    }
    for (var _iterator = _createForOfIteratorHelperLoose(message.blockRoots), _step; !(_step = _iterator()).done;) {
      var v = _step.value;
      writer.uint32(18).string(v);
    }
    for (var _iterator2 = _createForOfIteratorHelperLoose(message.networks), _step2; !(_step2 = _iterator2()).done;) {
      var _v = _step2.value;
      AnchorNetwork.encode(_v, writer.uint32(26).fork()).ldelim();
    }
    if (message.root !== "") {
      writer.uint32(34).string(message.root);
    }
    if (message.status !== "") {
      writer.uint32(42).string(message.status);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseAnchor();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }
          message.id = longToNumber$1(reader.int64());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.blockRoots.push(reader.string());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.networks.push(AnchorNetwork.decode(reader, reader.uint32()));
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }
          message.root = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }
          message.status = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      id: isSet$3(object.id) ? globalThis.Number(object.id) : 0,
      blockRoots: globalThis.Array.isArray(object == null ? void 0 : object.blockRoots) ? object.blockRoots.map(function (e) {
        return globalThis.String(e);
      }) : [],
      networks: globalThis.Array.isArray(object == null ? void 0 : object.networks) ? object.networks.map(function (e) {
        return AnchorNetwork.fromJSON(e);
      }) : [],
      root: isSet$3(object.root) ? globalThis.String(object.root) : "",
      status: isSet$3(object.status) ? globalThis.String(object.status) : ""
    };
  },
  toJSON: function toJSON(message) {
    var _message$blockRoots, _message$networks;
    var obj = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if ((_message$blockRoots = message.blockRoots) != null && _message$blockRoots.length) {
      obj.blockRoots = message.blockRoots;
    }
    if ((_message$networks = message.networks) != null && _message$networks.length) {
      obj.networks = message.networks.map(function (e) {
        return AnchorNetwork.toJSON(e);
      });
    }
    if (message.root !== "") {
      obj.root = message.root;
    }
    if (message.status !== "") {
      obj.status = message.status;
    }
    return obj;
  },
  create: function create(base) {
    return Anchor.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$id, _object$blockRoots, _object$networks, _object$root, _object$status;
    var message = createBaseAnchor();
    message.id = (_object$id = object.id) != null ? _object$id : 0;
    message.blockRoots = ((_object$blockRoots = object.blockRoots) == null ? void 0 : _object$blockRoots.map(function (e) {
      return e;
    })) || [];
    message.networks = ((_object$networks = object.networks) == null ? void 0 : _object$networks.map(function (e) {
      return AnchorNetwork.fromPartial(e);
    })) || [];
    message.root = (_object$root = object.root) != null ? _object$root : "";
    message.status = (_object$status = object.status) != null ? _object$status : "";
    return message;
  }
};
function createBaseAnchorNetwork() {
  return {
    name: "",
    state: "",
    txHash: "",
    root: undefined
  };
}
var AnchorNetwork = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.state !== "") {
      writer.uint32(18).string(message.state);
    }
    if (message.txHash !== "") {
      writer.uint32(26).string(message.txHash);
    }
    if (message.root !== undefined) {
      writer.uint32(34).string(message.root);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseAnchorNetwork();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.name = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.state = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.txHash = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }
          message.root = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      name: isSet$3(object.name) ? globalThis.String(object.name) : "",
      state: isSet$3(object.state) ? globalThis.String(object.state) : "",
      txHash: isSet$3(object.txHash) ? globalThis.String(object.txHash) : "",
      root: isSet$3(object.root) ? globalThis.String(object.root) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.state !== "") {
      obj.state = message.state;
    }
    if (message.txHash !== "") {
      obj.txHash = message.txHash;
    }
    if (message.root !== undefined) {
      obj.root = message.root;
    }
    return obj;
  },
  create: function create(base) {
    return AnchorNetwork.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$name, _object$state, _object$txHash, _object$root2;
    var message = createBaseAnchorNetwork();
    message.name = (_object$name = object.name) != null ? _object$name : "";
    message.state = (_object$state = object.state) != null ? _object$state : "";
    message.txHash = (_object$txHash = object.txHash) != null ? _object$txHash : "";
    message.root = (_object$root2 = object.root) != null ? _object$root2 : undefined;
    return message;
  }
};
function createBaseProof() {
  return {
    leaves: [],
    nodes: [],
    depth: "",
    bitmap: "",
    anchor: undefined
  };
}
var Proof = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    for (var _iterator3 = _createForOfIteratorHelperLoose(message.leaves), _step3; !(_step3 = _iterator3()).done;) {
      var v = _step3.value;
      writer.uint32(10).string(v);
    }
    for (var _iterator4 = _createForOfIteratorHelperLoose(message.nodes), _step4; !(_step4 = _iterator4()).done;) {
      var _v2 = _step4.value;
      writer.uint32(18).string(_v2);
    }
    if (message.depth !== "") {
      writer.uint32(26).string(message.depth);
    }
    if (message.bitmap !== "") {
      writer.uint32(34).string(message.bitmap);
    }
    if (message.anchor !== undefined) {
      ProofAnchor.encode(message.anchor, writer.uint32(42).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseProof();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.leaves.push(reader.string());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.nodes.push(reader.string());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.depth = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }
          message.bitmap = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }
          message.anchor = ProofAnchor.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      leaves: globalThis.Array.isArray(object == null ? void 0 : object.leaves) ? object.leaves.map(function (e) {
        return globalThis.String(e);
      }) : [],
      nodes: globalThis.Array.isArray(object == null ? void 0 : object.nodes) ? object.nodes.map(function (e) {
        return globalThis.String(e);
      }) : [],
      depth: isSet$3(object.depth) ? globalThis.String(object.depth) : "",
      bitmap: isSet$3(object.bitmap) ? globalThis.String(object.bitmap) : "",
      anchor: isSet$3(object.anchor) ? ProofAnchor.fromJSON(object.anchor) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var _message$leaves, _message$nodes;
    var obj = {};
    if ((_message$leaves = message.leaves) != null && _message$leaves.length) {
      obj.leaves = message.leaves;
    }
    if ((_message$nodes = message.nodes) != null && _message$nodes.length) {
      obj.nodes = message.nodes;
    }
    if (message.depth !== "") {
      obj.depth = message.depth;
    }
    if (message.bitmap !== "") {
      obj.bitmap = message.bitmap;
    }
    if (message.anchor !== undefined) {
      obj.anchor = ProofAnchor.toJSON(message.anchor);
    }
    return obj;
  },
  create: function create(base) {
    return Proof.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$leaves, _object$nodes, _object$depth, _object$bitmap;
    var message = createBaseProof();
    message.leaves = ((_object$leaves = object.leaves) == null ? void 0 : _object$leaves.map(function (e) {
      return e;
    })) || [];
    message.nodes = ((_object$nodes = object.nodes) == null ? void 0 : _object$nodes.map(function (e) {
      return e;
    })) || [];
    message.depth = (_object$depth = object.depth) != null ? _object$depth : "";
    message.bitmap = (_object$bitmap = object.bitmap) != null ? _object$bitmap : "";
    message.anchor = object.anchor !== undefined && object.anchor !== null ? ProofAnchor.fromPartial(object.anchor) : undefined;
    return message;
  }
};
function createBaseProofAnchor() {
  return {
    anchorId: 0,
    networks: [],
    root: "",
    status: ""
  };
}
var ProofAnchor = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.anchorId !== 0) {
      writer.uint32(8).int64(message.anchorId);
    }
    for (var _iterator5 = _createForOfIteratorHelperLoose(message.networks), _step5; !(_step5 = _iterator5()).done;) {
      var v = _step5.value;
      AnchorNetwork.encode(v, writer.uint32(18).fork()).ldelim();
    }
    if (message.root !== "") {
      writer.uint32(26).string(message.root);
    }
    if (message.status !== "") {
      writer.uint32(34).string(message.status);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseProofAnchor();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }
          message.anchorId = longToNumber$1(reader.int64());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.networks.push(AnchorNetwork.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.root = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }
          message.status = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      anchorId: isSet$3(object.anchorId) ? globalThis.Number(object.anchorId) : 0,
      networks: globalThis.Array.isArray(object == null ? void 0 : object.networks) ? object.networks.map(function (e) {
        return AnchorNetwork.fromJSON(e);
      }) : [],
      root: isSet$3(object.root) ? globalThis.String(object.root) : "",
      status: isSet$3(object.status) ? globalThis.String(object.status) : ""
    };
  },
  toJSON: function toJSON(message) {
    var _message$networks2;
    var obj = {};
    if (message.anchorId !== 0) {
      obj.anchorId = Math.round(message.anchorId);
    }
    if ((_message$networks2 = message.networks) != null && _message$networks2.length) {
      obj.networks = message.networks.map(function (e) {
        return AnchorNetwork.toJSON(e);
      });
    }
    if (message.root !== "") {
      obj.root = message.root;
    }
    if (message.status !== "") {
      obj.status = message.status;
    }
    return obj;
  },
  create: function create(base) {
    return ProofAnchor.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$anchorId, _object$networks2, _object$root3, _object$status2;
    var message = createBaseProofAnchor();
    message.anchorId = (_object$anchorId = object.anchorId) != null ? _object$anchorId : 0;
    message.networks = ((_object$networks2 = object.networks) == null ? void 0 : _object$networks2.map(function (e) {
      return AnchorNetwork.fromPartial(e);
    })) || [];
    message.root = (_object$root3 = object.root) != null ? _object$root3 : "";
    message.status = (_object$status2 = object.status) != null ? _object$status2 : "";
    return message;
  }
};
function createBaseRecordReceipt() {
  return {
    anchor: 0,
    client: "",
    record: "",
    status: ""
  };
}
var RecordReceipt = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.anchor !== 0) {
      writer.uint32(8).int64(message.anchor);
    }
    if (message.client !== "") {
      writer.uint32(18).string(message.client);
    }
    if (message.record !== "") {
      writer.uint32(26).string(message.record);
    }
    if (message.status !== "") {
      writer.uint32(34).string(message.status);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseRecordReceipt();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }
          message.anchor = longToNumber$1(reader.int64());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.client = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.record = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }
          message.status = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      anchor: isSet$3(object.anchor) ? globalThis.Number(object.anchor) : 0,
      client: isSet$3(object.client) ? globalThis.String(object.client) : "",
      record: isSet$3(object.record) ? globalThis.String(object.record) : "",
      status: isSet$3(object.status) ? globalThis.String(object.status) : ""
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.anchor !== 0) {
      obj.anchor = Math.round(message.anchor);
    }
    if (message.client !== "") {
      obj.client = message.client;
    }
    if (message.record !== "") {
      obj.record = message.record;
    }
    if (message.status !== "") {
      obj.status = message.status;
    }
    return obj;
  },
  create: function create(base) {
    return RecordReceipt.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$anchor, _object$client, _object$record, _object$status3;
    var message = createBaseRecordReceipt();
    message.anchor = (_object$anchor = object.anchor) != null ? _object$anchor : 0;
    message.client = (_object$client = object.client) != null ? _object$client : "";
    message.record = (_object$record = object.record) != null ? _object$record : "";
    message.status = (_object$status3 = object.status) != null ? _object$status3 : "";
    return message;
  }
};
function longToNumber$1(_long) {
  if (_long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return _long.toNumber();
}
if (_m0.util.Long !== Long) {
  _m0.util.Long = Long;
  _m0.configure();
}
function isSet$3(value) {
  return value !== null && value !== undefined;
}

var RecordTypes;
(function (RecordTypes) {
  RecordTypes[RecordTypes["STRING"] = 0] = "STRING";
  RecordTypes[RecordTypes["HEX"] = 1] = "HEX";
  RecordTypes[RecordTypes["JSON"] = 2] = "JSON";
  RecordTypes[RecordTypes["BYTES"] = 3] = "BYTES";
  RecordTypes[RecordTypes["FILE"] = 4] = "FILE";
  RecordTypes[RecordTypes["RECORD"] = 5] = "RECORD";
  RecordTypes[RecordTypes["LOADER"] = 6] = "LOADER";
  RecordTypes[RecordTypes["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(RecordTypes || (RecordTypes = {}));
function createBaseRecordHeader() {
  return {
    ty: ""
  };
}
var RecordHeader = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.ty !== "") {
      writer.uint32(10).string(message.ty);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseRecordHeader();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.ty = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      ty: isSet$4(object.ty) ? globalThis.String(object.ty) : ""
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.ty !== "") {
      obj.ty = message.ty;
    }
    return obj;
  },
  create: function create(base) {
    return RecordHeader.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$ty;
    var message = createBaseRecordHeader();
    message.ty = (_object$ty = object.ty) != null ? _object$ty : "";
    return message;
  }
};
function createBaseRecord() {
  return {
    configData: undefined,
    payload: new Uint8Array(0),
    hash: ""
  };
}
var Record = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.payload.length !== 0) {
      writer.uint32(18).bytes(message.payload);
    }
    if (message.hash !== "") {
      writer.uint32(26).string(message.hash);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseRecord();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.payload = reader.bytes();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.hash = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$4(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      payload: isSet$4(object.payload) ? bytesFromBase64$1(object.payload) : new Uint8Array(0),
      hash: isSet$4(object.hash) ? globalThis.String(object.hash) : ""
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.payload.length !== 0) {
      obj.payload = base64FromBytes$1(message.payload);
    }
    if (message.hash !== "") {
      obj.hash = message.hash;
    }
    return obj;
  },
  create: function create(base) {
    return Record.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$payload, _object$hash;
    var message = createBaseRecord();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.payload = (_object$payload = object.payload) != null ? _object$payload : new Uint8Array(0);
    message.hash = (_object$hash = object.hash) != null ? _object$hash : "";
    return message;
  }
};
function createBaseIntegrityDetails() {
  return {
    hash: "",
    proof: undefined
  };
}
var IntegrityDetails = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.hash !== "") {
      writer.uint32(10).string(message.hash);
    }
    if (message.proof !== undefined) {
      Proof.encode(message.proof, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseIntegrityDetails();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.hash = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.proof = Proof.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      hash: isSet$4(object.hash) ? globalThis.String(object.hash) : "",
      proof: isSet$4(object.proof) ? Proof.fromJSON(object.proof) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.hash !== "") {
      obj.hash = message.hash;
    }
    if (message.proof !== undefined) {
      obj.proof = Proof.toJSON(message.proof);
    }
    return obj;
  },
  create: function create(base) {
    return IntegrityDetails.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$hash2;
    var message = createBaseIntegrityDetails();
    message.hash = (_object$hash2 = object.hash) != null ? _object$hash2 : "";
    message.proof = object.proof !== undefined && object.proof !== null ? Proof.fromPartial(object.proof) : undefined;
    return message;
  }
};
function createBaseAuthenticityDetails() {
  return {
    signatures: []
  };
}
var AuthenticityDetails = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    for (var _iterator = _createForOfIteratorHelperLoose(message.signatures), _step; !(_step = _iterator()).done;) {
      var v = _step.value;
      Signature.encode(v, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseAuthenticityDetails();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.signatures.push(Signature.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      signatures: globalThis.Array.isArray(object == null ? void 0 : object.signatures) ? object.signatures.map(function (e) {
        return Signature.fromJSON(e);
      }) : []
    };
  },
  toJSON: function toJSON(message) {
    var _message$signatures;
    var obj = {};
    if ((_message$signatures = message.signatures) != null && _message$signatures.length) {
      obj.signatures = message.signatures.map(function (e) {
        return Signature.toJSON(e);
      });
    }
    return obj;
  },
  create: function create(base) {
    return AuthenticityDetails.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$signatures;
    var message = createBaseAuthenticityDetails();
    message.signatures = ((_object$signatures = object.signatures) == null ? void 0 : _object$signatures.map(function (e) {
      return Signature.fromPartial(e);
    })) || [];
    return message;
  }
};
function createBaseEncryptionDetails() {
  return {
    alg: undefined,
    key: undefined,
    subject: undefined
  };
}
var EncryptionDetails = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.alg !== undefined) {
      writer.uint32(10).string(message.alg);
    }
    if (message.key !== undefined) {
      writer.uint32(18).string(message.key);
    }
    if (message.subject !== undefined) {
      writer.uint32(26).string(message.subject);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseEncryptionDetails();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.alg = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.key = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.subject = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      alg: isSet$4(object.alg) ? globalThis.String(object.alg) : undefined,
      key: isSet$4(object.key) ? globalThis.String(object.key) : undefined,
      subject: isSet$4(object.subject) ? globalThis.String(object.subject) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.alg !== undefined) {
      obj.alg = message.alg;
    }
    if (message.key !== undefined) {
      obj.key = message.key;
    }
    if (message.subject !== undefined) {
      obj.subject = message.subject;
    }
    return obj;
  },
  create: function create(base) {
    return EncryptionDetails.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$alg, _object$key, _object$subject;
    var message = createBaseEncryptionDetails();
    message.alg = (_object$alg = object.alg) != null ? _object$alg : undefined;
    message.key = (_object$key = object.key) != null ? _object$key : undefined;
    message.subject = (_object$subject = object.subject) != null ? _object$subject : undefined;
    return message;
  }
};
function createBaseAvailabilityDetails() {
  return {
    size: 0,
    type: undefined
  };
}
var AvailabilityDetails = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.size !== 0) {
      writer.uint32(8).int64(message.size);
    }
    if (message.type !== undefined) {
      writer.uint32(18).string(message.type);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseAvailabilityDetails();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }
          message.size = longToNumber$2(reader.int64());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.type = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      size: isSet$4(object.size) ? globalThis.Number(object.size) : 0,
      type: isSet$4(object.type) ? globalThis.String(object.type) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.size !== 0) {
      obj.size = Math.round(message.size);
    }
    if (message.type !== undefined) {
      obj.type = message.type;
    }
    return obj;
  },
  create: function create(base) {
    return AvailabilityDetails.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$size, _object$type;
    var message = createBaseAvailabilityDetails();
    message.size = (_object$size = object.size) != null ? _object$size : 0;
    message.type = (_object$type = object.type) != null ? _object$type : undefined;
    return message;
  }
};
function createBaseRecordDetails() {
  return {
    integrity: undefined,
    authenticity: undefined,
    encryption: undefined,
    availability: undefined
  };
}
var RecordDetails = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.integrity !== undefined) {
      IntegrityDetails.encode(message.integrity, writer.uint32(10).fork()).ldelim();
    }
    if (message.authenticity !== undefined) {
      AuthenticityDetails.encode(message.authenticity, writer.uint32(18).fork()).ldelim();
    }
    if (message.encryption !== undefined) {
      EncryptionDetails.encode(message.encryption, writer.uint32(26).fork()).ldelim();
    }
    if (message.availability !== undefined) {
      AvailabilityDetails.encode(message.availability, writer.uint32(34).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseRecordDetails();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.integrity = IntegrityDetails.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.authenticity = AuthenticityDetails.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.encryption = EncryptionDetails.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }
          message.availability = AvailabilityDetails.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      integrity: isSet$4(object.integrity) ? IntegrityDetails.fromJSON(object.integrity) : undefined,
      authenticity: isSet$4(object.authenticity) ? AuthenticityDetails.fromJSON(object.authenticity) : undefined,
      encryption: isSet$4(object.encryption) ? EncryptionDetails.fromJSON(object.encryption) : undefined,
      availability: isSet$4(object.availability) ? AvailabilityDetails.fromJSON(object.availability) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.integrity !== undefined) {
      obj.integrity = IntegrityDetails.toJSON(message.integrity);
    }
    if (message.authenticity !== undefined) {
      obj.authenticity = AuthenticityDetails.toJSON(message.authenticity);
    }
    if (message.encryption !== undefined) {
      obj.encryption = EncryptionDetails.toJSON(message.encryption);
    }
    if (message.availability !== undefined) {
      obj.availability = AvailabilityDetails.toJSON(message.availability);
    }
    return obj;
  },
  create: function create(base) {
    return RecordDetails.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseRecordDetails();
    message.integrity = object.integrity !== undefined && object.integrity !== null ? IntegrityDetails.fromPartial(object.integrity) : undefined;
    message.authenticity = object.authenticity !== undefined && object.authenticity !== null ? AuthenticityDetails.fromPartial(object.authenticity) : undefined;
    message.encryption = object.encryption !== undefined && object.encryption !== null ? EncryptionDetails.fromPartial(object.encryption) : undefined;
    message.availability = object.availability !== undefined && object.availability !== null ? AvailabilityDetails.fromPartial(object.availability) : undefined;
    return message;
  }
};
function bytesFromBase64$1(b64) {
  if (globalThis.Buffer) {
    return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
  } else {
    var bin = globalThis.atob(b64);
    var arr = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}
function base64FromBytes$1(arr) {
  if (globalThis.Buffer) {
    return globalThis.Buffer.from(arr).toString("base64");
  } else {
    var bin = [];
    arr.forEach(function (_byte) {
      bin.push(globalThis.String.fromCharCode(_byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}
function longToNumber$2(_long) {
  if (_long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return _long.toNumber();
}
if (_m0.util.Long !== Long) {
  _m0.util.Long = Long;
  _m0.configure();
}
function isSet$4(value) {
  return value !== null && value !== undefined;
}

/* eslint-disable */
function createBaseError() {
  return {
    kind: "",
    message: ""
  };
}
var Error$1 = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.kind !== "") {
      writer.uint32(10).string(message.kind);
    }
    if (message.message !== "") {
      writer.uint32(18).string(message.message);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseError();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.kind = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.message = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      kind: isSet$5(object.kind) ? globalThis.String(object.kind) : "",
      message: isSet$5(object.message) ? globalThis.String(object.message) : ""
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.kind !== "") {
      obj.kind = message.kind;
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    return obj;
  },
  create: function create(base) {
    return Error$1.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$kind, _object$message;
    var message = createBaseError();
    message.kind = (_object$kind = object.kind) != null ? _object$kind : "";
    message.message = (_object$message = object.message) != null ? _object$message : "";
    return message;
  }
};
function isSet$5(value) {
  return value !== null && value !== undefined;
}

function createBaseSignRequest() {
  return {
    configData: undefined,
    record: undefined,
    signer: undefined
  };
}
var SignRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.record !== undefined) {
      Record.encode(message.record, writer.uint32(18).fork()).ldelim();
    }
    if (message.signer !== undefined) {
      Signer.encode(message.signer, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseSignRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.record = Record.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.signer = Signer.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$6(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      record: isSet$6(object.record) ? Record.fromJSON(object.record) : undefined,
      signer: isSet$6(object.signer) ? Signer.fromJSON(object.signer) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.record !== undefined) {
      obj.record = Record.toJSON(message.record);
    }
    if (message.signer !== undefined) {
      obj.signer = Signer.toJSON(message.signer);
    }
    return obj;
  },
  create: function create(base) {
    return SignRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseSignRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.record = object.record !== undefined && object.record !== null ? Record.fromPartial(object.record) : undefined;
    message.signer = object.signer !== undefined && object.signer !== null ? Signer.fromPartial(object.signer) : undefined;
    return message;
  }
};
function createBaseSignResponse() {
  return {
    signature: undefined,
    error: undefined
  };
}
var SignResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.signature !== undefined) {
      Signature.encode(message.signature, writer.uint32(10).fork()).ldelim();
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseSignResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.signature = Signature.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      signature: isSet$6(object.signature) ? Signature.fromJSON(object.signature) : undefined,
      error: isSet$6(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.signature !== undefined) {
      obj.signature = Signature.toJSON(message.signature);
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return SignResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseSignResponse();
    message.signature = object.signature !== undefined && object.signature !== null ? Signature.fromPartial(object.signature) : undefined;
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
function createBaseVerifyRequest() {
  return {
    configData: undefined,
    record: undefined
  };
}
var VerifyRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.record !== undefined) {
      Record.encode(message.record, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseVerifyRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.record = Record.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$6(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      record: isSet$6(object.record) ? Record.fromJSON(object.record) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.record !== undefined) {
      obj.record = Record.toJSON(message.record);
    }
    return obj;
  },
  create: function create(base) {
    return VerifyRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseVerifyRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.record = object.record !== undefined && object.record !== null ? Record.fromPartial(object.record) : undefined;
    return message;
  }
};
function createBaseVerifyResponse() {
  return {
    valid: false,
    error: undefined
  };
}
var VerifyResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.valid === true) {
      writer.uint32(8).bool(message.valid);
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseVerifyResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }
          message.valid = reader.bool();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      valid: isSet$6(object.valid) ? globalThis.Boolean(object.valid) : false,
      error: isSet$6(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.valid === true) {
      obj.valid = message.valid;
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return VerifyResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$valid;
    var message = createBaseVerifyResponse();
    message.valid = (_object$valid = object.valid) != null ? _object$valid : false;
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
function createBaseGetSignaturesRequest() {
  return {
    configData: undefined,
    record: undefined
  };
}
var GetSignaturesRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.record !== undefined) {
      Record.encode(message.record, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseGetSignaturesRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.record = Record.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$6(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      record: isSet$6(object.record) ? Record.fromJSON(object.record) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.record !== undefined) {
      obj.record = Record.toJSON(message.record);
    }
    return obj;
  },
  create: function create(base) {
    return GetSignaturesRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseGetSignaturesRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.record = object.record !== undefined && object.record !== null ? Record.fromPartial(object.record) : undefined;
    return message;
  }
};
function createBaseGetSignaturesResponse() {
  return {
    signatures: [],
    error: undefined
  };
}
var GetSignaturesResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    for (var _iterator = _createForOfIteratorHelperLoose(message.signatures), _step; !(_step = _iterator()).done;) {
      var v = _step.value;
      Signature.encode(v, writer.uint32(10).fork()).ldelim();
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseGetSignaturesResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.signatures.push(Signature.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      signatures: globalThis.Array.isArray(object == null ? void 0 : object.signatures) ? object.signatures.map(function (e) {
        return Signature.fromJSON(e);
      }) : [],
      error: isSet$6(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var _message$signatures;
    var obj = {};
    if ((_message$signatures = message.signatures) != null && _message$signatures.length) {
      obj.signatures = message.signatures.map(function (e) {
        return Signature.toJSON(e);
      });
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return GetSignaturesResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$signatures;
    var message = createBaseGetSignaturesResponse();
    message.signatures = ((_object$signatures = object.signatures) == null ? void 0 : _object$signatures.map(function (e) {
      return Signature.fromPartial(e);
    })) || [];
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
var AuthenticityServiceServiceName = "bloock.AuthenticityService";
var AuthenticityServiceClientImpl = /*#__PURE__*/function () {
  function AuthenticityServiceClientImpl(rpc, opts) {
    this.service = (opts == null ? void 0 : opts.service) || AuthenticityServiceServiceName;
    this.rpc = rpc;
    this.Sign = this.Sign.bind(this);
    this.Verify = this.Verify.bind(this);
    this.GetSignatures = this.GetSignatures.bind(this);
  }
  var _proto = AuthenticityServiceClientImpl.prototype;
  _proto.Sign = function Sign(request) {
    var data = SignRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "Sign", data);
    return promise.then(function (data) {
      return SignResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.Verify = function Verify(request) {
    var data = VerifyRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "Verify", data);
    return promise.then(function (data) {
      return VerifyResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.GetSignatures = function GetSignatures(request) {
    var data = GetSignaturesRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "GetSignatures", data);
    return promise.then(function (data) {
      return GetSignaturesResponse.decode(_m0.Reader.create(data));
    });
  };
  return AuthenticityServiceClientImpl;
}();
function isSet$6(value) {
  return value !== null && value !== undefined;
}

/* eslint-disable */
var DataAvailabilityType;
(function (DataAvailabilityType) {
  DataAvailabilityType[DataAvailabilityType["HOSTED"] = 0] = "HOSTED";
  DataAvailabilityType[DataAvailabilityType["IPFS"] = 1] = "IPFS";
  DataAvailabilityType[DataAvailabilityType["IPNS"] = 2] = "IPNS";
  DataAvailabilityType[DataAvailabilityType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(DataAvailabilityType || (DataAvailabilityType = {}));
function dataAvailabilityTypeFromJSON(object) {
  switch (object) {
    case 0:
    case "HOSTED":
      return DataAvailabilityType.HOSTED;
    case 1:
    case "IPFS":
      return DataAvailabilityType.IPFS;
    case 2:
    case "IPNS":
      return DataAvailabilityType.IPNS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DataAvailabilityType.UNRECOGNIZED;
  }
}
function dataAvailabilityTypeToJSON(object) {
  switch (object) {
    case DataAvailabilityType.HOSTED:
      return "HOSTED";
    case DataAvailabilityType.IPFS:
      return "IPFS";
    case DataAvailabilityType.IPNS:
      return "IPNS";
    case DataAvailabilityType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
function createBasePublisher() {
  return {
    type: 0,
    args: undefined
  };
}
var Publisher = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.args !== undefined) {
      PublisherArgs.encode(message.args, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBasePublisher();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }
          message.type = reader.int32();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.args = PublisherArgs.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      type: isSet$7(object.type) ? dataAvailabilityTypeFromJSON(object.type) : 0,
      args: isSet$7(object.args) ? PublisherArgs.fromJSON(object.args) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.type !== 0) {
      obj.type = dataAvailabilityTypeToJSON(message.type);
    }
    if (message.args !== undefined) {
      obj.args = PublisherArgs.toJSON(message.args);
    }
    return obj;
  },
  create: function create(base) {
    return Publisher.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$type;
    var message = createBasePublisher();
    message.type = (_object$type = object.type) != null ? _object$type : 0;
    message.args = object.args !== undefined && object.args !== null ? PublisherArgs.fromPartial(object.args) : undefined;
    return message;
  }
};
function createBasePublisherArgs() {
  return {
    ipnsKey: undefined
  };
}
var PublisherArgs = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.ipnsKey !== undefined) {
      IpnsKey.encode(message.ipnsKey, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBasePublisherArgs();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.ipnsKey = IpnsKey.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      ipnsKey: isSet$7(object.ipnsKey) ? IpnsKey.fromJSON(object.ipnsKey) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.ipnsKey !== undefined) {
      obj.ipnsKey = IpnsKey.toJSON(message.ipnsKey);
    }
    return obj;
  },
  create: function create(base) {
    return PublisherArgs.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBasePublisherArgs();
    message.ipnsKey = object.ipnsKey !== undefined && object.ipnsKey !== null ? IpnsKey.fromPartial(object.ipnsKey) : undefined;
    return message;
  }
};
function createBaseLoader() {
  return {
    type: 0,
    args: undefined
  };
}
var Loader = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.args !== undefined) {
      LoaderArgs.encode(message.args, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseLoader();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }
          message.type = reader.int32();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.args = LoaderArgs.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      type: isSet$7(object.type) ? dataAvailabilityTypeFromJSON(object.type) : 0,
      args: isSet$7(object.args) ? LoaderArgs.fromJSON(object.args) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.type !== 0) {
      obj.type = dataAvailabilityTypeToJSON(message.type);
    }
    if (message.args !== undefined) {
      obj.args = LoaderArgs.toJSON(message.args);
    }
    return obj;
  },
  create: function create(base) {
    return Loader.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$type2;
    var message = createBaseLoader();
    message.type = (_object$type2 = object.type) != null ? _object$type2 : 0;
    message.args = object.args !== undefined && object.args !== null ? LoaderArgs.fromPartial(object.args) : undefined;
    return message;
  }
};
function createBaseLoaderArgs() {
  return {
    id: ""
  };
}
var LoaderArgs = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseLoaderArgs();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.id = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      id: isSet$7(object.id) ? globalThis.String(object.id) : ""
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },
  create: function create(base) {
    return LoaderArgs.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$id;
    var message = createBaseLoaderArgs();
    message.id = (_object$id = object.id) != null ? _object$id : "";
    return message;
  }
};
function createBaseIpnsKey() {
  return {
    managedKey: undefined,
    managedCertificate: undefined
  };
}
var IpnsKey = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.managedKey !== undefined) {
      ManagedKey.encode(message.managedKey, writer.uint32(10).fork()).ldelim();
    }
    if (message.managedCertificate !== undefined) {
      ManagedCertificate.encode(message.managedCertificate, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseIpnsKey();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.managedKey = ManagedKey.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.managedCertificate = ManagedCertificate.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      managedKey: isSet$7(object.managedKey) ? ManagedKey.fromJSON(object.managedKey) : undefined,
      managedCertificate: isSet$7(object.managedCertificate) ? ManagedCertificate.fromJSON(object.managedCertificate) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.managedKey !== undefined) {
      obj.managedKey = ManagedKey.toJSON(message.managedKey);
    }
    if (message.managedCertificate !== undefined) {
      obj.managedCertificate = ManagedCertificate.toJSON(message.managedCertificate);
    }
    return obj;
  },
  create: function create(base) {
    return IpnsKey.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseIpnsKey();
    message.managedKey = object.managedKey !== undefined && object.managedKey !== null ? ManagedKey.fromPartial(object.managedKey) : undefined;
    message.managedCertificate = object.managedCertificate !== undefined && object.managedCertificate !== null ? ManagedCertificate.fromPartial(object.managedCertificate) : undefined;
    return message;
  }
};
function isSet$7(value) {
  return value !== null && value !== undefined;
}

/* eslint-disable */
function createBasePublishRequest() {
  return {
    configData: undefined,
    record: undefined,
    publisher: undefined
  };
}
var PublishRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.record !== undefined) {
      Record.encode(message.record, writer.uint32(18).fork()).ldelim();
    }
    if (message.publisher !== undefined) {
      Publisher.encode(message.publisher, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBasePublishRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.record = Record.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.publisher = Publisher.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$8(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      record: isSet$8(object.record) ? Record.fromJSON(object.record) : undefined,
      publisher: isSet$8(object.publisher) ? Publisher.fromJSON(object.publisher) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.record !== undefined) {
      obj.record = Record.toJSON(message.record);
    }
    if (message.publisher !== undefined) {
      obj.publisher = Publisher.toJSON(message.publisher);
    }
    return obj;
  },
  create: function create(base) {
    return PublishRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBasePublishRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.record = object.record !== undefined && object.record !== null ? Record.fromPartial(object.record) : undefined;
    message.publisher = object.publisher !== undefined && object.publisher !== null ? Publisher.fromPartial(object.publisher) : undefined;
    return message;
  }
};
function createBasePublishResponse() {
  return {
    id: "",
    error: undefined
  };
}
var PublishResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBasePublishResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      id: isSet$8(object.id) ? globalThis.String(object.id) : "",
      error: isSet$8(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return PublishResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$id;
    var message = createBasePublishResponse();
    message.id = (_object$id = object.id) != null ? _object$id : "";
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
function createBaseRetrieveRequest() {
  return {
    configData: undefined,
    loader: undefined
  };
}
var RetrieveRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.loader !== undefined) {
      Loader.encode(message.loader, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseRetrieveRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.loader = Loader.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$8(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      loader: isSet$8(object.loader) ? Loader.fromJSON(object.loader) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.loader !== undefined) {
      obj.loader = Loader.toJSON(message.loader);
    }
    return obj;
  },
  create: function create(base) {
    return RetrieveRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseRetrieveRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.loader = object.loader !== undefined && object.loader !== null ? Loader.fromPartial(object.loader) : undefined;
    return message;
  }
};
function createBaseRetrieveResponse() {
  return {
    record: undefined,
    error: undefined
  };
}
var RetrieveResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.record !== undefined) {
      Record.encode(message.record, writer.uint32(10).fork()).ldelim();
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseRetrieveResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.record = Record.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      record: isSet$8(object.record) ? Record.fromJSON(object.record) : undefined,
      error: isSet$8(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.record !== undefined) {
      obj.record = Record.toJSON(message.record);
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return RetrieveResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseRetrieveResponse();
    message.record = object.record !== undefined && object.record !== null ? Record.fromPartial(object.record) : undefined;
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
var AvailabilityServiceServiceName = "bloock.AvailabilityService";
var AvailabilityServiceClientImpl = /*#__PURE__*/function () {
  function AvailabilityServiceClientImpl(rpc, opts) {
    this.service = (opts == null ? void 0 : opts.service) || AvailabilityServiceServiceName;
    this.rpc = rpc;
    this.Publish = this.Publish.bind(this);
    this.Retrieve = this.Retrieve.bind(this);
  }
  var _proto = AvailabilityServiceClientImpl.prototype;
  _proto.Publish = function Publish(request) {
    var data = PublishRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "Publish", data);
    return promise.then(function (data) {
      return PublishResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.Retrieve = function Retrieve(request) {
    var data = RetrieveRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "Retrieve", data);
    return promise.then(function (data) {
      return RetrieveResponse.decode(_m0.Reader.create(data));
    });
  };
  return AvailabilityServiceClientImpl;
}();
function isSet$8(value) {
  return value !== null && value !== undefined;
}

/* eslint-disable */
var EncryptionAlg;
(function (EncryptionAlg) {
  EncryptionAlg[EncryptionAlg["A256GCM"] = 0] = "A256GCM";
  EncryptionAlg[EncryptionAlg["A256GCM_M"] = 1] = "A256GCM_M";
  EncryptionAlg[EncryptionAlg["RSA"] = 2] = "RSA";
  EncryptionAlg[EncryptionAlg["RSA_M"] = 3] = "RSA_M";
  EncryptionAlg[EncryptionAlg["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(EncryptionAlg || (EncryptionAlg = {}));
function encryptionAlgFromJSON(object) {
  switch (object) {
    case 0:
    case "A256GCM":
      return EncryptionAlg.A256GCM;
    case 1:
    case "A256GCM_M":
      return EncryptionAlg.A256GCM_M;
    case 2:
    case "RSA":
      return EncryptionAlg.RSA;
    case 3:
    case "RSA_M":
      return EncryptionAlg.RSA_M;
    case -1:
    case "UNRECOGNIZED":
    default:
      return EncryptionAlg.UNRECOGNIZED;
  }
}
function encryptionAlgToJSON(object) {
  switch (object) {
    case EncryptionAlg.A256GCM:
      return "A256GCM";
    case EncryptionAlg.A256GCM_M:
      return "A256GCM_M";
    case EncryptionAlg.RSA:
      return "RSA";
    case EncryptionAlg.RSA_M:
      return "RSA_M";
    case EncryptionAlg.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
function createBaseEncrypter() {
  return {
    localKey: undefined,
    managedKey: undefined,
    localCertificate: undefined,
    managedCertificate: undefined,
    accessControl: undefined
  };
}
var Encrypter = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.localKey !== undefined) {
      LocalKey.encode(message.localKey, writer.uint32(10).fork()).ldelim();
    }
    if (message.managedKey !== undefined) {
      ManagedKey.encode(message.managedKey, writer.uint32(18).fork()).ldelim();
    }
    if (message.localCertificate !== undefined) {
      LocalCertificate.encode(message.localCertificate, writer.uint32(26).fork()).ldelim();
    }
    if (message.managedCertificate !== undefined) {
      ManagedCertificate.encode(message.managedCertificate, writer.uint32(34).fork()).ldelim();
    }
    if (message.accessControl !== undefined) {
      AccessControl.encode(message.accessControl, writer.uint32(50).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseEncrypter();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.localKey = LocalKey.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.managedKey = ManagedKey.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.localCertificate = LocalCertificate.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }
          message.managedCertificate = ManagedCertificate.decode(reader, reader.uint32());
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }
          message.accessControl = AccessControl.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      localKey: isSet$9(object.localKey) ? LocalKey.fromJSON(object.localKey) : undefined,
      managedKey: isSet$9(object.managedKey) ? ManagedKey.fromJSON(object.managedKey) : undefined,
      localCertificate: isSet$9(object.localCertificate) ? LocalCertificate.fromJSON(object.localCertificate) : undefined,
      managedCertificate: isSet$9(object.managedCertificate) ? ManagedCertificate.fromJSON(object.managedCertificate) : undefined,
      accessControl: isSet$9(object.accessControl) ? AccessControl.fromJSON(object.accessControl) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.localKey !== undefined) {
      obj.localKey = LocalKey.toJSON(message.localKey);
    }
    if (message.managedKey !== undefined) {
      obj.managedKey = ManagedKey.toJSON(message.managedKey);
    }
    if (message.localCertificate !== undefined) {
      obj.localCertificate = LocalCertificate.toJSON(message.localCertificate);
    }
    if (message.managedCertificate !== undefined) {
      obj.managedCertificate = ManagedCertificate.toJSON(message.managedCertificate);
    }
    if (message.accessControl !== undefined) {
      obj.accessControl = AccessControl.toJSON(message.accessControl);
    }
    return obj;
  },
  create: function create(base) {
    return Encrypter.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseEncrypter();
    message.localKey = object.localKey !== undefined && object.localKey !== null ? LocalKey.fromPartial(object.localKey) : undefined;
    message.managedKey = object.managedKey !== undefined && object.managedKey !== null ? ManagedKey.fromPartial(object.managedKey) : undefined;
    message.localCertificate = object.localCertificate !== undefined && object.localCertificate !== null ? LocalCertificate.fromPartial(object.localCertificate) : undefined;
    message.managedCertificate = object.managedCertificate !== undefined && object.managedCertificate !== null ? ManagedCertificate.fromPartial(object.managedCertificate) : undefined;
    message.accessControl = object.accessControl !== undefined && object.accessControl !== null ? AccessControl.fromPartial(object.accessControl) : undefined;
    return message;
  }
};
function isSet$9(value) {
  return value !== null && value !== undefined;
}

/* eslint-disable */
function createBaseEncryptRequest() {
  return {
    configData: undefined,
    record: undefined,
    encrypter: undefined
  };
}
var EncryptRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.record !== undefined) {
      Record.encode(message.record, writer.uint32(18).fork()).ldelim();
    }
    if (message.encrypter !== undefined) {
      Encrypter.encode(message.encrypter, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseEncryptRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.record = Record.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.encrypter = Encrypter.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$a(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      record: isSet$a(object.record) ? Record.fromJSON(object.record) : undefined,
      encrypter: isSet$a(object.encrypter) ? Encrypter.fromJSON(object.encrypter) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.record !== undefined) {
      obj.record = Record.toJSON(message.record);
    }
    if (message.encrypter !== undefined) {
      obj.encrypter = Encrypter.toJSON(message.encrypter);
    }
    return obj;
  },
  create: function create(base) {
    return EncryptRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseEncryptRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.record = object.record !== undefined && object.record !== null ? Record.fromPartial(object.record) : undefined;
    message.encrypter = object.encrypter !== undefined && object.encrypter !== null ? Encrypter.fromPartial(object.encrypter) : undefined;
    return message;
  }
};
function createBaseEncryptResponse() {
  return {
    record: undefined,
    error: undefined
  };
}
var EncryptResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.record !== undefined) {
      Record.encode(message.record, writer.uint32(10).fork()).ldelim();
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseEncryptResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.record = Record.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      record: isSet$a(object.record) ? Record.fromJSON(object.record) : undefined,
      error: isSet$a(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.record !== undefined) {
      obj.record = Record.toJSON(message.record);
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return EncryptResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseEncryptResponse();
    message.record = object.record !== undefined && object.record !== null ? Record.fromPartial(object.record) : undefined;
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
function createBaseDecryptRequest() {
  return {
    configData: undefined,
    record: undefined,
    decrypter: undefined
  };
}
var DecryptRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.record !== undefined) {
      Record.encode(message.record, writer.uint32(18).fork()).ldelim();
    }
    if (message.decrypter !== undefined) {
      Encrypter.encode(message.decrypter, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseDecryptRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.record = Record.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.decrypter = Encrypter.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$a(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      record: isSet$a(object.record) ? Record.fromJSON(object.record) : undefined,
      decrypter: isSet$a(object.decrypter) ? Encrypter.fromJSON(object.decrypter) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.record !== undefined) {
      obj.record = Record.toJSON(message.record);
    }
    if (message.decrypter !== undefined) {
      obj.decrypter = Encrypter.toJSON(message.decrypter);
    }
    return obj;
  },
  create: function create(base) {
    return DecryptRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseDecryptRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.record = object.record !== undefined && object.record !== null ? Record.fromPartial(object.record) : undefined;
    message.decrypter = object.decrypter !== undefined && object.decrypter !== null ? Encrypter.fromPartial(object.decrypter) : undefined;
    return message;
  }
};
function createBaseDecryptResponse() {
  return {
    record: undefined,
    error: undefined
  };
}
var DecryptResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.record !== undefined) {
      Record.encode(message.record, writer.uint32(10).fork()).ldelim();
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseDecryptResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.record = Record.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      record: isSet$a(object.record) ? Record.fromJSON(object.record) : undefined,
      error: isSet$a(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.record !== undefined) {
      obj.record = Record.toJSON(message.record);
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return DecryptResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseDecryptResponse();
    message.record = object.record !== undefined && object.record !== null ? Record.fromPartial(object.record) : undefined;
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
function createBaseEncryptionAlgRequest() {
  return {
    configData: undefined,
    record: undefined
  };
}
var EncryptionAlgRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.record !== undefined) {
      Record.encode(message.record, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseEncryptionAlgRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.record = Record.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$a(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      record: isSet$a(object.record) ? Record.fromJSON(object.record) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.record !== undefined) {
      obj.record = Record.toJSON(message.record);
    }
    return obj;
  },
  create: function create(base) {
    return EncryptionAlgRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseEncryptionAlgRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.record = object.record !== undefined && object.record !== null ? Record.fromPartial(object.record) : undefined;
    return message;
  }
};
function createBaseEncryptionAlgResponse() {
  return {
    alg: 0,
    error: undefined
  };
}
var EncryptionAlgResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.alg !== 0) {
      writer.uint32(8).int32(message.alg);
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseEncryptionAlgResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }
          message.alg = reader.int32();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      alg: isSet$a(object.alg) ? encryptionAlgFromJSON(object.alg) : 0,
      error: isSet$a(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.alg !== 0) {
      obj.alg = encryptionAlgToJSON(message.alg);
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return EncryptionAlgResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$alg;
    var message = createBaseEncryptionAlgResponse();
    message.alg = (_object$alg = object.alg) != null ? _object$alg : 0;
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
var EncryptionServiceServiceName = "bloock.EncryptionService";
var EncryptionServiceClientImpl = /*#__PURE__*/function () {
  function EncryptionServiceClientImpl(rpc, opts) {
    this.service = (opts == null ? void 0 : opts.service) || EncryptionServiceServiceName;
    this.rpc = rpc;
    this.Encrypt = this.Encrypt.bind(this);
    this.Decrypt = this.Decrypt.bind(this);
    this.GetEncryptionAlg = this.GetEncryptionAlg.bind(this);
  }
  var _proto = EncryptionServiceClientImpl.prototype;
  _proto.Encrypt = function Encrypt(request) {
    var data = EncryptRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "Encrypt", data);
    return promise.then(function (data) {
      return EncryptResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.Decrypt = function Decrypt(request) {
    var data = DecryptRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "Decrypt", data);
    return promise.then(function (data) {
      return DecryptResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.GetEncryptionAlg = function GetEncryptionAlg(request) {
    var data = EncryptionAlgRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "GetEncryptionAlg", data);
    return promise.then(function (data) {
      return EncryptionAlgResponse.decode(_m0.Reader.create(data));
    });
  };
  return EncryptionServiceClientImpl;
}();
function isSet$a(value) {
  return value !== null && value !== undefined;
}

var DidMethod;
(function (DidMethod) {
  DidMethod[DidMethod["POLYGON_ID"] = 0] = "POLYGON_ID";
  DidMethod[DidMethod["POLYGON_ID_TEST"] = 1] = "POLYGON_ID_TEST";
  DidMethod[DidMethod["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(DidMethod || (DidMethod = {}));
function didMethodFromJSON(object) {
  switch (object) {
    case 0:
    case "POLYGON_ID":
      return DidMethod.POLYGON_ID;
    case 1:
    case "POLYGON_ID_TEST":
      return DidMethod.POLYGON_ID_TEST;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DidMethod.UNRECOGNIZED;
  }
}
function didMethodToJSON(object) {
  switch (object) {
    case DidMethod.POLYGON_ID:
      return "POLYGON_ID";
    case DidMethod.POLYGON_ID_TEST:
      return "POLYGON_ID_TEST";
    case DidMethod.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
var PublishInterval;
(function (PublishInterval) {
  PublishInterval[PublishInterval["INTERVAL_5"] = 0] = "INTERVAL_5";
  PublishInterval[PublishInterval["INTERVAL_15"] = 1] = "INTERVAL_15";
  PublishInterval[PublishInterval["INTERVAL_60"] = 2] = "INTERVAL_60";
  PublishInterval[PublishInterval["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(PublishInterval || (PublishInterval = {}));
function publishIntervalFromJSON(object) {
  switch (object) {
    case 0:
    case "INTERVAL_5":
      return PublishInterval.INTERVAL_5;
    case 1:
    case "INTERVAL_15":
      return PublishInterval.INTERVAL_15;
    case 2:
    case "INTERVAL_60":
      return PublishInterval.INTERVAL_60;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PublishInterval.UNRECOGNIZED;
  }
}
function publishIntervalToJSON(object) {
  switch (object) {
    case PublishInterval.INTERVAL_5:
      return "INTERVAL_5";
    case PublishInterval.INTERVAL_15:
      return "INTERVAL_15";
    case PublishInterval.INTERVAL_60:
      return "INTERVAL_60";
    case PublishInterval.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
function createBaseCredential() {
  return {
    context: [],
    id: "",
    type: [],
    issuanceDate: "",
    expiration: "",
    credentialSubject: "",
    credentialStatus: undefined,
    issuer: "",
    credentialSchema: undefined,
    proof: undefined
  };
}
var Credential = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    for (var _iterator = _createForOfIteratorHelperLoose(message.context), _step; !(_step = _iterator()).done;) {
      var v = _step.value;
      writer.uint32(10).string(v);
    }
    if (message.id !== "") {
      writer.uint32(18).string(message.id);
    }
    for (var _iterator2 = _createForOfIteratorHelperLoose(message.type), _step2; !(_step2 = _iterator2()).done;) {
      var _v = _step2.value;
      writer.uint32(26).string(_v);
    }
    if (message.issuanceDate !== "") {
      writer.uint32(34).string(message.issuanceDate);
    }
    if (message.expiration !== "") {
      writer.uint32(42).string(message.expiration);
    }
    if (message.credentialSubject !== "") {
      writer.uint32(50).string(message.credentialSubject);
    }
    if (message.credentialStatus !== undefined) {
      CredentialStatus.encode(message.credentialStatus, writer.uint32(58).fork()).ldelim();
    }
    if (message.issuer !== "") {
      writer.uint32(66).string(message.issuer);
    }
    if (message.credentialSchema !== undefined) {
      CredentialSchema.encode(message.credentialSchema, writer.uint32(74).fork()).ldelim();
    }
    if (message.proof !== undefined) {
      CredentialProof.encode(message.proof, writer.uint32(82).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseCredential();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.context.push(reader.string());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.id = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.type.push(reader.string());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }
          message.issuanceDate = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }
          message.expiration = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }
          message.credentialSubject = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }
          message.credentialStatus = CredentialStatus.decode(reader, reader.uint32());
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }
          message.issuer = reader.string();
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }
          message.credentialSchema = CredentialSchema.decode(reader, reader.uint32());
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }
          message.proof = CredentialProof.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      context: globalThis.Array.isArray(object == null ? void 0 : object.context) ? object.context.map(function (e) {
        return globalThis.String(e);
      }) : [],
      id: isSet$b(object.id) ? globalThis.String(object.id) : "",
      type: globalThis.Array.isArray(object == null ? void 0 : object.type) ? object.type.map(function (e) {
        return globalThis.String(e);
      }) : [],
      issuanceDate: isSet$b(object.issuanceDate) ? globalThis.String(object.issuanceDate) : "",
      expiration: isSet$b(object.expiration) ? globalThis.String(object.expiration) : "",
      credentialSubject: isSet$b(object.credentialSubject) ? globalThis.String(object.credentialSubject) : "",
      credentialStatus: isSet$b(object.credentialStatus) ? CredentialStatus.fromJSON(object.credentialStatus) : undefined,
      issuer: isSet$b(object.issuer) ? globalThis.String(object.issuer) : "",
      credentialSchema: isSet$b(object.credentialSchema) ? CredentialSchema.fromJSON(object.credentialSchema) : undefined,
      proof: isSet$b(object.proof) ? CredentialProof.fromJSON(object.proof) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var _message$context, _message$type;
    var obj = {};
    if ((_message$context = message.context) != null && _message$context.length) {
      obj.context = message.context;
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if ((_message$type = message.type) != null && _message$type.length) {
      obj.type = message.type;
    }
    if (message.issuanceDate !== "") {
      obj.issuanceDate = message.issuanceDate;
    }
    if (message.expiration !== "") {
      obj.expiration = message.expiration;
    }
    if (message.credentialSubject !== "") {
      obj.credentialSubject = message.credentialSubject;
    }
    if (message.credentialStatus !== undefined) {
      obj.credentialStatus = CredentialStatus.toJSON(message.credentialStatus);
    }
    if (message.issuer !== "") {
      obj.issuer = message.issuer;
    }
    if (message.credentialSchema !== undefined) {
      obj.credentialSchema = CredentialSchema.toJSON(message.credentialSchema);
    }
    if (message.proof !== undefined) {
      obj.proof = CredentialProof.toJSON(message.proof);
    }
    return obj;
  },
  create: function create(base) {
    return Credential.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$context, _object$id, _object$type, _object$issuanceDate, _object$expiration, _object$credentialSub, _object$issuer;
    var message = createBaseCredential();
    message.context = ((_object$context = object.context) == null ? void 0 : _object$context.map(function (e) {
      return e;
    })) || [];
    message.id = (_object$id = object.id) != null ? _object$id : "";
    message.type = ((_object$type = object.type) == null ? void 0 : _object$type.map(function (e) {
      return e;
    })) || [];
    message.issuanceDate = (_object$issuanceDate = object.issuanceDate) != null ? _object$issuanceDate : "";
    message.expiration = (_object$expiration = object.expiration) != null ? _object$expiration : "";
    message.credentialSubject = (_object$credentialSub = object.credentialSubject) != null ? _object$credentialSub : "";
    message.credentialStatus = object.credentialStatus !== undefined && object.credentialStatus !== null ? CredentialStatus.fromPartial(object.credentialStatus) : undefined;
    message.issuer = (_object$issuer = object.issuer) != null ? _object$issuer : "";
    message.credentialSchema = object.credentialSchema !== undefined && object.credentialSchema !== null ? CredentialSchema.fromPartial(object.credentialSchema) : undefined;
    message.proof = object.proof !== undefined && object.proof !== null ? CredentialProof.fromPartial(object.proof) : undefined;
    return message;
  }
};
function createBaseCredentialProof() {
  return {
    signatureProof: "",
    sparseMtProof: undefined
  };
}
var CredentialProof = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.signatureProof !== "") {
      writer.uint32(10).string(message.signatureProof);
    }
    if (message.sparseMtProof !== undefined) {
      writer.uint32(18).string(message.sparseMtProof);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseCredentialProof();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.signatureProof = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.sparseMtProof = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      signatureProof: isSet$b(object.signatureProof) ? globalThis.String(object.signatureProof) : "",
      sparseMtProof: isSet$b(object.sparseMtProof) ? globalThis.String(object.sparseMtProof) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.signatureProof !== "") {
      obj.signatureProof = message.signatureProof;
    }
    if (message.sparseMtProof !== undefined) {
      obj.sparseMtProof = message.sparseMtProof;
    }
    return obj;
  },
  create: function create(base) {
    return CredentialProof.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$signatureProo, _object$sparseMtProof;
    var message = createBaseCredentialProof();
    message.signatureProof = (_object$signatureProo = object.signatureProof) != null ? _object$signatureProo : "";
    message.sparseMtProof = (_object$sparseMtProof = object.sparseMtProof) != null ? _object$sparseMtProof : undefined;
    return message;
  }
};
function createBaseCredentialStatus() {
  return {
    id: "",
    revocationNonce: 0,
    type: ""
  };
}
var CredentialStatus = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.revocationNonce !== 0) {
      writer.uint32(16).int64(message.revocationNonce);
    }
    if (message.type !== "") {
      writer.uint32(26).string(message.type);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseCredentialStatus();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }
          message.revocationNonce = longToNumber$3(reader.int64());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.type = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      id: isSet$b(object.id) ? globalThis.String(object.id) : "",
      revocationNonce: isSet$b(object.revocationNonce) ? globalThis.Number(object.revocationNonce) : 0,
      type: isSet$b(object.type) ? globalThis.String(object.type) : ""
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.revocationNonce !== 0) {
      obj.revocationNonce = Math.round(message.revocationNonce);
    }
    if (message.type !== "") {
      obj.type = message.type;
    }
    return obj;
  },
  create: function create(base) {
    return CredentialStatus.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$id2, _object$revocationNon, _object$type2;
    var message = createBaseCredentialStatus();
    message.id = (_object$id2 = object.id) != null ? _object$id2 : "";
    message.revocationNonce = (_object$revocationNon = object.revocationNonce) != null ? _object$revocationNon : 0;
    message.type = (_object$type2 = object.type) != null ? _object$type2 : "";
    return message;
  }
};
function createBaseCredentialSchema() {
  return {
    id: "",
    type: ""
  };
}
var CredentialSchema = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.type !== "") {
      writer.uint32(18).string(message.type);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseCredentialSchema();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.type = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      id: isSet$b(object.id) ? globalThis.String(object.id) : "",
      type: isSet$b(object.type) ? globalThis.String(object.type) : ""
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.type !== "") {
      obj.type = message.type;
    }
    return obj;
  },
  create: function create(base) {
    return CredentialSchema.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$id3, _object$type3;
    var message = createBaseCredentialSchema();
    message.id = (_object$id3 = object.id) != null ? _object$id3 : "";
    message.type = (_object$type3 = object.type) != null ? _object$type3 : "";
    return message;
  }
};
function createBaseStringAttribute() {
  return {
    id: "",
    value: ""
  };
}
var StringAttribute = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseStringAttribute();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.value = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      id: isSet$b(object.id) ? globalThis.String(object.id) : "",
      value: isSet$b(object.value) ? globalThis.String(object.value) : ""
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },
  create: function create(base) {
    return StringAttribute.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$id4, _object$value;
    var message = createBaseStringAttribute();
    message.id = (_object$id4 = object.id) != null ? _object$id4 : "";
    message.value = (_object$value = object.value) != null ? _object$value : "";
    return message;
  }
};
function createBaseIntegerAttribute() {
  return {
    id: "",
    value: 0
  };
}
var IntegerAttribute = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.value !== 0) {
      writer.uint32(16).int64(message.value);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseIntegerAttribute();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }
          message.value = longToNumber$3(reader.int64());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      id: isSet$b(object.id) ? globalThis.String(object.id) : "",
      value: isSet$b(object.value) ? globalThis.Number(object.value) : 0
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.value !== 0) {
      obj.value = Math.round(message.value);
    }
    return obj;
  },
  create: function create(base) {
    return IntegerAttribute.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$id5, _object$value2;
    var message = createBaseIntegerAttribute();
    message.id = (_object$id5 = object.id) != null ? _object$id5 : "";
    message.value = (_object$value2 = object.value) != null ? _object$value2 : 0;
    return message;
  }
};
function createBaseDecimalAttribute() {
  return {
    id: "",
    value: 0
  };
}
var DecimalAttribute = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.value !== 0) {
      writer.uint32(17)["double"](message.value);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseDecimalAttribute();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 17) {
            break;
          }
          message.value = reader["double"]();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      id: isSet$b(object.id) ? globalThis.String(object.id) : "",
      value: isSet$b(object.value) ? globalThis.Number(object.value) : 0
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },
  create: function create(base) {
    return DecimalAttribute.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$id6, _object$value3;
    var message = createBaseDecimalAttribute();
    message.id = (_object$id6 = object.id) != null ? _object$id6 : "";
    message.value = (_object$value3 = object.value) != null ? _object$value3 : 0;
    return message;
  }
};
function createBaseBooleanAttribute() {
  return {
    id: "",
    value: false
  };
}
var BooleanAttribute = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.value === true) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseBooleanAttribute();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }
          message.value = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      id: isSet$b(object.id) ? globalThis.String(object.id) : "",
      value: isSet$b(object.value) ? globalThis.Boolean(object.value) : false
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.value === true) {
      obj.value = message.value;
    }
    return obj;
  },
  create: function create(base) {
    return BooleanAttribute.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$id7, _object$value4;
    var message = createBaseBooleanAttribute();
    message.id = (_object$id7 = object.id) != null ? _object$id7 : "";
    message.value = (_object$value4 = object.value) != null ? _object$value4 : false;
    return message;
  }
};
function createBaseDateAttribute() {
  return {
    id: "",
    value: ""
  };
}
var DateAttribute = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseDateAttribute();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.value = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      id: isSet$b(object.id) ? globalThis.String(object.id) : "",
      value: isSet$b(object.value) ? globalThis.String(object.value) : ""
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },
  create: function create(base) {
    return DateAttribute.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$id8, _object$value5;
    var message = createBaseDateAttribute();
    message.id = (_object$id8 = object.id) != null ? _object$id8 : "";
    message.value = (_object$value5 = object.value) != null ? _object$value5 : "";
    return message;
  }
};
function createBaseDateTimeAttribute() {
  return {
    id: "",
    value: ""
  };
}
var DateTimeAttribute = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseDateTimeAttribute();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.value = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      id: isSet$b(object.id) ? globalThis.String(object.id) : "",
      value: isSet$b(object.value) ? globalThis.String(object.value) : ""
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },
  create: function create(base) {
    return DateTimeAttribute.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$id9, _object$value6;
    var message = createBaseDateTimeAttribute();
    message.id = (_object$id9 = object.id) != null ? _object$id9 : "";
    message.value = (_object$value6 = object.value) != null ? _object$value6 : "";
    return message;
  }
};
function createBaseStringAttributeDefinition() {
  return {
    displayName: "",
    id: "",
    description: "",
    required: false
  };
}
var StringAttributeDefinition = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.displayName !== "") {
      writer.uint32(10).string(message.displayName);
    }
    if (message.id !== "") {
      writer.uint32(18).string(message.id);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    if (message.required === true) {
      writer.uint32(32).bool(message.required);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseStringAttributeDefinition();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.displayName = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.id = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.description = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }
          message.required = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      displayName: isSet$b(object.displayName) ? globalThis.String(object.displayName) : "",
      id: isSet$b(object.id) ? globalThis.String(object.id) : "",
      description: isSet$b(object.description) ? globalThis.String(object.description) : "",
      required: isSet$b(object.required) ? globalThis.Boolean(object.required) : false
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.displayName !== "") {
      obj.displayName = message.displayName;
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.required === true) {
      obj.required = message.required;
    }
    return obj;
  },
  create: function create(base) {
    return StringAttributeDefinition.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$displayName, _object$id10, _object$description, _object$required;
    var message = createBaseStringAttributeDefinition();
    message.displayName = (_object$displayName = object.displayName) != null ? _object$displayName : "";
    message.id = (_object$id10 = object.id) != null ? _object$id10 : "";
    message.description = (_object$description = object.description) != null ? _object$description : "";
    message.required = (_object$required = object.required) != null ? _object$required : false;
    return message;
  }
};
function createBaseIntegerAttributeDefinition() {
  return {
    displayName: "",
    id: "",
    description: "",
    required: false
  };
}
var IntegerAttributeDefinition = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.displayName !== "") {
      writer.uint32(10).string(message.displayName);
    }
    if (message.id !== "") {
      writer.uint32(18).string(message.id);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    if (message.required === true) {
      writer.uint32(32).bool(message.required);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseIntegerAttributeDefinition();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.displayName = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.id = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.description = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }
          message.required = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      displayName: isSet$b(object.displayName) ? globalThis.String(object.displayName) : "",
      id: isSet$b(object.id) ? globalThis.String(object.id) : "",
      description: isSet$b(object.description) ? globalThis.String(object.description) : "",
      required: isSet$b(object.required) ? globalThis.Boolean(object.required) : false
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.displayName !== "") {
      obj.displayName = message.displayName;
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.required === true) {
      obj.required = message.required;
    }
    return obj;
  },
  create: function create(base) {
    return IntegerAttributeDefinition.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$displayName2, _object$id11, _object$description2, _object$required2;
    var message = createBaseIntegerAttributeDefinition();
    message.displayName = (_object$displayName2 = object.displayName) != null ? _object$displayName2 : "";
    message.id = (_object$id11 = object.id) != null ? _object$id11 : "";
    message.description = (_object$description2 = object.description) != null ? _object$description2 : "";
    message.required = (_object$required2 = object.required) != null ? _object$required2 : false;
    return message;
  }
};
function createBaseDecimalAttributeDefinition() {
  return {
    displayName: "",
    id: "",
    description: "",
    required: false
  };
}
var DecimalAttributeDefinition = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.displayName !== "") {
      writer.uint32(10).string(message.displayName);
    }
    if (message.id !== "") {
      writer.uint32(18).string(message.id);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    if (message.required === true) {
      writer.uint32(32).bool(message.required);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseDecimalAttributeDefinition();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.displayName = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.id = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.description = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }
          message.required = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      displayName: isSet$b(object.displayName) ? globalThis.String(object.displayName) : "",
      id: isSet$b(object.id) ? globalThis.String(object.id) : "",
      description: isSet$b(object.description) ? globalThis.String(object.description) : "",
      required: isSet$b(object.required) ? globalThis.Boolean(object.required) : false
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.displayName !== "") {
      obj.displayName = message.displayName;
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.required === true) {
      obj.required = message.required;
    }
    return obj;
  },
  create: function create(base) {
    return DecimalAttributeDefinition.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$displayName3, _object$id12, _object$description3, _object$required3;
    var message = createBaseDecimalAttributeDefinition();
    message.displayName = (_object$displayName3 = object.displayName) != null ? _object$displayName3 : "";
    message.id = (_object$id12 = object.id) != null ? _object$id12 : "";
    message.description = (_object$description3 = object.description) != null ? _object$description3 : "";
    message.required = (_object$required3 = object.required) != null ? _object$required3 : false;
    return message;
  }
};
function createBaseBooleanAttributeDefinition() {
  return {
    displayName: "",
    id: "",
    description: "",
    required: false
  };
}
var BooleanAttributeDefinition = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.displayName !== "") {
      writer.uint32(10).string(message.displayName);
    }
    if (message.id !== "") {
      writer.uint32(18).string(message.id);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    if (message.required === true) {
      writer.uint32(32).bool(message.required);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseBooleanAttributeDefinition();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.displayName = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.id = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.description = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }
          message.required = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      displayName: isSet$b(object.displayName) ? globalThis.String(object.displayName) : "",
      id: isSet$b(object.id) ? globalThis.String(object.id) : "",
      description: isSet$b(object.description) ? globalThis.String(object.description) : "",
      required: isSet$b(object.required) ? globalThis.Boolean(object.required) : false
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.displayName !== "") {
      obj.displayName = message.displayName;
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.required === true) {
      obj.required = message.required;
    }
    return obj;
  },
  create: function create(base) {
    return BooleanAttributeDefinition.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$displayName4, _object$id13, _object$description4, _object$required4;
    var message = createBaseBooleanAttributeDefinition();
    message.displayName = (_object$displayName4 = object.displayName) != null ? _object$displayName4 : "";
    message.id = (_object$id13 = object.id) != null ? _object$id13 : "";
    message.description = (_object$description4 = object.description) != null ? _object$description4 : "";
    message.required = (_object$required4 = object.required) != null ? _object$required4 : false;
    return message;
  }
};
function createBaseDateAttributeDefinition() {
  return {
    displayName: "",
    id: "",
    description: "",
    required: false
  };
}
var DateAttributeDefinition = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.displayName !== "") {
      writer.uint32(10).string(message.displayName);
    }
    if (message.id !== "") {
      writer.uint32(18).string(message.id);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    if (message.required === true) {
      writer.uint32(32).bool(message.required);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseDateAttributeDefinition();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.displayName = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.id = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.description = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }
          message.required = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      displayName: isSet$b(object.displayName) ? globalThis.String(object.displayName) : "",
      id: isSet$b(object.id) ? globalThis.String(object.id) : "",
      description: isSet$b(object.description) ? globalThis.String(object.description) : "",
      required: isSet$b(object.required) ? globalThis.Boolean(object.required) : false
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.displayName !== "") {
      obj.displayName = message.displayName;
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.required === true) {
      obj.required = message.required;
    }
    return obj;
  },
  create: function create(base) {
    return DateAttributeDefinition.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$displayName5, _object$id14, _object$description5, _object$required5;
    var message = createBaseDateAttributeDefinition();
    message.displayName = (_object$displayName5 = object.displayName) != null ? _object$displayName5 : "";
    message.id = (_object$id14 = object.id) != null ? _object$id14 : "";
    message.description = (_object$description5 = object.description) != null ? _object$description5 : "";
    message.required = (_object$required5 = object.required) != null ? _object$required5 : false;
    return message;
  }
};
function createBaseDateTimeAttributeDefinition() {
  return {
    displayName: "",
    id: "",
    description: "",
    required: false
  };
}
var DateTimeAttributeDefinition = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.displayName !== "") {
      writer.uint32(10).string(message.displayName);
    }
    if (message.id !== "") {
      writer.uint32(18).string(message.id);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    if (message.required === true) {
      writer.uint32(32).bool(message.required);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseDateTimeAttributeDefinition();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.displayName = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.id = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.description = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }
          message.required = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      displayName: isSet$b(object.displayName) ? globalThis.String(object.displayName) : "",
      id: isSet$b(object.id) ? globalThis.String(object.id) : "",
      description: isSet$b(object.description) ? globalThis.String(object.description) : "",
      required: isSet$b(object.required) ? globalThis.Boolean(object.required) : false
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.displayName !== "") {
      obj.displayName = message.displayName;
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.required === true) {
      obj.required = message.required;
    }
    return obj;
  },
  create: function create(base) {
    return DateTimeAttributeDefinition.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$displayName6, _object$id15, _object$description6, _object$required6;
    var message = createBaseDateTimeAttributeDefinition();
    message.displayName = (_object$displayName6 = object.displayName) != null ? _object$displayName6 : "";
    message.id = (_object$id15 = object.id) != null ? _object$id15 : "";
    message.description = (_object$description6 = object.description) != null ? _object$description6 : "";
    message.required = (_object$required6 = object.required) != null ? _object$required6 : false;
    return message;
  }
};
function createBaseStringEnumAttributeDefinition() {
  return {
    displayName: "",
    id: "",
    description: "",
    required: false,
    "enum": []
  };
}
var StringEnumAttributeDefinition = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.displayName !== "") {
      writer.uint32(10).string(message.displayName);
    }
    if (message.id !== "") {
      writer.uint32(18).string(message.id);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    if (message.required === true) {
      writer.uint32(32).bool(message.required);
    }
    for (var _iterator3 = _createForOfIteratorHelperLoose(message["enum"]), _step3; !(_step3 = _iterator3()).done;) {
      var v = _step3.value;
      writer.uint32(42).string(v);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseStringEnumAttributeDefinition();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.displayName = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.id = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.description = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }
          message.required = reader.bool();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }
          message["enum"].push(reader.string());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      displayName: isSet$b(object.displayName) ? globalThis.String(object.displayName) : "",
      id: isSet$b(object.id) ? globalThis.String(object.id) : "",
      description: isSet$b(object.description) ? globalThis.String(object.description) : "",
      required: isSet$b(object.required) ? globalThis.Boolean(object.required) : false,
      "enum": globalThis.Array.isArray(object == null ? void 0 : object["enum"]) ? object["enum"].map(function (e) {
        return globalThis.String(e);
      }) : []
    };
  },
  toJSON: function toJSON(message) {
    var _message$enum;
    var obj = {};
    if (message.displayName !== "") {
      obj.displayName = message.displayName;
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.required === true) {
      obj.required = message.required;
    }
    if ((_message$enum = message["enum"]) != null && _message$enum.length) {
      obj["enum"] = message["enum"];
    }
    return obj;
  },
  create: function create(base) {
    return StringEnumAttributeDefinition.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$displayName7, _object$id16, _object$description7, _object$required7, _object$enum;
    var message = createBaseStringEnumAttributeDefinition();
    message.displayName = (_object$displayName7 = object.displayName) != null ? _object$displayName7 : "";
    message.id = (_object$id16 = object.id) != null ? _object$id16 : "";
    message.description = (_object$description7 = object.description) != null ? _object$description7 : "";
    message.required = (_object$required7 = object.required) != null ? _object$required7 : false;
    message["enum"] = ((_object$enum = object["enum"]) == null ? void 0 : _object$enum.map(function (e) {
      return e;
    })) || [];
    return message;
  }
};
function createBaseIntegerEnumAttributeDefinition() {
  return {
    displayName: "",
    id: "",
    description: "",
    required: false,
    "enum": []
  };
}
var IntegerEnumAttributeDefinition = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.displayName !== "") {
      writer.uint32(10).string(message.displayName);
    }
    if (message.id !== "") {
      writer.uint32(18).string(message.id);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    if (message.required === true) {
      writer.uint32(32).bool(message.required);
    }
    writer.uint32(42).fork();
    for (var _iterator4 = _createForOfIteratorHelperLoose(message["enum"]), _step4; !(_step4 = _iterator4()).done;) {
      var v = _step4.value;
      writer.int64(v);
    }
    writer.ldelim();
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseIntegerEnumAttributeDefinition();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.displayName = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.id = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.description = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }
          message.required = reader.bool();
          continue;
        case 5:
          if (tag === 40) {
            message["enum"].push(longToNumber$3(reader.int64()));
            continue;
          }
          if (tag === 42) {
            var end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message["enum"].push(longToNumber$3(reader.int64()));
            }
            continue;
          }
          break;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      displayName: isSet$b(object.displayName) ? globalThis.String(object.displayName) : "",
      id: isSet$b(object.id) ? globalThis.String(object.id) : "",
      description: isSet$b(object.description) ? globalThis.String(object.description) : "",
      required: isSet$b(object.required) ? globalThis.Boolean(object.required) : false,
      "enum": globalThis.Array.isArray(object == null ? void 0 : object["enum"]) ? object["enum"].map(function (e) {
        return globalThis.Number(e);
      }) : []
    };
  },
  toJSON: function toJSON(message) {
    var _message$enum2;
    var obj = {};
    if (message.displayName !== "") {
      obj.displayName = message.displayName;
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.required === true) {
      obj.required = message.required;
    }
    if ((_message$enum2 = message["enum"]) != null && _message$enum2.length) {
      obj["enum"] = message["enum"].map(function (e) {
        return Math.round(e);
      });
    }
    return obj;
  },
  create: function create(base) {
    return IntegerEnumAttributeDefinition.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$displayName8, _object$id17, _object$description8, _object$required8, _object$enum2;
    var message = createBaseIntegerEnumAttributeDefinition();
    message.displayName = (_object$displayName8 = object.displayName) != null ? _object$displayName8 : "";
    message.id = (_object$id17 = object.id) != null ? _object$id17 : "";
    message.description = (_object$description8 = object.description) != null ? _object$description8 : "";
    message.required = (_object$required8 = object.required) != null ? _object$required8 : false;
    message["enum"] = ((_object$enum2 = object["enum"]) == null ? void 0 : _object$enum2.map(function (e) {
      return e;
    })) || [];
    return message;
  }
};
function createBaseDecimalEnumAttributeDefinition() {
  return {
    displayName: "",
    id: "",
    description: "",
    required: false,
    "enum": []
  };
}
var DecimalEnumAttributeDefinition = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.displayName !== "") {
      writer.uint32(10).string(message.displayName);
    }
    if (message.id !== "") {
      writer.uint32(18).string(message.id);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    if (message.required === true) {
      writer.uint32(32).bool(message.required);
    }
    writer.uint32(42).fork();
    for (var _iterator5 = _createForOfIteratorHelperLoose(message["enum"]), _step5; !(_step5 = _iterator5()).done;) {
      var v = _step5.value;
      writer["double"](v);
    }
    writer.ldelim();
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseDecimalEnumAttributeDefinition();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.displayName = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.id = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.description = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }
          message.required = reader.bool();
          continue;
        case 5:
          if (tag === 41) {
            message["enum"].push(reader["double"]());
            continue;
          }
          if (tag === 42) {
            var end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message["enum"].push(reader["double"]());
            }
            continue;
          }
          break;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      displayName: isSet$b(object.displayName) ? globalThis.String(object.displayName) : "",
      id: isSet$b(object.id) ? globalThis.String(object.id) : "",
      description: isSet$b(object.description) ? globalThis.String(object.description) : "",
      required: isSet$b(object.required) ? globalThis.Boolean(object.required) : false,
      "enum": globalThis.Array.isArray(object == null ? void 0 : object["enum"]) ? object["enum"].map(function (e) {
        return globalThis.Number(e);
      }) : []
    };
  },
  toJSON: function toJSON(message) {
    var _message$enum3;
    var obj = {};
    if (message.displayName !== "") {
      obj.displayName = message.displayName;
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.required === true) {
      obj.required = message.required;
    }
    if ((_message$enum3 = message["enum"]) != null && _message$enum3.length) {
      obj["enum"] = message["enum"];
    }
    return obj;
  },
  create: function create(base) {
    return DecimalEnumAttributeDefinition.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$displayName9, _object$id18, _object$description9, _object$required9, _object$enum3;
    var message = createBaseDecimalEnumAttributeDefinition();
    message.displayName = (_object$displayName9 = object.displayName) != null ? _object$displayName9 : "";
    message.id = (_object$id18 = object.id) != null ? _object$id18 : "";
    message.description = (_object$description9 = object.description) != null ? _object$description9 : "";
    message.required = (_object$required9 = object.required) != null ? _object$required9 : false;
    message["enum"] = ((_object$enum3 = object["enum"]) == null ? void 0 : _object$enum3.map(function (e) {
      return e;
    })) || [];
    return message;
  }
};
function createBaseCredentialReceipt() {
  return {
    credential: undefined,
    credentialId: "",
    credentialType: ""
  };
}
var CredentialReceipt = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.credential !== undefined) {
      Credential.encode(message.credential, writer.uint32(10).fork()).ldelim();
    }
    if (message.credentialId !== "") {
      writer.uint32(18).string(message.credentialId);
    }
    if (message.credentialType !== "") {
      writer.uint32(26).string(message.credentialType);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseCredentialReceipt();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.credential = Credential.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.credentialId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.credentialType = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      credential: isSet$b(object.credential) ? Credential.fromJSON(object.credential) : undefined,
      credentialId: isSet$b(object.credentialId) ? globalThis.String(object.credentialId) : "",
      credentialType: isSet$b(object.credentialType) ? globalThis.String(object.credentialType) : ""
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.credential !== undefined) {
      obj.credential = Credential.toJSON(message.credential);
    }
    if (message.credentialId !== "") {
      obj.credentialId = message.credentialId;
    }
    if (message.credentialType !== "") {
      obj.credentialType = message.credentialType;
    }
    return obj;
  },
  create: function create(base) {
    return CredentialReceipt.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$credentialId, _object$credentialTyp;
    var message = createBaseCredentialReceipt();
    message.credential = object.credential !== undefined && object.credential !== null ? Credential.fromPartial(object.credential) : undefined;
    message.credentialId = (_object$credentialId = object.credentialId) != null ? _object$credentialId : "";
    message.credentialType = (_object$credentialTyp = object.credentialType) != null ? _object$credentialTyp : "";
    return message;
  }
};
function createBaseIssuerStateReceipt() {
  return {
    txHash: ""
  };
}
var IssuerStateReceipt = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.txHash !== "") {
      writer.uint32(10).string(message.txHash);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseIssuerStateReceipt();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.txHash = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      txHash: isSet$b(object.txHash) ? globalThis.String(object.txHash) : ""
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.txHash !== "") {
      obj.txHash = message.txHash;
    }
    return obj;
  },
  create: function create(base) {
    return IssuerStateReceipt.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$txHash;
    var message = createBaseIssuerStateReceipt();
    message.txHash = (_object$txHash = object.txHash) != null ? _object$txHash : "";
    return message;
  }
};
function createBaseSchema() {
  return {
    cid: "",
    cidJsonLd: "",
    schemaType: "",
    json: ""
  };
}
var Schema = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.cid !== "") {
      writer.uint32(10).string(message.cid);
    }
    if (message.cidJsonLd !== "") {
      writer.uint32(18).string(message.cidJsonLd);
    }
    if (message.schemaType !== "") {
      writer.uint32(26).string(message.schemaType);
    }
    if (message.json !== "") {
      writer.uint32(34).string(message.json);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseSchema();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.cid = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.cidJsonLd = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.schemaType = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }
          message.json = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      cid: isSet$b(object.cid) ? globalThis.String(object.cid) : "",
      cidJsonLd: isSet$b(object.cidJsonLd) ? globalThis.String(object.cidJsonLd) : "",
      schemaType: isSet$b(object.schemaType) ? globalThis.String(object.schemaType) : "",
      json: isSet$b(object.json) ? globalThis.String(object.json) : ""
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.cid !== "") {
      obj.cid = message.cid;
    }
    if (message.cidJsonLd !== "") {
      obj.cidJsonLd = message.cidJsonLd;
    }
    if (message.schemaType !== "") {
      obj.schemaType = message.schemaType;
    }
    if (message.json !== "") {
      obj.json = message.json;
    }
    return obj;
  },
  create: function create(base) {
    return Schema.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$cid, _object$cidJsonLd, _object$schemaType, _object$json;
    var message = createBaseSchema();
    message.cid = (_object$cid = object.cid) != null ? _object$cid : "";
    message.cidJsonLd = (_object$cidJsonLd = object.cidJsonLd) != null ? _object$cidJsonLd : "";
    message.schemaType = (_object$schemaType = object.schemaType) != null ? _object$schemaType : "";
    message.json = (_object$json = object.json) != null ? _object$json : "";
    return message;
  }
};
function createBaseCredentialRevocation() {
  return {
    success: false
  };
}
var CredentialRevocation = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.success === true) {
      writer.uint32(8).bool(message.success);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseCredentialRevocation();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }
          message.success = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      success: isSet$b(object.success) ? globalThis.Boolean(object.success) : false
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.success === true) {
      obj.success = message.success;
    }
    return obj;
  },
  create: function create(base) {
    return CredentialRevocation.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$success;
    var message = createBaseCredentialRevocation();
    message.success = (_object$success = object.success) != null ? _object$success : false;
    return message;
  }
};
function createBaseVerificationReceipt() {
  return {
    verificationRequest: "",
    sessionId: 0
  };
}
var VerificationReceipt = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.verificationRequest !== "") {
      writer.uint32(10).string(message.verificationRequest);
    }
    if (message.sessionId !== 0) {
      writer.uint32(16).int64(message.sessionId);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseVerificationReceipt();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.verificationRequest = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }
          message.sessionId = longToNumber$3(reader.int64());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      verificationRequest: isSet$b(object.verificationRequest) ? globalThis.String(object.verificationRequest) : "",
      sessionId: isSet$b(object.sessionId) ? globalThis.Number(object.sessionId) : 0
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.verificationRequest !== "") {
      obj.verificationRequest = message.verificationRequest;
    }
    if (message.sessionId !== 0) {
      obj.sessionId = Math.round(message.sessionId);
    }
    return obj;
  },
  create: function create(base) {
    return VerificationReceipt.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$verificationR, _object$sessionId;
    var message = createBaseVerificationReceipt();
    message.verificationRequest = (_object$verificationR = object.verificationRequest) != null ? _object$verificationR : "";
    message.sessionId = (_object$sessionId = object.sessionId) != null ? _object$sessionId : 0;
    return message;
  }
};
function createBaseSignatureJWS() {
  return {
    signature: "",
    "protected": "",
    header: undefined,
    messageHash: ""
  };
}
var SignatureJWS = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.signature !== "") {
      writer.uint32(10).string(message.signature);
    }
    if (message["protected"] !== "") {
      writer.uint32(18).string(message["protected"]);
    }
    if (message.header !== undefined) {
      SignatureHeaderJWS.encode(message.header, writer.uint32(26).fork()).ldelim();
    }
    if (message.messageHash !== "") {
      writer.uint32(34).string(message.messageHash);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseSignatureJWS();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.signature = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message["protected"] = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.header = SignatureHeaderJWS.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }
          message.messageHash = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      signature: isSet$b(object.signature) ? globalThis.String(object.signature) : "",
      "protected": isSet$b(object["protected"]) ? globalThis.String(object["protected"]) : "",
      header: isSet$b(object.header) ? SignatureHeaderJWS.fromJSON(object.header) : undefined,
      messageHash: isSet$b(object.messageHash) ? globalThis.String(object.messageHash) : ""
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.signature !== "") {
      obj.signature = message.signature;
    }
    if (message["protected"] !== "") {
      obj["protected"] = message["protected"];
    }
    if (message.header !== undefined) {
      obj.header = SignatureHeaderJWS.toJSON(message.header);
    }
    if (message.messageHash !== "") {
      obj.messageHash = message.messageHash;
    }
    return obj;
  },
  create: function create(base) {
    return SignatureJWS.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$signature, _object$protected, _object$messageHash;
    var message = createBaseSignatureJWS();
    message.signature = (_object$signature = object.signature) != null ? _object$signature : "";
    message["protected"] = (_object$protected = object["protected"]) != null ? _object$protected : "";
    message.header = object.header !== undefined && object.header !== null ? SignatureHeaderJWS.fromPartial(object.header) : undefined;
    message.messageHash = (_object$messageHash = object.messageHash) != null ? _object$messageHash : "";
    return message;
  }
};
function createBaseSignatureHeaderJWS() {
  return {
    alg: "",
    kid: "",
    subject: undefined,
    hashAlg: undefined
  };
}
var SignatureHeaderJWS = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.alg !== "") {
      writer.uint32(10).string(message.alg);
    }
    if (message.kid !== "") {
      writer.uint32(18).string(message.kid);
    }
    if (message.subject !== undefined) {
      writer.uint32(26).string(message.subject);
    }
    if (message.hashAlg !== undefined) {
      writer.uint32(34).string(message.hashAlg);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseSignatureHeaderJWS();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.alg = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.kid = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.subject = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }
          message.hashAlg = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      alg: isSet$b(object.alg) ? globalThis.String(object.alg) : "",
      kid: isSet$b(object.kid) ? globalThis.String(object.kid) : "",
      subject: isSet$b(object.subject) ? globalThis.String(object.subject) : undefined,
      hashAlg: isSet$b(object.hashAlg) ? globalThis.String(object.hashAlg) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.alg !== "") {
      obj.alg = message.alg;
    }
    if (message.kid !== "") {
      obj.kid = message.kid;
    }
    if (message.subject !== undefined) {
      obj.subject = message.subject;
    }
    if (message.hashAlg !== undefined) {
      obj.hashAlg = message.hashAlg;
    }
    return obj;
  },
  create: function create(base) {
    return SignatureHeaderJWS.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$alg, _object$kid, _object$subject, _object$hashAlg;
    var message = createBaseSignatureHeaderJWS();
    message.alg = (_object$alg = object.alg) != null ? _object$alg : "";
    message.kid = (_object$kid = object.kid) != null ? _object$kid : "";
    message.subject = (_object$subject = object.subject) != null ? _object$subject : undefined;
    message.hashAlg = (_object$hashAlg = object.hashAlg) != null ? _object$hashAlg : undefined;
    return message;
  }
};
function longToNumber$3(_long) {
  if (_long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return _long.toNumber();
}
if (_m0.util.Long !== Long) {
  _m0.util.Long = Long;
  _m0.configure();
}
function isSet$b(value) {
  return value !== null && value !== undefined;
}

function createBaseGetSchemaRequest() {
  return {
    configData: undefined,
    id: ""
  };
}
var GetSchemaRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.id !== "") {
      writer.uint32(18).string(message.id);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseGetSchemaRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.id = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$c(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      id: isSet$c(object.id) ? globalThis.String(object.id) : ""
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },
  create: function create(base) {
    return GetSchemaRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$id;
    var message = createBaseGetSchemaRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.id = (_object$id = object.id) != null ? _object$id : "";
    return message;
  }
};
function createBaseGetSchemaResponse() {
  return {
    schema: undefined,
    error: undefined
  };
}
var GetSchemaResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.schema !== undefined) {
      Schema.encode(message.schema, writer.uint32(10).fork()).ldelim();
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseGetSchemaResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.schema = Schema.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      schema: isSet$c(object.schema) ? Schema.fromJSON(object.schema) : undefined,
      error: isSet$c(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.schema !== undefined) {
      obj.schema = Schema.toJSON(message.schema);
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return GetSchemaResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseGetSchemaResponse();
    message.schema = object.schema !== undefined && object.schema !== null ? Schema.fromPartial(object.schema) : undefined;
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
function createBaseImportIssuerResponse() {
  return {
    did: "",
    error: undefined
  };
}
var ImportIssuerResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.did !== "") {
      writer.uint32(10).string(message.did);
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseImportIssuerResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.did = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      did: isSet$c(object.did) ? globalThis.String(object.did) : "",
      error: isSet$c(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.did !== "") {
      obj.did = message.did;
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return ImportIssuerResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$did;
    var message = createBaseImportIssuerResponse();
    message.did = (_object$did = object.did) != null ? _object$did : "";
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
function createBaseGetCredentialProofRequest() {
  return {
    configData: undefined,
    issuerDid: "",
    credentialId: ""
  };
}
var GetCredentialProofRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.issuerDid !== "") {
      writer.uint32(18).string(message.issuerDid);
    }
    if (message.credentialId !== "") {
      writer.uint32(26).string(message.credentialId);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseGetCredentialProofRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.issuerDid = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.credentialId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$c(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      issuerDid: isSet$c(object.issuerDid) ? globalThis.String(object.issuerDid) : "",
      credentialId: isSet$c(object.credentialId) ? globalThis.String(object.credentialId) : ""
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.issuerDid !== "") {
      obj.issuerDid = message.issuerDid;
    }
    if (message.credentialId !== "") {
      obj.credentialId = message.credentialId;
    }
    return obj;
  },
  create: function create(base) {
    return GetCredentialProofRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$issuerDid, _object$credentialId;
    var message = createBaseGetCredentialProofRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.issuerDid = (_object$issuerDid = object.issuerDid) != null ? _object$issuerDid : "";
    message.credentialId = (_object$credentialId = object.credentialId) != null ? _object$credentialId : "";
    return message;
  }
};
function createBaseGetCredentialProofResponse() {
  return {
    proof: undefined,
    error: undefined
  };
}
var GetCredentialProofResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.proof !== undefined) {
      CredentialProof.encode(message.proof, writer.uint32(10).fork()).ldelim();
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseGetCredentialProofResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.proof = CredentialProof.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      proof: isSet$c(object.proof) ? CredentialProof.fromJSON(object.proof) : undefined,
      error: isSet$c(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.proof !== undefined) {
      obj.proof = CredentialProof.toJSON(message.proof);
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return GetCredentialProofResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseGetCredentialProofResponse();
    message.proof = object.proof !== undefined && object.proof !== null ? CredentialProof.fromPartial(object.proof) : undefined;
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
function createBaseCredentialToJsonRequest() {
  return {
    configData: undefined,
    credential: undefined
  };
}
var CredentialToJsonRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.credential !== undefined) {
      Credential.encode(message.credential, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseCredentialToJsonRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.credential = Credential.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$c(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      credential: isSet$c(object.credential) ? Credential.fromJSON(object.credential) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.credential !== undefined) {
      obj.credential = Credential.toJSON(message.credential);
    }
    return obj;
  },
  create: function create(base) {
    return CredentialToJsonRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseCredentialToJsonRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.credential = object.credential !== undefined && object.credential !== null ? Credential.fromPartial(object.credential) : undefined;
    return message;
  }
};
function createBaseCredentialToJsonResponse() {
  return {
    json: "",
    error: undefined
  };
}
var CredentialToJsonResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.json !== "") {
      writer.uint32(10).string(message.json);
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseCredentialToJsonResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.json = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      json: isSet$c(object.json) ? globalThis.String(object.json) : "",
      error: isSet$c(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.json !== "") {
      obj.json = message.json;
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return CredentialToJsonResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$json;
    var message = createBaseCredentialToJsonResponse();
    message.json = (_object$json = object.json) != null ? _object$json : "";
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
function createBaseCredentialFromJsonRequest() {
  return {
    configData: undefined,
    json: ""
  };
}
var CredentialFromJsonRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.json !== "") {
      writer.uint32(18).string(message.json);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseCredentialFromJsonRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.json = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$c(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      json: isSet$c(object.json) ? globalThis.String(object.json) : ""
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.json !== "") {
      obj.json = message.json;
    }
    return obj;
  },
  create: function create(base) {
    return CredentialFromJsonRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$json2;
    var message = createBaseCredentialFromJsonRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.json = (_object$json2 = object.json) != null ? _object$json2 : "";
    return message;
  }
};
function createBaseCredentialFromJsonResponse() {
  return {
    credential: undefined,
    error: undefined
  };
}
var CredentialFromJsonResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.credential !== undefined) {
      Credential.encode(message.credential, writer.uint32(10).fork()).ldelim();
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseCredentialFromJsonResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.credential = Credential.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      credential: isSet$c(object.credential) ? Credential.fromJSON(object.credential) : undefined,
      error: isSet$c(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.credential !== undefined) {
      obj.credential = Credential.toJSON(message.credential);
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return CredentialFromJsonResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseCredentialFromJsonResponse();
    message.credential = object.credential !== undefined && object.credential !== null ? Credential.fromPartial(object.credential) : undefined;
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
function createBaseCreateCredentialRequest() {
  return {
    configData: undefined,
    schemaId: "",
    holderDid: "",
    expiration: 0,
    version: undefined,
    key: undefined,
    stringAttributes: [],
    integerAttributes: [],
    decimalAttributes: [],
    booleanAttributes: [],
    dateAttributes: [],
    datetimeAttributes: []
  };
}
var CreateCredentialRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.schemaId !== "") {
      writer.uint32(18).string(message.schemaId);
    }
    if (message.holderDid !== "") {
      writer.uint32(26).string(message.holderDid);
    }
    if (message.expiration !== 0) {
      writer.uint32(32).int64(message.expiration);
    }
    if (message.version !== undefined) {
      writer.uint32(40).int32(message.version);
    }
    if (message.key !== undefined) {
      Key.encode(message.key, writer.uint32(50).fork()).ldelim();
    }
    for (var _iterator = _createForOfIteratorHelperLoose(message.stringAttributes), _step; !(_step = _iterator()).done;) {
      var v = _step.value;
      StringAttribute.encode(v, writer.uint32(58).fork()).ldelim();
    }
    for (var _iterator2 = _createForOfIteratorHelperLoose(message.integerAttributes), _step2; !(_step2 = _iterator2()).done;) {
      var _v = _step2.value;
      IntegerAttribute.encode(_v, writer.uint32(66).fork()).ldelim();
    }
    for (var _iterator3 = _createForOfIteratorHelperLoose(message.decimalAttributes), _step3; !(_step3 = _iterator3()).done;) {
      var _v2 = _step3.value;
      DecimalAttribute.encode(_v2, writer.uint32(74).fork()).ldelim();
    }
    for (var _iterator4 = _createForOfIteratorHelperLoose(message.booleanAttributes), _step4; !(_step4 = _iterator4()).done;) {
      var _v3 = _step4.value;
      BooleanAttribute.encode(_v3, writer.uint32(82).fork()).ldelim();
    }
    for (var _iterator5 = _createForOfIteratorHelperLoose(message.dateAttributes), _step5; !(_step5 = _iterator5()).done;) {
      var _v4 = _step5.value;
      DateAttribute.encode(_v4, writer.uint32(90).fork()).ldelim();
    }
    for (var _iterator6 = _createForOfIteratorHelperLoose(message.datetimeAttributes), _step6; !(_step6 = _iterator6()).done;) {
      var _v5 = _step6.value;
      DateTimeAttribute.encode(_v5, writer.uint32(98).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseCreateCredentialRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.schemaId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.holderDid = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }
          message.expiration = longToNumber$4(reader.int64());
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }
          message.version = reader.int32();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }
          message.key = Key.decode(reader, reader.uint32());
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }
          message.stringAttributes.push(StringAttribute.decode(reader, reader.uint32()));
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }
          message.integerAttributes.push(IntegerAttribute.decode(reader, reader.uint32()));
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }
          message.decimalAttributes.push(DecimalAttribute.decode(reader, reader.uint32()));
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }
          message.booleanAttributes.push(BooleanAttribute.decode(reader, reader.uint32()));
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }
          message.dateAttributes.push(DateAttribute.decode(reader, reader.uint32()));
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }
          message.datetimeAttributes.push(DateTimeAttribute.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$c(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      schemaId: isSet$c(object.schemaId) ? globalThis.String(object.schemaId) : "",
      holderDid: isSet$c(object.holderDid) ? globalThis.String(object.holderDid) : "",
      expiration: isSet$c(object.expiration) ? globalThis.Number(object.expiration) : 0,
      version: isSet$c(object.version) ? globalThis.Number(object.version) : undefined,
      key: isSet$c(object.key) ? Key.fromJSON(object.key) : undefined,
      stringAttributes: globalThis.Array.isArray(object == null ? void 0 : object.stringAttributes) ? object.stringAttributes.map(function (e) {
        return StringAttribute.fromJSON(e);
      }) : [],
      integerAttributes: globalThis.Array.isArray(object == null ? void 0 : object.integerAttributes) ? object.integerAttributes.map(function (e) {
        return IntegerAttribute.fromJSON(e);
      }) : [],
      decimalAttributes: globalThis.Array.isArray(object == null ? void 0 : object.decimalAttributes) ? object.decimalAttributes.map(function (e) {
        return DecimalAttribute.fromJSON(e);
      }) : [],
      booleanAttributes: globalThis.Array.isArray(object == null ? void 0 : object.booleanAttributes) ? object.booleanAttributes.map(function (e) {
        return BooleanAttribute.fromJSON(e);
      }) : [],
      dateAttributes: globalThis.Array.isArray(object == null ? void 0 : object.dateAttributes) ? object.dateAttributes.map(function (e) {
        return DateAttribute.fromJSON(e);
      }) : [],
      datetimeAttributes: globalThis.Array.isArray(object == null ? void 0 : object.datetimeAttributes) ? object.datetimeAttributes.map(function (e) {
        return DateTimeAttribute.fromJSON(e);
      }) : []
    };
  },
  toJSON: function toJSON(message) {
    var _message$stringAttrib, _message$integerAttri, _message$decimalAttri, _message$booleanAttri, _message$dateAttribut, _message$datetimeAttr;
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.schemaId !== "") {
      obj.schemaId = message.schemaId;
    }
    if (message.holderDid !== "") {
      obj.holderDid = message.holderDid;
    }
    if (message.expiration !== 0) {
      obj.expiration = Math.round(message.expiration);
    }
    if (message.version !== undefined) {
      obj.version = Math.round(message.version);
    }
    if (message.key !== undefined) {
      obj.key = Key.toJSON(message.key);
    }
    if ((_message$stringAttrib = message.stringAttributes) != null && _message$stringAttrib.length) {
      obj.stringAttributes = message.stringAttributes.map(function (e) {
        return StringAttribute.toJSON(e);
      });
    }
    if ((_message$integerAttri = message.integerAttributes) != null && _message$integerAttri.length) {
      obj.integerAttributes = message.integerAttributes.map(function (e) {
        return IntegerAttribute.toJSON(e);
      });
    }
    if ((_message$decimalAttri = message.decimalAttributes) != null && _message$decimalAttri.length) {
      obj.decimalAttributes = message.decimalAttributes.map(function (e) {
        return DecimalAttribute.toJSON(e);
      });
    }
    if ((_message$booleanAttri = message.booleanAttributes) != null && _message$booleanAttri.length) {
      obj.booleanAttributes = message.booleanAttributes.map(function (e) {
        return BooleanAttribute.toJSON(e);
      });
    }
    if ((_message$dateAttribut = message.dateAttributes) != null && _message$dateAttribut.length) {
      obj.dateAttributes = message.dateAttributes.map(function (e) {
        return DateAttribute.toJSON(e);
      });
    }
    if ((_message$datetimeAttr = message.datetimeAttributes) != null && _message$datetimeAttr.length) {
      obj.datetimeAttributes = message.datetimeAttributes.map(function (e) {
        return DateTimeAttribute.toJSON(e);
      });
    }
    return obj;
  },
  create: function create(base) {
    return CreateCredentialRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$schemaId, _object$holderDid, _object$expiration, _object$version, _object$stringAttribu, _object$integerAttrib, _object$decimalAttrib, _object$booleanAttrib, _object$dateAttribute, _object$datetimeAttri;
    var message = createBaseCreateCredentialRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.schemaId = (_object$schemaId = object.schemaId) != null ? _object$schemaId : "";
    message.holderDid = (_object$holderDid = object.holderDid) != null ? _object$holderDid : "";
    message.expiration = (_object$expiration = object.expiration) != null ? _object$expiration : 0;
    message.version = (_object$version = object.version) != null ? _object$version : undefined;
    message.key = object.key !== undefined && object.key !== null ? Key.fromPartial(object.key) : undefined;
    message.stringAttributes = ((_object$stringAttribu = object.stringAttributes) == null ? void 0 : _object$stringAttribu.map(function (e) {
      return StringAttribute.fromPartial(e);
    })) || [];
    message.integerAttributes = ((_object$integerAttrib = object.integerAttributes) == null ? void 0 : _object$integerAttrib.map(function (e) {
      return IntegerAttribute.fromPartial(e);
    })) || [];
    message.decimalAttributes = ((_object$decimalAttrib = object.decimalAttributes) == null ? void 0 : _object$decimalAttrib.map(function (e) {
      return DecimalAttribute.fromPartial(e);
    })) || [];
    message.booleanAttributes = ((_object$booleanAttrib = object.booleanAttributes) == null ? void 0 : _object$booleanAttrib.map(function (e) {
      return BooleanAttribute.fromPartial(e);
    })) || [];
    message.dateAttributes = ((_object$dateAttribute = object.dateAttributes) == null ? void 0 : _object$dateAttribute.map(function (e) {
      return DateAttribute.fromPartial(e);
    })) || [];
    message.datetimeAttributes = ((_object$datetimeAttri = object.datetimeAttributes) == null ? void 0 : _object$datetimeAttri.map(function (e) {
      return DateTimeAttribute.fromPartial(e);
    })) || [];
    return message;
  }
};
function createBaseBuildSchemaRequest() {
  return {
    configData: undefined,
    displayName: "",
    schemaType: "",
    version: "",
    description: "",
    stringAttributes: [],
    integerAttributes: [],
    decimalAttributes: [],
    booleanAttributes: [],
    dateAttributes: [],
    datetimeAttributes: [],
    stringEnumAttributes: [],
    integerEnumAttributes: [],
    decimalEnumAttributes: []
  };
}
var BuildSchemaRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.displayName !== "") {
      writer.uint32(18).string(message.displayName);
    }
    if (message.schemaType !== "") {
      writer.uint32(26).string(message.schemaType);
    }
    if (message.version !== "") {
      writer.uint32(34).string(message.version);
    }
    if (message.description !== "") {
      writer.uint32(42).string(message.description);
    }
    for (var _iterator7 = _createForOfIteratorHelperLoose(message.stringAttributes), _step7; !(_step7 = _iterator7()).done;) {
      var v = _step7.value;
      StringAttributeDefinition.encode(v, writer.uint32(50).fork()).ldelim();
    }
    for (var _iterator8 = _createForOfIteratorHelperLoose(message.integerAttributes), _step8; !(_step8 = _iterator8()).done;) {
      var _v6 = _step8.value;
      IntegerAttributeDefinition.encode(_v6, writer.uint32(58).fork()).ldelim();
    }
    for (var _iterator9 = _createForOfIteratorHelperLoose(message.decimalAttributes), _step9; !(_step9 = _iterator9()).done;) {
      var _v7 = _step9.value;
      DecimalAttributeDefinition.encode(_v7, writer.uint32(66).fork()).ldelim();
    }
    for (var _iterator10 = _createForOfIteratorHelperLoose(message.booleanAttributes), _step10; !(_step10 = _iterator10()).done;) {
      var _v8 = _step10.value;
      BooleanAttributeDefinition.encode(_v8, writer.uint32(74).fork()).ldelim();
    }
    for (var _iterator11 = _createForOfIteratorHelperLoose(message.dateAttributes), _step11; !(_step11 = _iterator11()).done;) {
      var _v9 = _step11.value;
      DateAttributeDefinition.encode(_v9, writer.uint32(82).fork()).ldelim();
    }
    for (var _iterator12 = _createForOfIteratorHelperLoose(message.datetimeAttributes), _step12; !(_step12 = _iterator12()).done;) {
      var _v10 = _step12.value;
      DateTimeAttributeDefinition.encode(_v10, writer.uint32(90).fork()).ldelim();
    }
    for (var _iterator13 = _createForOfIteratorHelperLoose(message.stringEnumAttributes), _step13; !(_step13 = _iterator13()).done;) {
      var _v11 = _step13.value;
      StringEnumAttributeDefinition.encode(_v11, writer.uint32(98).fork()).ldelim();
    }
    for (var _iterator14 = _createForOfIteratorHelperLoose(message.integerEnumAttributes), _step14; !(_step14 = _iterator14()).done;) {
      var _v12 = _step14.value;
      IntegerEnumAttributeDefinition.encode(_v12, writer.uint32(106).fork()).ldelim();
    }
    for (var _iterator15 = _createForOfIteratorHelperLoose(message.decimalEnumAttributes), _step15; !(_step15 = _iterator15()).done;) {
      var _v13 = _step15.value;
      DecimalEnumAttributeDefinition.encode(_v13, writer.uint32(114).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseBuildSchemaRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.displayName = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.schemaType = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }
          message.version = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }
          message.description = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }
          message.stringAttributes.push(StringAttributeDefinition.decode(reader, reader.uint32()));
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }
          message.integerAttributes.push(IntegerAttributeDefinition.decode(reader, reader.uint32()));
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }
          message.decimalAttributes.push(DecimalAttributeDefinition.decode(reader, reader.uint32()));
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }
          message.booleanAttributes.push(BooleanAttributeDefinition.decode(reader, reader.uint32()));
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }
          message.dateAttributes.push(DateAttributeDefinition.decode(reader, reader.uint32()));
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }
          message.datetimeAttributes.push(DateTimeAttributeDefinition.decode(reader, reader.uint32()));
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }
          message.stringEnumAttributes.push(StringEnumAttributeDefinition.decode(reader, reader.uint32()));
          continue;
        case 13:
          if (tag !== 106) {
            break;
          }
          message.integerEnumAttributes.push(IntegerEnumAttributeDefinition.decode(reader, reader.uint32()));
          continue;
        case 14:
          if (tag !== 114) {
            break;
          }
          message.decimalEnumAttributes.push(DecimalEnumAttributeDefinition.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$c(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      displayName: isSet$c(object.displayName) ? globalThis.String(object.displayName) : "",
      schemaType: isSet$c(object.schemaType) ? globalThis.String(object.schemaType) : "",
      version: isSet$c(object.version) ? globalThis.String(object.version) : "",
      description: isSet$c(object.description) ? globalThis.String(object.description) : "",
      stringAttributes: globalThis.Array.isArray(object == null ? void 0 : object.stringAttributes) ? object.stringAttributes.map(function (e) {
        return StringAttributeDefinition.fromJSON(e);
      }) : [],
      integerAttributes: globalThis.Array.isArray(object == null ? void 0 : object.integerAttributes) ? object.integerAttributes.map(function (e) {
        return IntegerAttributeDefinition.fromJSON(e);
      }) : [],
      decimalAttributes: globalThis.Array.isArray(object == null ? void 0 : object.decimalAttributes) ? object.decimalAttributes.map(function (e) {
        return DecimalAttributeDefinition.fromJSON(e);
      }) : [],
      booleanAttributes: globalThis.Array.isArray(object == null ? void 0 : object.booleanAttributes) ? object.booleanAttributes.map(function (e) {
        return BooleanAttributeDefinition.fromJSON(e);
      }) : [],
      dateAttributes: globalThis.Array.isArray(object == null ? void 0 : object.dateAttributes) ? object.dateAttributes.map(function (e) {
        return DateAttributeDefinition.fromJSON(e);
      }) : [],
      datetimeAttributes: globalThis.Array.isArray(object == null ? void 0 : object.datetimeAttributes) ? object.datetimeAttributes.map(function (e) {
        return DateTimeAttributeDefinition.fromJSON(e);
      }) : [],
      stringEnumAttributes: globalThis.Array.isArray(object == null ? void 0 : object.stringEnumAttributes) ? object.stringEnumAttributes.map(function (e) {
        return StringEnumAttributeDefinition.fromJSON(e);
      }) : [],
      integerEnumAttributes: globalThis.Array.isArray(object == null ? void 0 : object.integerEnumAttributes) ? object.integerEnumAttributes.map(function (e) {
        return IntegerEnumAttributeDefinition.fromJSON(e);
      }) : [],
      decimalEnumAttributes: globalThis.Array.isArray(object == null ? void 0 : object.decimalEnumAttributes) ? object.decimalEnumAttributes.map(function (e) {
        return DecimalEnumAttributeDefinition.fromJSON(e);
      }) : []
    };
  },
  toJSON: function toJSON(message) {
    var _message$stringAttrib2, _message$integerAttri2, _message$decimalAttri2, _message$booleanAttri2, _message$dateAttribut2, _message$datetimeAttr2, _message$stringEnumAt, _message$integerEnumA, _message$decimalEnumA;
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.displayName !== "") {
      obj.displayName = message.displayName;
    }
    if (message.schemaType !== "") {
      obj.schemaType = message.schemaType;
    }
    if (message.version !== "") {
      obj.version = message.version;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if ((_message$stringAttrib2 = message.stringAttributes) != null && _message$stringAttrib2.length) {
      obj.stringAttributes = message.stringAttributes.map(function (e) {
        return StringAttributeDefinition.toJSON(e);
      });
    }
    if ((_message$integerAttri2 = message.integerAttributes) != null && _message$integerAttri2.length) {
      obj.integerAttributes = message.integerAttributes.map(function (e) {
        return IntegerAttributeDefinition.toJSON(e);
      });
    }
    if ((_message$decimalAttri2 = message.decimalAttributes) != null && _message$decimalAttri2.length) {
      obj.decimalAttributes = message.decimalAttributes.map(function (e) {
        return DecimalAttributeDefinition.toJSON(e);
      });
    }
    if ((_message$booleanAttri2 = message.booleanAttributes) != null && _message$booleanAttri2.length) {
      obj.booleanAttributes = message.booleanAttributes.map(function (e) {
        return BooleanAttributeDefinition.toJSON(e);
      });
    }
    if ((_message$dateAttribut2 = message.dateAttributes) != null && _message$dateAttribut2.length) {
      obj.dateAttributes = message.dateAttributes.map(function (e) {
        return DateAttributeDefinition.toJSON(e);
      });
    }
    if ((_message$datetimeAttr2 = message.datetimeAttributes) != null && _message$datetimeAttr2.length) {
      obj.datetimeAttributes = message.datetimeAttributes.map(function (e) {
        return DateTimeAttributeDefinition.toJSON(e);
      });
    }
    if ((_message$stringEnumAt = message.stringEnumAttributes) != null && _message$stringEnumAt.length) {
      obj.stringEnumAttributes = message.stringEnumAttributes.map(function (e) {
        return StringEnumAttributeDefinition.toJSON(e);
      });
    }
    if ((_message$integerEnumA = message.integerEnumAttributes) != null && _message$integerEnumA.length) {
      obj.integerEnumAttributes = message.integerEnumAttributes.map(function (e) {
        return IntegerEnumAttributeDefinition.toJSON(e);
      });
    }
    if ((_message$decimalEnumA = message.decimalEnumAttributes) != null && _message$decimalEnumA.length) {
      obj.decimalEnumAttributes = message.decimalEnumAttributes.map(function (e) {
        return DecimalEnumAttributeDefinition.toJSON(e);
      });
    }
    return obj;
  },
  create: function create(base) {
    return BuildSchemaRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$displayName, _object$schemaType, _object$version2, _object$description, _object$stringAttribu2, _object$integerAttrib2, _object$decimalAttrib2, _object$booleanAttrib2, _object$dateAttribute2, _object$datetimeAttri2, _object$stringEnumAtt, _object$integerEnumAt, _object$decimalEnumAt;
    var message = createBaseBuildSchemaRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.displayName = (_object$displayName = object.displayName) != null ? _object$displayName : "";
    message.schemaType = (_object$schemaType = object.schemaType) != null ? _object$schemaType : "";
    message.version = (_object$version2 = object.version) != null ? _object$version2 : "";
    message.description = (_object$description = object.description) != null ? _object$description : "";
    message.stringAttributes = ((_object$stringAttribu2 = object.stringAttributes) == null ? void 0 : _object$stringAttribu2.map(function (e) {
      return StringAttributeDefinition.fromPartial(e);
    })) || [];
    message.integerAttributes = ((_object$integerAttrib2 = object.integerAttributes) == null ? void 0 : _object$integerAttrib2.map(function (e) {
      return IntegerAttributeDefinition.fromPartial(e);
    })) || [];
    message.decimalAttributes = ((_object$decimalAttrib2 = object.decimalAttributes) == null ? void 0 : _object$decimalAttrib2.map(function (e) {
      return DecimalAttributeDefinition.fromPartial(e);
    })) || [];
    message.booleanAttributes = ((_object$booleanAttrib2 = object.booleanAttributes) == null ? void 0 : _object$booleanAttrib2.map(function (e) {
      return BooleanAttributeDefinition.fromPartial(e);
    })) || [];
    message.dateAttributes = ((_object$dateAttribute2 = object.dateAttributes) == null ? void 0 : _object$dateAttribute2.map(function (e) {
      return DateAttributeDefinition.fromPartial(e);
    })) || [];
    message.datetimeAttributes = ((_object$datetimeAttri2 = object.datetimeAttributes) == null ? void 0 : _object$datetimeAttri2.map(function (e) {
      return DateTimeAttributeDefinition.fromPartial(e);
    })) || [];
    message.stringEnumAttributes = ((_object$stringEnumAtt = object.stringEnumAttributes) == null ? void 0 : _object$stringEnumAtt.map(function (e) {
      return StringEnumAttributeDefinition.fromPartial(e);
    })) || [];
    message.integerEnumAttributes = ((_object$integerEnumAt = object.integerEnumAttributes) == null ? void 0 : _object$integerEnumAt.map(function (e) {
      return IntegerEnumAttributeDefinition.fromPartial(e);
    })) || [];
    message.decimalEnumAttributes = ((_object$decimalEnumAt = object.decimalEnumAttributes) == null ? void 0 : _object$decimalEnumAt.map(function (e) {
      return DecimalEnumAttributeDefinition.fromPartial(e);
    })) || [];
    return message;
  }
};
function createBaseCreateHolderRequest() {
  return {
    key: undefined,
    configData: undefined,
    didMethod: 0
  };
}
var CreateHolderRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.key !== undefined) {
      Key.encode(message.key, writer.uint32(10).fork()).ldelim();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(18).fork()).ldelim();
    }
    if (message.didMethod !== 0) {
      writer.uint32(24).int32(message.didMethod);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseCreateHolderRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.key = Key.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }
          message.didMethod = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      key: isSet$c(object.key) ? Key.fromJSON(object.key) : undefined,
      configData: isSet$c(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      didMethod: isSet$c(object.didMethod) ? didMethodFromJSON(object.didMethod) : 0
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.key !== undefined) {
      obj.key = Key.toJSON(message.key);
    }
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.didMethod !== 0) {
      obj.didMethod = didMethodToJSON(message.didMethod);
    }
    return obj;
  },
  create: function create(base) {
    return CreateHolderRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$didMethod;
    var message = createBaseCreateHolderRequest();
    message.key = object.key !== undefined && object.key !== null ? Key.fromPartial(object.key) : undefined;
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.didMethod = (_object$didMethod = object.didMethod) != null ? _object$didMethod : 0;
    return message;
  }
};
function createBaseCreateIssuerRequest() {
  return {
    key: undefined,
    configData: undefined,
    didMethod: 0,
    name: undefined,
    description: undefined,
    image: undefined,
    publishInterval: 0
  };
}
var CreateIssuerRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.key !== undefined) {
      Key.encode(message.key, writer.uint32(10).fork()).ldelim();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(18).fork()).ldelim();
    }
    if (message.didMethod !== 0) {
      writer.uint32(24).int32(message.didMethod);
    }
    if (message.name !== undefined) {
      writer.uint32(34).string(message.name);
    }
    if (message.description !== undefined) {
      writer.uint32(42).string(message.description);
    }
    if (message.image !== undefined) {
      writer.uint32(50).string(message.image);
    }
    if (message.publishInterval !== 0) {
      writer.uint32(56).int32(message.publishInterval);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseCreateIssuerRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.key = Key.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }
          message.didMethod = reader.int32();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }
          message.name = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }
          message.description = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }
          message.image = reader.string();
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }
          message.publishInterval = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      key: isSet$c(object.key) ? Key.fromJSON(object.key) : undefined,
      configData: isSet$c(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      didMethod: isSet$c(object.didMethod) ? didMethodFromJSON(object.didMethod) : 0,
      name: isSet$c(object.name) ? globalThis.String(object.name) : undefined,
      description: isSet$c(object.description) ? globalThis.String(object.description) : undefined,
      image: isSet$c(object.image) ? globalThis.String(object.image) : undefined,
      publishInterval: isSet$c(object.publishInterval) ? publishIntervalFromJSON(object.publishInterval) : 0
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.key !== undefined) {
      obj.key = Key.toJSON(message.key);
    }
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.didMethod !== 0) {
      obj.didMethod = didMethodToJSON(message.didMethod);
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.image !== undefined) {
      obj.image = message.image;
    }
    if (message.publishInterval !== 0) {
      obj.publishInterval = publishIntervalToJSON(message.publishInterval);
    }
    return obj;
  },
  create: function create(base) {
    return CreateIssuerRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$didMethod2, _object$name, _object$description2, _object$image, _object$publishInterv;
    var message = createBaseCreateIssuerRequest();
    message.key = object.key !== undefined && object.key !== null ? Key.fromPartial(object.key) : undefined;
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.didMethod = (_object$didMethod2 = object.didMethod) != null ? _object$didMethod2 : 0;
    message.name = (_object$name = object.name) != null ? _object$name : undefined;
    message.description = (_object$description2 = object.description) != null ? _object$description2 : undefined;
    message.image = (_object$image = object.image) != null ? _object$image : undefined;
    message.publishInterval = (_object$publishInterv = object.publishInterval) != null ? _object$publishInterv : 0;
    return message;
  }
};
function createBaseImportIssuerRequest() {
  return {
    key: undefined,
    configData: undefined,
    didMethod: 0
  };
}
var ImportIssuerRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.key !== undefined) {
      Key.encode(message.key, writer.uint32(10).fork()).ldelim();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(18).fork()).ldelim();
    }
    if (message.didMethod !== 0) {
      writer.uint32(24).int32(message.didMethod);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseImportIssuerRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.key = Key.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }
          message.didMethod = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      key: isSet$c(object.key) ? Key.fromJSON(object.key) : undefined,
      configData: isSet$c(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      didMethod: isSet$c(object.didMethod) ? didMethodFromJSON(object.didMethod) : 0
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.key !== undefined) {
      obj.key = Key.toJSON(message.key);
    }
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.didMethod !== 0) {
      obj.didMethod = didMethodToJSON(message.didMethod);
    }
    return obj;
  },
  create: function create(base) {
    return ImportIssuerRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$didMethod3;
    var message = createBaseImportIssuerRequest();
    message.key = object.key !== undefined && object.key !== null ? Key.fromPartial(object.key) : undefined;
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.didMethod = (_object$didMethod3 = object.didMethod) != null ? _object$didMethod3 : 0;
    return message;
  }
};
function createBaseForcePublishIssuerStateRequest() {
  return {
    configData: undefined,
    issuerDid: "",
    key: undefined
  };
}
var ForcePublishIssuerStateRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.issuerDid !== "") {
      writer.uint32(18).string(message.issuerDid);
    }
    if (message.key !== undefined) {
      Key.encode(message.key, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseForcePublishIssuerStateRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.issuerDid = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.key = Key.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$c(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      issuerDid: isSet$c(object.issuerDid) ? globalThis.String(object.issuerDid) : "",
      key: isSet$c(object.key) ? Key.fromJSON(object.key) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.issuerDid !== "") {
      obj.issuerDid = message.issuerDid;
    }
    if (message.key !== undefined) {
      obj.key = Key.toJSON(message.key);
    }
    return obj;
  },
  create: function create(base) {
    return ForcePublishIssuerStateRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$issuerDid2;
    var message = createBaseForcePublishIssuerStateRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.issuerDid = (_object$issuerDid2 = object.issuerDid) != null ? _object$issuerDid2 : "";
    message.key = object.key !== undefined && object.key !== null ? Key.fromPartial(object.key) : undefined;
    return message;
  }
};
function createBaseCreateCredentialResponse() {
  return {
    credentialReceipt: undefined,
    error: undefined
  };
}
var CreateCredentialResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.credentialReceipt !== undefined) {
      CredentialReceipt.encode(message.credentialReceipt, writer.uint32(10).fork()).ldelim();
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseCreateCredentialResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.credentialReceipt = CredentialReceipt.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      credentialReceipt: isSet$c(object.credentialReceipt) ? CredentialReceipt.fromJSON(object.credentialReceipt) : undefined,
      error: isSet$c(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.credentialReceipt !== undefined) {
      obj.credentialReceipt = CredentialReceipt.toJSON(message.credentialReceipt);
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return CreateCredentialResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseCreateCredentialResponse();
    message.credentialReceipt = object.credentialReceipt !== undefined && object.credentialReceipt !== null ? CredentialReceipt.fromPartial(object.credentialReceipt) : undefined;
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
function createBaseCreateHolderResponse() {
  return {
    did: "",
    error: undefined
  };
}
var CreateHolderResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.did !== "") {
      writer.uint32(10).string(message.did);
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseCreateHolderResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.did = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      did: isSet$c(object.did) ? globalThis.String(object.did) : "",
      error: isSet$c(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.did !== "") {
      obj.did = message.did;
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return CreateHolderResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$did2;
    var message = createBaseCreateHolderResponse();
    message.did = (_object$did2 = object.did) != null ? _object$did2 : "";
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
function createBaseCreateIssuerResponse() {
  return {
    did: "",
    error: undefined
  };
}
var CreateIssuerResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.did !== "") {
      writer.uint32(10).string(message.did);
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseCreateIssuerResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.did = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      did: isSet$c(object.did) ? globalThis.String(object.did) : "",
      error: isSet$c(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.did !== "") {
      obj.did = message.did;
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return CreateIssuerResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$did3;
    var message = createBaseCreateIssuerResponse();
    message.did = (_object$did3 = object.did) != null ? _object$did3 : "";
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
function createBaseBuildSchemaResponse() {
  return {
    schema: undefined,
    error: undefined
  };
}
var BuildSchemaResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.schema !== undefined) {
      Schema.encode(message.schema, writer.uint32(10).fork()).ldelim();
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseBuildSchemaResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.schema = Schema.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      schema: isSet$c(object.schema) ? Schema.fromJSON(object.schema) : undefined,
      error: isSet$c(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.schema !== undefined) {
      obj.schema = Schema.toJSON(message.schema);
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return BuildSchemaResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseBuildSchemaResponse();
    message.schema = object.schema !== undefined && object.schema !== null ? Schema.fromPartial(object.schema) : undefined;
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
function createBaseForcePublishIssuerStateResponse() {
  return {
    stateReceipt: undefined,
    error: undefined
  };
}
var ForcePublishIssuerStateResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.stateReceipt !== undefined) {
      IssuerStateReceipt.encode(message.stateReceipt, writer.uint32(10).fork()).ldelim();
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseForcePublishIssuerStateResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.stateReceipt = IssuerStateReceipt.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      stateReceipt: isSet$c(object.stateReceipt) ? IssuerStateReceipt.fromJSON(object.stateReceipt) : undefined,
      error: isSet$c(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.stateReceipt !== undefined) {
      obj.stateReceipt = IssuerStateReceipt.toJSON(message.stateReceipt);
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return ForcePublishIssuerStateResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseForcePublishIssuerStateResponse();
    message.stateReceipt = object.stateReceipt !== undefined && object.stateReceipt !== null ? IssuerStateReceipt.fromPartial(object.stateReceipt) : undefined;
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
function createBaseRevokeCredentialRequest() {
  return {
    configData: undefined,
    credential: undefined,
    key: undefined
  };
}
var RevokeCredentialRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.credential !== undefined) {
      Credential.encode(message.credential, writer.uint32(18).fork()).ldelim();
    }
    if (message.key !== undefined) {
      Key.encode(message.key, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseRevokeCredentialRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.credential = Credential.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.key = Key.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$c(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      credential: isSet$c(object.credential) ? Credential.fromJSON(object.credential) : undefined,
      key: isSet$c(object.key) ? Key.fromJSON(object.key) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.credential !== undefined) {
      obj.credential = Credential.toJSON(message.credential);
    }
    if (message.key !== undefined) {
      obj.key = Key.toJSON(message.key);
    }
    return obj;
  },
  create: function create(base) {
    return RevokeCredentialRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseRevokeCredentialRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.credential = object.credential !== undefined && object.credential !== null ? Credential.fromPartial(object.credential) : undefined;
    message.key = object.key !== undefined && object.key !== null ? Key.fromPartial(object.key) : undefined;
    return message;
  }
};
function createBaseRevokeCredentialResponse() {
  return {
    result: undefined,
    error: undefined
  };
}
var RevokeCredentialResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.result !== undefined) {
      CredentialRevocation.encode(message.result, writer.uint32(10).fork()).ldelim();
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseRevokeCredentialResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.result = CredentialRevocation.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      result: isSet$c(object.result) ? CredentialRevocation.fromJSON(object.result) : undefined,
      error: isSet$c(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.result !== undefined) {
      obj.result = CredentialRevocation.toJSON(message.result);
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return RevokeCredentialResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseRevokeCredentialResponse();
    message.result = object.result !== undefined && object.result !== null ? CredentialRevocation.fromPartial(object.result) : undefined;
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
function createBaseCreateVerificationRequest() {
  return {
    configData: undefined,
    proofRequest: ""
  };
}
var CreateVerificationRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.proofRequest !== "") {
      writer.uint32(18).string(message.proofRequest);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseCreateVerificationRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.proofRequest = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$c(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      proofRequest: isSet$c(object.proofRequest) ? globalThis.String(object.proofRequest) : ""
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.proofRequest !== "") {
      obj.proofRequest = message.proofRequest;
    }
    return obj;
  },
  create: function create(base) {
    return CreateVerificationRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$proofRequest;
    var message = createBaseCreateVerificationRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.proofRequest = (_object$proofRequest = object.proofRequest) != null ? _object$proofRequest : "";
    return message;
  }
};
function createBaseCreateVerificationResponse() {
  return {
    result: undefined,
    error: undefined
  };
}
var CreateVerificationResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.result !== undefined) {
      VerificationReceipt.encode(message.result, writer.uint32(10).fork()).ldelim();
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseCreateVerificationResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.result = VerificationReceipt.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      result: isSet$c(object.result) ? VerificationReceipt.fromJSON(object.result) : undefined,
      error: isSet$c(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.result !== undefined) {
      obj.result = VerificationReceipt.toJSON(message.result);
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return CreateVerificationResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseCreateVerificationResponse();
    message.result = object.result !== undefined && object.result !== null ? VerificationReceipt.fromPartial(object.result) : undefined;
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
function createBaseWaitVerificationRequest() {
  return {
    configData: undefined,
    sessionId: 0,
    timeout: 0
  };
}
var WaitVerificationRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.sessionId !== 0) {
      writer.uint32(16).int64(message.sessionId);
    }
    if (message.timeout !== 0) {
      writer.uint32(24).int64(message.timeout);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseWaitVerificationRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }
          message.sessionId = longToNumber$4(reader.int64());
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }
          message.timeout = longToNumber$4(reader.int64());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$c(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      sessionId: isSet$c(object.sessionId) ? globalThis.Number(object.sessionId) : 0,
      timeout: isSet$c(object.timeout) ? globalThis.Number(object.timeout) : 0
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.sessionId !== 0) {
      obj.sessionId = Math.round(message.sessionId);
    }
    if (message.timeout !== 0) {
      obj.timeout = Math.round(message.timeout);
    }
    return obj;
  },
  create: function create(base) {
    return WaitVerificationRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$sessionId, _object$timeout;
    var message = createBaseWaitVerificationRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.sessionId = (_object$sessionId = object.sessionId) != null ? _object$sessionId : 0;
    message.timeout = (_object$timeout = object.timeout) != null ? _object$timeout : 0;
    return message;
  }
};
function createBaseWaitVerificationResponse() {
  return {
    status: false,
    error: undefined
  };
}
var WaitVerificationResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.status === true) {
      writer.uint32(8).bool(message.status);
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseWaitVerificationResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }
          message.status = reader.bool();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      status: isSet$c(object.status) ? globalThis.Boolean(object.status) : false,
      error: isSet$c(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.status === true) {
      obj.status = message.status;
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return WaitVerificationResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$status;
    var message = createBaseWaitVerificationResponse();
    message.status = (_object$status = object.status) != null ? _object$status : false;
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
function createBaseGetVerificationStatusRequest() {
  return {
    configData: undefined,
    sessionId: 0
  };
}
var GetVerificationStatusRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.sessionId !== 0) {
      writer.uint32(16).int64(message.sessionId);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseGetVerificationStatusRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }
          message.sessionId = longToNumber$4(reader.int64());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$c(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      sessionId: isSet$c(object.sessionId) ? globalThis.Number(object.sessionId) : 0
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.sessionId !== 0) {
      obj.sessionId = Math.round(message.sessionId);
    }
    return obj;
  },
  create: function create(base) {
    return GetVerificationStatusRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$sessionId2;
    var message = createBaseGetVerificationStatusRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.sessionId = (_object$sessionId2 = object.sessionId) != null ? _object$sessionId2 : 0;
    return message;
  }
};
function createBaseGetVerificationStatusResponse() {
  return {
    status: false,
    error: undefined
  };
}
var GetVerificationStatusResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.status === true) {
      writer.uint32(8).bool(message.status);
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseGetVerificationStatusResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }
          message.status = reader.bool();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      status: isSet$c(object.status) ? globalThis.Boolean(object.status) : false,
      error: isSet$c(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.status === true) {
      obj.status = message.status;
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return GetVerificationStatusResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$status2;
    var message = createBaseGetVerificationStatusResponse();
    message.status = (_object$status2 = object.status) != null ? _object$status2 : false;
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
function createBaseGetCredentialRequest() {
  return {
    configData: undefined,
    credentialId: ""
  };
}
var GetCredentialRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.credentialId !== "") {
      writer.uint32(18).string(message.credentialId);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseGetCredentialRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.credentialId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$c(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      credentialId: isSet$c(object.credentialId) ? globalThis.String(object.credentialId) : ""
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.credentialId !== "") {
      obj.credentialId = message.credentialId;
    }
    return obj;
  },
  create: function create(base) {
    return GetCredentialRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$credentialId2;
    var message = createBaseGetCredentialRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.credentialId = (_object$credentialId2 = object.credentialId) != null ? _object$credentialId2 : "";
    return message;
  }
};
function createBaseGetCredentialResponse() {
  return {
    credential: undefined,
    error: undefined
  };
}
var GetCredentialResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.credential !== undefined) {
      Credential.encode(message.credential, writer.uint32(10).fork()).ldelim();
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseGetCredentialResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.credential = Credential.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      credential: isSet$c(object.credential) ? Credential.fromJSON(object.credential) : undefined,
      error: isSet$c(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.credential !== undefined) {
      obj.credential = Credential.toJSON(message.credential);
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return GetCredentialResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseGetCredentialResponse();
    message.credential = object.credential !== undefined && object.credential !== null ? Credential.fromPartial(object.credential) : undefined;
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
function createBaseGetCredentialOfferRequest() {
  return {
    configData: undefined,
    credentialId: "",
    key: undefined
  };
}
var GetCredentialOfferRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.credentialId !== "") {
      writer.uint32(18).string(message.credentialId);
    }
    if (message.key !== undefined) {
      Key.encode(message.key, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseGetCredentialOfferRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.credentialId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.key = Key.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$c(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      credentialId: isSet$c(object.credentialId) ? globalThis.String(object.credentialId) : "",
      key: isSet$c(object.key) ? Key.fromJSON(object.key) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.credentialId !== "") {
      obj.credentialId = message.credentialId;
    }
    if (message.key !== undefined) {
      obj.key = Key.toJSON(message.key);
    }
    return obj;
  },
  create: function create(base) {
    return GetCredentialOfferRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$credentialId3;
    var message = createBaseGetCredentialOfferRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.credentialId = (_object$credentialId3 = object.credentialId) != null ? _object$credentialId3 : "";
    message.key = object.key !== undefined && object.key !== null ? Key.fromPartial(object.key) : undefined;
    return message;
  }
};
function createBaseGetCredentialOfferResponse() {
  return {
    credentialOffer: "",
    error: undefined
  };
}
var GetCredentialOfferResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.credentialOffer !== "") {
      writer.uint32(10).string(message.credentialOffer);
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseGetCredentialOfferResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.credentialOffer = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      credentialOffer: isSet$c(object.credentialOffer) ? globalThis.String(object.credentialOffer) : "",
      error: isSet$c(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.credentialOffer !== "") {
      obj.credentialOffer = message.credentialOffer;
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return GetCredentialOfferResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$credentialOff;
    var message = createBaseGetCredentialOfferResponse();
    message.credentialOffer = (_object$credentialOff = object.credentialOffer) != null ? _object$credentialOff : "";
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
var IdentityServiceServiceName = "bloock.IdentityService";
var IdentityServiceClientImpl = /*#__PURE__*/function () {
  function IdentityServiceClientImpl(rpc, opts) {
    this.service = (opts == null ? void 0 : opts.service) || IdentityServiceServiceName;
    this.rpc = rpc;
    this.CreateHolder = this.CreateHolder.bind(this);
    this.CreateIssuer = this.CreateIssuer.bind(this);
    this.ImportIssuer = this.ImportIssuer.bind(this);
    this.BuildSchema = this.BuildSchema.bind(this);
    this.GetSchema = this.GetSchema.bind(this);
    this.CreateCredential = this.CreateCredential.bind(this);
    this.GetCredential = this.GetCredential.bind(this);
    this.GetCredentialProof = this.GetCredentialProof.bind(this);
    this.RevokeCredential = this.RevokeCredential.bind(this);
    this.CredentialToJson = this.CredentialToJson.bind(this);
    this.CredentialFromJson = this.CredentialFromJson.bind(this);
    this.GetCredentialOffer = this.GetCredentialOffer.bind(this);
    this.ForcePublishIssuerState = this.ForcePublishIssuerState.bind(this);
    this.CreateVerification = this.CreateVerification.bind(this);
    this.WaitVerification = this.WaitVerification.bind(this);
    this.GetVerificationStatus = this.GetVerificationStatus.bind(this);
  }
  var _proto = IdentityServiceClientImpl.prototype;
  _proto.CreateHolder = function CreateHolder(request) {
    var data = CreateHolderRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "CreateHolder", data);
    return promise.then(function (data) {
      return CreateHolderResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.CreateIssuer = function CreateIssuer(request) {
    var data = CreateIssuerRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "CreateIssuer", data);
    return promise.then(function (data) {
      return CreateIssuerResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.ImportIssuer = function ImportIssuer(request) {
    var data = ImportIssuerRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "ImportIssuer", data);
    return promise.then(function (data) {
      return ImportIssuerResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.BuildSchema = function BuildSchema(request) {
    var data = BuildSchemaRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "BuildSchema", data);
    return promise.then(function (data) {
      return BuildSchemaResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.GetSchema = function GetSchema(request) {
    var data = GetSchemaRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "GetSchema", data);
    return promise.then(function (data) {
      return GetSchemaResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.CreateCredential = function CreateCredential(request) {
    var data = CreateCredentialRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "CreateCredential", data);
    return promise.then(function (data) {
      return CreateCredentialResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.GetCredential = function GetCredential(request) {
    var data = GetCredentialRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "GetCredential", data);
    return promise.then(function (data) {
      return GetCredentialResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.GetCredentialProof = function GetCredentialProof(request) {
    var data = GetCredentialProofRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "GetCredentialProof", data);
    return promise.then(function (data) {
      return GetCredentialProofResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.RevokeCredential = function RevokeCredential(request) {
    var data = RevokeCredentialRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "RevokeCredential", data);
    return promise.then(function (data) {
      return RevokeCredentialResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.CredentialToJson = function CredentialToJson(request) {
    var data = CredentialToJsonRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "CredentialToJson", data);
    return promise.then(function (data) {
      return CredentialToJsonResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.CredentialFromJson = function CredentialFromJson(request) {
    var data = CredentialFromJsonRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "CredentialFromJson", data);
    return promise.then(function (data) {
      return CredentialFromJsonResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.GetCredentialOffer = function GetCredentialOffer(request) {
    var data = GetCredentialOfferRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "GetCredentialOffer", data);
    return promise.then(function (data) {
      return GetCredentialOfferResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.ForcePublishIssuerState = function ForcePublishIssuerState(request) {
    var data = ForcePublishIssuerStateRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "ForcePublishIssuerState", data);
    return promise.then(function (data) {
      return ForcePublishIssuerStateResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.CreateVerification = function CreateVerification(request) {
    var data = CreateVerificationRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "CreateVerification", data);
    return promise.then(function (data) {
      return CreateVerificationResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.WaitVerification = function WaitVerification(request) {
    var data = WaitVerificationRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "WaitVerification", data);
    return promise.then(function (data) {
      return WaitVerificationResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.GetVerificationStatus = function GetVerificationStatus(request) {
    var data = GetVerificationStatusRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "GetVerificationStatus", data);
    return promise.then(function (data) {
      return GetVerificationStatusResponse.decode(_m0.Reader.create(data));
    });
  };
  return IdentityServiceClientImpl;
}();
function longToNumber$4(_long) {
  if (_long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return _long.toNumber();
}
if (_m0.util.Long !== Long) {
  _m0.util.Long = Long;
  _m0.configure();
}
function isSet$c(value) {
  return value !== null && value !== undefined;
}

function createBaseCreateCoreCredentialRequest() {
  return {
    configData: undefined,
    schemaId: "",
    issuerDid: "",
    holderDid: "",
    expiration: 0,
    version: undefined,
    key: undefined,
    stringAttributes: [],
    integerAttributes: [],
    decimalAttributes: [],
    booleanAttributes: [],
    dateAttributes: [],
    datetimeAttributes: []
  };
}
var CreateCoreCredentialRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.schemaId !== "") {
      writer.uint32(18).string(message.schemaId);
    }
    if (message.issuerDid !== "") {
      writer.uint32(26).string(message.issuerDid);
    }
    if (message.holderDid !== "") {
      writer.uint32(34).string(message.holderDid);
    }
    if (message.expiration !== 0) {
      writer.uint32(40).int64(message.expiration);
    }
    if (message.version !== undefined) {
      writer.uint32(48).int32(message.version);
    }
    if (message.key !== undefined) {
      Key.encode(message.key, writer.uint32(58).fork()).ldelim();
    }
    for (var _iterator = _createForOfIteratorHelperLoose(message.stringAttributes), _step; !(_step = _iterator()).done;) {
      var v = _step.value;
      StringAttribute.encode(v, writer.uint32(66).fork()).ldelim();
    }
    for (var _iterator2 = _createForOfIteratorHelperLoose(message.integerAttributes), _step2; !(_step2 = _iterator2()).done;) {
      var _v = _step2.value;
      IntegerAttribute.encode(_v, writer.uint32(74).fork()).ldelim();
    }
    for (var _iterator3 = _createForOfIteratorHelperLoose(message.decimalAttributes), _step3; !(_step3 = _iterator3()).done;) {
      var _v2 = _step3.value;
      DecimalAttribute.encode(_v2, writer.uint32(82).fork()).ldelim();
    }
    for (var _iterator4 = _createForOfIteratorHelperLoose(message.booleanAttributes), _step4; !(_step4 = _iterator4()).done;) {
      var _v3 = _step4.value;
      BooleanAttribute.encode(_v3, writer.uint32(90).fork()).ldelim();
    }
    for (var _iterator5 = _createForOfIteratorHelperLoose(message.dateAttributes), _step5; !(_step5 = _iterator5()).done;) {
      var _v4 = _step5.value;
      DateAttribute.encode(_v4, writer.uint32(98).fork()).ldelim();
    }
    for (var _iterator6 = _createForOfIteratorHelperLoose(message.datetimeAttributes), _step6; !(_step6 = _iterator6()).done;) {
      var _v5 = _step6.value;
      DateTimeAttribute.encode(_v5, writer.uint32(106).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseCreateCoreCredentialRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.schemaId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.issuerDid = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }
          message.holderDid = reader.string();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }
          message.expiration = longToNumber$5(reader.int64());
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }
          message.version = reader.int32();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }
          message.key = Key.decode(reader, reader.uint32());
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }
          message.stringAttributes.push(StringAttribute.decode(reader, reader.uint32()));
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }
          message.integerAttributes.push(IntegerAttribute.decode(reader, reader.uint32()));
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }
          message.decimalAttributes.push(DecimalAttribute.decode(reader, reader.uint32()));
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }
          message.booleanAttributes.push(BooleanAttribute.decode(reader, reader.uint32()));
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }
          message.dateAttributes.push(DateAttribute.decode(reader, reader.uint32()));
          continue;
        case 13:
          if (tag !== 106) {
            break;
          }
          message.datetimeAttributes.push(DateTimeAttribute.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$d(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      schemaId: isSet$d(object.schemaId) ? globalThis.String(object.schemaId) : "",
      issuerDid: isSet$d(object.issuerDid) ? globalThis.String(object.issuerDid) : "",
      holderDid: isSet$d(object.holderDid) ? globalThis.String(object.holderDid) : "",
      expiration: isSet$d(object.expiration) ? globalThis.Number(object.expiration) : 0,
      version: isSet$d(object.version) ? globalThis.Number(object.version) : undefined,
      key: isSet$d(object.key) ? Key.fromJSON(object.key) : undefined,
      stringAttributes: globalThis.Array.isArray(object == null ? void 0 : object.stringAttributes) ? object.stringAttributes.map(function (e) {
        return StringAttribute.fromJSON(e);
      }) : [],
      integerAttributes: globalThis.Array.isArray(object == null ? void 0 : object.integerAttributes) ? object.integerAttributes.map(function (e) {
        return IntegerAttribute.fromJSON(e);
      }) : [],
      decimalAttributes: globalThis.Array.isArray(object == null ? void 0 : object.decimalAttributes) ? object.decimalAttributes.map(function (e) {
        return DecimalAttribute.fromJSON(e);
      }) : [],
      booleanAttributes: globalThis.Array.isArray(object == null ? void 0 : object.booleanAttributes) ? object.booleanAttributes.map(function (e) {
        return BooleanAttribute.fromJSON(e);
      }) : [],
      dateAttributes: globalThis.Array.isArray(object == null ? void 0 : object.dateAttributes) ? object.dateAttributes.map(function (e) {
        return DateAttribute.fromJSON(e);
      }) : [],
      datetimeAttributes: globalThis.Array.isArray(object == null ? void 0 : object.datetimeAttributes) ? object.datetimeAttributes.map(function (e) {
        return DateTimeAttribute.fromJSON(e);
      }) : []
    };
  },
  toJSON: function toJSON(message) {
    var _message$stringAttrib, _message$integerAttri, _message$decimalAttri, _message$booleanAttri, _message$dateAttribut, _message$datetimeAttr;
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.schemaId !== "") {
      obj.schemaId = message.schemaId;
    }
    if (message.issuerDid !== "") {
      obj.issuerDid = message.issuerDid;
    }
    if (message.holderDid !== "") {
      obj.holderDid = message.holderDid;
    }
    if (message.expiration !== 0) {
      obj.expiration = Math.round(message.expiration);
    }
    if (message.version !== undefined) {
      obj.version = Math.round(message.version);
    }
    if (message.key !== undefined) {
      obj.key = Key.toJSON(message.key);
    }
    if ((_message$stringAttrib = message.stringAttributes) != null && _message$stringAttrib.length) {
      obj.stringAttributes = message.stringAttributes.map(function (e) {
        return StringAttribute.toJSON(e);
      });
    }
    if ((_message$integerAttri = message.integerAttributes) != null && _message$integerAttri.length) {
      obj.integerAttributes = message.integerAttributes.map(function (e) {
        return IntegerAttribute.toJSON(e);
      });
    }
    if ((_message$decimalAttri = message.decimalAttributes) != null && _message$decimalAttri.length) {
      obj.decimalAttributes = message.decimalAttributes.map(function (e) {
        return DecimalAttribute.toJSON(e);
      });
    }
    if ((_message$booleanAttri = message.booleanAttributes) != null && _message$booleanAttri.length) {
      obj.booleanAttributes = message.booleanAttributes.map(function (e) {
        return BooleanAttribute.toJSON(e);
      });
    }
    if ((_message$dateAttribut = message.dateAttributes) != null && _message$dateAttribut.length) {
      obj.dateAttributes = message.dateAttributes.map(function (e) {
        return DateAttribute.toJSON(e);
      });
    }
    if ((_message$datetimeAttr = message.datetimeAttributes) != null && _message$datetimeAttr.length) {
      obj.datetimeAttributes = message.datetimeAttributes.map(function (e) {
        return DateTimeAttribute.toJSON(e);
      });
    }
    return obj;
  },
  create: function create(base) {
    return CreateCoreCredentialRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$schemaId, _object$issuerDid, _object$holderDid, _object$expiration, _object$version, _object$stringAttribu, _object$integerAttrib, _object$decimalAttrib, _object$booleanAttrib, _object$dateAttribute, _object$datetimeAttri;
    var message = createBaseCreateCoreCredentialRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.schemaId = (_object$schemaId = object.schemaId) != null ? _object$schemaId : "";
    message.issuerDid = (_object$issuerDid = object.issuerDid) != null ? _object$issuerDid : "";
    message.holderDid = (_object$holderDid = object.holderDid) != null ? _object$holderDid : "";
    message.expiration = (_object$expiration = object.expiration) != null ? _object$expiration : 0;
    message.version = (_object$version = object.version) != null ? _object$version : undefined;
    message.key = object.key !== undefined && object.key !== null ? Key.fromPartial(object.key) : undefined;
    message.stringAttributes = ((_object$stringAttribu = object.stringAttributes) == null ? void 0 : _object$stringAttribu.map(function (e) {
      return StringAttribute.fromPartial(e);
    })) || [];
    message.integerAttributes = ((_object$integerAttrib = object.integerAttributes) == null ? void 0 : _object$integerAttrib.map(function (e) {
      return IntegerAttribute.fromPartial(e);
    })) || [];
    message.decimalAttributes = ((_object$decimalAttrib = object.decimalAttributes) == null ? void 0 : _object$decimalAttrib.map(function (e) {
      return DecimalAttribute.fromPartial(e);
    })) || [];
    message.booleanAttributes = ((_object$booleanAttrib = object.booleanAttributes) == null ? void 0 : _object$booleanAttrib.map(function (e) {
      return BooleanAttribute.fromPartial(e);
    })) || [];
    message.dateAttributes = ((_object$dateAttribute = object.dateAttributes) == null ? void 0 : _object$dateAttribute.map(function (e) {
      return DateAttribute.fromPartial(e);
    })) || [];
    message.datetimeAttributes = ((_object$datetimeAttri = object.datetimeAttributes) == null ? void 0 : _object$datetimeAttri.map(function (e) {
      return DateTimeAttribute.fromPartial(e);
    })) || [];
    return message;
  }
};
function createBaseCreateCoreCredentialResponse() {
  return {
    credentialReceipt: undefined,
    error: undefined
  };
}
var CreateCoreCredentialResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.credentialReceipt !== undefined) {
      CredentialReceipt.encode(message.credentialReceipt, writer.uint32(10).fork()).ldelim();
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseCreateCoreCredentialResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.credentialReceipt = CredentialReceipt.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      credentialReceipt: isSet$d(object.credentialReceipt) ? CredentialReceipt.fromJSON(object.credentialReceipt) : undefined,
      error: isSet$d(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.credentialReceipt !== undefined) {
      obj.credentialReceipt = CredentialReceipt.toJSON(message.credentialReceipt);
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return CreateCoreCredentialResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseCreateCoreCredentialResponse();
    message.credentialReceipt = object.credentialReceipt !== undefined && object.credentialReceipt !== null ? CredentialReceipt.fromPartial(object.credentialReceipt) : undefined;
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
var IdentityCoreServiceServiceName = "bloock.IdentityCoreService";
var IdentityCoreServiceClientImpl = /*#__PURE__*/function () {
  function IdentityCoreServiceClientImpl(rpc, opts) {
    this.service = (opts == null ? void 0 : opts.service) || IdentityCoreServiceServiceName;
    this.rpc = rpc;
    this.CreateCoreCredential = this.CreateCoreCredential.bind(this);
  }
  var _proto = IdentityCoreServiceClientImpl.prototype;
  _proto.CreateCoreCredential = function CreateCoreCredential(request) {
    var data = CreateCoreCredentialRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "CreateCoreCredential", data);
    return promise.then(function (data) {
      return CreateCoreCredentialResponse.decode(_m0.Reader.create(data));
    });
  };
  return IdentityCoreServiceClientImpl;
}();
function longToNumber$5(_long) {
  if (_long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return _long.toNumber();
}
if (_m0.util.Long !== Long) {
  _m0.util.Long = Long;
  _m0.configure();
}
function isSet$d(value) {
  return value !== null && value !== undefined;
}

function createBaseSendRecordsRequest() {
  return {
    configData: undefined,
    records: []
  };
}
var SendRecordsRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    for (var _iterator = _createForOfIteratorHelperLoose(message.records), _step; !(_step = _iterator()).done;) {
      var v = _step.value;
      Record.encode(v, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseSendRecordsRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.records.push(Record.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$e(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      records: globalThis.Array.isArray(object == null ? void 0 : object.records) ? object.records.map(function (e) {
        return Record.fromJSON(e);
      }) : []
    };
  },
  toJSON: function toJSON(message) {
    var _message$records;
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if ((_message$records = message.records) != null && _message$records.length) {
      obj.records = message.records.map(function (e) {
        return Record.toJSON(e);
      });
    }
    return obj;
  },
  create: function create(base) {
    return SendRecordsRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$records;
    var message = createBaseSendRecordsRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.records = ((_object$records = object.records) == null ? void 0 : _object$records.map(function (e) {
      return Record.fromPartial(e);
    })) || [];
    return message;
  }
};
function createBaseSendRecordsResponse() {
  return {
    records: [],
    error: undefined
  };
}
var SendRecordsResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    for (var _iterator2 = _createForOfIteratorHelperLoose(message.records), _step2; !(_step2 = _iterator2()).done;) {
      var v = _step2.value;
      RecordReceipt.encode(v, writer.uint32(10).fork()).ldelim();
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseSendRecordsResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.records.push(RecordReceipt.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      records: globalThis.Array.isArray(object == null ? void 0 : object.records) ? object.records.map(function (e) {
        return RecordReceipt.fromJSON(e);
      }) : [],
      error: isSet$e(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var _message$records2;
    var obj = {};
    if ((_message$records2 = message.records) != null && _message$records2.length) {
      obj.records = message.records.map(function (e) {
        return RecordReceipt.toJSON(e);
      });
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return SendRecordsResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$records2;
    var message = createBaseSendRecordsResponse();
    message.records = ((_object$records2 = object.records) == null ? void 0 : _object$records2.map(function (e) {
      return RecordReceipt.fromPartial(e);
    })) || [];
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
function createBaseGetAnchorRequest() {
  return {
    configData: undefined,
    anchorId: 0
  };
}
var GetAnchorRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.anchorId !== 0) {
      writer.uint32(16).int64(message.anchorId);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseGetAnchorRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }
          message.anchorId = longToNumber$6(reader.int64());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$e(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      anchorId: isSet$e(object.anchorId) ? globalThis.Number(object.anchorId) : 0
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.anchorId !== 0) {
      obj.anchorId = Math.round(message.anchorId);
    }
    return obj;
  },
  create: function create(base) {
    return GetAnchorRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$anchorId;
    var message = createBaseGetAnchorRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.anchorId = (_object$anchorId = object.anchorId) != null ? _object$anchorId : 0;
    return message;
  }
};
function createBaseGetAnchorResponse() {
  return {
    anchor: undefined,
    error: undefined
  };
}
var GetAnchorResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.anchor !== undefined) {
      Anchor.encode(message.anchor, writer.uint32(10).fork()).ldelim();
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseGetAnchorResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.anchor = Anchor.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      anchor: isSet$e(object.anchor) ? Anchor.fromJSON(object.anchor) : undefined,
      error: isSet$e(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.anchor !== undefined) {
      obj.anchor = Anchor.toJSON(message.anchor);
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return GetAnchorResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseGetAnchorResponse();
    message.anchor = object.anchor !== undefined && object.anchor !== null ? Anchor.fromPartial(object.anchor) : undefined;
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
function createBaseWaitAnchorRequest() {
  return {
    configData: undefined,
    anchorId: 0,
    timeout: 0
  };
}
var WaitAnchorRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.anchorId !== 0) {
      writer.uint32(16).int64(message.anchorId);
    }
    if (message.timeout !== 0) {
      writer.uint32(24).int64(message.timeout);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseWaitAnchorRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }
          message.anchorId = longToNumber$6(reader.int64());
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }
          message.timeout = longToNumber$6(reader.int64());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$e(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      anchorId: isSet$e(object.anchorId) ? globalThis.Number(object.anchorId) : 0,
      timeout: isSet$e(object.timeout) ? globalThis.Number(object.timeout) : 0
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.anchorId !== 0) {
      obj.anchorId = Math.round(message.anchorId);
    }
    if (message.timeout !== 0) {
      obj.timeout = Math.round(message.timeout);
    }
    return obj;
  },
  create: function create(base) {
    return WaitAnchorRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$anchorId2, _object$timeout;
    var message = createBaseWaitAnchorRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.anchorId = (_object$anchorId2 = object.anchorId) != null ? _object$anchorId2 : 0;
    message.timeout = (_object$timeout = object.timeout) != null ? _object$timeout : 0;
    return message;
  }
};
function createBaseWaitAnchorResponse() {
  return {
    anchor: undefined,
    error: undefined
  };
}
var WaitAnchorResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.anchor !== undefined) {
      Anchor.encode(message.anchor, writer.uint32(10).fork()).ldelim();
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseWaitAnchorResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.anchor = Anchor.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      anchor: isSet$e(object.anchor) ? Anchor.fromJSON(object.anchor) : undefined,
      error: isSet$e(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.anchor !== undefined) {
      obj.anchor = Anchor.toJSON(message.anchor);
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return WaitAnchorResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseWaitAnchorResponse();
    message.anchor = object.anchor !== undefined && object.anchor !== null ? Anchor.fromPartial(object.anchor) : undefined;
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
function createBaseGetProofRequest() {
  return {
    configData: undefined,
    records: []
  };
}
var GetProofRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    for (var _iterator3 = _createForOfIteratorHelperLoose(message.records), _step3; !(_step3 = _iterator3()).done;) {
      var v = _step3.value;
      Record.encode(v, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseGetProofRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.records.push(Record.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$e(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      records: globalThis.Array.isArray(object == null ? void 0 : object.records) ? object.records.map(function (e) {
        return Record.fromJSON(e);
      }) : []
    };
  },
  toJSON: function toJSON(message) {
    var _message$records3;
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if ((_message$records3 = message.records) != null && _message$records3.length) {
      obj.records = message.records.map(function (e) {
        return Record.toJSON(e);
      });
    }
    return obj;
  },
  create: function create(base) {
    return GetProofRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$records3;
    var message = createBaseGetProofRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.records = ((_object$records3 = object.records) == null ? void 0 : _object$records3.map(function (e) {
      return Record.fromPartial(e);
    })) || [];
    return message;
  }
};
function createBaseGetProofResponse() {
  return {
    proof: undefined,
    error: undefined
  };
}
var GetProofResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.proof !== undefined) {
      Proof.encode(message.proof, writer.uint32(10).fork()).ldelim();
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseGetProofResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.proof = Proof.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      proof: isSet$e(object.proof) ? Proof.fromJSON(object.proof) : undefined,
      error: isSet$e(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.proof !== undefined) {
      obj.proof = Proof.toJSON(message.proof);
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return GetProofResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseGetProofResponse();
    message.proof = object.proof !== undefined && object.proof !== null ? Proof.fromPartial(object.proof) : undefined;
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
function createBaseValidateRootRequest() {
  return {
    configData: undefined,
    root: "",
    network: 0
  };
}
var ValidateRootRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.root !== "") {
      writer.uint32(18).string(message.root);
    }
    if (message.network !== 0) {
      writer.uint32(24).int32(message.network);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseValidateRootRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.root = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }
          message.network = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$e(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      root: isSet$e(object.root) ? globalThis.String(object.root) : "",
      network: isSet$e(object.network) ? networkFromJSON(object.network) : 0
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.root !== "") {
      obj.root = message.root;
    }
    if (message.network !== 0) {
      obj.network = networkToJSON(message.network);
    }
    return obj;
  },
  create: function create(base) {
    return ValidateRootRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$root, _object$network;
    var message = createBaseValidateRootRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.root = (_object$root = object.root) != null ? _object$root : "";
    message.network = (_object$network = object.network) != null ? _object$network : 0;
    return message;
  }
};
function createBaseValidateRootResponse() {
  return {
    timestamp: 0,
    error: undefined
  };
}
var ValidateRootResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.timestamp !== 0) {
      writer.uint32(8).uint64(message.timestamp);
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseValidateRootResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }
          message.timestamp = longToNumber$6(reader.uint64());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      timestamp: isSet$e(object.timestamp) ? globalThis.Number(object.timestamp) : 0,
      error: isSet$e(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.timestamp !== 0) {
      obj.timestamp = Math.round(message.timestamp);
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return ValidateRootResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$timestamp;
    var message = createBaseValidateRootResponse();
    message.timestamp = (_object$timestamp = object.timestamp) != null ? _object$timestamp : 0;
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
function createBaseVerifyProofRequest() {
  return {
    configData: undefined,
    proof: undefined
  };
}
var VerifyProofRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.proof !== undefined) {
      Proof.encode(message.proof, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseVerifyProofRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.proof = Proof.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$e(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      proof: isSet$e(object.proof) ? Proof.fromJSON(object.proof) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.proof !== undefined) {
      obj.proof = Proof.toJSON(message.proof);
    }
    return obj;
  },
  create: function create(base) {
    return VerifyProofRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseVerifyProofRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.proof = object.proof !== undefined && object.proof !== null ? Proof.fromPartial(object.proof) : undefined;
    return message;
  }
};
function createBaseVerifyProofResponse() {
  return {
    record: undefined,
    error: undefined
  };
}
var VerifyProofResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.record !== undefined) {
      writer.uint32(10).string(message.record);
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseVerifyProofResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.record = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      record: isSet$e(object.record) ? globalThis.String(object.record) : undefined,
      error: isSet$e(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.record !== undefined) {
      obj.record = message.record;
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return VerifyProofResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$record;
    var message = createBaseVerifyProofResponse();
    message.record = (_object$record = object.record) != null ? _object$record : undefined;
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
function createBaseVerifyRecordsRequest() {
  return {
    configData: undefined,
    records: [],
    network: undefined
  };
}
var VerifyRecordsRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    for (var _iterator4 = _createForOfIteratorHelperLoose(message.records), _step4; !(_step4 = _iterator4()).done;) {
      var v = _step4.value;
      Record.encode(v, writer.uint32(18).fork()).ldelim();
    }
    if (message.network !== undefined) {
      writer.uint32(24).int32(message.network);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseVerifyRecordsRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.records.push(Record.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }
          message.network = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$e(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      records: globalThis.Array.isArray(object == null ? void 0 : object.records) ? object.records.map(function (e) {
        return Record.fromJSON(e);
      }) : [],
      network: isSet$e(object.network) ? networkFromJSON(object.network) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var _message$records4;
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if ((_message$records4 = message.records) != null && _message$records4.length) {
      obj.records = message.records.map(function (e) {
        return Record.toJSON(e);
      });
    }
    if (message.network !== undefined) {
      obj.network = networkToJSON(message.network);
    }
    return obj;
  },
  create: function create(base) {
    return VerifyRecordsRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$records4, _object$network2;
    var message = createBaseVerifyRecordsRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.records = ((_object$records4 = object.records) == null ? void 0 : _object$records4.map(function (e) {
      return Record.fromPartial(e);
    })) || [];
    message.network = (_object$network2 = object.network) != null ? _object$network2 : undefined;
    return message;
  }
};
function createBaseVerifyRecordsResponse() {
  return {
    timestamp: 0,
    error: undefined
  };
}
var VerifyRecordsResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.timestamp !== 0) {
      writer.uint32(8).uint64(message.timestamp);
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseVerifyRecordsResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }
          message.timestamp = longToNumber$6(reader.uint64());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      timestamp: isSet$e(object.timestamp) ? globalThis.Number(object.timestamp) : 0,
      error: isSet$e(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.timestamp !== 0) {
      obj.timestamp = Math.round(message.timestamp);
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return VerifyRecordsResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$timestamp2;
    var message = createBaseVerifyRecordsResponse();
    message.timestamp = (_object$timestamp2 = object.timestamp) != null ? _object$timestamp2 : 0;
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
var IntegrityServiceServiceName = "bloock.IntegrityService";
var IntegrityServiceClientImpl = /*#__PURE__*/function () {
  function IntegrityServiceClientImpl(rpc, opts) {
    this.service = (opts == null ? void 0 : opts.service) || IntegrityServiceServiceName;
    this.rpc = rpc;
    this.SendRecords = this.SendRecords.bind(this);
    this.GetAnchor = this.GetAnchor.bind(this);
    this.WaitAnchor = this.WaitAnchor.bind(this);
    this.GetProof = this.GetProof.bind(this);
    this.ValidateRoot = this.ValidateRoot.bind(this);
    this.VerifyProof = this.VerifyProof.bind(this);
    this.VerifyRecords = this.VerifyRecords.bind(this);
  }
  var _proto = IntegrityServiceClientImpl.prototype;
  _proto.SendRecords = function SendRecords(request) {
    var data = SendRecordsRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "SendRecords", data);
    return promise.then(function (data) {
      return SendRecordsResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.GetAnchor = function GetAnchor(request) {
    var data = GetAnchorRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "GetAnchor", data);
    return promise.then(function (data) {
      return GetAnchorResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.WaitAnchor = function WaitAnchor(request) {
    var data = WaitAnchorRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "WaitAnchor", data);
    return promise.then(function (data) {
      return WaitAnchorResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.GetProof = function GetProof(request) {
    var data = GetProofRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "GetProof", data);
    return promise.then(function (data) {
      return GetProofResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.ValidateRoot = function ValidateRoot(request) {
    var data = ValidateRootRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "ValidateRoot", data);
    return promise.then(function (data) {
      return ValidateRootResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.VerifyProof = function VerifyProof(request) {
    var data = VerifyProofRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "VerifyProof", data);
    return promise.then(function (data) {
      return VerifyProofResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.VerifyRecords = function VerifyRecords(request) {
    var data = VerifyRecordsRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "VerifyRecords", data);
    return promise.then(function (data) {
      return VerifyRecordsResponse.decode(_m0.Reader.create(data));
    });
  };
  return IntegrityServiceClientImpl;
}();
function longToNumber$6(_long) {
  if (_long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return _long.toNumber();
}
if (_m0.util.Long !== Long) {
  _m0.util.Long = Long;
  _m0.configure();
}
function isSet$e(value) {
  return value !== null && value !== undefined;
}

function createBaseGenerateLocalKeyRequest() {
  return {
    configData: undefined,
    keyType: 0
  };
}
var GenerateLocalKeyRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.keyType !== 0) {
      writer.uint32(16).int32(message.keyType);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseGenerateLocalKeyRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }
          message.keyType = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$f(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      keyType: isSet$f(object.keyType) ? keyTypeFromJSON(object.keyType) : 0
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.keyType !== 0) {
      obj.keyType = keyTypeToJSON(message.keyType);
    }
    return obj;
  },
  create: function create(base) {
    return GenerateLocalKeyRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$keyType;
    var message = createBaseGenerateLocalKeyRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.keyType = (_object$keyType = object.keyType) != null ? _object$keyType : 0;
    return message;
  }
};
function createBaseGenerateLocalKeyResponse() {
  return {
    localKey: undefined,
    error: undefined
  };
}
var GenerateLocalKeyResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.localKey !== undefined) {
      LocalKey.encode(message.localKey, writer.uint32(10).fork()).ldelim();
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseGenerateLocalKeyResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.localKey = LocalKey.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      localKey: isSet$f(object.localKey) ? LocalKey.fromJSON(object.localKey) : undefined,
      error: isSet$f(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.localKey !== undefined) {
      obj.localKey = LocalKey.toJSON(message.localKey);
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return GenerateLocalKeyResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseGenerateLocalKeyResponse();
    message.localKey = object.localKey !== undefined && object.localKey !== null ? LocalKey.fromPartial(object.localKey) : undefined;
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
function createBaseGenerateManagedKeyRequest() {
  return {
    configData: undefined,
    params: undefined
  };
}
var GenerateManagedKeyRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.params !== undefined) {
      ManagedKeyParams.encode(message.params, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseGenerateManagedKeyRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.params = ManagedKeyParams.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$f(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      params: isSet$f(object.params) ? ManagedKeyParams.fromJSON(object.params) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.params !== undefined) {
      obj.params = ManagedKeyParams.toJSON(message.params);
    }
    return obj;
  },
  create: function create(base) {
    return GenerateManagedKeyRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseGenerateManagedKeyRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.params = object.params !== undefined && object.params !== null ? ManagedKeyParams.fromPartial(object.params) : undefined;
    return message;
  }
};
function createBaseGenerateManagedKeyResponse() {
  return {
    managedKey: undefined,
    error: undefined
  };
}
var GenerateManagedKeyResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.managedKey !== undefined) {
      ManagedKey.encode(message.managedKey, writer.uint32(10).fork()).ldelim();
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseGenerateManagedKeyResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.managedKey = ManagedKey.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      managedKey: isSet$f(object.managedKey) ? ManagedKey.fromJSON(object.managedKey) : undefined,
      error: isSet$f(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.managedKey !== undefined) {
      obj.managedKey = ManagedKey.toJSON(message.managedKey);
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return GenerateManagedKeyResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseGenerateManagedKeyResponse();
    message.managedKey = object.managedKey !== undefined && object.managedKey !== null ? ManagedKey.fromPartial(object.managedKey) : undefined;
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
function createBaseLoadLocalKeyRequest() {
  return {
    configData: undefined,
    keyType: 0,
    key: ""
  };
}
var LoadLocalKeyRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.keyType !== 0) {
      writer.uint32(16).int32(message.keyType);
    }
    if (message.key !== "") {
      writer.uint32(26).string(message.key);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseLoadLocalKeyRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }
          message.keyType = reader.int32();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.key = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$f(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      keyType: isSet$f(object.keyType) ? keyTypeFromJSON(object.keyType) : 0,
      key: isSet$f(object.key) ? globalThis.String(object.key) : ""
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.keyType !== 0) {
      obj.keyType = keyTypeToJSON(message.keyType);
    }
    if (message.key !== "") {
      obj.key = message.key;
    }
    return obj;
  },
  create: function create(base) {
    return LoadLocalKeyRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$keyType2, _object$key;
    var message = createBaseLoadLocalKeyRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.keyType = (_object$keyType2 = object.keyType) != null ? _object$keyType2 : 0;
    message.key = (_object$key = object.key) != null ? _object$key : "";
    return message;
  }
};
function createBaseLoadLocalKeyResponse() {
  return {
    localKey: undefined,
    error: undefined
  };
}
var LoadLocalKeyResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.localKey !== undefined) {
      LocalKey.encode(message.localKey, writer.uint32(10).fork()).ldelim();
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseLoadLocalKeyResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.localKey = LocalKey.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      localKey: isSet$f(object.localKey) ? LocalKey.fromJSON(object.localKey) : undefined,
      error: isSet$f(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.localKey !== undefined) {
      obj.localKey = LocalKey.toJSON(message.localKey);
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return LoadLocalKeyResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseLoadLocalKeyResponse();
    message.localKey = object.localKey !== undefined && object.localKey !== null ? LocalKey.fromPartial(object.localKey) : undefined;
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
function createBaseLoadManagedKeyRequest() {
  return {
    configData: undefined,
    id: ""
  };
}
var LoadManagedKeyRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.id !== "") {
      writer.uint32(18).string(message.id);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseLoadManagedKeyRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.id = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$f(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      id: isSet$f(object.id) ? globalThis.String(object.id) : ""
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },
  create: function create(base) {
    return LoadManagedKeyRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$id;
    var message = createBaseLoadManagedKeyRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.id = (_object$id = object.id) != null ? _object$id : "";
    return message;
  }
};
function createBaseLoadManagedKeyResponse() {
  return {
    managedKey: undefined,
    error: undefined
  };
}
var LoadManagedKeyResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.managedKey !== undefined) {
      ManagedKey.encode(message.managedKey, writer.uint32(10).fork()).ldelim();
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseLoadManagedKeyResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.managedKey = ManagedKey.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      managedKey: isSet$f(object.managedKey) ? ManagedKey.fromJSON(object.managedKey) : undefined,
      error: isSet$f(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.managedKey !== undefined) {
      obj.managedKey = ManagedKey.toJSON(message.managedKey);
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return LoadManagedKeyResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseLoadManagedKeyResponse();
    message.managedKey = object.managedKey !== undefined && object.managedKey !== null ? ManagedKey.fromPartial(object.managedKey) : undefined;
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
function createBaseGenerateLocalCertificateRequest() {
  return {
    configData: undefined,
    params: undefined
  };
}
var GenerateLocalCertificateRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.params !== undefined) {
      LocalCertificateParams.encode(message.params, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseGenerateLocalCertificateRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.params = LocalCertificateParams.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$f(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      params: isSet$f(object.params) ? LocalCertificateParams.fromJSON(object.params) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.params !== undefined) {
      obj.params = LocalCertificateParams.toJSON(message.params);
    }
    return obj;
  },
  create: function create(base) {
    return GenerateLocalCertificateRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseGenerateLocalCertificateRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.params = object.params !== undefined && object.params !== null ? LocalCertificateParams.fromPartial(object.params) : undefined;
    return message;
  }
};
function createBaseGenerateLocalCertificateResponse() {
  return {
    localCertificate: undefined,
    error: undefined
  };
}
var GenerateLocalCertificateResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.localCertificate !== undefined) {
      LocalCertificate.encode(message.localCertificate, writer.uint32(10).fork()).ldelim();
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseGenerateLocalCertificateResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.localCertificate = LocalCertificate.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      localCertificate: isSet$f(object.localCertificate) ? LocalCertificate.fromJSON(object.localCertificate) : undefined,
      error: isSet$f(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.localCertificate !== undefined) {
      obj.localCertificate = LocalCertificate.toJSON(message.localCertificate);
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return GenerateLocalCertificateResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseGenerateLocalCertificateResponse();
    message.localCertificate = object.localCertificate !== undefined && object.localCertificate !== null ? LocalCertificate.fromPartial(object.localCertificate) : undefined;
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
function createBaseGenerateManagedCertificateRequest() {
  return {
    configData: undefined,
    params: undefined
  };
}
var GenerateManagedCertificateRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.params !== undefined) {
      ManagedCertificateParams.encode(message.params, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseGenerateManagedCertificateRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.params = ManagedCertificateParams.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$f(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      params: isSet$f(object.params) ? ManagedCertificateParams.fromJSON(object.params) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.params !== undefined) {
      obj.params = ManagedCertificateParams.toJSON(message.params);
    }
    return obj;
  },
  create: function create(base) {
    return GenerateManagedCertificateRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseGenerateManagedCertificateRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.params = object.params !== undefined && object.params !== null ? ManagedCertificateParams.fromPartial(object.params) : undefined;
    return message;
  }
};
function createBaseGenerateManagedCertificateResponse() {
  return {
    managedCertificate: undefined,
    error: undefined
  };
}
var GenerateManagedCertificateResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.managedCertificate !== undefined) {
      ManagedCertificate.encode(message.managedCertificate, writer.uint32(10).fork()).ldelim();
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseGenerateManagedCertificateResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.managedCertificate = ManagedCertificate.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      managedCertificate: isSet$f(object.managedCertificate) ? ManagedCertificate.fromJSON(object.managedCertificate) : undefined,
      error: isSet$f(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.managedCertificate !== undefined) {
      obj.managedCertificate = ManagedCertificate.toJSON(message.managedCertificate);
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return GenerateManagedCertificateResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseGenerateManagedCertificateResponse();
    message.managedCertificate = object.managedCertificate !== undefined && object.managedCertificate !== null ? ManagedCertificate.fromPartial(object.managedCertificate) : undefined;
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
function createBaseLoadLocalCertificateRequest() {
  return {
    configData: undefined,
    pkcs12: new Uint8Array(0),
    password: ""
  };
}
var LoadLocalCertificateRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.pkcs12.length !== 0) {
      writer.uint32(18).bytes(message.pkcs12);
    }
    if (message.password !== "") {
      writer.uint32(26).string(message.password);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseLoadLocalCertificateRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.pkcs12 = reader.bytes();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.password = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$f(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      pkcs12: isSet$f(object.pkcs12) ? bytesFromBase64$2(object.pkcs12) : new Uint8Array(0),
      password: isSet$f(object.password) ? globalThis.String(object.password) : ""
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.pkcs12.length !== 0) {
      obj.pkcs12 = base64FromBytes$2(message.pkcs12);
    }
    if (message.password !== "") {
      obj.password = message.password;
    }
    return obj;
  },
  create: function create(base) {
    return LoadLocalCertificateRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$pkcs, _object$password;
    var message = createBaseLoadLocalCertificateRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.pkcs12 = (_object$pkcs = object.pkcs12) != null ? _object$pkcs : new Uint8Array(0);
    message.password = (_object$password = object.password) != null ? _object$password : "";
    return message;
  }
};
function createBaseLoadLocalCertificateResponse() {
  return {
    localCertificate: undefined,
    error: undefined
  };
}
var LoadLocalCertificateResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.localCertificate !== undefined) {
      LocalCertificate.encode(message.localCertificate, writer.uint32(10).fork()).ldelim();
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseLoadLocalCertificateResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.localCertificate = LocalCertificate.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      localCertificate: isSet$f(object.localCertificate) ? LocalCertificate.fromJSON(object.localCertificate) : undefined,
      error: isSet$f(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.localCertificate !== undefined) {
      obj.localCertificate = LocalCertificate.toJSON(message.localCertificate);
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return LoadLocalCertificateResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseLoadLocalCertificateResponse();
    message.localCertificate = object.localCertificate !== undefined && object.localCertificate !== null ? LocalCertificate.fromPartial(object.localCertificate) : undefined;
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
function createBaseLoadManagedCertificateRequest() {
  return {
    configData: undefined,
    id: ""
  };
}
var LoadManagedCertificateRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.id !== "") {
      writer.uint32(18).string(message.id);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseLoadManagedCertificateRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.id = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$f(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      id: isSet$f(object.id) ? globalThis.String(object.id) : ""
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },
  create: function create(base) {
    return LoadManagedCertificateRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$id2;
    var message = createBaseLoadManagedCertificateRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.id = (_object$id2 = object.id) != null ? _object$id2 : "";
    return message;
  }
};
function createBaseLoadManagedCertificateResponse() {
  return {
    managedCertificate: undefined,
    error: undefined
  };
}
var LoadManagedCertificateResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.managedCertificate !== undefined) {
      ManagedCertificate.encode(message.managedCertificate, writer.uint32(10).fork()).ldelim();
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseLoadManagedCertificateResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.managedCertificate = ManagedCertificate.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      managedCertificate: isSet$f(object.managedCertificate) ? ManagedCertificate.fromJSON(object.managedCertificate) : undefined,
      error: isSet$f(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.managedCertificate !== undefined) {
      obj.managedCertificate = ManagedCertificate.toJSON(message.managedCertificate);
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return LoadManagedCertificateResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseLoadManagedCertificateResponse();
    message.managedCertificate = object.managedCertificate !== undefined && object.managedCertificate !== null ? ManagedCertificate.fromPartial(object.managedCertificate) : undefined;
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
function createBaseImportManagedCertificateRequest() {
  return {
    configData: undefined,
    certificate: new Uint8Array(0),
    password: undefined,
    certificateType: 0
  };
}
var ImportManagedCertificateRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.certificate.length !== 0) {
      writer.uint32(18).bytes(message.certificate);
    }
    if (message.password !== undefined) {
      writer.uint32(26).string(message.password);
    }
    if (message.certificateType !== 0) {
      writer.uint32(32).int32(message.certificateType);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseImportManagedCertificateRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.certificate = reader.bytes();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.password = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }
          message.certificateType = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$f(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      certificate: isSet$f(object.certificate) ? bytesFromBase64$2(object.certificate) : new Uint8Array(0),
      password: isSet$f(object.password) ? globalThis.String(object.password) : undefined,
      certificateType: isSet$f(object.certificateType) ? certificateTypeFromJSON(object.certificateType) : 0
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.certificate.length !== 0) {
      obj.certificate = base64FromBytes$2(message.certificate);
    }
    if (message.password !== undefined) {
      obj.password = message.password;
    }
    if (message.certificateType !== 0) {
      obj.certificateType = certificateTypeToJSON(message.certificateType);
    }
    return obj;
  },
  create: function create(base) {
    return ImportManagedCertificateRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$certificate, _object$password2, _object$certificateTy;
    var message = createBaseImportManagedCertificateRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.certificate = (_object$certificate = object.certificate) != null ? _object$certificate : new Uint8Array(0);
    message.password = (_object$password2 = object.password) != null ? _object$password2 : undefined;
    message.certificateType = (_object$certificateTy = object.certificateType) != null ? _object$certificateTy : 0;
    return message;
  }
};
function createBaseImportManagedCertificateResponse() {
  return {
    managedCertificate: undefined,
    error: undefined
  };
}
var ImportManagedCertificateResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.managedCertificate !== undefined) {
      ManagedCertificate.encode(message.managedCertificate, writer.uint32(10).fork()).ldelim();
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseImportManagedCertificateResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.managedCertificate = ManagedCertificate.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      managedCertificate: isSet$f(object.managedCertificate) ? ManagedCertificate.fromJSON(object.managedCertificate) : undefined,
      error: isSet$f(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.managedCertificate !== undefined) {
      obj.managedCertificate = ManagedCertificate.toJSON(message.managedCertificate);
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return ImportManagedCertificateResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseImportManagedCertificateResponse();
    message.managedCertificate = object.managedCertificate !== undefined && object.managedCertificate !== null ? ManagedCertificate.fromPartial(object.managedCertificate) : undefined;
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
function createBaseSetupTotpAccessControlRequest() {
  return {
    configData: undefined,
    managedKey: undefined,
    managedCertificate: undefined
  };
}
var SetupTotpAccessControlRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.managedKey !== undefined) {
      ManagedKey.encode(message.managedKey, writer.uint32(18).fork()).ldelim();
    }
    if (message.managedCertificate !== undefined) {
      ManagedCertificate.encode(message.managedCertificate, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseSetupTotpAccessControlRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.managedKey = ManagedKey.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.managedCertificate = ManagedCertificate.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$f(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      managedKey: isSet$f(object.managedKey) ? ManagedKey.fromJSON(object.managedKey) : undefined,
      managedCertificate: isSet$f(object.managedCertificate) ? ManagedCertificate.fromJSON(object.managedCertificate) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.managedKey !== undefined) {
      obj.managedKey = ManagedKey.toJSON(message.managedKey);
    }
    if (message.managedCertificate !== undefined) {
      obj.managedCertificate = ManagedCertificate.toJSON(message.managedCertificate);
    }
    return obj;
  },
  create: function create(base) {
    return SetupTotpAccessControlRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseSetupTotpAccessControlRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.managedKey = object.managedKey !== undefined && object.managedKey !== null ? ManagedKey.fromPartial(object.managedKey) : undefined;
    message.managedCertificate = object.managedCertificate !== undefined && object.managedCertificate !== null ? ManagedCertificate.fromPartial(object.managedCertificate) : undefined;
    return message;
  }
};
function createBaseSetupTotpAccessControlResponse() {
  return {
    secret: "",
    secretQr: "",
    recoveryCodes: [],
    error: undefined
  };
}
var SetupTotpAccessControlResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.secret !== "") {
      writer.uint32(10).string(message.secret);
    }
    if (message.secretQr !== "") {
      writer.uint32(18).string(message.secretQr);
    }
    for (var _iterator = _createForOfIteratorHelperLoose(message.recoveryCodes), _step; !(_step = _iterator()).done;) {
      var v = _step.value;
      writer.uint32(26).string(v);
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(34).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseSetupTotpAccessControlResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.secret = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.secretQr = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.recoveryCodes.push(reader.string());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      secret: isSet$f(object.secret) ? globalThis.String(object.secret) : "",
      secretQr: isSet$f(object.secretQr) ? globalThis.String(object.secretQr) : "",
      recoveryCodes: globalThis.Array.isArray(object == null ? void 0 : object.recoveryCodes) ? object.recoveryCodes.map(function (e) {
        return globalThis.String(e);
      }) : [],
      error: isSet$f(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var _message$recoveryCode;
    var obj = {};
    if (message.secret !== "") {
      obj.secret = message.secret;
    }
    if (message.secretQr !== "") {
      obj.secretQr = message.secretQr;
    }
    if ((_message$recoveryCode = message.recoveryCodes) != null && _message$recoveryCode.length) {
      obj.recoveryCodes = message.recoveryCodes;
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return SetupTotpAccessControlResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$secret, _object$secretQr, _object$recoveryCodes;
    var message = createBaseSetupTotpAccessControlResponse();
    message.secret = (_object$secret = object.secret) != null ? _object$secret : "";
    message.secretQr = (_object$secretQr = object.secretQr) != null ? _object$secretQr : "";
    message.recoveryCodes = ((_object$recoveryCodes = object.recoveryCodes) == null ? void 0 : _object$recoveryCodes.map(function (e) {
      return e;
    })) || [];
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
function createBaseSetupSecretAccessControlRequest() {
  return {
    configData: undefined,
    secret: "",
    email: "",
    managedKey: undefined,
    managedCertificate: undefined
  };
}
var SetupSecretAccessControlRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.secret !== "") {
      writer.uint32(18).string(message.secret);
    }
    if (message.email !== "") {
      writer.uint32(26).string(message.email);
    }
    if (message.managedKey !== undefined) {
      ManagedKey.encode(message.managedKey, writer.uint32(34).fork()).ldelim();
    }
    if (message.managedCertificate !== undefined) {
      ManagedCertificate.encode(message.managedCertificate, writer.uint32(42).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseSetupSecretAccessControlRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.secret = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.email = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }
          message.managedKey = ManagedKey.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }
          message.managedCertificate = ManagedCertificate.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$f(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      secret: isSet$f(object.secret) ? globalThis.String(object.secret) : "",
      email: isSet$f(object.email) ? globalThis.String(object.email) : "",
      managedKey: isSet$f(object.managedKey) ? ManagedKey.fromJSON(object.managedKey) : undefined,
      managedCertificate: isSet$f(object.managedCertificate) ? ManagedCertificate.fromJSON(object.managedCertificate) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.secret !== "") {
      obj.secret = message.secret;
    }
    if (message.email !== "") {
      obj.email = message.email;
    }
    if (message.managedKey !== undefined) {
      obj.managedKey = ManagedKey.toJSON(message.managedKey);
    }
    if (message.managedCertificate !== undefined) {
      obj.managedCertificate = ManagedCertificate.toJSON(message.managedCertificate);
    }
    return obj;
  },
  create: function create(base) {
    return SetupSecretAccessControlRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$secret2, _object$email;
    var message = createBaseSetupSecretAccessControlRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.secret = (_object$secret2 = object.secret) != null ? _object$secret2 : "";
    message.email = (_object$email = object.email) != null ? _object$email : "";
    message.managedKey = object.managedKey !== undefined && object.managedKey !== null ? ManagedKey.fromPartial(object.managedKey) : undefined;
    message.managedCertificate = object.managedCertificate !== undefined && object.managedCertificate !== null ? ManagedCertificate.fromPartial(object.managedCertificate) : undefined;
    return message;
  }
};
function createBaseSetupSecretAccessControlResponse() {
  return {
    error: undefined
  };
}
var SetupSecretAccessControlResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseSetupSecretAccessControlResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      error: isSet$f(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return SetupSecretAccessControlResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseSetupSecretAccessControlResponse();
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
function createBaseRecoverTotpAccessControlRequest() {
  return {
    configData: undefined,
    code: "",
    managedKey: undefined,
    managedCertificate: undefined
  };
}
var RecoverTotpAccessControlRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.code !== "") {
      writer.uint32(18).string(message.code);
    }
    if (message.managedKey !== undefined) {
      ManagedKey.encode(message.managedKey, writer.uint32(26).fork()).ldelim();
    }
    if (message.managedCertificate !== undefined) {
      ManagedCertificate.encode(message.managedCertificate, writer.uint32(34).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseRecoverTotpAccessControlRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.code = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.managedKey = ManagedKey.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }
          message.managedCertificate = ManagedCertificate.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$f(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      code: isSet$f(object.code) ? globalThis.String(object.code) : "",
      managedKey: isSet$f(object.managedKey) ? ManagedKey.fromJSON(object.managedKey) : undefined,
      managedCertificate: isSet$f(object.managedCertificate) ? ManagedCertificate.fromJSON(object.managedCertificate) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.managedKey !== undefined) {
      obj.managedKey = ManagedKey.toJSON(message.managedKey);
    }
    if (message.managedCertificate !== undefined) {
      obj.managedCertificate = ManagedCertificate.toJSON(message.managedCertificate);
    }
    return obj;
  },
  create: function create(base) {
    return RecoverTotpAccessControlRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$code;
    var message = createBaseRecoverTotpAccessControlRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.code = (_object$code = object.code) != null ? _object$code : "";
    message.managedKey = object.managedKey !== undefined && object.managedKey !== null ? ManagedKey.fromPartial(object.managedKey) : undefined;
    message.managedCertificate = object.managedCertificate !== undefined && object.managedCertificate !== null ? ManagedCertificate.fromPartial(object.managedCertificate) : undefined;
    return message;
  }
};
function createBaseRecoverTotpAccessControlResponse() {
  return {
    secret: "",
    secretQr: "",
    recoveryCodes: [],
    error: undefined
  };
}
var RecoverTotpAccessControlResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.secret !== "") {
      writer.uint32(10).string(message.secret);
    }
    if (message.secretQr !== "") {
      writer.uint32(18).string(message.secretQr);
    }
    for (var _iterator2 = _createForOfIteratorHelperLoose(message.recoveryCodes), _step2; !(_step2 = _iterator2()).done;) {
      var v = _step2.value;
      writer.uint32(26).string(v);
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(34).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseRecoverTotpAccessControlResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.secret = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.secretQr = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.recoveryCodes.push(reader.string());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      secret: isSet$f(object.secret) ? globalThis.String(object.secret) : "",
      secretQr: isSet$f(object.secretQr) ? globalThis.String(object.secretQr) : "",
      recoveryCodes: globalThis.Array.isArray(object == null ? void 0 : object.recoveryCodes) ? object.recoveryCodes.map(function (e) {
        return globalThis.String(e);
      }) : [],
      error: isSet$f(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var _message$recoveryCode2;
    var obj = {};
    if (message.secret !== "") {
      obj.secret = message.secret;
    }
    if (message.secretQr !== "") {
      obj.secretQr = message.secretQr;
    }
    if ((_message$recoveryCode2 = message.recoveryCodes) != null && _message$recoveryCode2.length) {
      obj.recoveryCodes = message.recoveryCodes;
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return RecoverTotpAccessControlResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$secret3, _object$secretQr2, _object$recoveryCodes2;
    var message = createBaseRecoverTotpAccessControlResponse();
    message.secret = (_object$secret3 = object.secret) != null ? _object$secret3 : "";
    message.secretQr = (_object$secretQr2 = object.secretQr) != null ? _object$secretQr2 : "";
    message.recoveryCodes = ((_object$recoveryCodes2 = object.recoveryCodes) == null ? void 0 : _object$recoveryCodes2.map(function (e) {
      return e;
    })) || [];
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
var KeyServiceServiceName = "bloock.KeyService";
var KeyServiceClientImpl = /*#__PURE__*/function () {
  function KeyServiceClientImpl(rpc, opts) {
    this.service = (opts == null ? void 0 : opts.service) || KeyServiceServiceName;
    this.rpc = rpc;
    this.GenerateLocalKey = this.GenerateLocalKey.bind(this);
    this.LoadLocalKey = this.LoadLocalKey.bind(this);
    this.GenerateManagedKey = this.GenerateManagedKey.bind(this);
    this.LoadManagedKey = this.LoadManagedKey.bind(this);
    this.GenerateLocalCertificate = this.GenerateLocalCertificate.bind(this);
    this.LoadLocalCertificate = this.LoadLocalCertificate.bind(this);
    this.GenerateManagedCertificate = this.GenerateManagedCertificate.bind(this);
    this.LoadManagedCertificate = this.LoadManagedCertificate.bind(this);
    this.ImportManagedCertificate = this.ImportManagedCertificate.bind(this);
    this.SetupTotpAccessControl = this.SetupTotpAccessControl.bind(this);
    this.SetupSecretAccessControl = this.SetupSecretAccessControl.bind(this);
    this.RecoverTotpAccessControl = this.RecoverTotpAccessControl.bind(this);
  }
  var _proto = KeyServiceClientImpl.prototype;
  _proto.GenerateLocalKey = function GenerateLocalKey(request) {
    var data = GenerateLocalKeyRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "GenerateLocalKey", data);
    return promise.then(function (data) {
      return GenerateLocalKeyResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.LoadLocalKey = function LoadLocalKey(request) {
    var data = LoadLocalKeyRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "LoadLocalKey", data);
    return promise.then(function (data) {
      return LoadLocalKeyResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.GenerateManagedKey = function GenerateManagedKey(request) {
    var data = GenerateManagedKeyRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "GenerateManagedKey", data);
    return promise.then(function (data) {
      return GenerateManagedKeyResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.LoadManagedKey = function LoadManagedKey(request) {
    var data = LoadManagedKeyRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "LoadManagedKey", data);
    return promise.then(function (data) {
      return LoadManagedKeyResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.GenerateLocalCertificate = function GenerateLocalCertificate(request) {
    var data = GenerateLocalCertificateRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "GenerateLocalCertificate", data);
    return promise.then(function (data) {
      return GenerateLocalCertificateResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.LoadLocalCertificate = function LoadLocalCertificate(request) {
    var data = LoadLocalCertificateRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "LoadLocalCertificate", data);
    return promise.then(function (data) {
      return LoadLocalCertificateResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.GenerateManagedCertificate = function GenerateManagedCertificate(request) {
    var data = GenerateManagedCertificateRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "GenerateManagedCertificate", data);
    return promise.then(function (data) {
      return GenerateManagedCertificateResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.LoadManagedCertificate = function LoadManagedCertificate(request) {
    var data = LoadManagedCertificateRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "LoadManagedCertificate", data);
    return promise.then(function (data) {
      return LoadManagedCertificateResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.ImportManagedCertificate = function ImportManagedCertificate(request) {
    var data = ImportManagedCertificateRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "ImportManagedCertificate", data);
    return promise.then(function (data) {
      return ImportManagedCertificateResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.SetupTotpAccessControl = function SetupTotpAccessControl(request) {
    var data = SetupTotpAccessControlRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "SetupTotpAccessControl", data);
    return promise.then(function (data) {
      return SetupTotpAccessControlResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.SetupSecretAccessControl = function SetupSecretAccessControl(request) {
    var data = SetupSecretAccessControlRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "SetupSecretAccessControl", data);
    return promise.then(function (data) {
      return SetupSecretAccessControlResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.RecoverTotpAccessControl = function RecoverTotpAccessControl(request) {
    var data = RecoverTotpAccessControlRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "RecoverTotpAccessControl", data);
    return promise.then(function (data) {
      return RecoverTotpAccessControlResponse.decode(_m0.Reader.create(data));
    });
  };
  return KeyServiceClientImpl;
}();
function bytesFromBase64$2(b64) {
  if (globalThis.Buffer) {
    return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
  } else {
    var bin = globalThis.atob(b64);
    var arr = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}
function base64FromBytes$2(arr) {
  if (globalThis.Buffer) {
    return globalThis.Buffer.from(arr).toString("base64");
  } else {
    var bin = [];
    arr.forEach(function (_byte) {
      bin.push(globalThis.String.fromCharCode(_byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}
function isSet$f(value) {
  return value !== null && value !== undefined;
}

/* eslint-disable */
function createBaseRecordBuilderFromStringRequest() {
  return {
    configData: undefined,
    payload: "",
    signer: undefined,
    encrypter: undefined,
    decrypter: undefined
  };
}
var RecordBuilderFromStringRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.payload !== "") {
      writer.uint32(18).string(message.payload);
    }
    if (message.signer !== undefined) {
      Signer.encode(message.signer, writer.uint32(26).fork()).ldelim();
    }
    if (message.encrypter !== undefined) {
      Encrypter.encode(message.encrypter, writer.uint32(34).fork()).ldelim();
    }
    if (message.decrypter !== undefined) {
      Encrypter.encode(message.decrypter, writer.uint32(42).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseRecordBuilderFromStringRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.payload = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.signer = Signer.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }
          message.encrypter = Encrypter.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }
          message.decrypter = Encrypter.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$g(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      payload: isSet$g(object.payload) ? globalThis.String(object.payload) : "",
      signer: isSet$g(object.signer) ? Signer.fromJSON(object.signer) : undefined,
      encrypter: isSet$g(object.encrypter) ? Encrypter.fromJSON(object.encrypter) : undefined,
      decrypter: isSet$g(object.decrypter) ? Encrypter.fromJSON(object.decrypter) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.payload !== "") {
      obj.payload = message.payload;
    }
    if (message.signer !== undefined) {
      obj.signer = Signer.toJSON(message.signer);
    }
    if (message.encrypter !== undefined) {
      obj.encrypter = Encrypter.toJSON(message.encrypter);
    }
    if (message.decrypter !== undefined) {
      obj.decrypter = Encrypter.toJSON(message.decrypter);
    }
    return obj;
  },
  create: function create(base) {
    return RecordBuilderFromStringRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$payload;
    var message = createBaseRecordBuilderFromStringRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.payload = (_object$payload = object.payload) != null ? _object$payload : "";
    message.signer = object.signer !== undefined && object.signer !== null ? Signer.fromPartial(object.signer) : undefined;
    message.encrypter = object.encrypter !== undefined && object.encrypter !== null ? Encrypter.fromPartial(object.encrypter) : undefined;
    message.decrypter = object.decrypter !== undefined && object.decrypter !== null ? Encrypter.fromPartial(object.decrypter) : undefined;
    return message;
  }
};
function createBaseRecordBuilderFromHexRequest() {
  return {
    configData: undefined,
    payload: "",
    signer: undefined,
    encrypter: undefined,
    decrypter: undefined
  };
}
var RecordBuilderFromHexRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.payload !== "") {
      writer.uint32(18).string(message.payload);
    }
    if (message.signer !== undefined) {
      Signer.encode(message.signer, writer.uint32(26).fork()).ldelim();
    }
    if (message.encrypter !== undefined) {
      Encrypter.encode(message.encrypter, writer.uint32(34).fork()).ldelim();
    }
    if (message.decrypter !== undefined) {
      Encrypter.encode(message.decrypter, writer.uint32(42).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseRecordBuilderFromHexRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.payload = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.signer = Signer.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }
          message.encrypter = Encrypter.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }
          message.decrypter = Encrypter.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$g(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      payload: isSet$g(object.payload) ? globalThis.String(object.payload) : "",
      signer: isSet$g(object.signer) ? Signer.fromJSON(object.signer) : undefined,
      encrypter: isSet$g(object.encrypter) ? Encrypter.fromJSON(object.encrypter) : undefined,
      decrypter: isSet$g(object.decrypter) ? Encrypter.fromJSON(object.decrypter) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.payload !== "") {
      obj.payload = message.payload;
    }
    if (message.signer !== undefined) {
      obj.signer = Signer.toJSON(message.signer);
    }
    if (message.encrypter !== undefined) {
      obj.encrypter = Encrypter.toJSON(message.encrypter);
    }
    if (message.decrypter !== undefined) {
      obj.decrypter = Encrypter.toJSON(message.decrypter);
    }
    return obj;
  },
  create: function create(base) {
    return RecordBuilderFromHexRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$payload2;
    var message = createBaseRecordBuilderFromHexRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.payload = (_object$payload2 = object.payload) != null ? _object$payload2 : "";
    message.signer = object.signer !== undefined && object.signer !== null ? Signer.fromPartial(object.signer) : undefined;
    message.encrypter = object.encrypter !== undefined && object.encrypter !== null ? Encrypter.fromPartial(object.encrypter) : undefined;
    message.decrypter = object.decrypter !== undefined && object.decrypter !== null ? Encrypter.fromPartial(object.decrypter) : undefined;
    return message;
  }
};
function createBaseRecordBuilderFromJSONRequest() {
  return {
    configData: undefined,
    payload: "",
    signer: undefined,
    encrypter: undefined,
    decrypter: undefined
  };
}
var RecordBuilderFromJSONRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.payload !== "") {
      writer.uint32(18).string(message.payload);
    }
    if (message.signer !== undefined) {
      Signer.encode(message.signer, writer.uint32(26).fork()).ldelim();
    }
    if (message.encrypter !== undefined) {
      Encrypter.encode(message.encrypter, writer.uint32(34).fork()).ldelim();
    }
    if (message.decrypter !== undefined) {
      Encrypter.encode(message.decrypter, writer.uint32(42).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseRecordBuilderFromJSONRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.payload = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.signer = Signer.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }
          message.encrypter = Encrypter.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }
          message.decrypter = Encrypter.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$g(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      payload: isSet$g(object.payload) ? globalThis.String(object.payload) : "",
      signer: isSet$g(object.signer) ? Signer.fromJSON(object.signer) : undefined,
      encrypter: isSet$g(object.encrypter) ? Encrypter.fromJSON(object.encrypter) : undefined,
      decrypter: isSet$g(object.decrypter) ? Encrypter.fromJSON(object.decrypter) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.payload !== "") {
      obj.payload = message.payload;
    }
    if (message.signer !== undefined) {
      obj.signer = Signer.toJSON(message.signer);
    }
    if (message.encrypter !== undefined) {
      obj.encrypter = Encrypter.toJSON(message.encrypter);
    }
    if (message.decrypter !== undefined) {
      obj.decrypter = Encrypter.toJSON(message.decrypter);
    }
    return obj;
  },
  create: function create(base) {
    return RecordBuilderFromJSONRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$payload3;
    var message = createBaseRecordBuilderFromJSONRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.payload = (_object$payload3 = object.payload) != null ? _object$payload3 : "";
    message.signer = object.signer !== undefined && object.signer !== null ? Signer.fromPartial(object.signer) : undefined;
    message.encrypter = object.encrypter !== undefined && object.encrypter !== null ? Encrypter.fromPartial(object.encrypter) : undefined;
    message.decrypter = object.decrypter !== undefined && object.decrypter !== null ? Encrypter.fromPartial(object.decrypter) : undefined;
    return message;
  }
};
function createBaseRecordBuilderFromBytesRequest() {
  return {
    configData: undefined,
    payload: new Uint8Array(0),
    signer: undefined,
    encrypter: undefined,
    decrypter: undefined
  };
}
var RecordBuilderFromBytesRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.payload.length !== 0) {
      writer.uint32(18).bytes(message.payload);
    }
    if (message.signer !== undefined) {
      Signer.encode(message.signer, writer.uint32(26).fork()).ldelim();
    }
    if (message.encrypter !== undefined) {
      Encrypter.encode(message.encrypter, writer.uint32(34).fork()).ldelim();
    }
    if (message.decrypter !== undefined) {
      Encrypter.encode(message.decrypter, writer.uint32(42).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseRecordBuilderFromBytesRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.payload = reader.bytes();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.signer = Signer.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }
          message.encrypter = Encrypter.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }
          message.decrypter = Encrypter.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$g(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      payload: isSet$g(object.payload) ? bytesFromBase64$3(object.payload) : new Uint8Array(0),
      signer: isSet$g(object.signer) ? Signer.fromJSON(object.signer) : undefined,
      encrypter: isSet$g(object.encrypter) ? Encrypter.fromJSON(object.encrypter) : undefined,
      decrypter: isSet$g(object.decrypter) ? Encrypter.fromJSON(object.decrypter) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.payload.length !== 0) {
      obj.payload = base64FromBytes$3(message.payload);
    }
    if (message.signer !== undefined) {
      obj.signer = Signer.toJSON(message.signer);
    }
    if (message.encrypter !== undefined) {
      obj.encrypter = Encrypter.toJSON(message.encrypter);
    }
    if (message.decrypter !== undefined) {
      obj.decrypter = Encrypter.toJSON(message.decrypter);
    }
    return obj;
  },
  create: function create(base) {
    return RecordBuilderFromBytesRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$payload4;
    var message = createBaseRecordBuilderFromBytesRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.payload = (_object$payload4 = object.payload) != null ? _object$payload4 : new Uint8Array(0);
    message.signer = object.signer !== undefined && object.signer !== null ? Signer.fromPartial(object.signer) : undefined;
    message.encrypter = object.encrypter !== undefined && object.encrypter !== null ? Encrypter.fromPartial(object.encrypter) : undefined;
    message.decrypter = object.decrypter !== undefined && object.decrypter !== null ? Encrypter.fromPartial(object.decrypter) : undefined;
    return message;
  }
};
function createBaseRecordBuilderFromFileRequest() {
  return {
    configData: undefined,
    payload: new Uint8Array(0),
    signer: undefined,
    encrypter: undefined,
    decrypter: undefined
  };
}
var RecordBuilderFromFileRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.payload.length !== 0) {
      writer.uint32(18).bytes(message.payload);
    }
    if (message.signer !== undefined) {
      Signer.encode(message.signer, writer.uint32(26).fork()).ldelim();
    }
    if (message.encrypter !== undefined) {
      Encrypter.encode(message.encrypter, writer.uint32(34).fork()).ldelim();
    }
    if (message.decrypter !== undefined) {
      Encrypter.encode(message.decrypter, writer.uint32(42).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseRecordBuilderFromFileRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.payload = reader.bytes();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.signer = Signer.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }
          message.encrypter = Encrypter.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }
          message.decrypter = Encrypter.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$g(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      payload: isSet$g(object.payload) ? bytesFromBase64$3(object.payload) : new Uint8Array(0),
      signer: isSet$g(object.signer) ? Signer.fromJSON(object.signer) : undefined,
      encrypter: isSet$g(object.encrypter) ? Encrypter.fromJSON(object.encrypter) : undefined,
      decrypter: isSet$g(object.decrypter) ? Encrypter.fromJSON(object.decrypter) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.payload.length !== 0) {
      obj.payload = base64FromBytes$3(message.payload);
    }
    if (message.signer !== undefined) {
      obj.signer = Signer.toJSON(message.signer);
    }
    if (message.encrypter !== undefined) {
      obj.encrypter = Encrypter.toJSON(message.encrypter);
    }
    if (message.decrypter !== undefined) {
      obj.decrypter = Encrypter.toJSON(message.decrypter);
    }
    return obj;
  },
  create: function create(base) {
    return RecordBuilderFromFileRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$payload5;
    var message = createBaseRecordBuilderFromFileRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.payload = (_object$payload5 = object.payload) != null ? _object$payload5 : new Uint8Array(0);
    message.signer = object.signer !== undefined && object.signer !== null ? Signer.fromPartial(object.signer) : undefined;
    message.encrypter = object.encrypter !== undefined && object.encrypter !== null ? Encrypter.fromPartial(object.encrypter) : undefined;
    message.decrypter = object.decrypter !== undefined && object.decrypter !== null ? Encrypter.fromPartial(object.decrypter) : undefined;
    return message;
  }
};
function createBaseRecordBuilderFromRecordRequest() {
  return {
    configData: undefined,
    payload: undefined,
    signer: undefined,
    encrypter: undefined,
    decrypter: undefined
  };
}
var RecordBuilderFromRecordRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.payload !== undefined) {
      Record.encode(message.payload, writer.uint32(18).fork()).ldelim();
    }
    if (message.signer !== undefined) {
      Signer.encode(message.signer, writer.uint32(26).fork()).ldelim();
    }
    if (message.encrypter !== undefined) {
      Encrypter.encode(message.encrypter, writer.uint32(34).fork()).ldelim();
    }
    if (message.decrypter !== undefined) {
      Encrypter.encode(message.decrypter, writer.uint32(42).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseRecordBuilderFromRecordRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.payload = Record.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.signer = Signer.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }
          message.encrypter = Encrypter.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }
          message.decrypter = Encrypter.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$g(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      payload: isSet$g(object.payload) ? Record.fromJSON(object.payload) : undefined,
      signer: isSet$g(object.signer) ? Signer.fromJSON(object.signer) : undefined,
      encrypter: isSet$g(object.encrypter) ? Encrypter.fromJSON(object.encrypter) : undefined,
      decrypter: isSet$g(object.decrypter) ? Encrypter.fromJSON(object.decrypter) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.payload !== undefined) {
      obj.payload = Record.toJSON(message.payload);
    }
    if (message.signer !== undefined) {
      obj.signer = Signer.toJSON(message.signer);
    }
    if (message.encrypter !== undefined) {
      obj.encrypter = Encrypter.toJSON(message.encrypter);
    }
    if (message.decrypter !== undefined) {
      obj.decrypter = Encrypter.toJSON(message.decrypter);
    }
    return obj;
  },
  create: function create(base) {
    return RecordBuilderFromRecordRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseRecordBuilderFromRecordRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.payload = object.payload !== undefined && object.payload !== null ? Record.fromPartial(object.payload) : undefined;
    message.signer = object.signer !== undefined && object.signer !== null ? Signer.fromPartial(object.signer) : undefined;
    message.encrypter = object.encrypter !== undefined && object.encrypter !== null ? Encrypter.fromPartial(object.encrypter) : undefined;
    message.decrypter = object.decrypter !== undefined && object.decrypter !== null ? Encrypter.fromPartial(object.decrypter) : undefined;
    return message;
  }
};
function createBaseRecordBuilderResponse() {
  return {
    record: undefined,
    error: undefined
  };
}
var RecordBuilderResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.record !== undefined) {
      Record.encode(message.record, writer.uint32(10).fork()).ldelim();
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseRecordBuilderResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.record = Record.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      record: isSet$g(object.record) ? Record.fromJSON(object.record) : undefined,
      error: isSet$g(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.record !== undefined) {
      obj.record = Record.toJSON(message.record);
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return RecordBuilderResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseRecordBuilderResponse();
    message.record = object.record !== undefined && object.record !== null ? Record.fromPartial(object.record) : undefined;
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
function createBaseRecordBuilderFromLoaderRequest() {
  return {
    configData: undefined,
    loader: undefined,
    signer: undefined,
    encrypter: undefined,
    decrypter: undefined
  };
}
var RecordBuilderFromLoaderRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.loader !== undefined) {
      Loader.encode(message.loader, writer.uint32(18).fork()).ldelim();
    }
    if (message.signer !== undefined) {
      Signer.encode(message.signer, writer.uint32(26).fork()).ldelim();
    }
    if (message.encrypter !== undefined) {
      Encrypter.encode(message.encrypter, writer.uint32(34).fork()).ldelim();
    }
    if (message.decrypter !== undefined) {
      Encrypter.encode(message.decrypter, writer.uint32(42).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseRecordBuilderFromLoaderRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.loader = Loader.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.signer = Signer.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }
          message.encrypter = Encrypter.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }
          message.decrypter = Encrypter.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$g(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      loader: isSet$g(object.loader) ? Loader.fromJSON(object.loader) : undefined,
      signer: isSet$g(object.signer) ? Signer.fromJSON(object.signer) : undefined,
      encrypter: isSet$g(object.encrypter) ? Encrypter.fromJSON(object.encrypter) : undefined,
      decrypter: isSet$g(object.decrypter) ? Encrypter.fromJSON(object.decrypter) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.loader !== undefined) {
      obj.loader = Loader.toJSON(message.loader);
    }
    if (message.signer !== undefined) {
      obj.signer = Signer.toJSON(message.signer);
    }
    if (message.encrypter !== undefined) {
      obj.encrypter = Encrypter.toJSON(message.encrypter);
    }
    if (message.decrypter !== undefined) {
      obj.decrypter = Encrypter.toJSON(message.decrypter);
    }
    return obj;
  },
  create: function create(base) {
    return RecordBuilderFromLoaderRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseRecordBuilderFromLoaderRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.loader = object.loader !== undefined && object.loader !== null ? Loader.fromPartial(object.loader) : undefined;
    message.signer = object.signer !== undefined && object.signer !== null ? Signer.fromPartial(object.signer) : undefined;
    message.encrypter = object.encrypter !== undefined && object.encrypter !== null ? Encrypter.fromPartial(object.encrypter) : undefined;
    message.decrypter = object.decrypter !== undefined && object.decrypter !== null ? Encrypter.fromPartial(object.decrypter) : undefined;
    return message;
  }
};
function createBaseGetDetailsRequest() {
  return {
    configData: undefined,
    payload: new Uint8Array(0)
  };
}
var GetDetailsRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.payload.length !== 0) {
      writer.uint32(18).bytes(message.payload);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseGetDetailsRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.payload = reader.bytes();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$g(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      payload: isSet$g(object.payload) ? bytesFromBase64$3(object.payload) : new Uint8Array(0)
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.payload.length !== 0) {
      obj.payload = base64FromBytes$3(message.payload);
    }
    return obj;
  },
  create: function create(base) {
    return GetDetailsRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$payload6;
    var message = createBaseGetDetailsRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.payload = (_object$payload6 = object.payload) != null ? _object$payload6 : new Uint8Array(0);
    return message;
  }
};
function createBaseGetDetailsResponse() {
  return {
    details: undefined,
    error: undefined
  };
}
var GetDetailsResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.details !== undefined) {
      RecordDetails.encode(message.details, writer.uint32(10).fork()).ldelim();
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseGetDetailsResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.details = RecordDetails.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      details: isSet$g(object.details) ? RecordDetails.fromJSON(object.details) : undefined,
      error: isSet$g(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.details !== undefined) {
      obj.details = RecordDetails.toJSON(message.details);
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return GetDetailsResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseGetDetailsResponse();
    message.details = object.details !== undefined && object.details !== null ? RecordDetails.fromPartial(object.details) : undefined;
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
function createBaseGetHashRequest() {
  return {
    configData: undefined,
    record: undefined
  };
}
var GetHashRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.record !== undefined) {
      Record.encode(message.record, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseGetHashRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.record = Record.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$g(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      record: isSet$g(object.record) ? Record.fromJSON(object.record) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.record !== undefined) {
      obj.record = Record.toJSON(message.record);
    }
    return obj;
  },
  create: function create(base) {
    return GetHashRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseGetHashRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.record = object.record !== undefined && object.record !== null ? Record.fromPartial(object.record) : undefined;
    return message;
  }
};
function createBaseGetHashResponse() {
  return {
    hash: "",
    error: undefined
  };
}
var GetHashResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.hash !== "") {
      writer.uint32(10).string(message.hash);
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseGetHashResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.hash = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      hash: isSet$g(object.hash) ? globalThis.String(object.hash) : "",
      error: isSet$g(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.hash !== "") {
      obj.hash = message.hash;
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return GetHashResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$hash;
    var message = createBaseGetHashResponse();
    message.hash = (_object$hash = object.hash) != null ? _object$hash : "";
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
function createBaseGetPayloadRequest() {
  return {
    configData: undefined,
    record: undefined
  };
}
var GetPayloadRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.record !== undefined) {
      Record.encode(message.record, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseGetPayloadRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.record = Record.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$g(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      record: isSet$g(object.record) ? Record.fromJSON(object.record) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.record !== undefined) {
      obj.record = Record.toJSON(message.record);
    }
    return obj;
  },
  create: function create(base) {
    return GetPayloadRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseGetPayloadRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.record = object.record !== undefined && object.record !== null ? Record.fromPartial(object.record) : undefined;
    return message;
  }
};
function createBaseGetPayloadResponse() {
  return {
    payload: new Uint8Array(0),
    error: undefined
  };
}
var GetPayloadResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.payload.length !== 0) {
      writer.uint32(10).bytes(message.payload);
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseGetPayloadResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.payload = reader.bytes();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      payload: isSet$g(object.payload) ? bytesFromBase64$3(object.payload) : new Uint8Array(0),
      error: isSet$g(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.payload.length !== 0) {
      obj.payload = base64FromBytes$3(message.payload);
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return GetPayloadResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$payload7;
    var message = createBaseGetPayloadResponse();
    message.payload = (_object$payload7 = object.payload) != null ? _object$payload7 : new Uint8Array(0);
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
function createBaseSetProofRequest() {
  return {
    configData: undefined,
    record: undefined,
    proof: undefined
  };
}
var SetProofRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.record !== undefined) {
      Record.encode(message.record, writer.uint32(18).fork()).ldelim();
    }
    if (message.proof !== undefined) {
      Proof.encode(message.proof, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseSetProofRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.record = Record.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.proof = Proof.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$g(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      record: isSet$g(object.record) ? Record.fromJSON(object.record) : undefined,
      proof: isSet$g(object.proof) ? Proof.fromJSON(object.proof) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.record !== undefined) {
      obj.record = Record.toJSON(message.record);
    }
    if (message.proof !== undefined) {
      obj.proof = Proof.toJSON(message.proof);
    }
    return obj;
  },
  create: function create(base) {
    return SetProofRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseSetProofRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.record = object.record !== undefined && object.record !== null ? Record.fromPartial(object.record) : undefined;
    message.proof = object.proof !== undefined && object.proof !== null ? Proof.fromPartial(object.proof) : undefined;
    return message;
  }
};
function createBaseSetProofResponse() {
  return {
    error: undefined,
    record: undefined
  };
}
var SetProofResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(10).fork()).ldelim();
    }
    if (message.record !== undefined) {
      Record.encode(message.record, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseSetProofResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.record = Record.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      error: isSet$g(object.error) ? Error$1.fromJSON(object.error) : undefined,
      record: isSet$g(object.record) ? Record.fromJSON(object.record) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    if (message.record !== undefined) {
      obj.record = Record.toJSON(message.record);
    }
    return obj;
  },
  create: function create(base) {
    return SetProofResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var message = createBaseSetProofResponse();
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    message.record = object.record !== undefined && object.record !== null ? Record.fromPartial(object.record) : undefined;
    return message;
  }
};
var RecordServiceServiceName = "bloock.RecordService";
var RecordServiceClientImpl = /*#__PURE__*/function () {
  function RecordServiceClientImpl(rpc, opts) {
    this.service = (opts == null ? void 0 : opts.service) || RecordServiceServiceName;
    this.rpc = rpc;
    this.BuildRecordFromString = this.BuildRecordFromString.bind(this);
    this.BuildRecordFromHex = this.BuildRecordFromHex.bind(this);
    this.BuildRecordFromJson = this.BuildRecordFromJson.bind(this);
    this.BuildRecordFromFile = this.BuildRecordFromFile.bind(this);
    this.BuildRecordFromBytes = this.BuildRecordFromBytes.bind(this);
    this.BuildRecordFromRecord = this.BuildRecordFromRecord.bind(this);
    this.BuildRecordFromLoader = this.BuildRecordFromLoader.bind(this);
    this.GetDetails = this.GetDetails.bind(this);
    this.GetHash = this.GetHash.bind(this);
    this.GetPayload = this.GetPayload.bind(this);
    this.SetProof = this.SetProof.bind(this);
  }
  var _proto = RecordServiceClientImpl.prototype;
  _proto.BuildRecordFromString = function BuildRecordFromString(request) {
    var data = RecordBuilderFromStringRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "BuildRecordFromString", data);
    return promise.then(function (data) {
      return RecordBuilderResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.BuildRecordFromHex = function BuildRecordFromHex(request) {
    var data = RecordBuilderFromHexRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "BuildRecordFromHex", data);
    return promise.then(function (data) {
      return RecordBuilderResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.BuildRecordFromJson = function BuildRecordFromJson(request) {
    var data = RecordBuilderFromJSONRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "BuildRecordFromJson", data);
    return promise.then(function (data) {
      return RecordBuilderResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.BuildRecordFromFile = function BuildRecordFromFile(request) {
    var data = RecordBuilderFromFileRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "BuildRecordFromFile", data);
    return promise.then(function (data) {
      return RecordBuilderResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.BuildRecordFromBytes = function BuildRecordFromBytes(request) {
    var data = RecordBuilderFromBytesRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "BuildRecordFromBytes", data);
    return promise.then(function (data) {
      return RecordBuilderResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.BuildRecordFromRecord = function BuildRecordFromRecord(request) {
    var data = RecordBuilderFromRecordRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "BuildRecordFromRecord", data);
    return promise.then(function (data) {
      return RecordBuilderResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.BuildRecordFromLoader = function BuildRecordFromLoader(request) {
    var data = RecordBuilderFromLoaderRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "BuildRecordFromLoader", data);
    return promise.then(function (data) {
      return RecordBuilderResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.GetDetails = function GetDetails(request) {
    var data = GetDetailsRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "GetDetails", data);
    return promise.then(function (data) {
      return GetDetailsResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.GetHash = function GetHash(request) {
    var data = GetHashRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "GetHash", data);
    return promise.then(function (data) {
      return GetHashResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.GetPayload = function GetPayload(request) {
    var data = GetPayloadRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "GetPayload", data);
    return promise.then(function (data) {
      return GetPayloadResponse.decode(_m0.Reader.create(data));
    });
  };
  _proto.SetProof = function SetProof(request) {
    var data = SetProofRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "SetProof", data);
    return promise.then(function (data) {
      return SetProofResponse.decode(_m0.Reader.create(data));
    });
  };
  return RecordServiceClientImpl;
}();
function bytesFromBase64$3(b64) {
  if (globalThis.Buffer) {
    return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
  } else {
    var bin = globalThis.atob(b64);
    var arr = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}
function base64FromBytes$3(arr) {
  if (globalThis.Buffer) {
    return globalThis.Buffer.from(arr).toString("base64");
  } else {
    var bin = [];
    arr.forEach(function (_byte) {
      bin.push(globalThis.String.fromCharCode(_byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}
function isSet$g(value) {
  return value !== null && value !== undefined;
}

/* eslint-disable */
function createBaseVerifyWebhookSignatureRequest() {
  return {
    configData: undefined,
    payload: new Uint8Array(0),
    header: "",
    secretKey: "",
    enforceTolerance: false
  };
}
var VerifyWebhookSignatureRequest = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.configData !== undefined) {
      ConfigData.encode(message.configData, writer.uint32(10).fork()).ldelim();
    }
    if (message.payload.length !== 0) {
      writer.uint32(18).bytes(message.payload);
    }
    if (message.header !== "") {
      writer.uint32(26).string(message.header);
    }
    if (message.secretKey !== "") {
      writer.uint32(34).string(message.secretKey);
    }
    if (message.enforceTolerance === true) {
      writer.uint32(40).bool(message.enforceTolerance);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseVerifyWebhookSignatureRequest();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }
          message.configData = ConfigData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.payload = reader.bytes();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }
          message.header = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }
          message.secretKey = reader.string();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }
          message.enforceTolerance = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      configData: isSet$h(object.configData) ? ConfigData.fromJSON(object.configData) : undefined,
      payload: isSet$h(object.payload) ? bytesFromBase64$4(object.payload) : new Uint8Array(0),
      header: isSet$h(object.header) ? globalThis.String(object.header) : "",
      secretKey: isSet$h(object.secretKey) ? globalThis.String(object.secretKey) : "",
      enforceTolerance: isSet$h(object.enforceTolerance) ? globalThis.Boolean(object.enforceTolerance) : false
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.configData !== undefined) {
      obj.configData = ConfigData.toJSON(message.configData);
    }
    if (message.payload.length !== 0) {
      obj.payload = base64FromBytes$4(message.payload);
    }
    if (message.header !== "") {
      obj.header = message.header;
    }
    if (message.secretKey !== "") {
      obj.secretKey = message.secretKey;
    }
    if (message.enforceTolerance === true) {
      obj.enforceTolerance = message.enforceTolerance;
    }
    return obj;
  },
  create: function create(base) {
    return VerifyWebhookSignatureRequest.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$payload, _object$header, _object$secretKey, _object$enforceTolera;
    var message = createBaseVerifyWebhookSignatureRequest();
    message.configData = object.configData !== undefined && object.configData !== null ? ConfigData.fromPartial(object.configData) : undefined;
    message.payload = (_object$payload = object.payload) != null ? _object$payload : new Uint8Array(0);
    message.header = (_object$header = object.header) != null ? _object$header : "";
    message.secretKey = (_object$secretKey = object.secretKey) != null ? _object$secretKey : "";
    message.enforceTolerance = (_object$enforceTolera = object.enforceTolerance) != null ? _object$enforceTolera : false;
    return message;
  }
};
function createBaseVerifyWebhookSignatureResponse() {
  return {
    isValid: false,
    error: undefined
  };
}
var VerifyWebhookSignatureResponse = {
  encode: function encode(message, writer) {
    if (writer === void 0) {
      writer = _m0.Writer.create();
    }
    if (message.isValid === true) {
      writer.uint32(8).bool(message.isValid);
    }
    if (message.error !== undefined) {
      Error$1.encode(message.error, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseVerifyWebhookSignatureResponse();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }
          message.isValid = reader.bool();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.error = Error$1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      isValid: isSet$h(object.isValid) ? globalThis.Boolean(object.isValid) : false,
      error: isSet$h(object.error) ? Error$1.fromJSON(object.error) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.isValid === true) {
      obj.isValid = message.isValid;
    }
    if (message.error !== undefined) {
      obj.error = Error$1.toJSON(message.error);
    }
    return obj;
  },
  create: function create(base) {
    return VerifyWebhookSignatureResponse.fromPartial(base != null ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _object$isValid;
    var message = createBaseVerifyWebhookSignatureResponse();
    message.isValid = (_object$isValid = object.isValid) != null ? _object$isValid : false;
    message.error = object.error !== undefined && object.error !== null ? Error$1.fromPartial(object.error) : undefined;
    return message;
  }
};
var WebhookServiceServiceName = "bloock.WebhookService";
var WebhookServiceClientImpl = /*#__PURE__*/function () {
  function WebhookServiceClientImpl(rpc, opts) {
    this.service = (opts == null ? void 0 : opts.service) || WebhookServiceServiceName;
    this.rpc = rpc;
    this.VerifyWebhookSignature = this.VerifyWebhookSignature.bind(this);
  }
  var _proto = WebhookServiceClientImpl.prototype;
  _proto.VerifyWebhookSignature = function VerifyWebhookSignature(request) {
    var data = VerifyWebhookSignatureRequest.encode(request).finish();
    var promise = this.rpc.request(this.service, "VerifyWebhookSignature", data);
    return promise.then(function (data) {
      return VerifyWebhookSignatureResponse.decode(_m0.Reader.create(data));
    });
  };
  return WebhookServiceClientImpl;
}();
function bytesFromBase64$4(b64) {
  if (globalThis.Buffer) {
    return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
  } else {
    var bin = globalThis.atob(b64);
    var arr = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}
function base64FromBytes$4(arr) {
  if (globalThis.Buffer) {
    return globalThis.Buffer.from(arr).toString("base64");
  } else {
    var bin = [];
    arr.forEach(function (_byte) {
      bin.push(globalThis.String.fromCharCode(_byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}
function isSet$h(value) {
  return value !== null && value !== undefined;
}

var BloockBridge = /*#__PURE__*/function () {
  function BloockBridge() {
    var connection = new Connection();
    this.authenticity = new AuthenticityServiceClientImpl(connection);
    this.availability = new AvailabilityServiceClientImpl(connection);
    this.encryption = new EncryptionServiceClientImpl(connection);
    this.key = new KeyServiceClientImpl(connection);
    this.integrity = new IntegrityServiceClientImpl(connection);
    this.identity = new IdentityServiceClientImpl(connection);
    this.identityCore = new IdentityCoreServiceClientImpl(connection);
    this.record = new RecordServiceClientImpl(connection);
    this.webhook = new WebhookServiceClientImpl(connection);
  }
  var _proto = BloockBridge.prototype;
  _proto.getAuthenticity = function getAuthenticity() {
    return this.authenticity;
  };
  _proto.getAvailability = function getAvailability() {
    return this.availability;
  };
  _proto.getEncryption = function getEncryption() {
    return this.encryption;
  };
  _proto.getIdentity = function getIdentity() {
    return this.identity;
  };
  _proto.getIdentityCore = function getIdentityCore() {
    return this.identityCore;
  };
  _proto.getIntegrity = function getIntegrity() {
    return this.integrity;
  };
  _proto.getKey = function getKey() {
    return this.key;
  };
  _proto.getRecord = function getRecord() {
    return this.record;
  };
  _proto.getWebhook = function getWebhook() {
    return this.webhook;
  };
  return BloockBridge;
}();

/**
 * Provides a centralized configuration for the Bloock SDK library. For information about Bloock SDK in Go, see https://bloock.com.
 */
var Bloock = /*#__PURE__*/function () {
  /**
   * Creates a new instance of Bloock instance.
   */
  function Bloock() {
    this.apiKey = "";
    this.apiHost = "";
    this.networksConfig = {};
  }
  /**
   * Is a string variable representing the API key used for authentication with the Bloock SDK, create [here](https://dashboard.bloock.com/login).
   * @returns
   */
  Bloock.getApiKey = function getApiKey() {
    if (!Bloock.instance) {
      Bloock.instance = new Bloock();
    }
    return Bloock.instance.apiKey;
  }
  /**
   * Sets the API key used for authentication with the Bloock SDK.
   * @param apiKey
   */;
  Bloock.setApiKey = function setApiKey(apiKey) {
    if (!Bloock.instance) {
      Bloock.instance = new Bloock();
    }
    Bloock.instance.apiKey = apiKey;
  }
  /**
   * Is a string variable representing the host URL used for Identity Managed API, required to be set for identity-related features of the Bloock SDK.
   * @returns
   */;
  Bloock.getIdentityApiHost = function getIdentityApiHost() {
    if (!Bloock.instance) {
      Bloock.instance = new Bloock();
    }
    return Bloock.instance.identityApiHost;
  }
  /**
   * Sets the host URL used for Identity Managed API.
   * @param identityApiHost
   */;
  Bloock.setIdentityApiHost = function setIdentityApiHost(identityApiHost) {
    if (!Bloock.instance) {
      Bloock.instance = new Bloock();
    }
    Bloock.instance.identityApiHost = identityApiHost;
  }
  /**
   * Is a string variable representing the host URL used for API communication with the Bloock SDK.
   * @returns
   */;
  Bloock.getApiHost = function getApiHost() {
    if (!Bloock.instance) {
      Bloock.instance = new Bloock();
    }
    return Bloock.instance.apiHost;
  }
  /**
   * Sets the host used for API communication with the Bloock SDK.
   * @param host
   */;
  Bloock.setApiHost = function setApiHost(host) {
    if (!Bloock.instance) {
      Bloock.instance = new Bloock();
    }
    Bloock.instance.apiHost = host;
  }
  /**
   * Is a variable that holds network configurations associated with specific network IDs in the Bloock SDK.
   * @returns
   */;
  Bloock.getNetworkConfiguration = function getNetworkConfiguration() {
    if (!Bloock.instance) {
      Bloock.instance = new Bloock();
    }
    return Bloock.instance.networksConfig;
  }
  /**
   * Sets the HTTP provider for the specified network in the Bloock SDK configuration.
   * @param network
   * @param provider
   */;
  Bloock.setProvider = function setProvider(network, provider) {
    if (!Bloock.instance) {
      Bloock.instance = new Bloock();
    }
    if (Bloock.instance.networksConfig) {
      if (network in Bloock.instance.networksConfig) {
        Bloock.instance.networksConfig[network].HttpProvider = provider;
      } else {
        Bloock.instance.networksConfig[network] = {
          ContractAddress: "",
          ContractAbi: "",
          HttpProvider: provider
        };
      }
    }
  }
  /**
   * Sets the contract address for the specified network in the Bloock SDK configuration.
   * @param network
   * @param contractAddress
   */;
  Bloock.setContractAddress = function setContractAddress(network, contractAddress) {
    if (!Bloock.instance) {
      Bloock.instance = new Bloock();
    }
    if (Bloock.instance.networksConfig) {
      if (network in Bloock.instance.networksConfig) {
        Bloock.instance.networksConfig[network].ContractAddress = contractAddress;
      } else {
        Bloock.instance.networksConfig[network] = {
          ContractAddress: "",
          ContractAbi: contractAddress,
          HttpProvider: ""
        };
      }
    }
  };
  return Bloock;
}();

function NewConfigData(configData) {
  if (configData) return configData;
  return ConfigData.fromPartial({
    config: Configuration.fromPartial({
      libraryName: "Javascript",
      apiKey: Bloock.getApiKey(),
      identityApiHost: Bloock.getIdentityApiHost(),
      host: Bloock.getApiHost()
    }),
    networksConfig: Bloock.getNetworkConfiguration()
  });
}

/**
 * Represents a secret used for secret-based access control.
 */
var AccessControlSecret$1 = /*#__PURE__*/function () {
  /**
   * Creates a new AccessControlSecret instance with the provided secret.
   * @param secret
   */
  function AccessControlSecret$1(secret) {
    this.secret = secret;
  }
  var _proto = AccessControlSecret$1.prototype;
  _proto.toProto = function toProto() {
    return AccessControlSecret.fromPartial({
      secret: this.secret
    });
  };
  return AccessControlSecret$1;
}();

/**
 * Represents a Time-based One-Time Password ([TOTP](https://datatracker.ietf.org/doc/html/rfc6238)) code used for access control.
 */
var AccessControlTotp$1 = /*#__PURE__*/function () {
  /**
   * Constructs an AccessControlTotp object with the specified parameters.
   * @param code
   */
  function AccessControlTotp$1(code) {
    this.code = code;
  }
  var _proto = AccessControlTotp$1.prototype;
  _proto.toProto = function toProto() {
    return AccessControlTotp.fromPartial({
      code: this.code
    });
  };
  return AccessControlTotp$1;
}();

/**
 * Represents access control information, including Time-based One-Time Password (TOTP) and secret-based access.
 */
var AccessControl$1 = /*#__PURE__*/function () {
  /**
   * Constructs AccessControl object from an AccessControlTotp or AccessControlSecret object.
   * @param accessControl
   */
  function AccessControl$1(accessControl) {
    if (accessControl instanceof AccessControlTotp$1) {
      this.accessControlTotp = accessControl;
    } else if (accessControl instanceof AccessControlSecret$1) {
      this.accessControlSecret = accessControl;
    } else {
      throw new Error("invalid access control provided");
    }
  }
  var _proto = AccessControl$1.prototype;
  _proto.toProto = function toProto() {
    var accessControlTotp;
    if (this.accessControlTotp) {
      accessControlTotp = this.accessControlTotp && this.accessControlTotp.toProto();
    }
    var accessControlSecret;
    if (this.accessControlSecret) {
      accessControlSecret = this.accessControlSecret && this.accessControlSecret.toProto();
    }
    return AccessControl.fromPartial({
      accessControlTotp: accessControlTotp,
      accessControlSecret: accessControlSecret
    });
  };
  return AccessControl$1;
}();

/**
 * Represents the access control type a cryptographic key.
 */
var AccessControlType$1;
(function (AccessControlType) {
  /**
   * Indicates that the key is not protected by access control.
   */
  AccessControlType[AccessControlType["NONE"] = 0] = "NONE";
  /**
   * Indicates that the key is protected by a TOTP-based access control.
   */
  AccessControlType[AccessControlType["TOTP"] = 1] = "TOTP";
  /**
   * Indicates that the key is protected by a Secret-based access control.
   */
  AccessControlType[AccessControlType["SECRET"] = 2] = "SECRET";
})(AccessControlType$1 || (AccessControlType$1 = {}));
(function (AccessControlType$1) {
  function toProto(type) {
    switch (type) {
      case AccessControlType$1.NONE:
        return AccessControlType.NO_ACCESS_CONTROL;
      case AccessControlType$1.TOTP:
        return AccessControlType.TOTP;
      case AccessControlType$1.SECRET:
        return AccessControlType.SECRET;
      default:
        return AccessControlType.NO_ACCESS_CONTROL;
    }
  }
  AccessControlType$1.toProto = toProto;
  function fromProto(type) {
    switch (type) {
      case AccessControlType.NO_ACCESS_CONTROL:
        return AccessControlType$1.NONE;
      case AccessControlType.TOTP:
        return AccessControlType$1.TOTP;
      case AccessControlType.SECRET:
        return AccessControlType$1.SECRET;
      default:
        return AccessControlType$1.NONE;
    }
  }
  AccessControlType$1.fromProto = fromProto;
})(AccessControlType$1 || (AccessControlType$1 = {}));

/**
 * Represents the type of certificate.
 */
var CertificateType$1;
(function (CertificateType) {
  CertificateType[CertificateType["PEM"] = 0] = "PEM";
  CertificateType[CertificateType["PFX"] = 1] = "PFX";
})(CertificateType$1 || (CertificateType$1 = {}));
(function (CertificateType$1) {
  function toProto(type) {
    switch (type) {
      case CertificateType$1.PEM:
        return CertificateType.PEM;
      case CertificateType$1.PFX:
        return CertificateType.PFX;
    }
  }
  CertificateType$1.toProto = toProto;
  function fromProto(type) {
    switch (type) {
      case CertificateType.PEM:
        return CertificateType$1.PEM;
      case CertificateType.PFX:
        return CertificateType$1.PFX;
      default:
        return CertificateType$1.PEM;
    }
  }
  CertificateType$1.fromProto = fromProto;
})(CertificateType$1 || (CertificateType$1 = {}));

/**
 * Represents a pair of public and private keys.
 */
var KeyPair =
/**
 * Constructs a KeyPair object with the specified parameters.
 * @param publicKey
 * @param privateKey
 */
function KeyPair(publicKey, privateKey) {
  this.publicKey = publicKey;
  this.privateKey = privateKey;
};

/**
 * Represents an ecdsa key pair, with private and public key.
 */
var EcdsaKeyPair = /*#__PURE__*/function (_KeyPair) {
  _inheritsLoose(EcdsaKeyPair, _KeyPair);
  function EcdsaKeyPair() {
    return _KeyPair.apply(this, arguments) || this;
  }
  EcdsaKeyPair.fromProto = function fromProto(k) {
    return new KeyPair(k.localKey.key, k.localKey.privateKey);
  };
  return EcdsaKeyPair;
}(KeyPair);

/**
 * Represents the type of cryptographic key.
 */
var KeyType$1;
(function (KeyType) {
  /**
   * Represents the elliptic curve key type P-256k.
   */
  KeyType[KeyType["EcP256k"] = 0] = "EcP256k";
  /**
   * Represents the RSA key type with a 2048-bit modulus.
   */
  KeyType[KeyType["Rsa2048"] = 1] = "Rsa2048";
  /**
   * Represents the RSA key type with a 3072-bit modulus.
   */
  KeyType[KeyType["Rsa3072"] = 2] = "Rsa3072";
  /**
   * Represents the RSA key type with a 4096-bit modulus.
   */
  KeyType[KeyType["Rsa4096"] = 3] = "Rsa4096";
  /**
   * Represents the AES key type with a 128-bit key length.
   */
  KeyType[KeyType["Aes128"] = 4] = "Aes128";
  /**
   * Represents the AES key type with a 256-bit key length.
   */
  KeyType[KeyType["Aes256"] = 5] = "Aes256";
  /**
   * Represents the Baby JubJub key type, elliptic curve defined over the large prime subgroup of BN128.
   */
  KeyType[KeyType["Bjj"] = 6] = "Bjj";
})(KeyType$1 || (KeyType$1 = {}));
(function (KeyType$1) {
  function toProto(type) {
    switch (type) {
      case KeyType$1.EcP256k:
        return KeyType.EcP256k;
      case KeyType$1.Rsa2048:
        return KeyType.Rsa2048;
      case KeyType$1.Rsa3072:
        return KeyType.Rsa3072;
      case KeyType$1.Rsa4096:
        return KeyType.Rsa4096;
      case KeyType$1.Aes128:
        return KeyType.Aes128;
      case KeyType$1.Aes256:
        return KeyType.Aes256;
      case KeyType$1.Bjj:
        return KeyType.Bjj;
    }
  }
  KeyType$1.toProto = toProto;
  function fromProto(type) {
    switch (type) {
      case KeyType.Rsa2048:
        return KeyType$1.Rsa2048;
      case KeyType.Rsa3072:
        return KeyType$1.Rsa3072;
      case KeyType.Rsa4096:
        return KeyType$1.Rsa4096;
      case KeyType.Aes128:
        return KeyType$1.Aes128;
      case KeyType.Aes256:
        return KeyType$1.Aes256;
      case KeyType.Bjj:
        return KeyType$1.Bjj;
      default:
        return KeyType$1.EcP256k;
    }
  }
  KeyType$1.fromProto = fromProto;
})(KeyType$1 || (KeyType$1 = {}));

/**
 * Represents a local key with its public and private components.
 */
var LocalKey$1 = /*#__PURE__*/function () {
  /**
   * Constructs a LocalKey object with the specified parameters.
   * @param key
   * @param keyType
   * @param privateKey
   */
  function LocalKey$1(key, keyType, privateKey) {
    this.key = key;
    this.privateKey = privateKey;
    this.keyType = keyType;
  }
  var _proto = LocalKey$1.prototype;
  _proto.toProto = function toProto() {
    return LocalKey.fromPartial({
      key: this.key,
      privateKey: this.privateKey,
      keyType: KeyType$1.toProto(this.keyType)
    });
  };
  LocalKey$1.fromProto = function fromProto(r) {
    return new LocalKey$1(r.key, KeyType$1.fromProto(r.keyType), r.privateKey);
  };
  return LocalKey$1;
}();

/**
 * Represents the protection level of a cryptographic key.
 */
var KeyProtectionLevel$1;
(function (KeyProtectionLevel) {
  /**
   * Indicates that the key is protected by software.
   */
  KeyProtectionLevel[KeyProtectionLevel["SOFTWARE"] = 0] = "SOFTWARE";
  /**
   * Indicates that the key is protected by a Hardware Security Module (HSM).
   */
  KeyProtectionLevel[KeyProtectionLevel["HSM"] = 1] = "HSM";
})(KeyProtectionLevel$1 || (KeyProtectionLevel$1 = {}));
(function (KeyProtectionLevel$1) {
  function toProto(type) {
    switch (type) {
      case KeyProtectionLevel$1.SOFTWARE:
        return KeyProtectionLevel.SOFTWARE;
      case KeyProtectionLevel$1.HSM:
        return KeyProtectionLevel.HSM;
    }
  }
  KeyProtectionLevel$1.toProto = toProto;
  function fromProto(type) {
    switch (type) {
      case KeyProtectionLevel.SOFTWARE:
        return KeyProtectionLevel$1.SOFTWARE;
      case KeyProtectionLevel.HSM:
        return KeyProtectionLevel$1.HSM;
      default:
        return KeyProtectionLevel$1.SOFTWARE;
    }
  }
  KeyProtectionLevel$1.fromProto = fromProto;
})(KeyProtectionLevel$1 || (KeyProtectionLevel$1 = {}));

/**
 * Represents a managed key.
 */
var ManagedKey$1 = /*#__PURE__*/function () {
  /**
   * Constructs a ManagedKey object with the specified parameters.
   * @param id
   * @param protection
   * @param keyType
   * @param key
   * @param accessControlType
   * @param name
   * @param expiration
   */
  function ManagedKey$1(id, protection, keyType, key, accessControlType, name, expiration) {
    this.id = id;
    this.protection = protection;
    this.keyType = keyType;
    this.key = key;
    this.accessControlType = accessControlType;
    this.name = name;
    this.expiration = expiration;
  }
  var _proto = ManagedKey$1.prototype;
  _proto.toProto = function toProto() {
    return ManagedKey.fromPartial({
      id: this.id,
      protection: KeyProtectionLevel$1.toProto(this.protection),
      keyType: KeyType$1.toProto(this.keyType),
      key: this.key,
      name: this.name,
      expiration: this.expiration,
      accessControlType: AccessControlType$1.toProto(this.accessControlType)
    });
  };
  ManagedKey$1.fromProto = function fromProto(r) {
    return new ManagedKey$1(r.id, KeyProtectionLevel$1.fromProto(r.protection), KeyType$1.fromProto(r.keyType), r.key, AccessControlType$1.fromProto(r.accessControlType), r.name, r.expiration);
  };
  return ManagedKey$1;
}();

/**
 * Represents a key entity that can be either a LocalKey or a ManagedKey.
 */
var Key$1 = /*#__PURE__*/function () {
  /**
   * Constructs a Key object for a given managed or local key object.
   * @param key
   */
  function Key$1(key) {
    if (key instanceof LocalKey$1) {
      this.localKey = key;
    } else if (key instanceof ManagedKey$1) {
      this.managedKey = key;
    } else {
      throw new Error("invalid key provided");
    }
  }
  var _proto = Key$1.prototype;
  _proto.toProto = function toProto() {
    var localKey;
    if (this.localKey) {
      localKey = this.localKey.toProto();
    }
    var managedKey;
    if (this.managedKey) {
      managedKey = this.managedKey.toProto();
    }
    return Key.fromPartial({
      localKey: localKey,
      managedKey: managedKey
    });
  };
  return Key$1;
}();

/**
 * Represents a local certificate along with its password.
 */
var LocalCertificate$1 = /*#__PURE__*/function () {
  /**
   * Constructs a LocalCertificate object with the specified parameters.
   * @param pkcs12
   * @param password
   */
  function LocalCertificate$1(pkcs12, password) {
    this.pkcs12 = pkcs12;
    this.password = password;
  }
  var _proto = LocalCertificate$1.prototype;
  _proto.toProto = function toProto() {
    return LocalCertificate.fromPartial({
      pkcs12: this.pkcs12,
      password: this.password
    });
  };
  LocalCertificate$1.fromProto = function fromProto(r) {
    return new LocalCertificate$1(r.pkcs12, r.password);
  };
  return LocalCertificate$1;
}();

/**
 * Represents the parameters for generating a local certificate.
 */
var LocalCertificateParams$1 = /*#__PURE__*/function () {
  /**
   * Constructs an LocalCertificateParams object with the specified parameters.
   * @param keyType
   * @param subject
   * @param password
   * @param expiration
   */
  function LocalCertificateParams$1(keyType, subject, password, expiration) {
    this.keyType = keyType;
    this.subject = subject;
    this.password = password;
    this.expiration = expiration;
  }
  var _proto = LocalCertificateParams$1.prototype;
  _proto.toProto = function toProto() {
    return LocalCertificateParams.fromPartial({
      keyType: KeyType$1.toProto(this.keyType),
      subject: this.subject.toProto(),
      password: this.password,
      expiration: this.expiration
    });
  };
  return LocalCertificateParams$1;
}();

/**
 * Represents a managed entity that can be either a ManagedKey or a ManagedCertificate.
 */
var Managed =
/**
 * Constructs a Managed object for a given managed key or certificate object.
 * @param key
 */
function Managed(key) {
  if (key instanceof ManagedKey$1) {
    this.managedKey = key;
  } else if (key instanceof ManagedCertificate$1) {
    this.managedCertificate = key;
  } else {
    throw new Error("invalid key provided");
  }
};

/**
 * Represents a managed certificate with its details.
 */
var ManagedCertificate$1 = /*#__PURE__*/function () {
  /**
   * Constructs a ManagedCertificate object with the specified parameters.
   * @param id
   * @param protection
   * @param keyType
   * @param key
   * @param accessControlType
   * @param expiration
   */
  function ManagedCertificate$1(id, protection, keyType, key, accessControlType, expiration) {
    this.id = id;
    this.protection = protection;
    this.keyType = keyType;
    this.key = key;
    this.accessControlType = accessControlType;
    this.expiration = expiration;
  }
  var _proto = ManagedCertificate$1.prototype;
  _proto.toProto = function toProto() {
    return ManagedCertificate.fromPartial({
      id: this.id,
      protection: KeyProtectionLevel$1.toProto(this.protection),
      keyType: KeyType$1.toProto(this.keyType),
      key: this.key,
      expiration: this.expiration,
      accessControlType: AccessControlType$1.toProto(this.accessControlType)
    });
  };
  ManagedCertificate$1.fromProto = function fromProto(r) {
    return new ManagedCertificate$1(r.id, KeyProtectionLevel$1.fromProto(r.protection), KeyType$1.fromProto(r.keyType), r.key, AccessControlType$1.fromProto(r.accessControlType), r.expiration);
  };
  return ManagedCertificate$1;
}();

/**
 * Represents parameters for creating a managed certificate.
 */
var ManagedCertificateParams$1 = /*#__PURE__*/function () {
  /**
   * Constructs a ManagedCertificateParams object with the specified parameters.
   * @param keyType
   * @param subject
   * @param expiration
   */
  function ManagedCertificateParams$1(keyType, subject, expiration) {
    this.keyType = keyType;
    this.subject = subject;
    this.expiration = expiration;
  }
  var _proto = ManagedCertificateParams$1.prototype;
  _proto.toProto = function toProto() {
    return ManagedCertificateParams.fromPartial({
      keyType: KeyType$1.toProto(this.keyType),
      subject: this.subject.toProto(),
      expiration: this.expiration
    });
  };
  return ManagedCertificateParams$1;
}();
var ImportCertificateParams = function ImportCertificateParams(password) {
  this.password = password;
};

/**
 * Represents the parameters for creating a managed key.
 */
var ManagedKeyParams$1 = /*#__PURE__*/function () {
  /**
   * Constructs a ManagedKeyParams object with the specified parameters.
   * @param protection
   * @param keyType
   * @param name
   * @param expiration
   */
  function ManagedKeyParams$1(protection, keyType, name, expiration) {
    this.protection = protection;
    this.keyType = keyType;
    this.name = name;
    this.expiration = expiration;
  }
  var _proto = ManagedKeyParams$1.prototype;
  _proto.toProto = function toProto() {
    return ManagedKeyParams.fromPartial({
      protection: KeyProtectionLevel$1.toProto(this.protection),
      keyType: KeyType$1.toProto(this.keyType),
      name: this.name,
      expiration: this.expiration
    });
  };
  return ManagedKeyParams$1;
}();

/**
 * Represents a rsa key pair, with private and public key.
 */
var RsaKeyPair = /*#__PURE__*/function (_KeyPair) {
  _inheritsLoose(RsaKeyPair, _KeyPair);
  function RsaKeyPair() {
    return _KeyPair.apply(this, arguments) || this;
  }
  RsaKeyPair.fromProto = function fromProto(k) {
    return new KeyPair(k.localKey.key, k.localKey.privateKey);
  };
  return RsaKeyPair;
}(KeyPair);

/**
 * Represents parameters for generating a subject certificate.
 */
var SubjectCertificateParams = /*#__PURE__*/function () {
  /**
   * Constructs a SubjectCertificateParams object with the specified parameters.
   * @param commonName
   * @param organization
   * @param organizationUnit
   * @param location
   * @param state
   * @param country
   */
  function SubjectCertificateParams(commonName, organization, organizationUnit, location, state, country) {
    this.commonName = commonName;
    this.organization = organization;
    this.organizationUnit = organizationUnit;
    this.location = location;
    this.state = state;
    this.country = country;
  }
  var _proto = SubjectCertificateParams.prototype;
  _proto.toProto = function toProto() {
    return CertificateSubject.fromPartial({
      commonName: this.commonName,
      organization: this.organization,
      organizationalUnit: this.organizationUnit,
      location: this.location,
      state: this.state,
      country: this.country
    });
  };
  return SubjectCertificateParams;
}();

/**
 * Represents a receipt for a Time-based One-Time Password (TOTP) access control.
 */
var TotpAccessControlReceipt =
/**
 * Creates a new TotpAccessControlReceipt with the provided secret, secret QR code, and recovery codes.
 * @param secret
 * @param secretQr
 * @param recoveryCodes
 */
function TotpAccessControlReceipt(secret, secretQr, recoveryCodes) {
  this.secret = secret;
  this.secretQr = secretQr;
  this.recoveryCodes = recoveryCodes;
};

/**
 * Represents different hash algorithms.
 */
var HashAlg$1;
(function (HashAlg) {
  /**
   * Represents an unrecognized hash algorithm.
   */
  HashAlg[HashAlg["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
  /**
   * Represents the SHA-256 hash algorithm.
   */
  HashAlg[HashAlg["Sha256"] = 0] = "Sha256";
  /**
   * Represents the Keccak-256 hash algorithm.
   */
  HashAlg[HashAlg["Keccak256"] = 1] = "Keccak256";
  /**
   * Represents the Poseidon hash algorithm.
   */
  HashAlg[HashAlg["Poseidon"] = 2] = "Poseidon";
  /**
   * Represents no hash algorithm.
   */
  HashAlg[HashAlg["None"] = 3] = "None";
})(HashAlg$1 || (HashAlg$1 = {}));
(function (HashAlg$1) {
  function fromProto(alg) {
    switch (alg) {
      case HashAlg.SHA_256:
        return HashAlg$1.Sha256;
      case HashAlg.KECCAK_256:
        return HashAlg$1.Keccak256;
      case HashAlg.POSEIDON:
        return HashAlg$1.Poseidon;
      case HashAlg.NONE:
        return HashAlg$1.None;
      default:
        return HashAlg$1.UNRECOGNIZED;
    }
  }
  HashAlg$1.fromProto = fromProto;
  function toProto(alg) {
    switch (alg) {
      case HashAlg$1.Sha256:
        return HashAlg.SHA_256;
      case HashAlg$1.Keccak256:
        return HashAlg.KECCAK_256;
      case HashAlg$1.Poseidon:
        return HashAlg.POSEIDON;
      case HashAlg$1.None:
        return HashAlg.NONE;
      default:
        return HashAlg.UNRECOGNIZED;
    }
  }
  HashAlg$1.toProto = toProto;
})(HashAlg$1 || (HashAlg$1 = {}));

/**
 * Represents a signer with various key types and additional configurations.
 */
var Signer$1 = /*#__PURE__*/function () {
  /**
   * Creates a Signer instance with a local key, managed key, local certificate or managed certificate.
   * @param key
   * @param hashAlg
   * @param accessControl
   */
  function Signer$1(key, hashAlg, accessControl) {
    if (key instanceof LocalKey$1) {
      this.localKey = key;
    } else if (key instanceof ManagedKey$1) {
      this.managedKey = key;
    } else if (key instanceof ManagedCertificate$1) {
      this.managedCertificate = key;
    } else if (key instanceof LocalCertificate$1) {
      this.localCertificate = key;
    } else {
      throw new Error("invalid key provided");
    }
    if (hashAlg) {
      this.hashAlg = hashAlg;
    }
    if (accessControl) {
      this.accessControl = accessControl;
    }
  }
  var _proto = Signer$1.prototype;
  _proto.toProto = function toProto() {
    var _this$localKey, _this$managedKey, _this$managedCertific, _this$localCertificat;
    var hashAlg;
    if (this.hashAlg) {
      hashAlg = this.hashAlg && HashAlg$1.toProto(this.hashAlg);
    }
    var accessControl;
    if (this.accessControl) {
      accessControl = this.accessControl && this.accessControl.toProto();
    }
    return Signer.fromPartial({
      localKey: (_this$localKey = this.localKey) == null ? void 0 : _this$localKey.toProto(),
      managedKey: (_this$managedKey = this.managedKey) == null ? void 0 : _this$managedKey.toProto(),
      managedCertificate: (_this$managedCertific = this.managedCertificate) == null ? void 0 : _this$managedCertific.toProto(),
      localCertificate: (_this$localCertificat = this.localCertificate) == null ? void 0 : _this$localCertificat.toProto(),
      hashAlg: hashAlg,
      accessControl: accessControl
    });
  };
  return Signer$1;
}();

/**
 * Represents different signature algorithms.
 */
var SignatureAlg;
(function (SignatureAlg) {
  /**
   * Represents an unrecognized signature algorithm.
   */
  SignatureAlg[SignatureAlg["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
  /**
   * Represents the ECDSA signature algorithm with the "ES256K" name.
   */
  SignatureAlg[SignatureAlg["ECDSA"] = 0] = "ECDSA";
  /**
   * Represents the ENS (Ethereum Name Service) signature algorithm.
   */
  SignatureAlg[SignatureAlg["ENS"] = 1] = "ENS";
  /**
   * Represents the BJJ signature algorithm with the "BJJ" name.
   */
  SignatureAlg[SignatureAlg["BJJ"] = 2] = "BJJ";
})(SignatureAlg || (SignatureAlg = {}));
/**
 * Converts a string representation of an algorithm to the corresponding SignatureAlg enum.
 */
(function (SignatureAlg) {
  function fromString(alg) {
    switch (alg) {
      case "ES256K":
        return SignatureAlg.ECDSA;
      case "ENS":
        return SignatureAlg.ENS;
      case "BJJ":
        return SignatureAlg.BJJ;
      default:
        return SignatureAlg.UNRECOGNIZED;
    }
  }
  SignatureAlg.fromString = fromString;
})(SignatureAlg || (SignatureAlg = {}));

/**
 * Represents the header of a JSON Web Signature (JWS). [RFC 7515](https://datatracker.ietf.org/doc/html/rfc7515).
 */
var SignatureHeaderJws = /*#__PURE__*/function () {
  /**
   * Constructs a SignatureHeaderJws object with the specified algorithm and key identifier.
   * @param alg
   * @param kid
   */
  function SignatureHeaderJws(alg, kid) {
    this.alg = alg;
    this.kid = kid;
  }
  SignatureHeaderJws.fromProto = function fromProto(s) {
    return new SignatureHeaderJws(s.alg, s.kid);
  };
  var _proto = SignatureHeaderJws.prototype;
  _proto.toProto = function toProto() {
    return SignatureHeaderJWS.fromPartial({
      alg: this.alg,
      kid: this.kid
    });
  };
  return SignatureHeaderJws;
}();

/**
 * Represents a JSON Web Signature (JWS). [RFC 7515](https://datatracker.ietf.org/doc/html/rfc7515).
 */
var SignatureJws = /*#__PURE__*/function () {
  /**
   * Constructs a SignatureJws object with the specified parameters.
   * @param messageHash
   * @param signature
   * @param prot
   * @param header
   */
  function SignatureJws(messageHash, signature, prot, header) {
    this.signature = signature;
    this["protected"] = prot;
    this.header = header;
    this.messageHash = messageHash;
  }
  SignatureJws.fromProto = function fromProto(s) {
    return new SignatureJws(s.messageHash, s.signature, s["protected"], SignatureHeaderJws.fromProto(s.header));
  };
  var _proto = SignatureJws.prototype;
  _proto.toProto = function toProto() {
    return SignatureJWS.fromPartial({
      signature: this.signature,
      "protected": this["protected"],
      header: this.header.toProto(),
      messageHash: this.messageHash
    });
  };
  _proto.getAlg = function getAlg() {
    return SignatureAlg.fromString(this.header.alg);
  };
  return SignatureJws;
}();

/**
 * Represents a cryptographic signature along with additional metadata.
 */
var Signature$1 = /*#__PURE__*/function () {
  /**
   * Constructs a Signature object with the specified parameters.
   * @param messageHash
   * @param signature
   * @param alg
   * @param kid
   * @param subject
   */
  function Signature$1(messageHash, signature, alg, kid, subject) {
    this.signature = signature;
    this.alg = alg;
    this.kid = kid;
    this.messageHash = messageHash;
    this.subject = subject;
  }
  Signature$1.fromProto = function fromProto(s) {
    return new Signature$1(s.messageHash, s.signature, s.alg, s.kid, s.subject);
  };
  var _proto = Signature$1.prototype;
  _proto.toProto = function toProto() {
    return Signature.fromPartial({
      signature: this.signature,
      alg: this.alg,
      kid: this.kid,
      messageHash: this.messageHash,
      subject: this.subject
    });
  }
  /**
   * Returns the SignatureAlg based on the algorithm specified in the Alg field.
   * @returns
   */;
  _proto.getAlg = function getAlg() {
    return SignatureAlg.fromString(this.alg);
  };
  return Signature$1;
}();

/**
 * Represents a client for interacting with the [Bloock Authenticity service](https://dashboard.bloock.com/login).
 */
var AuthenticityClient = /*#__PURE__*/function () {
  /**
   * Creates a new instance of the AuthenticityClient with default configuration.
   * @param configData
   */
  function AuthenticityClient(configData) {
    this.bridge = new BloockBridge();
    this.configData = NewConfigData(configData);
  }
  /**
   * Generates ECDSA key pair for signing records.
   * @returns {Promise<KeyPair>} An object containing both the public and the private key
   * @deprecated Will be deleted in future versions. Use KeyClient.newLocalKey function instead.
   */
  var _proto = AuthenticityClient.prototype;
  _proto.generateEcdsaKeyPair =
  /*#__PURE__*/
  function () {
    var _generateEcdsaKeyPair = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var request;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            request = GenerateLocalKeyRequest.fromPartial({
              configData: this.configData,
              keyType: KeyType.EcP256k
            });
            return _context.abrupt("return", this.bridge.getKey().GenerateLocalKey(request).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return EcdsaKeyPair.fromProto(res);
            }));
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function generateEcdsaKeyPair() {
      return _generateEcdsaKeyPair.apply(this, arguments);
    }
    return generateEcdsaKeyPair;
  }()
  /**
   * Signs a Bloock record using the specified signer.
   * @param record
   * @param signer
   * @returns
   */
  ;
  _proto.sign =
  /*#__PURE__*/
  function () {
    var _sign = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(record, signer) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", this.bridge.getAuthenticity().Sign(SignRequest.fromPartial({
              configData: this.configData,
              record: record.toProto(),
              signer: signer.toProto()
            })).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return Signature$1.fromProto(res.signature);
            }));
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function sign(_x, _x2) {
      return _sign.apply(this, arguments);
    }
    return sign;
  }()
  /**
   * Verifies the authenticity of a Bloock record.
   * @param record
   * @returns
   */
  ;
  _proto.verify =
  /*#__PURE__*/
  function () {
    var _verify = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(record) {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", this.bridge.getAuthenticity().Verify(VerifyRequest.fromPartial({
              configData: this.configData,
              record: record.toProto()
            })).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return res.valid;
            }));
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3, this);
    }));
    function verify(_x3) {
      return _verify.apply(this, arguments);
    }
    return verify;
  }()
  /**
   * Gets the signatures associated with a Bloock record.
   * @param record
   * @returns
   */
  ;
  _proto.getSignatures =
  /*#__PURE__*/
  function () {
    var _getSignatures = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(record) {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", this.bridge.getAuthenticity().GetSignatures(GetSignaturesRequest.fromPartial({
              configData: this.configData,
              record: record.toProto()
            })).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return res.signatures.map(function (x) {
                return Signature$1.fromProto(x);
              });
            }));
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4, this);
    }));
    function getSignatures(_x4) {
      return _getSignatures.apply(this, arguments);
    }
    return getSignatures;
  }();
  return AuthenticityClient;
}();

/**
 * Represents a record with payload, hash, and configuration data.
 */
var Record$1 = /*#__PURE__*/function () {
  /**
   * Constructs a Record object with the specified parameters.
   * @param payload
   * @param hash
   * @param configData
   */
  function Record$1(payload, hash, configData) {
    this.payload = payload;
    this.hash = hash;
    this.configData = configData;
  }
  Record$1.fromProto = function fromProto(r, configData) {
    return new Record$1(r.payload, r.hash, configData);
  };
  var _proto = Record$1.prototype;
  _proto.toProto = function toProto() {
    return Record.fromPartial({
      configData: this.configData,
      payload: this.payload,
      hash: this.hash
    });
  }
  /**
   * Retrieves the hash of the record.
   * @returns
   */;
  _proto.getHash =
  /*#__PURE__*/
  function () {
    var _getHash = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var bridge;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            bridge = new BloockBridge();
            return _context.abrupt("return", bridge.getRecord().GetHash(GetHashRequest.fromPartial({
              configData: this.configData,
              record: this.toProto()
            })).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return res.hash;
            }));
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function getHash() {
      return _getHash.apply(this, arguments);
    }
    return getHash;
  }()
  /**
   * Retrieves the payload of the record.
   * @returns
   */
  ;
  _proto.getPayload =
  /*#__PURE__*/
  function () {
    var _getPayload = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var bridge;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            bridge = new BloockBridge();
            return _context2.abrupt("return", bridge.getRecord().GetPayload(GetPayloadRequest.fromPartial({
              configData: this.configData,
              record: this.toProto()
            })).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return res.payload;
            }));
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function getPayload() {
      return _getPayload.apply(this, arguments);
    }
    return getPayload;
  }()
  /**
   * Returns the payload of the record.
   * @returns
   */
  ;
  _proto.retrieve = function retrieve() {
    return this.payload;
  }
  /**
   * Sets the proof for a record.
   * @param proof
   * @returns
   */;
  _proto.setProof =
  /*#__PURE__*/
  function () {
    var _setProof = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(proof) {
      var _this = this;
      var bridge, req;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            bridge = new BloockBridge();
            req = SetProofRequest.fromPartial({
              configData: this.configData,
              record: this.toProto(),
              proof: proof.toProto()
            });
            return _context3.abrupt("return", bridge.getRecord().SetProof(req).then(function (res) {
              var _res$record;
              if (res.error) {
                throw res.error;
              }
              _this.payload = (_res$record = res.record) == null ? void 0 : _res$record.payload;
            }));
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3, this);
    }));
    function setProof(_x) {
      return _setProof.apply(this, arguments);
    }
    return setProof;
  }();
  return Record$1;
}();
var RecordHeader$1 = /*#__PURE__*/function () {
  function RecordHeader$1(ty) {
    this.ty = ty;
  }
  RecordHeader$1.fromProto = function fromProto(recordHeader) {
    return new RecordHeader$1(recordHeader.ty);
  };
  var _proto2 = RecordHeader$1.prototype;
  _proto2.toProto = function toProto() {
    return RecordHeader.fromPartial({
      ty: this.ty
    });
  };
  return RecordHeader$1;
}();

/**
 * Represents a client for interacting with the [Bloock Availability service](https://dashboard.bloock.com/login).
 */
var AvailabilityClient = /*#__PURE__*/function () {
  /**
   * Creates a new instance of the AvailabilityClient with default configuration.
   * @param configData
   */
  function AvailabilityClient(configData) {
    this.bridge = new BloockBridge();
    this.configData = NewConfigData(configData);
  }
  /**
   * Publishes a Bloock record to the Availability service using the specified publisher.
   * @param record
   * @param publisher
   * @returns
   */
  var _proto = AvailabilityClient.prototype;
  _proto.publish =
  /*#__PURE__*/
  function () {
    var _publish = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(record, publisher) {
      var request;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            request = PublishRequest.fromPartial({
              configData: this.configData,
              publisher: publisher.toProto(),
              record: record.toProto()
            });
            return _context.abrupt("return", this.bridge.getAvailability().Publish(request).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return res.id;
            }));
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function publish(_x, _x2) {
      return _publish.apply(this, arguments);
    }
    return publish;
  }()
  /**
   * Gets a Bloock record from the Availability service using the specified loader.
   * @param loader
   * @returns
   */
  ;
  _proto.retrieve =
  /*#__PURE__*/
  function () {
    var _retrieve = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(loader) {
      var _this = this;
      var request;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            request = RetrieveRequest.fromPartial({
              configData: this.configData,
              loader: loader.toProto()
            });
            return _context2.abrupt("return", this.bridge.getAvailability().Retrieve(request).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return Record$1.fromProto(res.record, _this.configData);
            }));
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function retrieve(_x3) {
      return _retrieve.apply(this, arguments);
    }
    return retrieve;
  }();
  return AvailabilityClient;
}();

/**
 * Represents an encryption configuration with various key types and access control.
 */
var Encrypter$1 = /*#__PURE__*/function () {
  /**
   * Creates a new Encrypter instance with a local encryption key.
   * @param key
   * @param accessControl
   */
  function Encrypter$1(key, accessControl) {
    if (key instanceof LocalKey$1) {
      this.localKey = key;
    } else if (key instanceof ManagedKey$1) {
      this.managedKey = key;
    } else if (key instanceof ManagedCertificate$1) {
      this.managedCertificate = key;
    } else if (key instanceof LocalCertificate$1) {
      this.localCertificate = key;
    } else {
      throw new Error("invalid key provided");
    }
    if (accessControl) {
      this.accessControl = accessControl;
    }
  }
  var _proto = Encrypter$1.prototype;
  _proto.toProto = function toProto() {
    var _this$localKey, _this$managedKey, _this$managedCertific, _this$localCertificat, _this$accessControl;
    return Encrypter.fromPartial({
      localKey: (_this$localKey = this.localKey) == null ? void 0 : _this$localKey.toProto(),
      managedKey: (_this$managedKey = this.managedKey) == null ? void 0 : _this$managedKey.toProto(),
      managedCertificate: (_this$managedCertific = this.managedCertificate) == null ? void 0 : _this$managedCertific.toProto(),
      localCertificate: (_this$localCertificat = this.localCertificate) == null ? void 0 : _this$localCertificat.toProto(),
      accessControl: (_this$accessControl = this.accessControl) == null ? void 0 : _this$accessControl.toProto()
    });
  };
  return Encrypter$1;
}();

/**
 * Represents encryption algorithm types.
 */
var EncryptionAlg$1;
(function (EncryptionAlg) {
  /**
   * Represents the AES-256-GCM encryption algorithm.
   */
  EncryptionAlg[EncryptionAlg["AES256GCM"] = 0] = "AES256GCM";
  /**
   * Represents the AES-256-GCM with managed key encryption algorithm.
   */
  EncryptionAlg[EncryptionAlg["AES256GCM_M"] = 1] = "AES256GCM_M";
  /**
   * Represents the RSA encryption algorithm.
   */
  EncryptionAlg[EncryptionAlg["RSA"] = 2] = "RSA";
  /**
   * Represents the RSA with managed key encryption algorithm.
   */
  EncryptionAlg[EncryptionAlg["RSA_M"] = 3] = "RSA_M";
  /**
   * Represents an unrecognized encryption algorithm.
   */
  EncryptionAlg[EncryptionAlg["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(EncryptionAlg$1 || (EncryptionAlg$1 = {}));
(function (EncryptionAlg$1) {
  function toProto(alg) {
    switch (alg) {
      case EncryptionAlg$1.AES256GCM:
        return EncryptionAlg.A256GCM;
      case EncryptionAlg$1.AES256GCM_M:
        return EncryptionAlg.A256GCM_M;
      case EncryptionAlg$1.RSA:
        return EncryptionAlg.RSA;
      case EncryptionAlg$1.RSA_M:
        return EncryptionAlg.RSA_M;
      default:
        return EncryptionAlg.UNRECOGNIZED;
    }
  }
  EncryptionAlg$1.toProto = toProto;
  function fromProto(alg) {
    switch (alg) {
      case EncryptionAlg.A256GCM:
        return EncryptionAlg$1.AES256GCM;
      case EncryptionAlg.RSA:
        return EncryptionAlg$1.RSA;
      default:
        return EncryptionAlg$1.UNRECOGNIZED;
    }
  }
  EncryptionAlg$1.fromProto = fromProto;
})(EncryptionAlg$1 || (EncryptionAlg$1 = {}));

/**
 * Represents a client for interacting with the [Bloock Encryption service](https://dashboard.bloock.com/login).
 */
var EncryptionClient = /*#__PURE__*/function () {
  /**
   * Creates a new instance of the EncryptionClient with default configuration.
   * @param configData
   */
  function EncryptionClient(configData) {
    this.bridge = new BloockBridge();
    this.configData = NewConfigData(configData);
  }
  /**
   * GenerateRsaKeyPair generates an RSA key pair for encryption.
   * @returns {Promise<KeyPair>} An object containing both the public and the private key
   * @deprecated Will be deleted in future versions. Use KeyClient.newLocalKey function instead.
   */
  var _proto = EncryptionClient.prototype;
  _proto.generateRsaKeyPair =
  /*#__PURE__*/
  function () {
    var _generateRsaKeyPair = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var request;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            request = GenerateLocalKeyRequest.fromPartial({
              configData: this.configData,
              keyType: KeyType.Rsa2048
            });
            return _context.abrupt("return", this.bridge.getKey().GenerateLocalKey(request).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return RsaKeyPair.fromProto(res);
            }));
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function generateRsaKeyPair() {
      return _generateRsaKeyPair.apply(this, arguments);
    }
    return generateRsaKeyPair;
  }()
  /**
   * Encrypts a Bloock record using the specified encrypter.
   * @param record
   * @param encrypter
   * @returns
   */
  ;
  _proto.encrypt =
  /*#__PURE__*/
  function () {
    var _encrypt = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(record, encrypter) {
      var _this = this;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", this.bridge.getEncryption().Encrypt(EncryptRequest.fromPartial({
              configData: this.configData,
              record: record.toProto(),
              encrypter: encrypter.toProto()
            })).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return Record$1.fromProto(res.record, _this.configData);
            }));
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function encrypt(_x, _x2) {
      return _encrypt.apply(this, arguments);
    }
    return encrypt;
  }()
  /**
   * Decrypts a Bloock record using the specified decrypter.
   * @param record
   * @param decrypter
   * @returns
   */
  ;
  _proto.decrypt =
  /*#__PURE__*/
  function () {
    var _decrypt = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(record, decrypter) {
      var _this2 = this;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", this.bridge.getEncryption().Decrypt(DecryptRequest.fromPartial({
              configData: this.configData,
              record: record.toProto(),
              decrypter: decrypter.toProto()
            })).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return Record$1.fromProto(res.record, _this2.configData);
            }));
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3, this);
    }));
    function decrypt(_x3, _x4) {
      return _decrypt.apply(this, arguments);
    }
    return decrypt;
  }()
  /**
   * Gets the encryption algorithm used for a Bloock record.
   * @param record
   * @returns
   */
  ;
  _proto.getEncryptionAlg =
  /*#__PURE__*/
  function () {
    var _getEncryptionAlg = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(record) {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", this.bridge.getEncryption().GetEncryptionAlg(EncryptionAlgRequest.fromPartial({
              configData: this.configData,
              record: record.toProto()
            })).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return EncryptionAlg$1.fromProto(res.alg);
            }));
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4, this);
    }));
    function getEncryptionAlg(_x5) {
      return _getEncryptionAlg.apply(this, arguments);
    }
    return getEncryptionAlg;
  }();
  return EncryptionClient;
}();

/**
 * Represents an attribute with an identifier and a corresponding value.
 */
var Attribute =
/**
 * Constructs a Attribute object with the specified parameters.
 * @param id
 * @param value
 */
function Attribute(id, value) {
  this.id = id;
  this.value = value;
};

/**
 * Represents a descriptor for an attribute.
 */
var AttributeDescriptor =
/**
 * Constructs an AttributeDescriptor object with the specified parameters.
 * @param displayName
 * @param technicalName
 * @param description
 * @param required
 */
function AttributeDescriptor(displayName, technicalName, description, required) {
  this.displayName = displayName;
  this.technicalName = technicalName;
  this.description = description;
  this.required = required;
};

/**
 * Represents a descriptor for a boolean attribute.
 */
var BooleanAttributeDescriptor = /*#__PURE__*/function (_AttributeDescriptor) {
  _inheritsLoose(BooleanAttributeDescriptor, _AttributeDescriptor);
  function BooleanAttributeDescriptor() {
    return _AttributeDescriptor.apply(this, arguments) || this;
  }
  var _proto = BooleanAttributeDescriptor.prototype;
  _proto.toProto = function toProto() {
    return BooleanAttributeDefinition.fromPartial({
      displayName: this.displayName,
      id: this.technicalName,
      description: this.description,
      required: this.required
    });
  };
  BooleanAttributeDescriptor.fromProto = function fromProto(r) {
    return new BooleanAttributeDescriptor(r.displayName, r.id, r.description, r.required);
  };
  return BooleanAttributeDescriptor;
}(AttributeDescriptor);

/**
 * Represents a descriptor for a date attribute, including its display name, ID, description, and required status.
 */
var DateAttributeDescriptor = /*#__PURE__*/function (_AttributeDescriptor) {
  _inheritsLoose(DateAttributeDescriptor, _AttributeDescriptor);
  function DateAttributeDescriptor() {
    return _AttributeDescriptor.apply(this, arguments) || this;
  }
  var _proto = DateAttributeDescriptor.prototype;
  _proto.toProto = function toProto() {
    return DateAttributeDefinition.fromPartial({
      displayName: this.displayName,
      id: this.technicalName,
      description: this.description,
      required: this.required
    });
  };
  DateAttributeDescriptor.fromProto = function fromProto(r) {
    return new DateAttributeDescriptor(r.displayName, r.id, r.description, r.required);
  };
  return DateAttributeDescriptor;
}(AttributeDescriptor);

/**
 * Represents a descriptor for an attribute with a datetime value.
 */
var DateTimeAttributeDescriptor = /*#__PURE__*/function (_AttributeDescriptor) {
  _inheritsLoose(DateTimeAttributeDescriptor, _AttributeDescriptor);
  function DateTimeAttributeDescriptor() {
    return _AttributeDescriptor.apply(this, arguments) || this;
  }
  var _proto = DateTimeAttributeDescriptor.prototype;
  _proto.toProto = function toProto() {
    return DateTimeAttributeDefinition.fromPartial({
      displayName: this.displayName,
      id: this.technicalName,
      description: this.description,
      required: this.required
    });
  };
  DateTimeAttributeDescriptor.fromProto = function fromProto(r) {
    return new DateTimeAttributeDescriptor(r.displayName, r.id, r.description, r.required);
  };
  return DateTimeAttributeDescriptor;
}(AttributeDescriptor);

/**
 * Represents a descriptor for an attribute with a string value.
 */
var StringAttributeDescriptor = /*#__PURE__*/function (_AttributeDescriptor) {
  _inheritsLoose(StringAttributeDescriptor, _AttributeDescriptor);
  function StringAttributeDescriptor(displayName, technicalName, description, required) {
    return _AttributeDescriptor.call(this, displayName, technicalName, description, required) || this;
  }
  var _proto = StringAttributeDescriptor.prototype;
  _proto.toProto = function toProto() {
    return StringAttributeDefinition.fromPartial({
      displayName: this.displayName,
      id: this.technicalName,
      description: this.description,
      required: this.required
    });
  };
  StringAttributeDescriptor.fromProto = function fromProto(r) {
    return new StringAttributeDescriptor(r.displayName, r.id, r.description, r.required);
  };
  return StringAttributeDescriptor;
}(AttributeDescriptor);

/**
 * Represents a descriptor for an attribute with an integer value.
 */
var IntegerAttributeDescriptor = /*#__PURE__*/function (_AttributeDescriptor) {
  _inheritsLoose(IntegerAttributeDescriptor, _AttributeDescriptor);
  function IntegerAttributeDescriptor() {
    return _AttributeDescriptor.apply(this, arguments) || this;
  }
  var _proto = IntegerAttributeDescriptor.prototype;
  _proto.toProto = function toProto() {
    return IntegerAttributeDefinition.fromPartial({
      displayName: this.displayName,
      id: this.technicalName,
      description: this.description,
      required: this.required
    });
  };
  IntegerAttributeDescriptor.fromProto = function fromProto(r) {
    return new IntegerAttributeDescriptor(r.displayName, r.id, r.description, r.required);
  };
  return IntegerAttributeDescriptor;
}(AttributeDescriptor);

/**
 * Represents a descriptor for an attribute with a decimal value.
 */
var DecimalAttributeDescriptor = /*#__PURE__*/function (_AttributeDescriptor) {
  _inheritsLoose(DecimalAttributeDescriptor, _AttributeDescriptor);
  function DecimalAttributeDescriptor() {
    return _AttributeDescriptor.apply(this, arguments) || this;
  }
  var _proto = DecimalAttributeDescriptor.prototype;
  _proto.toProto = function toProto() {
    return DecimalAttributeDefinition.fromPartial({
      displayName: this.displayName,
      id: this.technicalName,
      description: this.description,
      required: this.required
    });
  };
  DecimalAttributeDescriptor.fromProto = function fromProto(r) {
    return new DecimalAttributeDescriptor(r.displayName, r.id, r.description, r.required);
  };
  return DecimalAttributeDescriptor;
}(AttributeDescriptor);

/**
 * Represents a descriptor for an attribute with a string enum value.
 */
var StringEnumAttributeDescriptor = /*#__PURE__*/function (_AttributeDescriptor) {
  _inheritsLoose(StringEnumAttributeDescriptor, _AttributeDescriptor);
  /**
   * Constructs an StringEnumAttributeDescriptor object with the specified parameters.
   * @param displayName
   * @param technicalName
   * @param description
   * @param required
   * @param enumeration
   */
  function StringEnumAttributeDescriptor(displayName, technicalName, description, required, enumeration) {
    var _this;
    _this = _AttributeDescriptor.call(this, displayName, technicalName, description, required) || this;
    _this.enumeration = enumeration;
    return _this;
  }
  var _proto = StringEnumAttributeDescriptor.prototype;
  _proto.toProto = function toProto() {
    return StringEnumAttributeDefinition.fromPartial({
      displayName: this.displayName,
      id: this.technicalName,
      description: this.description,
      required: this.required,
      "enum": this.enumeration
    });
  };
  StringEnumAttributeDescriptor.fromProto = function fromProto(r) {
    return new StringEnumAttributeDescriptor(r.displayName, r.id, r.description, r.required, r["enum"]);
  };
  return StringEnumAttributeDescriptor;
}(AttributeDescriptor);

/**
 * Represents a descriptor for an attribute with an integer enum value.
 */
var IntegerEnumAttributeDescriptor = /*#__PURE__*/function (_AttributeDescriptor) {
  _inheritsLoose(IntegerEnumAttributeDescriptor, _AttributeDescriptor);
  /**
   * Constructs an IntegerEnumAttributeDescriptor object with the specified parameters.
   * @param displayName
   * @param technicalName
   * @param description
   * @param required
   * @param enumeration
   */
  function IntegerEnumAttributeDescriptor(displayName, technicalName, description, required, enumeration) {
    var _this;
    _this = _AttributeDescriptor.call(this, displayName, technicalName, description, required) || this;
    _this.enumeration = enumeration;
    return _this;
  }
  var _proto = IntegerEnumAttributeDescriptor.prototype;
  _proto.toProto = function toProto() {
    return IntegerEnumAttributeDefinition.fromPartial({
      displayName: this.displayName,
      id: this.technicalName,
      description: this.description,
      required: this.required,
      "enum": this.enumeration
    });
  };
  IntegerEnumAttributeDescriptor.fromProto = function fromProto(r) {
    return new IntegerEnumAttributeDescriptor(r.displayName, r.id, r.description, r.required, r["enum"]);
  };
  return IntegerEnumAttributeDescriptor;
}(AttributeDescriptor);

/**
 * Represents a descriptor for an attribute with a decimal enum value.
 */
var DecimalEnumAttributeDescriptor = /*#__PURE__*/function (_AttributeDescriptor) {
  _inheritsLoose(DecimalEnumAttributeDescriptor, _AttributeDescriptor);
  /**
   * Constructs an DecimalEnumAttributeDescriptor object with the specified parameters.
   * @param displayName
   * @param technicalName
   * @param description
   * @param required
   * @param enumeration
   */
  function DecimalEnumAttributeDescriptor(displayName, technicalName, description, required, enumeration) {
    var _this;
    _this = _AttributeDescriptor.call(this, displayName, technicalName, description, required) || this;
    _this.enumeration = enumeration;
    return _this;
  }
  var _proto = DecimalEnumAttributeDescriptor.prototype;
  _proto.toProto = function toProto() {
    return DecimalEnumAttributeDefinition.fromPartial({
      displayName: this.displayName,
      id: this.technicalName,
      description: this.description,
      required: this.required,
      "enum": this.enumeration
    });
  };
  DecimalEnumAttributeDescriptor.fromProto = function fromProto(r) {
    return new DecimalEnumAttributeDescriptor(r.displayName, r.id, r.description, r.required, r["enum"]);
  };
  return DecimalEnumAttributeDescriptor;
}(AttributeDescriptor);

/**
 * Represents an attribute with a boolean value.
 */
var BooleanAttribute$1 = /*#__PURE__*/function (_Attribute) {
  _inheritsLoose(BooleanAttribute$1, _Attribute);
  function BooleanAttribute$1() {
    return _Attribute.apply(this, arguments) || this;
  }
  var _proto = BooleanAttribute$1.prototype;
  _proto.toProto = function toProto() {
    return BooleanAttribute.fromPartial({
      id: this.id,
      value: this.value
    });
  };
  BooleanAttribute$1.fromProto = function fromProto(r) {
    return new BooleanAttribute$1(r.id, r.value);
  };
  return BooleanAttribute$1;
}(Attribute);

/**
 * Represents an attribute with a date value, including its key and formatted value.
 */
var DateAttribute$1 = /*#__PURE__*/function (_Attribute) {
  _inheritsLoose(DateAttribute$1, _Attribute);
  function DateAttribute$1() {
    return _Attribute.apply(this, arguments) || this;
  }
  var _proto = DateAttribute$1.prototype;
  _proto.toProto = function toProto() {
    return DateAttribute.fromPartial({
      id: this.id,
      value: this.value.toISOString().split("T")[0]
    });
  };
  DateAttribute$1.fromProto = function fromProto(r) {
    return new DateAttribute$1(r.id, new Date(r.value));
  };
  return DateAttribute$1;
}(Attribute);

/**
 * Represents an attribute with a datetime value.
 */
var DateTimeAttribute$1 = /*#__PURE__*/function (_Attribute) {
  _inheritsLoose(DateTimeAttribute$1, _Attribute);
  function DateTimeAttribute$1() {
    return _Attribute.apply(this, arguments) || this;
  }
  var _proto = DateTimeAttribute$1.prototype;
  _proto.toProto = function toProto() {
    return DateTimeAttribute.fromPartial({
      id: this.id,
      value: this.value.toISOString()
    });
  };
  DateTimeAttribute$1.fromProto = function fromProto(r) {
    return new DateTimeAttribute$1(r.id, new Date(r.value));
  };
  return DateTimeAttribute$1;
}(Attribute);

/**
 * Represents an attribute with a string value.
 */
var StringAttribute$1 = /*#__PURE__*/function (_Attribute) {
  _inheritsLoose(StringAttribute$1, _Attribute);
  function StringAttribute$1() {
    return _Attribute.apply(this, arguments) || this;
  }
  var _proto = StringAttribute$1.prototype;
  _proto.toProto = function toProto() {
    return StringAttribute.fromPartial({
      id: this.id,
      value: this.value
    });
  };
  StringAttribute$1.fromProto = function fromProto(r) {
    return new StringAttribute$1(r.id, r.value);
  };
  return StringAttribute$1;
}(Attribute);

/**
 * Represents an attribute with an integer value.
 */
var IntegerAttribute$1 = /*#__PURE__*/function (_Attribute) {
  _inheritsLoose(IntegerAttribute$1, _Attribute);
  function IntegerAttribute$1() {
    return _Attribute.apply(this, arguments) || this;
  }
  var _proto = IntegerAttribute$1.prototype;
  _proto.toProto = function toProto() {
    return IntegerAttribute.fromPartial({
      id: this.id,
      value: this.value
    });
  };
  IntegerAttribute$1.fromProto = function fromProto(r) {
    return new IntegerAttribute$1(r.id, r.value);
  };
  return IntegerAttribute$1;
}(Attribute);

/**
 * Represents an attribute with a decimal value.
 */
var DecimalAttribute$1 = /*#__PURE__*/function (_Attribute) {
  _inheritsLoose(DecimalAttribute$1, _Attribute);
  function DecimalAttribute$1() {
    return _Attribute.apply(this, arguments) || this;
  }
  var _proto = DecimalAttribute$1.prototype;
  _proto.toProto = function toProto() {
    return DecimalAttribute.fromPartial({
      id: this.id,
      value: this.value
    });
  };
  DecimalAttribute$1.fromProto = function fromProto(r) {
    return new DecimalAttribute$1(r.id, r.value);
  };
  return DecimalAttribute$1;
}(Attribute);

/**
 * Represents the proof associated with a credential, including signature and sparse merkle tree proof.
 */
var CredentialProof$1 = /*#__PURE__*/function () {
  /**
   * Constructs an CredentialProof object with the specified parameters.
   * @param signatureProof
   * @param sparseMtProof
   */
  function CredentialProof$1(signatureProof, sparseMtProof) {
    this.signatureProof = signatureProof;
    this.sparseMtProof = sparseMtProof;
  }
  var _proto = CredentialProof$1.prototype;
  _proto.toProto = function toProto() {
    return CredentialProof.fromPartial({
      signatureProof: this.signatureProof,
      sparseMtProof: this.sparseMtProof
    });
  };
  CredentialProof$1.fromProto = function fromProto(r) {
    return new CredentialProof$1(r.signatureProof, r.sparseMtProof);
  };
  return CredentialProof$1;
}();

/**
 * Represents the schema information for a credential, including its ID and type.
 */
var CredentialSchema$1 = /*#__PURE__*/function () {
  /**
   * Constructs an CredentialSchema object with the specified parameters.
   * @param id
   * @param type
   */
  function CredentialSchema$1(id, type) {
    this.id = id;
    this.type = type;
  }
  var _proto = CredentialSchema$1.prototype;
  _proto.toProto = function toProto() {
    return CredentialSchema.fromPartial({
      id: this.id,
      type: this.type
    });
  };
  CredentialSchema$1.fromProto = function fromProto(r) {
    return new CredentialSchema$1(r.id, r.type);
  };
  return CredentialSchema$1;
}();

/**
 * Represents the status information for a credential, including its ID, revocation nonce, and type.
 */
var CredentialStatus$1 = /*#__PURE__*/function () {
  /**
   * Constructs an CredentialStatus object with the specified parameters.
   * @param id
   * @param revocationNonce
   * @param type
   */
  function CredentialStatus$1(id, revocationNonce, type) {
    this.id = id;
    this.revocationNonce = revocationNonce;
    this.type = type;
  }
  var _proto = CredentialStatus$1.prototype;
  _proto.toProto = function toProto() {
    return CredentialStatus.fromPartial({
      id: this.id,
      revocationNonce: this.revocationNonce,
      type: this.type
    });
  };
  CredentialStatus$1.fromProto = function fromProto(r) {
    return new CredentialStatus$1(r.id, r.revocationNonce, r.type);
  };
  return CredentialStatus$1;
}();

/**
 * Represents a verifiable credential with its associated information. [Verifiable Credentials Data Model v2.0](https://www.w3.org/TR/vc-data-model-2.0/).
 */
var Credential$1 = /*#__PURE__*/function () {
  /**
   * Creates a new Credential instance with the provided details.
   * @param context
   * @param id
   * @param type
   * @param issuanceDate
   * @param expiration
   * @param credentialSubject
   * @param credentialStatus
   * @param issuer
   * @param credentialSchema
   * @param proof
   */
  function Credential$1(context, id, type, issuanceDate, expiration, credentialSubject, credentialStatus, issuer, credentialSchema, proof) {
    this.context = context;
    this.id = id;
    this.type = type;
    this.issuanceDate = issuanceDate;
    this.expiration = expiration;
    this.credentialStatus = credentialStatus;
    this.credentialSubject = credentialSubject;
    this.issuer = issuer;
    this.credentialSchema = credentialSchema;
    this.proof = proof;
  }
  var _proto = Credential$1.prototype;
  _proto.toProto = function toProto() {
    return Credential.fromPartial({
      context: this.context,
      id: this.id,
      type: this.type,
      issuanceDate: this.issuanceDate,
      expiration: this.expiration,
      credentialStatus: this.credentialStatus.toProto(),
      credentialSubject: this.credentialSubject,
      issuer: this.issuer,
      credentialSchema: this.credentialSchema.toProto(),
      proof: this.proof.toProto()
    });
  };
  Credential$1.fromProto = function fromProto(r) {
    return new Credential$1(r.context, r.id, r.type, r.issuanceDate, r.expiration, r.credentialSubject, CredentialStatus$1.fromProto(r.credentialStatus), r.issuer, CredentialSchema$1.fromProto(r.credentialSchema), CredentialProof$1.fromProto(r.proof));
  }
  /**
   * Converts the Credential instance to its JSON string representation.
   * @returns
   */;
  _proto.toJson = function toJson() {
    var bridge = new BloockBridge();
    var req = CredentialToJsonRequest.fromPartial({
      configData: NewConfigData(undefined),
      credential: this.toProto()
    });
    return bridge.getIdentity().CredentialToJson(req).then(function (res) {
      if (res.error) {
        throw res.error;
      }
      return res.json;
    });
  }
  /**
   * Creates a Credential instance from a JSON string representation.
   * @param json
   * @returns
   */;
  Credential$1.fromJson = function fromJson(json) {
    var bridge = new BloockBridge();
    var req = CredentialFromJsonRequest.fromPartial({
      configData: NewConfigData(undefined),
      json: json
    });
    return bridge.getIdentity().CredentialFromJson(req).then(function (res) {
      if (res.error) {
        throw res.error;
      }
      return Credential$1.fromProto(res.credential);
    });
  };
  return Credential$1;
}();

/**
 * Represents a receipt for a credential, including the credential itself, its ID, and type.
 */
var CredentialReceipt$1 = /*#__PURE__*/function () {
  /**
   * Constructs an CredentialReceipt object with the specified parameters.
   * @param credential
   * @param credentialId
   * @param credentialType
   */
  function CredentialReceipt$1(credential, credentialId, credentialType) {
    this.credential = credential;
    this.credentialId = credentialId;
    this.credentialType = credentialType;
  }
  var _proto = CredentialReceipt$1.prototype;
  _proto.toProto = function toProto() {
    return CredentialReceipt.fromPartial({
      credential: this.credential.toProto(),
      credentialId: this.credentialId,
      credentialType: this.credentialType
    });
  };
  CredentialReceipt$1.fromProto = function fromProto(r) {
    return new CredentialReceipt$1(Credential$1.fromProto(r.credential), r.credentialId, r.credentialType);
  };
  return CredentialReceipt$1;
}();

/**
 * Helps construct credentials by specifying various attributes.
 */
var CredentialBuilder = /*#__PURE__*/function () {
  /**
   * Creates a new CredentialBuilder instance with the specified parameters.
   * @param schemaId
   * @param issuerDid
   * @param holderDid
   * @param expiration
   * @param version
   * @param configData
   */
  function CredentialBuilder(issuer, schemaId, holderDid, expiration, version, configData) {
    this.schemaId = schemaId;
    this.holderDid = holderDid;
    this.expiration = expiration;
    this.version = version;
    this.configData = configData;
    this.key = issuer.key.toProto();
    this.stringAttributes = [];
    this.integerAttributes = [];
    this.decimalAttributes = [];
    this.booleanAttributes = [];
    this.dateAttributes = [];
    this.dateTimeAttributes = [];
  }
  /**
   * Adds a string attribute to the CredentialBuilder.
   * @param key
   * @param value
   * @returns
   */
  var _proto = CredentialBuilder.prototype;
  _proto.withStringAttribute = function withStringAttribute(key, value) {
    this.stringAttributes.push(new StringAttribute$1(key, value));
    return this;
  }
  /**
   * Adds an integer attribute to the CredentialBuilder.
   * @param key
   * @param value
   * @returns
   */;
  _proto.withIntegerAttribute = function withIntegerAttribute(key, value) {
    this.integerAttributes.push(new IntegerAttribute$1(key, value));
    return this;
  }
  /**
   * Adds a decimal attribute to the CredentialBuilder.
   * @param key
   * @param value
   * @returns
   */;
  _proto.withDecimalAttribute = function withDecimalAttribute(key, value) {
    this.decimalAttributes.push(new DecimalAttribute$1(key, value));
    return this;
  }
  /**
   * Adds a boolean attribute to the CredentialBuilder.
   * @param key
   * @param value
   * @returns
   */;
  _proto.withBooleanAttribute = function withBooleanAttribute(key, value) {
    this.booleanAttributes.push(new BooleanAttribute$1(key, value));
    return this;
  }
  /**
   * Adds a date attribute to the CredentialBuilder.
   * @param key
   * @param value
   * @returns
   */;
  _proto.withDateAttribute = function withDateAttribute(key, value) {
    this.dateAttributes.push(new DateAttribute$1(key, value).toProto());
    return this;
  }
  /**
   * Adds a datetime attribute to the CredentialBuilder.
   * @param key
   * @param value
   * @returns
   */;
  _proto.withDateTimeAttribute = function withDateTimeAttribute(key, value) {
    this.dateTimeAttributes.push(new DateTimeAttribute$1(key, value).toProto());
    return this;
  }
  /**
   * Creates and returns a Credential using the specified attributes.
   * @returns
   */;
  _proto.build =
  /*#__PURE__*/
  function () {
    var _build = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var bridge, req;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            bridge = new BloockBridge();
            req = CreateCredentialRequest.fromPartial({
              configData: this.configData,
              schemaId: this.schemaId,
              holderDid: this.holderDid,
              expiration: this.expiration,
              version: this.version,
              key: this.key,
              stringAttributes: this.stringAttributes,
              integerAttributes: this.integerAttributes,
              decimalAttributes: this.decimalAttributes,
              booleanAttributes: this.booleanAttributes,
              dateAttributes: this.dateAttributes,
              datetimeAttributes: this.dateTimeAttributes
            });
            return _context.abrupt("return", bridge.getIdentity().CreateCredential(req).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return CredentialReceipt$1.fromProto(res.credentialReceipt);
            }));
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function build() {
      return _build.apply(this, arguments);
    }
    return build;
  }();
  return CredentialBuilder;
}();

/**
 * Represents the type of method did.
 */
var DidMethod$1;
(function (DidMethod) {
  /**
   * Represents the polygon id method did.
   */
  DidMethod[DidMethod["PolygonID"] = 0] = "PolygonID";
  /**
   * Represents the polygon id test method did.
   */
  DidMethod[DidMethod["PolygonIDTest"] = 1] = "PolygonIDTest";
})(DidMethod$1 || (DidMethod$1 = {}));
(function (DidMethod$1) {
  function toProto(method) {
    switch (method) {
      case DidMethod$1.PolygonID:
        return DidMethod.POLYGON_ID;
      case DidMethod$1.PolygonIDTest:
        return DidMethod.POLYGON_ID_TEST;
    }
  }
  DidMethod$1.toProto = toProto;
  function fromProto(method) {
    switch (method) {
      case DidMethod.POLYGON_ID:
        return DidMethod$1.PolygonID;
      case DidMethod.POLYGON_ID_TEST:
        return DidMethod$1.PolygonIDTest;
      default:
        return DidMethod$1.PolygonID;
    }
  }
  DidMethod$1.fromProto = fromProto;
})(DidMethod$1 || (DidMethod$1 = {}));

/**
 * Represents a receipt for the issuer's state.
 */
var IssuerStateReceipt$1 = /*#__PURE__*/function () {
  /**
   * Constructs an IssuerStateReceipt object with the specified parameters.
   * @param txHash
   */
  function IssuerStateReceipt$1(txHash) {
    this.txHash = txHash;
  }
  var _proto = IssuerStateReceipt$1.prototype;
  _proto.toProto = function toProto() {
    return IssuerStateReceipt.fromPartial({
      txHash: this.txHash
    });
  };
  IssuerStateReceipt$1.fromProto = function fromProto(r) {
    return new IssuerStateReceipt$1(r.txHash);
  };
  return IssuerStateReceipt$1;
}();

/**
 * Represents a schema with its attributes.
 */
var Schema$1 = /*#__PURE__*/function () {
  /**
   * Constructs a Schema object with the specified parameters.
   * @param cid
   * @param cidJsonLd
   * @param schemaType
   * @param json
   */
  function Schema$1(cid, cidJsonLd, schemaType, json) {
    this.cid = cid;
    this.cidJsonLd = cidJsonLd;
    this.schemaType = schemaType;
    this.json = json;
  }
  var _proto = Schema$1.prototype;
  _proto.toProto = function toProto() {
    return Schema.fromPartial({
      cid: this.cid,
      cidJsonLd: this.cidJsonLd,
      schemaType: this.schemaType,
      json: this.json
    });
  };
  Schema$1.fromProto = function fromProto(r) {
    return new Schema$1(r.cid, r.cidJsonLd, r.schemaType, r.json);
  };
  return Schema$1;
}();

/**
 * Is a builder pattern for constructing schema instances.
 */
var SchemaBuilder = /*#__PURE__*/function () {
  /**
   * Creates a new instance of SchemaBuilder with initial values.
   * @param displayName
   * @param schemaType
   * @param version
   * @param description
   * @param configData
   */
  function SchemaBuilder(displayName, schemaType, version, description, configData) {
    this.displayName = displayName;
    this.schemaType = schemaType;
    this.version = version;
    this.description = description;
    this.configData = configData;
    this.stringAttributes = [];
    this.integerAttributes = [];
    this.decimalAttributes = [];
    this.booleanAttributes = [];
    this.dateAttributes = [];
    this.dateTimeAttributes = [];
    this.stringEnumAttributes = [];
    this.integerEnumAttributes = [];
    this.decimalEnumAttributes = [];
  }
  /**
   * Adds a string attribute descriptor to the schema builder.
   * @param name
   * @param technicalName
   * @param description
   * @param required
   * @returns
   */
  var _proto = SchemaBuilder.prototype;
  _proto.addStringAttribute = function addStringAttribute(name, technicalName, description, required) {
    this.stringAttributes.push(new StringAttributeDescriptor(name, technicalName, description, required));
    return this;
  }
  /**
   * Adds an integer attribute descriptor to the schema builder.
   * @param name
   * @param technicalName
   * @param description
   * @param required
   * @returns
   */;
  _proto.addIntegerAttribute = function addIntegerAttribute(name, technicalName, description, required) {
    this.integerAttributes.push(new IntegerAttributeDescriptor(name, technicalName, description, required));
    return this;
  }
  /**
   * Adds a decimal attribute descriptor to the schema builder.
   * @param name
   * @param technicalName
   * @param description
   * @param required
   * @returns
   */;
  _proto.addDecimalAttribute = function addDecimalAttribute(name, technicalName, description, required) {
    this.decimalAttributes.push(new IntegerAttributeDescriptor(name, technicalName, description, required));
    return this;
  }
  /**
   * Adds a boolean attribute descriptor to the schema builder.
   * @param name
   * @param technicalName
   * @param description
   * @param required
   * @returns
   */;
  _proto.addBooleanAttribute = function addBooleanAttribute(name, technicalName, description, required) {
    this.booleanAttributes.push(new BooleanAttributeDescriptor(name, technicalName, description, required));
    return this;
  }
  /**
   * Adds a date attribute descriptor to the schema builder.
   * @param name
   * @param technicalName
   * @param description
   * @param required
   * @returns
   */;
  _proto.addDateAttribute = function addDateAttribute(name, technicalName, description, required) {
    this.dateAttributes.push(new DateAttributeDescriptor(name, technicalName, description, required));
    return this;
  }
  /**
   * Adds a datetime attribute descriptor to the schema builder.
   * @param name
   * @param technicalName
   * @param description
   * @param required
   * @returns
   */;
  _proto.addDateTimeAttribute = function addDateTimeAttribute(name, technicalName, description, required) {
    this.dateTimeAttributes.push(new DateTimeAttributeDescriptor(name, technicalName, description, required));
    return this;
  }
  /**
   * Adds a string enum attribute descriptor to the schema builder.
   * @param name
   * @param technicalName
   * @param description
   * @param required
   * @param enumeration
   * @returns
   */;
  _proto.addStringEnumAttribute = function addStringEnumAttribute(name, technicalName, description, required, enumeration) {
    this.stringEnumAttributes.push(new StringEnumAttributeDescriptor(name, technicalName, description, required, enumeration));
    return this;
  }
  /**
   * Adds an integer enum attribute descriptor to the schema builder.
   * @param name
   * @param technicalName
   * @param description
   * @param required
   * @param enumeration
   * @returns
   */;
  _proto.addIntegerEnumAttribute = function addIntegerEnumAttribute(name, technicalName, description, required, enumeration) {
    this.integerEnumAttributes.push(new IntegerEnumAttributeDescriptor(name, technicalName, description, required, enumeration));
    return this;
  }
  /**
   * Adds a decimal enum attribute descriptor to the schema builder.
   * @param name
   * @param technicalName
   * @param description
   * @param required
   * @param enumeration
   * @returns
   */;
  _proto.addDecimalEnumAttribute = function addDecimalEnumAttribute(name, technicalName, description, required, enumeration) {
    this.decimalEnumAttributes.push(new DecimalEnumAttributeDescriptor(name, technicalName, description, required, enumeration));
    return this;
  }
  /**
   * Creates a schema using the configured attributes.
   * @returns
   */;
  _proto.build =
  /*#__PURE__*/
  function () {
    var _build = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var bridge, req;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            bridge = new BloockBridge();
            req = BuildSchemaRequest.fromPartial({
              configData: this.configData,
              displayName: this.displayName,
              schemaType: this.schemaType,
              version: this.version,
              description: this.description,
              stringAttributes: this.stringAttributes.map(function (a) {
                return a.toProto();
              }),
              integerAttributes: this.integerAttributes.map(function (a) {
                return a.toProto();
              }),
              decimalAttributes: this.decimalAttributes.map(function (a) {
                return a.toProto();
              }),
              booleanAttributes: this.booleanAttributes.map(function (a) {
                return a.toProto();
              }),
              dateAttributes: this.dateAttributes.map(function (a) {
                return a.toProto();
              }),
              datetimeAttributes: this.dateTimeAttributes.map(function (a) {
                return a.toProto();
              }),
              stringEnumAttributes: this.stringEnumAttributes.map(function (a) {
                return a.toProto();
              }),
              integerEnumAttributes: this.integerEnumAttributes.map(function (a) {
                return a.toProto();
              }),
              decimalEnumAttributes: this.decimalEnumAttributes.map(function (a) {
                return a.toProto();
              })
            });
            return _context.abrupt("return", bridge.getIdentity().BuildSchema(req).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return Schema$1.fromProto(res.schema);
            }));
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function build() {
      return _build.apply(this, arguments);
    }
    return build;
  }();
  return SchemaBuilder;
}();

/**
 * Represents a receipt for a verification session.
 */
var VerificationReceipt$1 = /*#__PURE__*/function () {
  /**
   * Constructs a VerificationReceipt object with the specified parameters.
   * @param sessionID
   * @param verificationRequest
   */
  function VerificationReceipt$1(sessionID, verificationRequest) {
    this.sessionID = sessionID;
    this.verificationRequest = verificationRequest;
  }
  var _proto = VerificationReceipt$1.prototype;
  _proto.toProto = function toProto() {
    return VerificationReceipt.fromPartial({
      sessionId: this.sessionID,
      verificationRequest: this.verificationRequest
    });
  };
  VerificationReceipt$1.fromProto = function fromProto(r) {
    return new VerificationReceipt$1(r.sessionId, r.verificationRequest);
  };
  return VerificationReceipt$1;
}();

/**
 * Represents different publish intervals.
 */
var PublishIntervalParams;
(function (PublishIntervalParams) {
  /**
   * Represents a 5-minute publish interval.
   */
  PublishIntervalParams[PublishIntervalParams["Interval5"] = 0] = "Interval5";
  /**
   * Represents a 15-minute publish interval.
   */
  PublishIntervalParams[PublishIntervalParams["Interval15"] = 1] = "Interval15";
  /**
   * Represents a 60-minute publish interval.
   */
  PublishIntervalParams[PublishIntervalParams["Interval60"] = 2] = "Interval60";
})(PublishIntervalParams || (PublishIntervalParams = {}));
(function (PublishIntervalParams) {
  function toProto(type) {
    switch (type) {
      case PublishIntervalParams.Interval5:
        return PublishInterval.INTERVAL_5;
      case PublishIntervalParams.Interval15:
        return PublishInterval.INTERVAL_15;
      case PublishIntervalParams.Interval60:
        return PublishInterval.INTERVAL_60;
      default:
        return PublishInterval.INTERVAL_60;
    }
  }
  PublishIntervalParams.toProto = toProto;
  function fromProto(type) {
    switch (type) {
      case PublishInterval.INTERVAL_5:
        return PublishIntervalParams.Interval5;
      case PublishInterval.INTERVAL_15:
        return PublishIntervalParams.Interval15;
      case PublishInterval.INTERVAL_60:
        return PublishIntervalParams.Interval60;
      default:
        return PublishIntervalParams.Interval60;
    }
  }
  PublishIntervalParams.fromProto = fromProto;
})(PublishIntervalParams || (PublishIntervalParams = {}));

/**
 * Helps construct credentials by specifying various attributes.
 */
var CredentialCoreBuilder = /*#__PURE__*/function () {
  /**
   * Creates a new CredentialCoreBuilder instance with the specified parameters.
   * @param schemaId
   * @param issuerDid
   * @param holderDid
   * @param expiration
   * @param version
   * @param configData
   */
  function CredentialCoreBuilder(issuer, schemaId, holderDid, expiration, version, configData) {
    this.schemaId = schemaId;
    this.issuerDid = issuer.did.did;
    this.holderDid = holderDid;
    this.expiration = expiration;
    this.version = version;
    this.configData = configData;
    this.key = issuer.key.toProto();
    this.stringAttributes = [];
    this.integerAttributes = [];
    this.decimalAttributes = [];
    this.booleanAttributes = [];
    this.dateAttributes = [];
    this.dateTimeAttributes = [];
  }
  /**
   * Adds a string attribute to the CredentialCoreBuilder.
   * @param key
   * @param value
   * @returns
   */
  var _proto = CredentialCoreBuilder.prototype;
  _proto.withStringAttribute = function withStringAttribute(key, value) {
    this.stringAttributes.push(new StringAttribute$1(key, value));
    return this;
  }
  /**
   * Adds an integer attribute to the CredentialCoreBuilder.
   * @param key
   * @param value
   * @returns
   */;
  _proto.withIntegerAttribute = function withIntegerAttribute(key, value) {
    this.integerAttributes.push(new IntegerAttribute$1(key, value));
    return this;
  }
  /**
   * Adds a decimal attribute to the CredentialCoreBuilder.
   * @param key
   * @param value
   * @returns
   */;
  _proto.withDecimalAttribute = function withDecimalAttribute(key, value) {
    this.decimalAttributes.push(new DecimalAttribute$1(key, value));
    return this;
  }
  /**
   * Adds a boolean attribute to the CredentialCoreBuilder.
   * @param key
   * @param value
   * @returns
   */;
  _proto.withBooleanAttribute = function withBooleanAttribute(key, value) {
    this.booleanAttributes.push(new BooleanAttribute$1(key, value));
    return this;
  }
  /**
   * Adds a date attribute to the CredentialCoreBuilder.
   * @param key
   * @param value
   * @returns
   */;
  _proto.withDateAttribute = function withDateAttribute(key, value) {
    this.dateAttributes.push(new DateAttribute$1(key, value).toProto());
    return this;
  }
  /**
   * Adds a datetime attribute to the CredentialCoreBuilder.
   * @param key
   * @param value
   * @returns
   */;
  _proto.withDateTimeAttribute = function withDateTimeAttribute(key, value) {
    this.dateTimeAttributes.push(new DateTimeAttribute$1(key, value).toProto());
    return this;
  }
  /**
   * Creates and returns a Credential using the specified attributes.
   * @returns
   */;
  _proto.build =
  /*#__PURE__*/
  function () {
    var _build = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var bridge, req;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            bridge = new BloockBridge();
            req = CreateCoreCredentialRequest.fromPartial({
              configData: this.configData,
              schemaId: this.schemaId,
              issuerDid: this.issuerDid,
              holderDid: this.holderDid,
              expiration: this.expiration,
              version: this.version,
              key: this.key,
              stringAttributes: this.stringAttributes,
              integerAttributes: this.integerAttributes,
              decimalAttributes: this.decimalAttributes,
              booleanAttributes: this.booleanAttributes,
              dateAttributes: this.dateAttributes,
              datetimeAttributes: this.dateTimeAttributes
            });
            return _context.abrupt("return", bridge.getIdentityCore().CreateCoreCredential(req).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return CredentialReceipt$1.fromProto(res.credentialReceipt);
            }));
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function build() {
      return _build.apply(this, arguments);
    }
    return build;
  }();
  return CredentialCoreBuilder;
}();

/**
 * Represents parameters used for generating DIDs.
 */
var Did =
/**
 * Constructs a Did object with the specified parameters.
 * @param did
 * @param didType
 */
function Did(did, didMethod) {
  this.did = did;
  this.didMethod = didMethod;
};

/**
 * represents a Holder identity.
 */
var Holder =
/**
 * Constructs a Holder object with the specified parameters.
 * @param did
 * @param didMethod
 */
function Holder(did, key, didMethod) {
  this.did = new Did(did, didMethod);
  this.key = key;
};

/**
 * represents a Issuer identity.
 */
var Issuer =
/**
 * Constructs a Issuer object with the specified parameters.
 * @param did
 * @param didMethod
 */
function Issuer(did, key, didMethod) {
  this.did = new Did(did, didMethod);
  this.key = key;
};

/**
 * Represents a client for interacting with the [Bloock Identity service](https://dashboard.bloock.com/login).
 */
var IdentityClient = /*#__PURE__*/function () {
  /**
   * Creates a new instance of the IdentityClient with default configuration.
   * @param configData
   */
  function IdentityClient(configData) {
    this.bridge = new BloockBridge();
    this.configData = NewConfigData(configData);
  }
  /**
   * Creates a new holder identity.
   * @param holderKey
   * @param didMethod
   * @returns
   */
  var _proto = IdentityClient.prototype;
  _proto.createHolder = function createHolder(holderKey, didMethod) {
    var request = CreateHolderRequest.fromPartial({
      key: holderKey.toProto(),
      didMethod: DidMethod$1.toProto(didMethod),
      configData: this.configData
    });
    return this.bridge.getIdentity().CreateHolder(request).then(function (res) {
      if (res.error) {
        throw res.error;
      }
      return new Holder(res.did, holderKey, didMethod);
    });
  }
  /**
   * Creates a new issuer on the Bloock Identity service.
   * @param issuerKey
   * @param publishInterval
   * @param didMethod
   * @param name
   * @param description
   * @param image
   * @returns
   */;
  _proto.createIssuer = function createIssuer(issuerKey, publishInterval, didMethod, name, description, image) {
    var request = CreateIssuerRequest.fromPartial({
      key: issuerKey.toProto(),
      didMethod: DidMethod$1.toProto(didMethod),
      name: name,
      description: description,
      image: image,
      publishInterval: PublishIntervalParams.toProto(publishInterval),
      configData: this.configData
    });
    return this.bridge.getIdentity().CreateIssuer(request).then(function (res) {
      if (res.error) {
        throw res.error;
      }
      return new Issuer(res.did, issuerKey, didMethod);
    });
  }
  /**
   * Gets the issuer based on the issuer key and DID method.
   * @param issuerKey
   * @param didMethod
   * @returns
   */;
  _proto.importIssuer = function importIssuer(issuerKey, didMethod) {
    var request = ImportIssuerRequest.fromPartial({
      key: issuerKey.toProto(),
      didMethod: DidMethod$1.toProto(didMethod),
      configData: this.configData
    });
    return this.bridge.getIdentity().ImportIssuer(request).then(function (res) {
      if (res.error) {
        throw res.error;
      }
      return new Issuer(res.did, issuerKey, didMethod);
    });
  }
  /**
   * Creates a new schema builder for defining a schema on the Bloock Identity service.
   * @param displayName
   * @param schemaType
   * @param version
   * @param description
   * @returns
   */;
  _proto.buildSchema = function buildSchema(displayName, schemaType, version, description) {
    return new SchemaBuilder(displayName, schemaType, version, description, this.configData);
  }
  /**
   * Gets a schema from the Bloock Identity service based on the schema ID (ex: Qma1t4uzbnB93E4rasNdu5UWMDh5qg3wMkPm68cnEyfnoM).
   * @param id
   * @returns
   */;
  _proto.getSchema = function getSchema(id) {
    var request = GetSchemaRequest.fromPartial({
      configData: this.configData,
      id: id
    });
    return this.bridge.getIdentity().GetSchema(request).then(function (res) {
      if (res.error) {
        throw res.error;
      }
      return Schema$1.fromProto(res.schema);
    });
  }
  /**
   * Creates a new credential builder for defining a credential on the Bloock Identity service.
   * @param issuer
   * @param schemaId
   * @param holderDid
   * @param expiration
   * @param version
   * @returns
   */;
  _proto.buildCredential = function buildCredential(issuer, schemaId, holderDid, expiration, version) {
    return new CredentialBuilder(issuer, schemaId, holderDid, expiration, version, this.configData);
  }
  /**
   * Retrieves the Verifiable Credential entity based on the credential ID (UUID). (ex: 1bf0c79e-55e6-4f14-aa9d-fb55619ba0cf)
   * @param credentialId
   * @returns
   */;
  _proto.getCredential = function getCredential(credentialId) {
    var request = GetCredentialRequest.fromPartial({
      configData: this.configData,
      credentialId: credentialId
    });
    return this.bridge.getIdentity().GetCredential(request).then(function (res) {
      if (res.error) {
        throw res.error;
      }
      return Credential$1.fromProto(res.credential);
    });
  }
  /**
   * Retrieves the json raw offer based on the credential ID (UUID). (ex: 1bf0c79e-55e6-4f14-aa9d-fb55619ba0cf)
   * @param issuer
   * @param credentialId
   * @returns
   */;
  _proto.getCredentialOffer = function getCredentialOffer(issuer, credentialId) {
    var request = GetCredentialOfferRequest.fromPartial({
      configData: this.configData,
      credentialId: credentialId,
      key: issuer.key.toProto()
    });
    return this.bridge.getIdentity().GetCredentialOffer(request).then(function (res) {
      if (res.error) {
        throw res.error;
      }
      return res.credentialOffer;
    });
  }
  /**
   * Publishes the state of an issuer on the Bloock Identity service.
   * @param issuerDid
   * @param signer
   * @returns
   */;
  _proto.forcePublishIssuerState = function forcePublishIssuerState(issuer) {
    var req = ForcePublishIssuerStateRequest.fromPartial({
      configData: this.configData,
      issuerDid: issuer.did.did,
      key: issuer.key.toProto()
    });
    return this.bridge.getIdentity().ForcePublishIssuerState(req).then(function (res) {
      if (res.error) {
        throw res.error;
      }
      return IssuerStateReceipt$1.fromProto(res.stateReceipt);
    });
  }
  /**
   * Gets the proof of a credential on the Bloock Identity service.
   * @param issuerDid
   * @param credentialId
   * @returns
   */;
  _proto.getCredentialProof = function getCredentialProof(issuerDid, credentialId) {
    var request = GetCredentialProofRequest.fromPartial({
      issuerDid: issuerDid,
      credentialId: credentialId,
      configData: this.configData
    });
    return this.bridge.getIdentity().GetCredentialProof(request).then(function (res) {
      if (res.error) {
        throw res.error;
      }
      return CredentialProof$1.fromProto(res.proof);
    });
  }
  /**
   * Revokes a credential on the Bloock Identity service.
   * @param credential
   * @param signer
   * @returns
   */;
  _proto.revokeCredential = function revokeCredential(credential, issuer) {
    var request = RevokeCredentialRequest.fromPartial({
      configData: this.configData,
      credential: credential.toProto(),
      key: issuer.key.toProto()
    });
    return this.bridge.getIdentity().RevokeCredential(request).then(function (res) {
      if (res.error) {
        throw res.error;
      }
      return res.result.success;
    });
  }
  /**
   * Creates a new verification session on the identity managed API provided.
   * @param proofRequest
   * @returns
   */;
  _proto.createVerification = function createVerification(proofRequest) {
    var request = CreateVerificationRequest.fromPartial({
      configData: this.configData,
      proofRequest: proofRequest
    });
    return this.bridge.getIdentity().CreateVerification(request).then(function (res) {
      if (res.error) {
        throw res.error;
      }
      return VerificationReceipt$1.fromProto(res.result);
    });
  }
  /**
   * Waits for the completion of a verification session on the identity managed API provided.
   * @param sessionID
   * @param timeout
   * @returns
   */;
  _proto.waitVerification = function waitVerification(sessionID, timeout) {
    var request = WaitVerificationRequest.fromPartial({
      configData: this.configData,
      sessionId: sessionID,
      timeout: timeout !== null ? timeout : 120000
    });
    return this.bridge.getIdentity().WaitVerification(request).then(function (res) {
      if (res.error) {
        throw res.error;
      }
      return res.status;
    });
  }
  /**
   * Gets the status of a verification session on the identity managed API provided.
   * @param sessionID
   * @returns
   */;
  _proto.getVerificationStatus = function getVerificationStatus(sessionID) {
    var request = GetVerificationStatusRequest.fromPartial({
      configData: this.configData,
      sessionId: sessionID
    });
    return this.bridge.getIdentity().GetVerificationStatus(request).then(function (res) {
      if (res.error) {
        throw res.error;
      }
      return res.status;
    });
  };
  return IdentityClient;
}();

/**
 * Represents a client for interacting with the [Bloock Identity service](https://dashboard.bloock.com/login).
 */
var IdentityCoreClient = /*#__PURE__*/function () {
  /**
   * Creates a new instance of the IdentityCoreClient with default configuration.
   * @param configData
   */
  function IdentityCoreClient(configData) {
    this.configData = NewConfigData(configData);
  }
  /**
   * Creates a new credential builder for defining a credential on the Bloock Identity service.
   * @param issuer
   * @param schemaId
   * @param holderDid
   * @param expiration
   * @param version
   * @returns
   */
  var _proto = IdentityCoreClient.prototype;
  _proto.buildCredential = function buildCredential(issuer, schemaId, holderDid, expiration, version) {
    return new CredentialCoreBuilder(issuer, schemaId, holderDid, expiration, version, this.configData);
  };
  return IdentityCoreClient;
}();

/**
 * Represents information about an anchor network.
 */
var AnchorNetwork$1 = /*#__PURE__*/function () {
  /**
   * Constructs an AnchorNetwork object with the specified parameters.
   * @param name
   * @param state
   * @param txHash
   * @param root
   */
  function AnchorNetwork$1(name, state, txHash, root) {
    this.name = name;
    this.state = state;
    this.txHash = txHash;
    this.root = root;
  }
  AnchorNetwork$1.fromProto = function fromProto(a) {
    return new AnchorNetwork$1(a.name, a.state, a.txHash, a.root);
  };
  var _proto = AnchorNetwork$1.prototype;
  _proto.toProto = function toProto() {
    return AnchorNetwork.fromPartial({
      name: this.name,
      state: this.state,
      txHash: this.txHash,
      root: this.root
    });
  };
  return AnchorNetwork$1;
}();

/**
 * Represents information about an anchor.
 */
var Anchor$1 = /*#__PURE__*/function () {
  /**
   * Constructs an Anchor object with the specified parameters.
   * @param id
   * @param blockRoots
   * @param networks
   * @param root
   * @param status
   */
  function Anchor(id, blockRoots, networks, root, status) {
    this.id = id;
    this.blockRoots = blockRoots;
    this.networks = networks;
    this.root = root;
    this.status = status;
  }
  Anchor.fromProto = function fromProto(a) {
    return new Anchor(a.id, a.blockRoots, a.networks.map(function (n) {
      return AnchorNetwork$1.fromProto(n);
    }), a.root, a.status);
  };
  return Anchor;
}();

/**
 * Represents a network.
 */
var Network$1;
(function (Network) {
  Network[Network["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
  Network[Network["ETHEREUM_MAINNET"] = 0] = "ETHEREUM_MAINNET";
  Network[Network["ETHEREUM_SEPOLIA"] = 1] = "ETHEREUM_SEPOLIA";
  Network[Network["GNOSIS_CHAIN"] = 2] = "GNOSIS_CHAIN";
  Network[Network["POLYGON_CHAIN"] = 3] = "POLYGON_CHAIN";
})(Network$1 || (Network$1 = {}));
(function (Network$1) {
  function toProto(network) {
    switch (network) {
      case Network$1.ETHEREUM_MAINNET:
        return Network.ETHEREUM_MAINNET;
      case Network$1.ETHEREUM_SEPOLIA:
        return Network.ETHEREUM_SEPOLIA;
      case Network$1.GNOSIS_CHAIN:
        return Network.GNOSIS_CHAIN;
      case Network$1.POLYGON_CHAIN:
        return Network.POLYGON_CHAIN;
      default:
        return Network.UNRECOGNIZED;
    }
  }
  Network$1.toProto = toProto;
  function fromProto(network) {
    switch (network) {
      case Network.ETHEREUM_MAINNET:
        return Network$1.ETHEREUM_MAINNET;
      case Network.ETHEREUM_SEPOLIA:
        return Network$1.ETHEREUM_SEPOLIA;
      case Network.GNOSIS_CHAIN:
        return Network$1.GNOSIS_CHAIN;
      case Network.POLYGON_CHAIN:
        return Network$1.POLYGON_CHAIN;
      default:
        return Network$1.UNRECOGNIZED;
    }
  }
  Network$1.fromProto = fromProto;
})(Network$1 || (Network$1 = {}));

/**
 * Represents a proof anchor.
 */
var ProofAnchor$1 = /*#__PURE__*/function () {
  /**
   * Constructs a ProofAnchor object with the specified parameters.
   * @param anchorID
   * @param networks
   * @param root
   * @param status
   */
  function ProofAnchor$1(anchorID, networks, root, status) {
    this.anchorID = anchorID;
    this.networks = networks;
    this.root = root;
    this.status = status;
  }
  ProofAnchor$1.fromProto = function fromProto(p) {
    return new ProofAnchor$1(p.anchorId, p.networks.map(function (x) {
      return AnchorNetwork$1.fromProto(x);
    }), p.root, p.status);
  };
  var _proto = ProofAnchor$1.prototype;
  _proto.toProto = function toProto() {
    return ProofAnchor.fromPartial({
      anchorId: this.anchorID,
      networks: this.networks.map(function (n) {
        return n.toProto();
      }),
      root: this.root,
      status: this.status
    });
  };
  return ProofAnchor$1;
}();

/**
 * Represents a proof, including leaves, nodes, depth, bitmap, and anchor information.
 */
var Proof$1 = /*#__PURE__*/function () {
  /**
   * Constructs a Proof object with the specified parameters.
   * @param leaves
   * @param nodes
   * @param depth
   * @param bitmap
   * @param anchor
   */
  function Proof$1(leaves, nodes, depth, bitmap, anchor) {
    this.leaves = leaves;
    this.nodes = nodes;
    this.depth = depth;
    this.bitmap = bitmap;
    this.anchor = anchor;
  }
  Proof$1.fromProto = function fromProto(p) {
    return new Proof$1(p.leaves, p.nodes, p.depth, p.bitmap, ProofAnchor$1.fromProto(p.anchor));
  };
  var _proto = Proof$1.prototype;
  _proto.toProto = function toProto() {
    return Proof.fromPartial({
      leaves: this.leaves,
      nodes: this.nodes,
      depth: this.depth,
      bitmap: this.bitmap,
      anchor: this.anchor.toProto()
    });
  };
  return Proof$1;
}();

/**
 * Represents a receipt for a record, including anchor ID, client, record, and status information.
 */
var RecordReceipt$1 = /*#__PURE__*/function () {
  /**
   * Constructs a RecordReceipt object with the specified parameters.
   * @param anchor
   * @param client
   * @param record
   * @param status
   */
  function RecordReceipt$1(anchor, client, record, status) {
    this.anchor = anchor;
    this.client = client;
    this.record = record;
    this.status = status;
  }
  RecordReceipt$1.fromProto = function fromProto(r) {
    return new RecordReceipt$1(r.anchor, r.client, r.record, r.status);
  };
  var _proto = RecordReceipt$1.prototype;
  _proto.toProto = function toProto() {
    return RecordReceipt.fromPartial({
      anchor: this.anchor,
      client: this.client,
      record: this.record,
      status: this.status
    });
  };
  return RecordReceipt$1;
}();

/**
 * Provides functionality to interact with the [Bloock Integrity service](https://dashboard.bloock.com/login).
 */
var IntegrityClient = /*#__PURE__*/function () {
  /**
   * Creates a new IntegrityClient with default configuration.
   * @param configData
   */
  function IntegrityClient(configData) {
    this.bridge = new BloockBridge();
    this.configData = NewConfigData(configData);
  }
  /**
   * Sends records to the Bloock Integrity service for certification.
   * @param records
   * @returns
   */
  var _proto = IntegrityClient.prototype;
  _proto.sendRecords =
  /*#__PURE__*/
  function () {
    var _sendRecords = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(records) {
      var request;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            request = SendRecordsRequest.fromPartial({
              configData: this.configData,
              records: records.map(function (x) {
                return x.toProto();
              })
            });
            return _context.abrupt("return", this.bridge.getIntegrity().SendRecords(request).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return res.records.map(function (r) {
                return RecordReceipt$1.fromProto(r);
              });
            }));
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function sendRecords(_x) {
      return _sendRecords.apply(this, arguments);
    }
    return sendRecords;
  }()
  /**
   * Gets an anchor by its ID from the Bloock Integrity service.
   * @param anchorId
   * @returns
   */
  ;
  _proto.getAnchor =
  /*#__PURE__*/
  function () {
    var _getAnchor = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(anchorId) {
      var request;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            request = GetAnchorRequest.fromPartial({
              configData: this.configData,
              anchorId: anchorId
            });
            return _context2.abrupt("return", this.bridge.getIntegrity().GetAnchor(request).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return Anchor$1.fromProto(res.anchor);
            }));
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function getAnchor(_x2) {
      return _getAnchor.apply(this, arguments);
    }
    return getAnchor;
  }()
  /**
   * Waits for the completion of an anchor on the Bloock Integrity service.
   * @param anchorId
   * @param timeout
   * @returns
   */
  ;
  _proto.waitAnchor =
  /*#__PURE__*/
  function () {
    var _waitAnchor = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(anchorId, timeout) {
      var request;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            request = WaitAnchorRequest.fromPartial({
              configData: this.configData,
              anchorId: anchorId,
              timeout: timeout !== null ? timeout : 120000
            });
            return _context3.abrupt("return", this.bridge.getIntegrity().WaitAnchor(request).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return Anchor$1.fromProto(res.anchor);
            }));
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3, this);
    }));
    function waitAnchor(_x3, _x4) {
      return _waitAnchor.apply(this, arguments);
    }
    return waitAnchor;
  }()
  /**
   * Gets a proof for a set of records from the Bloock Integrity service.
   * @param records
   * @returns
   */
  ;
  _proto.getProof =
  /*#__PURE__*/
  function () {
    var _getProof = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(records) {
      var request;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            request = GetProofRequest.fromPartial({
              configData: this.configData,
              records: records.map(function (x) {
                return x.toProto();
              })
            });
            return _context4.abrupt("return", this.bridge.getIntegrity().GetProof(request).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return Proof$1.fromProto(res.proof);
            }));
          case 2:
          case "end":
            return _context4.stop();
        }
      }, _callee4, this);
    }));
    function getProof(_x5) {
      return _getProof.apply(this, arguments);
    }
    return getProof;
  }()
  /**
   * Validates the integrity of a merkle root proof on blockchain.
   * @param root
   * @param network
   * @returns
   */
  ;
  _proto.validateRoot =
  /*#__PURE__*/
  function () {
    var _validateRoot = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(root, network) {
      var request;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            request = ValidateRootRequest.fromPartial({
              configData: this.configData,
              root: root,
              network: network
            });
            return _context5.abrupt("return", this.bridge.getIntegrity().ValidateRoot(request).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return res.timestamp;
            }));
          case 2:
          case "end":
            return _context5.stop();
        }
      }, _callee5, this);
    }));
    function validateRoot(_x6, _x7) {
      return _validateRoot.apply(this, arguments);
    }
    return validateRoot;
  }()
  /**
   * Verifies the integrity of a proof.
   * @param proof
   * @returns
   */
  ;
  _proto.verifyProof =
  /*#__PURE__*/
  function () {
    var _verifyProof = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(proof) {
      var request;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            request = VerifyProofRequest.fromPartial({
              configData: this.configData,
              proof: proof.toProto()
            });
            return _context6.abrupt("return", this.bridge.getIntegrity().VerifyProof(request).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return res.record;
            }));
          case 2:
          case "end":
            return _context6.stop();
        }
      }, _callee6, this);
    }));
    function verifyProof(_x8) {
      return _verifyProof.apply(this, arguments);
    }
    return verifyProof;
  }()
  /**
   * Verifies the integrity of a set of records.
   * @param records
   * @param network
   * @returns
   */
  ;
  _proto.verifyRecords =
  /*#__PURE__*/
  function () {
    var _verifyRecords = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(records, network) {
      var request;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            request = VerifyRecordsRequest.fromPartial({
              configData: this.configData,
              records: records.map(function (x) {
                return x.toProto();
              }),
              network: network
            });
            return _context7.abrupt("return", this.bridge.getIntegrity().VerifyRecords(request).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return res.timestamp;
            }));
          case 2:
          case "end":
            return _context7.stop();
        }
      }, _callee7, this);
    }));
    function verifyRecords(_x9, _x10) {
      return _verifyRecords.apply(this, arguments);
    }
    return verifyRecords;
  }();
  return IntegrityClient;
}();

/**
 * Provides functionality to interact with the [Bloock Keys service](https://dashboard.bloock.com/login).
 */
var KeyClient = /*#__PURE__*/function () {
  /**
   * Creates a new KeyClient with default configuration.
   * @param configData
   */
  function KeyClient(configData) {
    this.bridge = new BloockBridge();
    this.configData = NewConfigData(configData);
  }
  /**
   * Generates a new local key of the specified type.
   * @param keyType
   * @returns
   */
  var _proto = KeyClient.prototype;
  _proto.newLocalKey =
  /*#__PURE__*/
  function () {
    var _newLocalKey = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(keyType) {
      var request;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            request = GenerateLocalKeyRequest.fromPartial({
              configData: this.configData,
              keyType: KeyType$1.toProto(keyType)
            });
            return _context.abrupt("return", this.bridge.getKey().GenerateLocalKey(request).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return LocalKey$1.fromProto(res.localKey);
            }));
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function newLocalKey(_x) {
      return _newLocalKey.apply(this, arguments);
    }
    return newLocalKey;
  }()
  /**
   * Loads a local key of the specified type from a public key string.
   * @param keyType
   * @param key
   * @returns
   */
  ;
  _proto.loadLocalKey =
  /*#__PURE__*/
  function () {
    var _loadLocalKey = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(keyType, key) {
      var request;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            request = LoadLocalKeyRequest.fromPartial({
              configData: this.configData,
              keyType: KeyType$1.toProto(keyType),
              key: key
            });
            return _context2.abrupt("return", this.bridge.getKey().LoadLocalKey(request).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return LocalKey$1.fromProto(res.localKey);
            }));
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function loadLocalKey(_x2, _x3) {
      return _loadLocalKey.apply(this, arguments);
    }
    return loadLocalKey;
  }()
  /**
   * Generates a new managed key with the specified parameters.
   * @param params
   * @returns
   */
  ;
  _proto.newManagedKey =
  /*#__PURE__*/
  function () {
    var _newManagedKey = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(params) {
      var request;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            request = GenerateManagedKeyRequest.fromPartial({
              configData: this.configData,
              params: params.toProto()
            });
            return _context3.abrupt("return", this.bridge.getKey().GenerateManagedKey(request).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return ManagedKey$1.fromProto(res.managedKey);
            }));
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3, this);
    }));
    function newManagedKey(_x4) {
      return _newManagedKey.apply(this, arguments);
    }
    return newManagedKey;
  }()
  /**
   * Loads a managed key by its ID (ex: 51d22546-68f1-4340-b94b-2a80e60b8933).
   * @param id
   * @returns
   */
  ;
  _proto.loadManagedKey =
  /*#__PURE__*/
  function () {
    var _loadManagedKey = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(id) {
      var request;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            request = LoadManagedKeyRequest.fromPartial({
              configData: this.configData,
              id: id
            });
            return _context4.abrupt("return", this.bridge.getKey().LoadManagedKey(request).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return ManagedKey$1.fromProto(res.managedKey);
            }));
          case 2:
          case "end":
            return _context4.stop();
        }
      }, _callee4, this);
    }));
    function loadManagedKey(_x5) {
      return _loadManagedKey.apply(this, arguments);
    }
    return loadManagedKey;
  }()
  /**
   * Generates a new local certificate with the specified parameters.
   * @param params
   * @returns
   */
  ;
  _proto.newLocalCertificate =
  /*#__PURE__*/
  function () {
    var _newLocalCertificate = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(params) {
      var request;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            request = GenerateLocalCertificateRequest.fromPartial({
              configData: this.configData,
              params: params.toProto()
            });
            return _context5.abrupt("return", this.bridge.getKey().GenerateLocalCertificate(request).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return LocalCertificate$1.fromProto(res.localCertificate);
            }));
          case 2:
          case "end":
            return _context5.stop();
        }
      }, _callee5, this);
    }));
    function newLocalCertificate(_x6) {
      return _newLocalCertificate.apply(this, arguments);
    }
    return newLocalCertificate;
  }()
  /**
   * Loads a local certificate from a PKCS12 file.
   * @param pkcs12
   * @param password
   * @returns
   */
  ;
  _proto.loadLocalCertificate =
  /*#__PURE__*/
  function () {
    var _loadLocalCertificate = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(pkcs12, password) {
      var request;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            request = LoadLocalCertificateRequest.fromPartial({
              configData: this.configData,
              pkcs12: pkcs12,
              password: password
            });
            return _context6.abrupt("return", this.bridge.getKey().LoadLocalCertificate(request).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return LocalCertificate$1.fromProto(res.localCertificate);
            }));
          case 2:
          case "end":
            return _context6.stop();
        }
      }, _callee6, this);
    }));
    function loadLocalCertificate(_x7, _x8) {
      return _loadLocalCertificate.apply(this, arguments);
    }
    return loadLocalCertificate;
  }()
  /**
   * Generates a new managed certificate with the specified parameters.
   * @param params
   * @returns
   */
  ;
  _proto.newManagedCertificate =
  /*#__PURE__*/
  function () {
    var _newManagedCertificate = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(params) {
      var request;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            request = GenerateManagedCertificateRequest.fromPartial({
              configData: this.configData,
              params: params.toProto()
            });
            return _context7.abrupt("return", this.bridge.getKey().GenerateManagedCertificate(request).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return ManagedCertificate$1.fromProto(res.managedCertificate);
            }));
          case 2:
          case "end":
            return _context7.stop();
        }
      }, _callee7, this);
    }));
    function newManagedCertificate(_x9) {
      return _newManagedCertificate.apply(this, arguments);
    }
    return newManagedCertificate;
  }()
  /**
   * Loads a managed certificate by its ID (ex: ceef5b02-af17-43d8-ae7b-31d9bdf8027f).
   * @param id
   * @returns
   */
  ;
  _proto.loadManagedCertificate =
  /*#__PURE__*/
  function () {
    var _loadManagedCertificate = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(id) {
      var request;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            request = LoadManagedCertificateRequest.fromPartial({
              configData: this.configData,
              id: id
            });
            return _context8.abrupt("return", this.bridge.getKey().LoadManagedCertificate(request).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return ManagedCertificate$1.fromProto(res.managedCertificate);
            }));
          case 2:
          case "end":
            return _context8.stop();
        }
      }, _callee8, this);
    }));
    function loadManagedCertificate(_x10) {
      return _loadManagedCertificate.apply(this, arguments);
    }
    return loadManagedCertificate;
  }()
  /**
   * Imports a managed certificate with the specified parameters, supported types: .pem, .pfx.
   * @param type
   * @param certificate
   * @param params
   * @returns
   */
  ;
  _proto.importManagedCertificate =
  /*#__PURE__*/
  function () {
    var _importManagedCertificate = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(type, certificate, params) {
      var request;
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            request = ImportManagedCertificateRequest.fromPartial({
              configData: this.configData,
              certificate: certificate,
              certificateType: CertificateType$1.toProto(type),
              password: params.password
            });
            return _context9.abrupt("return", this.bridge.getKey().ImportManagedCertificate(request).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return ManagedCertificate$1.fromProto(res.managedCertificate);
            }));
          case 2:
          case "end":
            return _context9.stop();
        }
      }, _callee9, this);
    }));
    function importManagedCertificate(_x11, _x12, _x13) {
      return _importManagedCertificate.apply(this, arguments);
    }
    return importManagedCertificate;
  }()
  /**
   * Sets up TOTP-based access control for the given managed key or managed certificate.
   * @param key
   * @returns
   */
  ;
  _proto.setupTotpAccessControl =
  /*#__PURE__*/
  function () {
    var _setupTotpAccessControl = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(key) {
      var _key$managedKey, _key$managedCertifica;
      var request;
      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            request = SetupTotpAccessControlRequest.fromPartial({
              configData: this.configData,
              managedKey: (_key$managedKey = key.managedKey) == null ? void 0 : _key$managedKey.toProto(),
              managedCertificate: (_key$managedCertifica = key.managedCertificate) == null ? void 0 : _key$managedCertifica.toProto()
            });
            return _context10.abrupt("return", this.bridge.getKey().SetupTotpAccessControl(request).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return new TotpAccessControlReceipt(res.secret, res.secretQr, res.recoveryCodes);
            }));
          case 2:
          case "end":
            return _context10.stop();
        }
      }, _callee10, this);
    }));
    function setupTotpAccessControl(_x14) {
      return _setupTotpAccessControl.apply(this, arguments);
    }
    return setupTotpAccessControl;
  }()
  /**
   * Recovers TOTP-based access control for the given managed key or managed certificate using a recovery code.
   * @param key
   * @param code
   * @returns
   */
  ;
  _proto.recoverTotpAccessControl =
  /*#__PURE__*/
  function () {
    var _recoverTotpAccessControl = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(key, code) {
      var _key$managedKey2, _key$managedCertifica2;
      var request;
      return _regeneratorRuntime().wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            request = RecoverTotpAccessControlRequest.fromPartial({
              configData: this.configData,
              managedKey: (_key$managedKey2 = key.managedKey) == null ? void 0 : _key$managedKey2.toProto(),
              managedCertificate: (_key$managedCertifica2 = key.managedCertificate) == null ? void 0 : _key$managedCertifica2.toProto(),
              code: code
            });
            return _context11.abrupt("return", this.bridge.getKey().RecoverTotpAccessControl(request).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return new TotpAccessControlReceipt(res.secret, res.secretQr, res.recoveryCodes);
            }));
          case 2:
          case "end":
            return _context11.stop();
        }
      }, _callee11, this);
    }));
    function recoverTotpAccessControl(_x15, _x16) {
      return _recoverTotpAccessControl.apply(this, arguments);
    }
    return recoverTotpAccessControl;
  }()
  /**
   * Sets up secret-based access control for the given managed key or managed certificate.
   * @param key
   * @param secret
   * @param email
   * @returns
   */
  ;
  _proto.setupSecretAccessControl =
  /*#__PURE__*/
  function () {
    var _setupSecretAccessControl = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(key, secret, email) {
      var _key$managedKey3, _key$managedCertifica3;
      var request;
      return _regeneratorRuntime().wrap(function _callee12$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            request = SetupSecretAccessControlRequest.fromPartial({
              configData: this.configData,
              managedKey: (_key$managedKey3 = key.managedKey) == null ? void 0 : _key$managedKey3.toProto(),
              managedCertificate: (_key$managedCertifica3 = key.managedCertificate) == null ? void 0 : _key$managedCertifica3.toProto(),
              secret: secret,
              email: email
            });
            return _context12.abrupt("return", this.bridge.getKey().SetupSecretAccessControl(request).then(function (res) {
              if (res.error) {
                throw res.error;
              }
            }));
          case 2:
          case "end":
            return _context12.stop();
        }
      }, _callee12, this);
    }));
    function setupSecretAccessControl(_x17, _x18, _x19) {
      return _setupSecretAccessControl.apply(this, arguments);
    }
    return setupSecretAccessControl;
  }();
  return KeyClient;
}();

/**
 * Represents details related to the integrity of a record, including hash and proof.
 */
var IntegrityDetails$1 = /*#__PURE__*/function () {
  /**
   * Constructs a IntegrityDetails object with the specified parameters.
   * @param hash
   * @param proof
   */
  function IntegrityDetails$1(hash, proof) {
    this.hash = hash;
    this.proof = proof;
  }
  IntegrityDetails$1.fromProto = function fromProto(r) {
    return new IntegrityDetails$1(r.hash, r.proof ? Proof$1.fromProto(r.proof) : undefined);
  };
  var _proto = IntegrityDetails$1.prototype;
  _proto.toProto = function toProto() {
    var _this$proof;
    return IntegrityDetails.fromPartial({
      hash: this.hash,
      proof: (_this$proof = this.proof) == null ? void 0 : _this$proof.toProto()
    });
  };
  return IntegrityDetails$1;
}();
/**
 * Represents details related to the authenticity of a record, including signatures.
 */
var AuthenticityDetails$1 = /*#__PURE__*/function () {
  /**
   * Constructs a AuthenticityDetails object with the specified parameters.
   * @param signatures
   */
  function AuthenticityDetails$1(signatures) {
    this.signatures = signatures;
  }
  AuthenticityDetails$1.fromProto = function fromProto(r) {
    return new AuthenticityDetails$1(r.signatures.map(function (s) {
      return Signature$1.fromProto(s);
    }));
  };
  var _proto2 = AuthenticityDetails$1.prototype;
  _proto2.toProto = function toProto() {
    return AuthenticityDetails.fromPartial({
      signatures: this.signatures.map(function (s) {
        return s.toProto();
      })
    });
  };
  return AuthenticityDetails$1;
}();
/**
 * Represents details related to the encryption of a record, including algorithm, key, and subject.
 */
var EncryptionDetails$1 = /*#__PURE__*/function () {
  /**
   * Constructs a EncryptionDetails object with the specified parameters.
   * @param alg
   * @param key
   * @param subject
   */
  function EncryptionDetails$1(alg, key, subject) {
    this.alg = alg;
    this.key = key;
    this.subject = subject;
  }
  EncryptionDetails$1.fromProto = function fromProto(r) {
    return new EncryptionDetails$1(r.alg, r.key, r.subject);
  };
  var _proto3 = EncryptionDetails$1.prototype;
  _proto3.toProto = function toProto() {
    return EncryptionDetails.fromPartial({
      alg: this.alg,
      key: this.key,
      subject: this.subject
    });
  };
  return EncryptionDetails$1;
}();
/**
 * Represents details related to the availability of a record, including content type and size.
 */
var AvailabilityDetails$1 = /*#__PURE__*/function () {
  /**
   * Constructs a AvailabilityDetails object with the specified parameters.
   * @param size
   * @param contentType
   */
  function AvailabilityDetails$1(size, contentType) {
    this.size = size;
    this.contentType = contentType;
  }
  AvailabilityDetails$1.fromProto = function fromProto(r) {
    return new AvailabilityDetails$1(r.size, r.type);
  };
  var _proto4 = AvailabilityDetails$1.prototype;
  _proto4.toProto = function toProto() {
    return AvailabilityDetails.fromPartial({
      type: this.contentType,
      size: this.size
    });
  };
  return AvailabilityDetails$1;
}();
/**
 * Represents all details related to a record, including integrity, authenticity, encryption, and availability details.
 */
var RecordDetails$1 = /*#__PURE__*/function () {
  /**
   * Constructs a RecordDetails object with the specified parameters.
   * @param integrity
   * @param authenticity
   * @param encryption
   * @param availability
   */
  function RecordDetails$1(integrity, authenticity, encryption, availability) {
    this.integrity = integrity;
    this.authenticity = authenticity;
    this.encryption = encryption;
    this.availability = availability;
  }
  RecordDetails$1.fromProto = function fromProto(r) {
    return new RecordDetails$1(r.integrity ? IntegrityDetails$1.fromProto(r.integrity) : undefined, r.authenticity ? AuthenticityDetails$1.fromProto(r.authenticity) : undefined, r.encryption ? EncryptionDetails$1.fromProto(r.encryption) : undefined, r.availability ? AvailabilityDetails$1.fromProto(r.availability) : undefined);
  };
  var _proto5 = RecordDetails$1.prototype;
  _proto5.toProto = function toProto() {
    var _this$integrity, _this$authenticity, _this$encryption, _this$availability;
    return RecordDetails.fromPartial({
      integrity: (_this$integrity = this.integrity) == null ? void 0 : _this$integrity.toProto(),
      authenticity: (_this$authenticity = this.authenticity) == null ? void 0 : _this$authenticity.toProto(),
      encryption: (_this$encryption = this.encryption) == null ? void 0 : _this$encryption.toProto(),
      availability: (_this$availability = this.availability) == null ? void 0 : _this$availability.toProto()
    });
  };
  return RecordDetails$1;
}();

/**
 * Provides functionality for creating records using various data sources and to interact with the [Bloock Record service](https://dashboard.bloock.com/login).
 */
var RecordClient = /*#__PURE__*/function () {
  /**
   * Creates a new RecordClient with default configuration.
   * @param configData
   */
  function RecordClient(configData) {
    this.configData = NewConfigData(configData);
  }
  /**
   * Creates a RecordBuilder from a string payload.
   * @param str
   * @returns
   */
  var _proto = RecordClient.prototype;
  _proto.fromString = function fromString(str) {
    return new RecordBuilder(str, RecordTypes.STRING, this.configData);
  }
  /**
   * Creates a RecordBuilder from a JSON string payload.
   * @param json
   * @returns
   */;
  _proto.fromJson = function fromJson(json) {
    return new RecordBuilder(JSON.stringify(json), RecordTypes.JSON, this.configData);
  }
  /**
   * Creates a RecordBuilder from a hexadecimal string payload.
   * @param hex
   * @returns
   */;
  _proto.fromHex = function fromHex(hex) {
    return new RecordBuilder(hex, RecordTypes.HEX, this.configData);
  }
  /**
   * Creates a RecordBuilder from a byte slice payload.
   * @param bytes
   * @returns
   */;
  _proto.fromBytes = function fromBytes(bytes) {
    return new RecordBuilder(bytes, RecordTypes.BYTES, this.configData);
  }
  /**
   * Creates a RecordBuilder from a byte slice representing a file.
   * @param bytes
   * @returns
   */;
  _proto.fromFile = function fromFile(bytes) {
    return new RecordBuilder(bytes, RecordTypes.FILE, this.configData);
  }
  /**
   * Creates a RecordBuilder from an existing record.
   * @param bytes
   * @returns
   */;
  _proto.fromRecord = function fromRecord(bytes) {
    return new RecordBuilder(bytes, RecordTypes.RECORD, this.configData);
  }
  /**
   * Creates a RecordBuilder from a data loader.
   * @param loader
   * @returns
   */;
  _proto.fromLoader = function fromLoader(loader) {
    return new RecordBuilder(loader, RecordTypes.LOADER, this.configData);
  };
  return RecordClient;
}();
/**
 * Assists in constructing records with various configurations.
 */
var RecordBuilder = /*#__PURE__*/function () {
  /**
   * Creates a new RecordBuilder with default configuration.
   * @param payload
   * @param payloadType
   * @param configData
   */
  function RecordBuilder(payload, payloadType, configData) {
    this.payload = payload;
    this.payloadType = payloadType;
    this.configData = configData;
  }
  /**
   * Sets the signer for the RecordBuilder.
   * @param signer
   * @returns
   */
  var _proto2 = RecordBuilder.prototype;
  _proto2.withSigner = function withSigner(signer) {
    this.signer = signer.toProto();
    return this;
  }
  /**
   * Sets the encrypter for the RecordBuilder.
   * @param encrypter
   * @returns
   */;
  _proto2.withEncrypter = function withEncrypter(encrypter) {
    this.encrypter = encrypter.toProto();
    return this;
  }
  /**
   * Sets the decrypter for the RecordBuilder.
   * @param decrypter
   * @returns
   */;
  _proto2.withDecrypter = function withDecrypter(decrypter) {
    this.decrypter = decrypter.toProto();
    return this;
  }
  /**
   * Constructs a record based on the RecordBuilder's configuration.
   * @returns
   */;
  _proto2.build =
  /*#__PURE__*/
  function () {
    var _build = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _this = this;
      var bridge, req, _req, _req2, _req3, _req4, _req5, _req6;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            bridge = new BloockBridge();
            _context.t0 = this.payloadType;
            _context.next = _context.t0 === RecordTypes.STRING ? 4 : _context.t0 === RecordTypes.JSON ? 6 : _context.t0 === RecordTypes.HEX ? 8 : _context.t0 === RecordTypes.BYTES ? 10 : _context.t0 === RecordTypes.FILE ? 12 : _context.t0 === RecordTypes.RECORD ? 14 : _context.t0 === RecordTypes.LOADER ? 16 : 18;
            break;
          case 4:
            req = RecordBuilderFromStringRequest.fromPartial({
              configData: this.configData,
              payload: this.payload,
              signer: this.signer,
              encrypter: this.encrypter,
              decrypter: this.decrypter
            });
            return _context.abrupt("return", bridge.getRecord().BuildRecordFromString(req).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return Record$1.fromProto(res.record, _this.configData);
            }));
          case 6:
            _req = RecordBuilderFromJSONRequest.fromPartial({
              configData: this.configData,
              payload: this.payload,
              signer: this.signer,
              encrypter: this.encrypter,
              decrypter: this.decrypter
            });
            return _context.abrupt("return", bridge.getRecord().BuildRecordFromJson(_req).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return Record$1.fromProto(res.record, _this.configData);
            }));
          case 8:
            _req2 = RecordBuilderFromHexRequest.fromPartial({
              configData: this.configData,
              payload: this.payload,
              signer: this.signer,
              encrypter: this.encrypter,
              decrypter: this.decrypter
            });
            return _context.abrupt("return", bridge.getRecord().BuildRecordFromHex(_req2).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return Record$1.fromProto(res.record, _this.configData);
            }));
          case 10:
            _req3 = RecordBuilderFromBytesRequest.fromPartial({
              configData: this.configData,
              payload: this.payload,
              signer: this.signer,
              encrypter: this.encrypter,
              decrypter: this.decrypter
            });
            return _context.abrupt("return", bridge.getRecord().BuildRecordFromBytes(_req3).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return Record$1.fromProto(res.record, _this.configData);
            }));
          case 12:
            _req4 = RecordBuilderFromFileRequest.fromPartial({
              configData: this.configData,
              payload: this.payload,
              signer: this.signer,
              encrypter: this.encrypter,
              decrypter: this.decrypter
            });
            return _context.abrupt("return", bridge.getRecord().BuildRecordFromFile(_req4).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return Record$1.fromProto(res.record, _this.configData);
            }));
          case 14:
            _req5 = RecordBuilderFromRecordRequest.fromPartial({
              configData: this.configData,
              payload: this.payload,
              signer: this.signer,
              encrypter: this.encrypter,
              decrypter: this.decrypter
            });
            return _context.abrupt("return", bridge.getRecord().BuildRecordFromRecord(_req5).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return Record$1.fromProto(res.record, _this.configData);
            }));
          case 16:
            _req6 = RecordBuilderFromLoaderRequest.fromPartial({
              configData: this.configData,
              loader: this.payload,
              signer: this.signer,
              encrypter: this.encrypter,
              decrypter: this.decrypter
            });
            return _context.abrupt("return", bridge.getRecord().BuildRecordFromLoader(_req6).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return Record$1.fromProto(res.record, _this.configData);
            }));
          case 18:
            return _context.abrupt("return", Promise.reject(new Error("Unexpected record type")));
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function build() {
      return _build.apply(this, arguments);
    }
    return build;
  }()
  /**
   * Gets details about other Bloock services (Integrity, Authenticity, Encryption, Availability) configured in the RecordBuilder.
   * @returns
   */
  ;
  _proto2.getDetails =
  /*#__PURE__*/
  function () {
    var _getDetails = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var bridge, req;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            bridge = new BloockBridge();
            req = GetDetailsRequest.fromPartial({
              configData: this.configData,
              payload: this.payload
            });
            return _context2.abrupt("return", bridge.getRecord().GetDetails(req).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return RecordDetails$1.fromProto(res.details);
            }));
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function getDetails() {
      return _getDetails.apply(this, arguments);
    }
    return getDetails;
  }();
  return RecordBuilder;
}();

/**
 * Provides functionality for interacting with [Bloock Webhook service](https://dashboard.bloock.com/login).
 */
var WebhookClient = /*#__PURE__*/function () {
  /**
   * Creates a new WebhookClient with default configuration.
   * @param configData
   */
  function WebhookClient(configData) {
    this.bridge = new BloockBridge();
    this.configData = NewConfigData(configData);
  }
  /**
   * Verifies the signature of a webhook payload using the provided parameters.
   * @param payload
   * @param header
   * @param secretKey
   * @param enforceTolerance
   * @returns
   */
  var _proto = WebhookClient.prototype;
  _proto.verifyWebhookSignature =
  /*#__PURE__*/
  function () {
    var _verifyWebhookSignature = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, header, secretKey, enforceTolerance) {
      var request;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            request = VerifyWebhookSignatureRequest.fromPartial({
              configData: this.configData,
              payload: payload,
              header: header,
              secretKey: secretKey,
              enforceTolerance: enforceTolerance
            });
            return _context.abrupt("return", this.bridge.getWebhook().VerifyWebhookSignature(request).then(function (res) {
              if (res.error) {
                throw res.error;
              }
              return res.isValid;
            }));
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function verifyWebhookSignature(_x, _x2, _x3, _x4) {
      return _verifyWebhookSignature.apply(this, arguments);
    }
    return verifyWebhookSignature;
  }();
  return WebhookClient;
}();

/**
 * Represents a client for interacting with the Bloock SDK.
 */
var BloockClient =
/**
 * Creates a new instance of the Bloock SDK client with the specified configuration.
 * @param apiKey
 * @param identityApiHost
 */
function BloockClient(apiKey, identityApiHost) {
  this.configData = NewConfigData(undefined);
  if (this.configData.config) {
    this.configData.config.apiKey = apiKey;
    this.configData.config.identityApiHost = identityApiHost;
  }
  this.AuthenticityClient = new AuthenticityClient(this.configData);
  this.AvailabilityClient = new AvailabilityClient(this.configData);
  this.EncryptionClient = new EncryptionClient(this.configData);
  this.IdentityCoreClient = new IdentityCoreClient(this.configData);
  this.IdentityClient = new IdentityClient(this.configData);
  this.IntegrityClient = new IntegrityClient(this.configData);
  this.KeyClient = new KeyClient(this.configData);
  this.RecordClient = new RecordClient(this.configData);
  this.WebhookClient = new WebhookClient(this.configData);
};

/**
 * Represents the arguments for a data loader.
 */
var LoaderArgs$1 = /*#__PURE__*/function () {
  /**
   * Constructs a LoaderArgs object with the specified parameters.
   * @param id
   */
  function LoaderArgs$1(id) {
    this.id = id;
  }
  var _proto = LoaderArgs$1.prototype;
  _proto.toProto = function toProto() {
    return LoaderArgs.fromPartial({
      id: this.id
    });
  };
  return LoaderArgs$1;
}();

/**
 * Represents a loader for hosted data availability.
 */
var HostedLoader = /*#__PURE__*/function () {
  /**
   * Constructs a HostedLoader object with the specified parameters.
   * @param id
   */
  function HostedLoader(id) {
    this.type = DataAvailabilityType.HOSTED;
    this.args = new LoaderArgs$1(id);
  }
  var _proto = HostedLoader.prototype;
  _proto.toProto = function toProto() {
    return Loader.fromPartial({
      type: this.type,
      args: this.args.toProto()
    });
  };
  return HostedLoader;
}();

/**
 * Represents the arguments for a data publisher.
 */
var PublisherArgs$1 = /*#__PURE__*/function () {
  /**
   * Constructs a PublisherArgs object with the specified parameters.
   * @param ipnsKey
   */
  function PublisherArgs$1(ipnsKey) {
    if (ipnsKey) {
      this.ipnsKey = ipnsKey;
    }
  }
  var _proto = PublisherArgs$1.prototype;
  _proto.toProto = function toProto() {
    var ipnsKey;
    if (this.ipnsKey) {
      ipnsKey = this.ipnsKey.toProto();
    }
    return PublisherArgs.fromPartial({
      ipnsKey: ipnsKey
    });
  };
  return PublisherArgs$1;
}();

/**
 * Represents a publisher for hosted data availability.
 */
var HostedPublisher = /*#__PURE__*/function () {
  /**
   * Constructs a HostedPublisher object with the specified parameters.
   */
  function HostedPublisher() {
    this.type = DataAvailabilityType.HOSTED;
    this.args = new PublisherArgs$1().toProto();
  }
  var _proto = HostedPublisher.prototype;
  _proto.toProto = function toProto() {
    return Publisher.fromPartial({
      type: this.type,
      args: this.args
    });
  };
  return HostedPublisher;
}();

/**
 * Represents a loader for IPFS data availability.
 */
var IpfsLoader = /*#__PURE__*/function () {
  /**
   * Constructs a IpfsLoader object with the specified parameters.
   * @param id
   */
  function IpfsLoader(id) {
    this.type = DataAvailabilityType.IPFS;
    this.args = new LoaderArgs$1(id);
  }
  var _proto = IpfsLoader.prototype;
  _proto.toProto = function toProto() {
    return Loader.fromPartial({
      type: this.type,
      args: this.args.toProto()
    });
  };
  return IpfsLoader;
}();

/**
 * Represents a publisher for IPFS data availability.
 */
var IpfsPublisher = /*#__PURE__*/function () {
  /**
   * Constructs a IpfsPublisher object with the specified parameters.
   */
  function IpfsPublisher() {
    this.type = DataAvailabilityType.IPFS;
    this.args = new PublisherArgs$1().toProto();
  }
  var _proto = IpfsPublisher.prototype;
  _proto.toProto = function toProto() {
    return Publisher.fromPartial({
      type: this.type,
      args: this.args
    });
  };
  return IpfsPublisher;
}();

/**
 * Represents an IpnsKey with various key types.
 */
var IpnsKey$1 = /*#__PURE__*/function () {
  /**
   * Creates an IpnsKey instance with a managed key or managed certificate.
   * @param key
   */
  function IpnsKey$1(key) {
    if (key instanceof ManagedKey$1) {
      this.managedKey = key;
    } else if (key instanceof ManagedCertificate$1) {
      this.managedCertificate = key;
    } else {
      throw new Error("invalid key provided");
    }
  }
  var _proto = IpnsKey$1.prototype;
  _proto.toProto = function toProto() {
    var _this$managedKey, _this$managedCertific;
    return IpnsKey.fromPartial({
      managedKey: (_this$managedKey = this.managedKey) == null ? void 0 : _this$managedKey.toProto(),
      managedCertificate: (_this$managedCertific = this.managedCertificate) == null ? void 0 : _this$managedCertific.toProto()
    });
  };
  return IpnsKey$1;
}();

/**
 * Represents a publisher for IPNS data availability.
 */
var IpnsPublisher = /*#__PURE__*/function () {
  /**
   * Constructs a IpnsPublisher object with the specified parameters.
   */
  function IpnsPublisher(ipnsKey) {
    this.type = DataAvailabilityType.IPNS;
    this.args = new PublisherArgs$1(ipnsKey).toProto();
  }
  var _proto = IpnsPublisher.prototype;
  _proto.toProto = function toProto() {
    return Publisher.fromPartial({
      type: this.type,
      args: this.args
    });
  };
  return IpnsPublisher;
}();

/**
 * Represents a loader for IPNS data availability.
 */
var IpnsLoader = /*#__PURE__*/function () {
  /**
   * Constructs a IpnsLoader object with the specified parameters.
   * @param id
   */
  function IpnsLoader(id) {
    this.type = DataAvailabilityType.IPNS;
    this.args = new LoaderArgs$1(id);
  }
  var _proto = IpnsLoader.prototype;
  _proto.toProto = function toProto() {
    return Loader.fromPartial({
      type: this.type,
      args: this.args.toProto()
    });
  };
  return IpnsLoader;
}();

export { AccessControl$1 as AccessControl, AccessControlSecret$1 as AccessControlSecret, AccessControlTotp$1 as AccessControlTotp, AccessControlType$1 as AccessControlType, Anchor$1 as Anchor, AnchorNetwork$1 as AnchorNetwork, Attribute, AttributeDescriptor, AuthenticityClient, AvailabilityClient, Bloock, BloockClient, BooleanAttribute$1 as BooleanAttribute, BooleanAttributeDescriptor, CertificateType$1 as CertificateType, Credential$1 as Credential, CredentialBuilder, CredentialCoreBuilder, CredentialProof$1 as CredentialProof, CredentialReceipt$1 as CredentialReceipt, CredentialSchema$1 as CredentialSchema, CredentialStatus$1 as CredentialStatus, DateAttribute$1 as DateAttribute, DateAttributeDescriptor, DateTimeAttribute$1 as DateTimeAttribute, DateTimeAttributeDescriptor, DecimalAttribute$1 as DecimalAttribute, DecimalAttributeDescriptor, DecimalEnumAttributeDescriptor, Did, DidMethod$1 as DidMethod, EcdsaKeyPair, Encrypter$1 as Encrypter, EncryptionAlg$1 as EncryptionAlg, EncryptionClient, HashAlg$1 as HashAlg, Holder, HostedLoader, HostedPublisher, IdentityClient, IdentityCoreClient, ImportCertificateParams, IntegerAttribute$1 as IntegerAttribute, IntegerAttributeDescriptor, IntegerEnumAttributeDescriptor, IntegrityClient, IpfsLoader, IpfsPublisher, IpnsKey$1 as IpnsKey, IpnsLoader, IpnsPublisher, Issuer, IssuerStateReceipt$1 as IssuerStateReceipt, Key$1 as Key, KeyClient, KeyPair, KeyProtectionLevel$1 as KeyProtectionLevel, KeyType$1 as KeyType, LoaderArgs$1 as LoaderArgs, LocalCertificate$1 as LocalCertificate, LocalCertificateParams$1 as LocalCertificateParams, LocalKey$1 as LocalKey, Managed, ManagedCertificate$1 as ManagedCertificate, ManagedCertificateParams$1 as ManagedCertificateParams, ManagedKey$1 as ManagedKey, ManagedKeyParams$1 as ManagedKeyParams, Network$1 as Network, Proof$1 as Proof, ProofAnchor$1 as ProofAnchor, PublishIntervalParams, PublisherArgs$1 as PublisherArgs, Record$1 as Record, RecordBuilder, RecordClient, RecordHeader$1 as RecordHeader, RecordReceipt$1 as RecordReceipt, RsaKeyPair, Schema$1 as Schema, SchemaBuilder, Signature$1 as Signature, SignatureAlg, SignatureHeaderJws, SignatureJws, Signer$1 as Signer, StringAttribute$1 as StringAttribute, StringAttributeDescriptor, StringEnumAttributeDescriptor, SubjectCertificateParams, TotpAccessControlReceipt, VerificationReceipt$1 as VerificationReceipt, WebhookClient };
//# sourceMappingURL=index.esm.js.map
